window.SA_COLLECTION_NEED_PRESETS = {
  "generated_at": "2026-08-22T13:34:03.577Z",
  "generatedAt": "2026-08-22T13:34:03.577Z",
  "version": "collection-need-presets-2026-08-22",
  "store": "542485-a3.myshopify.com",
  "no_live_ai_runtime": true,
  "source": "collection_need_preset_backfill",
  "collections": {
    "2-cameras-4ch-nvr-packages-1": {
      "collectionHandle": "2-cameras-4ch-nvr-packages-1",
      "collectionProductCount": 4,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 2,
          "rankedProductIds": [
            "7591647412281",
            "7591647805497"
          ],
          "rankedProductHandles": [
            "6mp-4ch-hikvision-cctv-kit-2-x-ip-dome-cameras-4ch-nvr",
            "6mp-4ch-hikvision-cctv-kit-2-x-outdoor-turret-cameras-4ch-nvr"
          ]
        }
      }
    },
    "2-megapixel-ptz-cameras-1": {
      "collectionHandle": "2-megapixel-ptz-cameras-1",
      "collectionProductCount": 59,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 7,
          "rankedProductIds": [
            "7591729528889",
            "7591717306425",
            "8168627077177",
            "7591658881081",
            "7591607238713",
            "7591607074873",
            "7591638925369"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2df8225ih-ael-2mp-outdoor-darkfighter-x-ptz-25x-zoom",
            "hikvision-ds-2df9c435ihs-dlwt2-4mp-outdoor-darkfighter-x-ptz-camera-35x-zoom-500m-ir-ip67-ik10",
            "hikvision-ds-2dv6c425mxg-elwy-4mp-25x-optical-ptz-speed-dome-camera-darkfighter-low-light-200m-ir-ip67",
            "hikvision-ds-2df8236ix-ael-2mp-outdoor-darkfighter-ptz-camera-wdr-36x-zoom-200m-ir-hipoe",
            "hikvision-hik-2df8236iaelw-2mp-outdoor-darkfighter-ptz-camera-wdr-36x-zoom-200m-ir-hipoewiper",
            "hikvision-hik-2df8223iaelw-2mp-outdoor-darkfighter-ptz-camera-wdr-23x-zoom-200m-ir-hipoe-wiper",
            "hikvision-ds-2df8225ix-aelw-2mp-25x-network-ir-speed-dome"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 10,
          "rankedProductIds": [
            "7591817052217",
            "8168599715897",
            "7591859585081",
            "8168627077177",
            "7591668613177",
            "7591658881081",
            "7591654719545",
            "7591653507129",
            "7591587545145",
            "7591638138937"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2td4228-10-w",
            "hikvision-hm-td95c8-150ze4fl-w-thermal-optical-bi-spectrum-sphere-ptz-camera-with-smart-analytics",
            "hikvision-ds-2tx3636-25a-v1-thermal-smart-linkage-tracking-system",
            "hikvision-ds-2dv6c425mxg-elwy-4mp-25x-optical-ptz-speed-dome-camera-darkfighter-low-light-200m-ir-ip67",
            "hikvision-4mp-outdoor-darkfighter-ptz-camera-25x-zoom",
            "hikvision-ds-2df8236ix-ael-2mp-outdoor-darkfighter-ptz-camera-wdr-36x-zoom-200m-ir-hipoe",
            "hikvision-ds-2ae5225ti-tvi-2mp-outdoor-ptz-camera-25x-zoom-150m-ir",
            "hikvision-ds-2de4a204iwde-2mp-darkfighter-ir-ptz-camera-4x-optical-zoom-50m-ir-8-32mm",
            "hikvision-hik-2df7286-aw-2mp-outdoor-ptz-camera-30x-zoom-built-wiper",
            "hikvision-2mp-outdoor-darkfighter-ptz-camera-500m-laser-ir-36x-zoom-hipoe-special-order"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 5,
          "rankedProductIds": [
            "7591717306425",
            "8168627077177",
            "8168577433657",
            "7591668613177",
            "7591638138937"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2df9c435ihs-dlwt2-4mp-outdoor-darkfighter-x-ptz-camera-35x-zoom-500m-ir-ip67-ik10",
            "hikvision-ds-2dv6c425mxg-elwy-4mp-25x-optical-ptz-speed-dome-camera-darkfighter-low-light-200m-ir-ip67",
            "hikvision-ds-2td4238-10-s2-4mp-thermographic-thermal-optical-bi-spectrum-network-speed-dome",
            "hikvision-4mp-outdoor-darkfighter-ptz-camera-25x-zoom",
            "hikvision-2mp-outdoor-darkfighter-ptz-camera-500m-laser-ir-36x-zoom-hipoe-special-order"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 16,
          "rankedProductIds": [
            "7591729528889",
            "7591717306425",
            "7591859585081",
            "8168436891705",
            "8168627077177",
            "7591865024569",
            "7591642202169",
            "7591658881081",
            "7591654719545",
            "7591607238713",
            "7591607074873",
            "7591606714425",
            "7591587545145",
            "8168623865913",
            "7591638925369",
            "7591606485049"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2df8225ih-ael-2mp-outdoor-darkfighter-x-ptz-25x-zoom",
            "hikvision-ds-2df9c435ihs-dlwt2-4mp-outdoor-darkfighter-x-ptz-camera-35x-zoom-500m-ir-ip67-ik10",
            "hikvision-ds-2tx3636-25a-v1-thermal-smart-linkage-tracking-system",
            "hikvision-ds-2ae4225ti-d-2mp-outdoor-ptz-camera-25x-zoom-100m-ir-1",
            "hikvision-ds-2dv6c425mxg-elwy-4mp-25x-optical-ptz-speed-dome-camera-darkfighter-low-light-200m-ir-ip67",
            "hikvision-ds-2ae4225ti-d-2mp-outdoor-ptz-camera-25x-zoom-100m-ir",
            "hikvision-ds-2de4225iw-de-2mp-outdoor-mini-ir-ptz-camera-h-265-100m-ir-25x-zoom-ip66-poe-12vdc",
            "hikvision-ds-2df8236ix-ael-2mp-outdoor-darkfighter-ptz-camera-wdr-36x-zoom-200m-ir-hipoe",
            "hikvision-ds-2ae5225ti-tvi-2mp-outdoor-ptz-camera-25x-zoom-150m-ir",
            "hikvision-hik-2df8236iaelw-2mp-outdoor-darkfighter-ptz-camera-wdr-36x-zoom-200m-ir-hipoewiper",
            "hikvision-hik-2df8223iaelw-2mp-outdoor-darkfighter-ptz-camera-wdr-23x-zoom-200m-ir-hipoe-wiper",
            "hikvision-hik-2df7286-af-2mp-outdoor-ptz-camera-dwdr-30x-zoom-single-mode-fibre-fc-24vac",
            "hikvision-hik-2df7286-aw-2mp-outdoor-ptz-camera-30x-zoom-built-wiper",
            "hikvision-ds-2df8c260i5xg1-elw-2mp-60x-darkfighter-laser-network-speed-dome-up-to-500m-laser-ip67-ik10",
            "hikvision-ds-2df8225ix-aelw-2mp-25x-network-ir-speed-dome",
            "hikvision-hik-2df6223-cxw-2mp-explosion-proof-ptz-camera-23x-optical-zoom-ip68-hi-poe"
          ]
        }
      }
    },
    "3-megapixel-ptz-cameras-1": {
      "collectionHandle": "3-megapixel-ptz-cameras-1",
      "collectionProductCount": 1,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "3mp-outdoor-cameras": {
      "collectionHandle": "3mp-outdoor-cameras",
      "collectionProductCount": 1,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "4-cameras-nvr-package-1": {
      "collectionHandle": "4-cameras-nvr-package-1",
      "collectionProductCount": 29,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 10,
          "rankedProductIds": [
            "7591918174265",
            "8284563669049",
            "7591629389881",
            "7591918436409",
            "7591865614393",
            "7591918043193",
            "8168572715065",
            "8284554788921",
            "8284554625081",
            "7591918600249"
          ],
          "rankedProductHandles": [
            "8mp-hikvision-colorvu-hybrid-cctv-kit-6-x-liveguard-cameras-8ch-m-series-nvr-3tb",
            "hikvision-6mp-smart-hybrid-light-ds-2cd2067g3-li2uy-sl-4-camera-kit-with-ds-7604ni-m1-4p-4-channel-poe-nvr-no-hdd",
            "8mp-4ch-hikvision-cctv-kit-4-x-outdoor-bullet-cameras-4ch-nvr",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-8-x-liveguard-cameras-8ch-m-series-nvr-3tb",
            "8mp-hikvision-colorvu-cctv-kit-4-x-outdoor-8mp-colorvu-turret-cameras-8ch-m-series-nvr-3tb-kit",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-4-x-liveguard-cameras-8ch-m-series-nvr-3tb",
            "8mp-hikvision-colorvu-3-0-hybrid-cctv-kit-4-x-liveguard-cameras-8ch-m-series-nvr-4tb",
            "hikvision-8mp-colorvu-3-0-hybrid-cctv-kit-2-x-liveguard-gen3-cameras-4ch-m-series-nvr",
            "hikvision-8mp-colorvu-3-0-hybrid-cctv-kit-4-x-liveguard-gen-3-cameras-8ch-m-series-nvr-no-hdd",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-10-x-liveguard-cameras-16ch-m-series-nvr-3tb"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 15,
          "rankedProductIds": [
            "8284565569593",
            "8284563669049",
            "7591918174265",
            "7591918436409",
            "7591865614393",
            "7591825702969",
            "7591918043193",
            "8168572715065",
            "8284554788921",
            "7591698694201",
            "8284554625081",
            "8284555149369",
            "8168575729721",
            "7591918600249",
            "8284461760569"
          ],
          "rankedProductHandles": [
            "hikvision-4-camera-8mp-acusense-security-kit-with-ds-7604ni-m1-4p-4ch-poe-nvr-4x-ds-2cd2086g2h-i2u-sl-fixed-bullet-cameras-2-way-audio-active-strobe-light-no-hdd-included",
            "hikvision-6mp-smart-hybrid-light-ds-2cd2067g3-li2uy-sl-4-camera-kit-with-ds-7604ni-m1-4p-4-channel-poe-nvr-no-hdd",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-6-x-liveguard-cameras-8ch-m-series-nvr-3tb",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-8-x-liveguard-cameras-8ch-m-series-nvr-3tb",
            "8mp-hikvision-colorvu-cctv-kit-4-x-outdoor-8mp-colorvu-turret-cameras-8ch-m-series-nvr-3tb-kit",
            "4mp-hikvision-colorvu-cctv-kit-4-x-outdoor-colorvu-liveguard-turret-cameras-with-acusense-4ch-nvr-kit",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-4-x-liveguard-cameras-8ch-m-series-nvr-3tb",
            "8mp-hikvision-colorvu-3-0-hybrid-cctv-kit-4-x-liveguard-cameras-8ch-m-series-nvr-4tb",
            "hikvision-8mp-colorvu-3-0-hybrid-cctv-kit-2-x-liveguard-gen3-cameras-4ch-m-series-nvr",
            "6mp-4ch-hikvision-cctv-kit-4-x-outdoor-turret-cameras-4ch-nvr",
            "hikvision-8mp-colorvu-3-0-hybrid-cctv-kit-4-x-liveguard-gen-3-cameras-8ch-m-series-nvr-no-hdd",
            "hikvision-6mp-4ch-colorvu-3-0-cctv-kit-2-liveguard-turret-cameras-4ch-m-series-poe-nvr",
            "6mp-hikvision-colorvu-3-0-hybrid-cctv-kit-4-x-liveguard-cameras-4ch-m-series-nvr-4tb",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-10-x-liveguard-cameras-16ch-m-series-nvr-3tb",
            "hikvision-6mp-4ch-cctv-kit-4-turret-cameras-with-acusense-4ch-poe-nvr-ds-2cd2366g2h-iu-ds-7604ni-i1-4p-without-hdd"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 16,
          "rankedProductIds": [
            "7591918174265",
            "7591918436409",
            "8284565569593",
            "7591865614393",
            "7591621099577",
            "7591918043193",
            "7591629389881",
            "8168572715065",
            "8284554788921",
            "8284554625081",
            "7591918600249",
            "7591807844409",
            "7591628734521",
            "7591621656633",
            "7591807582265",
            "7591630340153"
          ],
          "rankedProductHandles": [
            "8mp-hikvision-colorvu-hybrid-cctv-kit-6-x-liveguard-cameras-8ch-m-series-nvr-3tb",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-8-x-liveguard-cameras-8ch-m-series-nvr-3tb",
            "hikvision-4-camera-8mp-acusense-security-kit-with-ds-7604ni-m1-4p-4ch-poe-nvr-4x-ds-2cd2086g2h-i2u-sl-fixed-bullet-cameras-2-way-audio-active-strobe-light-no-hdd-included",
            "8mp-hikvision-colorvu-cctv-kit-4-x-outdoor-8mp-colorvu-turret-cameras-8ch-m-series-nvr-3tb-kit",
            "8mp-4ch-hikvision-cctv-kit-4-x-outdoor-turret-cameras-4ch-nvr",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-4-x-liveguard-cameras-8ch-m-series-nvr-3tb",
            "8mp-4ch-hikvision-cctv-kit-4-x-outdoor-bullet-cameras-4ch-nvr",
            "8mp-hikvision-colorvu-3-0-hybrid-cctv-kit-4-x-liveguard-cameras-8ch-m-series-nvr-4tb",
            "hikvision-8mp-colorvu-3-0-hybrid-cctv-kit-2-x-liveguard-gen3-cameras-4ch-m-series-nvr",
            "hikvision-8mp-colorvu-3-0-hybrid-cctv-kit-4-x-liveguard-gen-3-cameras-8ch-m-series-nvr-no-hdd",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-10-x-liveguard-cameras-16ch-m-series-nvr-3tb",
            "8mp-4ch-hikvision-cctv-kit-4-x-outdoor-turret-black-shadow-series-8ch-nvr",
            "8mp-4ch-hikvision-cctv-kit-4-x-outdoor-motorised-vf-turrets-4ch-nvr",
            "8mp-4ch-hikvision-vandalproof-dome-cctv-kit",
            "8mp-4ch-hikvision-cctv-kit-4-x-outdoor-turret-black-shadow-series-w-acusense-4ch-nvr",
            "8mp-4ch-hikvision-cctv-kit-4-x-outdoor-turret-black-shadow-series-4ch-nvr"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 3,
          "rankedProductIds": [
            "7591918436409",
            "7591918600249",
            "7591918174265"
          ],
          "rankedProductHandles": [
            "8mp-hikvision-colorvu-hybrid-cctv-kit-8-x-liveguard-cameras-8ch-m-series-nvr-3tb",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-10-x-liveguard-cameras-16ch-m-series-nvr-3tb",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-6-x-liveguard-cameras-8ch-m-series-nvr-3tb"
          ]
        }
      }
    },
    "4-megapixel-ptz-cameras-1": {
      "collectionHandle": "4-megapixel-ptz-cameras-1",
      "collectionProductCount": 41,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 8,
          "rankedProductIds": [
            "8168515141689",
            "7745682407481",
            "8168624029753",
            "7591841366073",
            "7591844741177",
            "7837229809721",
            "7591876427833",
            "7745683521593"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2dt8c442mxg-lwt-4mp-ptz-dome-camera-with-42x-zoom-anti-corrosion-polymer-hybrid-light-ir-500m-36v-dc-ip67",
            "hikvision-ds-2dt8c442mxg-lwt-4mp-ptz-dome-camera-anti-corrosion-polymer-hybrid-light-42x-zoom-36-vdc",
            "hikvision-ds-2df8c435mhs-delw-4mp-35x-darkfighterx-ptz-camera-dual-sensor-ir-300m-ip67-ik10",
            "hikvision-ds-2se4c425mwg-e-14f0-4mp-tandemvu-colorvu-ptz",
            "hikvision-ds-2de7a412mcg-eb-4mp-7-inch-4-mp-12x-colorvu-network-speed-dome",
            "hikvision-ds-2df8c442ixg-elw-8c-series-4mp-42x-darkfighter-ir-network-speed-dome-ptz",
            "hikvision-ds-2df8c425mhs-delw-4-mp-25x-darkfighterx-ir-network-speed-dome-300m-ir",
            "hikvision-ds-2de7a425iw-aeb-4-mp-25x-powered-by-darkfighter-ir-network-speed-dome"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 7,
          "rankedProductIds": [
            "8168541519929",
            "8284541976633",
            "8284589981753",
            "7837247209529",
            "7745682604089",
            "7591866892345",
            "7591644692537"
          ],
          "rankedProductHandles": [
            "hilook-by-hikvision-ptz-n3404liu-sl-4-mp-4-x-intelligent-network-ptz-2-way-audio-flashing-lights",
            "hikvision-ptz-nd4404-slaus-dual-lens-4mp4mp-ptz-ip-camera-with-4x-optical-zoom-darkfighter-low-light-active-strobe-audio-alarm",
            "hikvision-ds-2de4425iwg1-e-4mp-25x-powered-by-darkfighter-ir-acusense-network-ptz-speed-dome-with-ai-isp-face-capture-strobe-audio-alarm",
            "hikvision-ds-2td4137t-9w-thermographic-thermal-optical-bi-spectrum-network-speed-dome",
            "hikvision-ds-2se7c432mwg-eb-26-6mp4mp-tandemvu-outdoor-ptz-camera-acusense-32x-zoom",
            "hikvision-acusense-ptz-4mp-6-252mm-42x-optical-16-x-digital-400m-ir-ip67-face-capture-white",
            "hikvision-ds-2de4a425iw-de-4mp-outdoor-ptz-camera-25x-zoom-50m-ir"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 16,
          "rankedProductIds": [
            "8284541681721",
            "8168595783737",
            "8168618393657",
            "8168624029753",
            "8168541519929",
            "7591844577337",
            "8284541976633",
            "7591979024441",
            "7591769899065",
            "7591661633593",
            "7591858307129",
            "8168601223225",
            "8284589981753",
            "7745682604089",
            "7591866892345",
            "7591721828409"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2st5c432mwg-e-26pa-4mp-32x-zoom-tandemvu-anti-corrosion-ptz-ip-camera-with-acusense-darkfighter-technology",
            "hikvision-ids-mcd402-e-4g-dual-lens-anpr-portable-speed-dome-with-36x-zoom-ai-detection",
            "hikvision-ids-mcd402-es-4g-dual-lens-anpr-portable-speed-dome-kit",
            "hikvision-ds-2df8c435mhs-delw-4mp-35x-darkfighterx-ptz-camera-dual-sensor-ir-300m-ip67-ik10",
            "hilook-by-hikvision-ptz-n3404liu-sl-4-mp-4-x-intelligent-network-ptz-2-way-audio-flashing-lights",
            "hikvision-ds-2de4a425iwg-e-4mp-outdoor-ptz-camera-25x-zoom-50m-ir-with-ai-tracking",
            "hikvision-ptz-nd4404-slaus-dual-lens-4mp4mp-ptz-ip-camera-with-4x-optical-zoom-darkfighter-low-light-active-strobe-audio-alarm",
            "hikvision-ds-2de4425iw-det5-4mp-outdoor-mini-ir-ptz-camera-100m-ir-25x-zoom-ip66-poe-12vdc-export",
            "hikvision-ds-2se7c124iw-ae32x-4s5-outdoor-smart-linkage-ptz-camera-acusense-32x-zoom-ip66-ik10-hi-poe",
            "hikvision-4mp-outdoor-mini-ptz-camera-4x-zoom",
            "hikvision-4mp-tandemvu-ptz-camera-24-7-colour-180-deg-overview-42x-zoom",
            "hikvision-ds-2df8442ixg1-elwy-df8-series-4mp-42x-darkfighter-camera-with-wiper",
            "hikvision-ds-2de4425iwg1-e-4mp-25x-powered-by-darkfighter-ir-acusense-network-ptz-speed-dome-with-ai-isp-face-capture-strobe-audio-alarm",
            "hikvision-ds-2se7c432mwg-eb-26-6mp4mp-tandemvu-outdoor-ptz-camera-acusense-32x-zoom",
            "hikvision-acusense-ptz-4mp-6-252mm-42x-optical-16-x-digital-400m-ir-ip67-face-capture-white",
            "hikvision-ds-2df8442ixs-ael-4mp-outdoor-hfr-ptz-camera-wdr-42x-zoom-ip67-500m-ir-hipoe"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 16,
          "rankedProductIds": [
            "8168624029753",
            "7591841366073",
            "7591924039737",
            "7591979024441",
            "7591769899065",
            "7591607631929",
            "7591858307129",
            "7591794769977",
            "7745682604089",
            "7591866892345",
            "7591721828409",
            "8168515141689",
            "7837229809721",
            "7591712817209",
            "8168618328121",
            "7591793262649"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2df8c435mhs-delw-4mp-35x-darkfighterx-ptz-camera-dual-sensor-ir-300m-ip67-ik10",
            "hikvision-ds-2se4c425mwg-e-14f0-4mp-tandemvu-colorvu-ptz",
            "hikvision-ds-2sf8c442mxg-elw-26-4mp-tandemvu-ptz-camera-24-7-colour-42x-zoom",
            "hikvision-ds-2de4425iw-det5-4mp-outdoor-mini-ir-ptz-camera-100m-ir-25x-zoom-ip66-poe-12vdc-export",
            "hikvision-ds-2se7c124iw-ae32x-4s5-outdoor-smart-linkage-ptz-camera-acusense-32x-zoom-ip66-ik10-hi-poe",
            "hikvision-ds-2df8436ix-ael-4mp-outdoor-hfr-ptz-camera-wdr-36x-zoom-wiper-ip66-200m-ir-hipoe",
            "hikvision-4mp-tandemvu-ptz-camera-24-7-colour-180-deg-overview-42x-zoom",
            "hikvision-ids-mcd202-b-ptz-2-mp-network-portable-ir-speed-dome-4g",
            "hikvision-ds-2se7c432mwg-eb-26-6mp4mp-tandemvu-outdoor-ptz-camera-acusense-32x-zoom",
            "hikvision-acusense-ptz-4mp-6-252mm-42x-optical-16-x-digital-400m-ir-ip67-face-capture-white",
            "hikvision-ds-2df8442ixs-ael-4mp-outdoor-hfr-ptz-camera-wdr-42x-zoom-ip67-500m-ir-hipoe",
            "hikvision-ds-2dt8c442mxg-lwt-4mp-ptz-dome-camera-with-42x-zoom-anti-corrosion-polymer-hybrid-light-ir-500m-36v-dc-ip67",
            "hikvision-ds-2df8c442ixg-elw-8c-series-4mp-42x-darkfighter-ir-network-speed-dome-ptz",
            "hikvision-ds-2de4425iw-de-4mp-outdoor-mini-ir-ptz-camera-100m-ir-25x-zoom-ip66-poe-12vdc",
            "hikvision-ds-2df7a436ixg-el-4mp-36x-ir-network-speed-dome-ultra-series",
            "hikvision-ds-2df6a436x-ael-ptz-8mp42x-ip676-252mm500m-ir-vehicle-human-tracking"
          ]
        }
      }
    },
    "4mp-hikvision-dome-cameras": {
      "collectionHandle": "4mp-hikvision-dome-cameras",
      "collectionProductCount": 7,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "4mp-hikvision-mini-bullets-1": {
      "collectionHandle": "4mp-hikvision-mini-bullets-1",
      "collectionProductCount": 13,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 5,
          "rankedProductIds": [
            "7591719469113",
            "7591719370809",
            "7591895466041",
            "8168622555193",
            "7591727202361"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd2066g2-iu-sl-6mp-outdoor-acusense-gen-2-mini-bullet-camera-mic-ir-strobe-audio-alarm-2-8mm",
            "hikvision-ds-2cd2066g2-iu-sl-6mp-outdoor-acusense-gen-2-mini-bullet-camera-mic-ir-strobe-audio-alarm-4mm",
            "hikvision-ds-2cd2t47g2-lsu-sl-4mp-gen2-outdoor-colorvu-bullet-camera-liveguard-60m-white-led-2-8mm",
            "hikvision-ds-2xc3646g0h-lizsupa-anti-corrosion-vari-focal-bullet-camera-2-7-13-5mm",
            "hikvision-ds-2cd2347g2-lu-4mp-gen2-outdoor-colorvu-turret-camera-with-acusense-mic-30m-white-led-2-8mm"
          ]
        }
      }
    },
    "4mp-hikvision-mini-domes-1": {
      "collectionHandle": "4mp-hikvision-mini-domes-1",
      "collectionProductCount": 4,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "5mp-ai-active-amp-starlight-eyeballs": {
      "collectionHandle": "5mp-ai-active-amp-starlight-eyeballs",
      "collectionProductCount": 12,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 2,
          "rankedProductIds": [
            "7591722385465",
            "8284558229561"
          ],
          "rankedProductHandles": [
            "dahua-tioc-dh-ipc-hdw3549hp-as-pv-0280b-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-turret-fixed-2-8mm-built-in-mic-speakerwdr-micro-sdip67poe",
            "dahua-dh-hac-hdw2802tp-a-8mp-4k-hdcvi-turret-camera-2-8mm-fixed-lens-starlight-ir-60m-built-in-mic-ip67"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 5,
          "rankedProductIds": [
            "7591722385465",
            "7745669627961",
            "7591707967545",
            "7591707836473",
            "7591698563129"
          ],
          "rankedProductHandles": [
            "dahua-tioc-dh-ipc-hdw3549hp-as-pv-0280b-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-turret-fixed-2-8mm-built-in-mic-speakerwdr-micro-sdip67poe",
            "dahua-dh-ipc-hdw5541tm-ase-5mp-ai-active-deterrence-starlight-ip-turret-fixed-2-8mm",
            "dahua-dh-ipc-hdbw3541rp-zs-27135-5mp-lite-ai-motorised-starlight-dome-perimeter-smd-sd-card-wdr-ir40m-ip67-poe",
            "dahua-ipc-hdbw3541ep-s-0280b-5mp-lite-ai-fixed-starlight-dome-perimeter-smd-sd-card-wdr-ir50m-ip67-poe",
            "dahua-dh-ipc-hdw5541h-as-pv-5mp-ai-active-deterrence-starlight-ip-turret-fixed-2-8mm"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 4,
          "rankedProductIds": [
            "8284558229561",
            "7591708033081",
            "7591763411001",
            "7591707967545"
          ],
          "rankedProductHandles": [
            "dahua-dh-hac-hdw2802tp-a-8mp-4k-hdcvi-turret-camera-2-8mm-fixed-lens-starlight-ir-60m-built-in-mic-ip67",
            "dahua-dh-ipc-hfw3541tp-zs-27135-5mp-lite-ai-motorised-starlight-bullet-perimeter-smd-sd-card-wdr-ir40m-ip67-poe",
            "dahua-dh-ipc-hfw3541tp-zas-27135-5mp-lite-ai-motorised-starlight-bullet-perimeter-smd-sd-card-wdr-ir60mip67-poe",
            "dahua-dh-ipc-hdbw3541rp-zs-27135-5mp-lite-ai-motorised-starlight-dome-perimeter-smd-sd-card-wdr-ir40m-ip67-poe"
          ]
        }
      }
    },
    "5mp-ai-active-and-starlight-pro-cameras-1": {
      "collectionHandle": "5mp-ai-active-and-starlight-pro-cameras-1",
      "collectionProductCount": 15,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 9,
          "rankedProductIds": [
            "7591785365561",
            "8168542044217",
            "7591832158265",
            "7591831109689",
            "8168609087545",
            "8284590407737",
            "8168415559737",
            "7591824752697",
            "7591787495481"
          ],
          "rankedProductHandles": [
            "dahua-tioc-advanced-2-0-dh-ipc-hfw3849t1p-as-pv-0280b-s3-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-built-in-mic-speakerip67poe-wizsense",
            "dahua-tioc-dh-ipc-hfw3849t1-as-pv-anz-s2-blk-8mp-ai-active-deterrence-ip-bullet-fixed-2-8mm-black",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-blk-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-black",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm",
            "dahua-ipc-hfw3849t1-as-pv-pro-8mp-smart-dual-light-active-deterrence-fixed-focal-bullet-camera-2-8-mm",
            "dahua-ipc-pfw3849s-a180-as-pv-8mp-180-tioc-duo-splicing-bullet-wizsense-network-camera",
            "dahua-dh-ipc-hfw3849t1-zas-pv-anz-s2-8mp-smart-dual-active-deterrence-vari-focal-bullet-wizsense-network-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hfw3849t1p-as-pv-0280b-s3-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm",
            "dahua-tioc-2-0-advanced-dh-ipc-hfw3549t1p-as-pv-0280b-s3-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-built-in-mic-speaker-ip67-poe-wizsense"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 12,
          "rankedProductIds": [
            "7591787495481",
            "8168542044217",
            "7591932067897",
            "7591832158265",
            "7591831109689",
            "7591830618169",
            "8168609087545",
            "8284590407737",
            "8168415559737",
            "7591824752697",
            "7591804731449",
            "7591785365561"
          ],
          "rankedProductHandles": [
            "dahua-tioc-2-0-advanced-dh-ipc-hfw3549t1p-as-pv-0280b-s3-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-built-in-mic-speaker-ip67-poe-wizsense",
            "dahua-tioc-dh-ipc-hfw3849t1-as-pv-anz-s2-blk-8mp-ai-active-deterrence-ip-bullet-fixed-2-8mm-black",
            "dahua-tioc-2-0-black-dh-ipc-hfw3649t1-as-pv-anz-6mp-ai-active-deterrence-fixed-lens-bullet-camera",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-blk-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-black",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm",
            "dahua-tioc-3-0-advanced-dh-ipc-hfw3649t1-as-pv-anz-6mp-ai-active-deterrence-motorised-bullet-camera",
            "dahua-ipc-hfw3849t1-as-pv-pro-8mp-smart-dual-light-active-deterrence-fixed-focal-bullet-camera-2-8-mm",
            "dahua-ipc-pfw3849s-a180-as-pv-8mp-180-tioc-duo-splicing-bullet-wizsense-network-camera",
            "dahua-dh-ipc-hfw3849t1-zas-pv-anz-s2-8mp-smart-dual-active-deterrence-vari-focal-bullet-wizsense-network-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hfw3849t1p-as-pv-0280b-s3-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm",
            "dahua-tioc-2-0-advanced-dh-ipc-hfw3549t1-zas-pv-5mp-ai-active-deterrence-motorised-bullet-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hfw3849t1p-as-pv-0280b-s3-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-built-in-mic-speakerip67poe-wizsense"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 10,
          "rankedProductIds": [
            "8168542044217",
            "7591832158265",
            "7591831109689",
            "8168609087545",
            "8284590407737",
            "8168415559737",
            "7591824752697",
            "7591830618169",
            "7591785365561",
            "7591804731449"
          ],
          "rankedProductHandles": [
            "dahua-tioc-dh-ipc-hfw3849t1-as-pv-anz-s2-blk-8mp-ai-active-deterrence-ip-bullet-fixed-2-8mm-black",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-blk-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-black",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm",
            "dahua-ipc-hfw3849t1-as-pv-pro-8mp-smart-dual-light-active-deterrence-fixed-focal-bullet-camera-2-8-mm",
            "dahua-ipc-pfw3849s-a180-as-pv-8mp-180-tioc-duo-splicing-bullet-wizsense-network-camera",
            "dahua-dh-ipc-hfw3849t1-zas-pv-anz-s2-8mp-smart-dual-active-deterrence-vari-focal-bullet-wizsense-network-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hfw3849t1p-as-pv-0280b-s3-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm",
            "dahua-tioc-3-0-advanced-dh-ipc-hfw3649t1-as-pv-anz-6mp-ai-active-deterrence-motorised-bullet-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hfw3849t1p-as-pv-0280b-s3-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-built-in-mic-speakerip67poe-wizsense",
            "dahua-tioc-2-0-advanced-dh-ipc-hfw3549t1-zas-pv-5mp-ai-active-deterrence-motorised-bullet-camera"
          ]
        }
      }
    },
    "5mp-hikvision-packages": {
      "collectionHandle": "5mp-hikvision-packages",
      "collectionProductCount": 27,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 2,
          "rankedProductIds": [
            "8284564062265",
            "8284563669049"
          ],
          "rankedProductHandles": [
            "hikvision-6-camera-6mp-smart-hybrid-light-security-kit-with-ds-2cd2067g3-li2uy-sl-cameras-ds-7608ni-m2-8p-8-channel-8-poe-nvr-no-hdd",
            "hikvision-6mp-smart-hybrid-light-ds-2cd2067g3-li2uy-sl-4-camera-kit-with-ds-7604ni-m1-4p-4-channel-poe-nvr-no-hdd"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 18,
          "rankedProductIds": [
            "8284561047609",
            "8284565340217",
            "8284559015993",
            "8284560621625",
            "8284558426169",
            "8284469624889",
            "8284559900729",
            "8284564455481",
            "8284560261177",
            "8284563669049",
            "8284458811449",
            "8284589621305",
            "8324153704505",
            "8284589883449",
            "8168575828025",
            "8284555149369",
            "8168575729721",
            "8284461760569"
          ],
          "rankedProductHandles": [
            "hikvision-6mp-8ch-cctv-kit-6x-black-liveguard-acusense-turret-cameras-with-strobe-audio-smart-light-8ch-poe-nvr-4tb-ds-2cd2366g2h-is2u-sl-blk-ds-7608ni-m2-8p",
            "hikvision-10-camera-6mp-colorvu-security-kit-with-ds-7616ni-m2-16p-16ch-16-poe-8k-nvr-10x-ds-2cd2067g3-li2uy-sl-fixed-mini-bullet-cameras-dual-microphones-active-strobe-light-no-hdd-included",
            "hikvision-6mp-8ch-cctv-kit-6x-acusense-turret-cameras-with-strobe-audio-8ch-poe-nvr-with-4tb-hdd-ds-2cd2366g2h-is2u-sl-ds-7608ni-m2-8p",
            "hikvision-6mp-8ch-cctv-kit-4x-black-liveguard-acusense-turret-cameras-with-strobe-audio-smart-light-4ch-poe-nvr-ds-2cd2366g2h-is2u-sl-blk-ds-7604ni-m1-4p",
            "hikvision-6mp-4ch-cctv-kit-4x-acusense-turret-cameras-with-strobe-audio-4ch-poe-nvr-without-hdd-ds-2cd2366g2h-is2u-sl-ds-7604ni-i1-4p",
            "hikvision-6mp-8ch-cctv-kit-8x-black-liveguard-acusense-turret-cameras-with-strobe-audio-smart-light-8ch-poe-nvr-4tb-ds-2cd2366g2h-is2u-sl-blk-ds-7608ni-m2-8p",
            "hikvision-6mp-8ch-cctv-kit-8x-liveguard-acusense-cameras-with-strobe-audio-smart-light-8ch-poe-nvr-with-4tb-hdd-ds-2cd2366g2h-is2u-sl-ds-7608ni-m2-8p",
            "hikvision-6-camera-kit-6mp-colorvu-with-ds-7608ni-m2-8p-8ch-poe-nvr-6x-ds-2cd2067g3-li2uy-sl-mini-bullet-cameras-4tb-hdd-included",
            "hikvision-6mp-16ch-cctv-kit-10x-liveguard-acusense-cameras-with-strobe-audio-smart-light-16ch-poe-nvr-ds-2cd2366g2h-is2u-sl-ds-7616ni-i2-16p",
            "hikvision-6mp-smart-hybrid-light-ds-2cd2067g3-li2uy-sl-4-camera-kit-with-ds-7604ni-m1-4p-4-channel-poe-nvr-no-hdd",
            "hikvision-6mp-acusense-cctv-kit-6x-darkfighter-bullet-cameras-ds-2cd2t66g2h-2i-8ch-poe-nvr-with-4tb-ds-7608ni-m2-8p",
            "hikvision-10-camera-6mp-colorvu-acusense-ds-2cd2367g3-lis2uy-srb-black-turret-kit-with-ds-7616ni-m2-16p-16ch-poe-8k-nvr-no-hdd",
            "hikvision-6mp-8ch-colorvu-3-0-hybrid-cctv-kit-6-liveguard-turret-cameras-8ch-m-series-poe-nvr-no-hdd-ds-2cd2367g3-lis2uy-sl-ds-7608ni-m2-8p",
            "hikvision-6mp-acusense-ds-2cd2t66g2h-2i-black-bullet-10-camera-kit-with-ds-7616ni-m2-16p-16ch-poe-8k-nvr-60m-ir-no-hdd-included",
            "6mp-hikvision-colorvu-3-0-hybrid-cctv-kit-6-x-liveguard-cameras-8ch-m-series-nvr-4tb",
            "hikvision-6mp-4ch-colorvu-3-0-cctv-kit-2-liveguard-turret-cameras-4ch-m-series-poe-nvr",
            "6mp-hikvision-colorvu-3-0-hybrid-cctv-kit-4-x-liveguard-cameras-4ch-m-series-nvr-4tb",
            "hikvision-6mp-4ch-cctv-kit-4-turret-cameras-with-acusense-4ch-poe-nvr-ds-2cd2366g2h-iu-ds-7604ni-i1-4p-without-hdd"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 9,
          "rankedProductIds": [
            "8324154130489",
            "8284589621305",
            "8284565340217",
            "8284589883449",
            "8284566945849",
            "8284567339065",
            "8284469624889",
            "8284560261177",
            "8284559900729"
          ],
          "rankedProductHandles": [
            "hikvision-6mp-8ch-cctv-kit-8x-darkfighter-bullet-cameras-with-acusense-8ch-poe-nvr-with-no-hdd-ds-2cd2t66g2h-2i-ds-7608ni-m2-8p",
            "hikvision-10-camera-6mp-colorvu-acusense-ds-2cd2367g3-lis2uy-srb-black-turret-kit-with-ds-7616ni-m2-16p-16ch-poe-8k-nvr-no-hdd",
            "hikvision-10-camera-6mp-colorvu-security-kit-with-ds-7616ni-m2-16p-16ch-16-poe-8k-nvr-10x-ds-2cd2067g3-li2uy-sl-fixed-mini-bullet-cameras-dual-microphones-active-strobe-light-no-hdd-included",
            "hikvision-6mp-acusense-ds-2cd2t66g2h-2i-black-bullet-10-camera-kit-with-ds-7616ni-m2-16p-16ch-poe-8k-nvr-60m-ir-no-hdd-included",
            "hikvision-10-camera-6mp-acusense-security-kit-with-ds-7616ni-m2-16p-16ch-16-poe-8k-nvr-10x-ds-2cd2066g2h-iu-fixed-mini-bullet-cameras-built-in-microphone-no-hdd-included",
            "hikvision-10-camera-6mp-acusense-security-kit-with-ds-7616ni-m2-16p-16ch-16-poe-8k-nvr-10x-ds-2cd2166g2h-isu-fixed-turret-cameras-built-in-microphone-no-hdd-included",
            "hikvision-6mp-8ch-cctv-kit-8x-black-liveguard-acusense-turret-cameras-with-strobe-audio-smart-light-8ch-poe-nvr-4tb-ds-2cd2366g2h-is2u-sl-blk-ds-7608ni-m2-8p",
            "hikvision-6mp-16ch-cctv-kit-10x-liveguard-acusense-cameras-with-strobe-audio-smart-light-16ch-poe-nvr-ds-2cd2366g2h-is2u-sl-ds-7616ni-i2-16p",
            "hikvision-6mp-8ch-cctv-kit-8x-liveguard-acusense-cameras-with-strobe-audio-smart-light-8ch-poe-nvr-with-4tb-hdd-ds-2cd2366g2h-is2u-sl-ds-7608ni-m2-8p"
          ]
        }
      }
    },
    "5mp-turret-cameras": {
      "collectionHandle": "5mp-turret-cameras",
      "collectionProductCount": 1,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "6-cameras-nvr-package-1": {
      "collectionHandle": "6-cameras-nvr-package-1",
      "collectionProductCount": 22,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 6,
          "rankedProductIds": [
            "7591977091129",
            "8284564062265",
            "7591629520953",
            "7591865745465",
            "7591865942073",
            "8168572944441"
          ],
          "rankedProductHandles": [
            "hikvision-6-cameras-8-channel-cctv-kit-2-x-8mp-colorvu-4-x-6mp-acusense-turret-cameras-8ch-8k-nvr-bundle",
            "hikvision-6-camera-6mp-smart-hybrid-light-security-kit-with-ds-2cd2067g3-li2uy-sl-cameras-ds-7608ni-m2-8p-8-channel-8-poe-nvr-no-hdd",
            "8mp-8ch-hikvision-cctv-kit-6-x-outdoor-bullet-cameras-8ch-nvr",
            "8mp-hikvision-colorvu-cctv-kit-6-x-outdoor-8mp-colorvu-turret-cameras-8ch-m-series-nvr-3tb-kit",
            "8mp-hikvision-colorvu-cctv-kit-8-x-colorvu-turret-liveguard-cameras-8ch-m-series-nvr-3tb",
            "8mp-hikvision-colorvu-3-0-hybrid-cctv-kit-6-x-liveguard-cameras-8ch-m-series-nvr-4tb"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 12,
          "rankedProductIds": [
            "8284558426169",
            "8284564455481",
            "7591977091129",
            "8284458811449",
            "7591865745465",
            "7591623655481",
            "7591585022009",
            "7591865942073",
            "8168572944441",
            "8324153704505",
            "8168575828025",
            "7591976665145"
          ],
          "rankedProductHandles": [
            "hikvision-6mp-4ch-cctv-kit-4x-acusense-turret-cameras-with-strobe-audio-4ch-poe-nvr-without-hdd-ds-2cd2366g2h-is2u-sl-ds-7604ni-i1-4p",
            "hikvision-6-camera-kit-6mp-colorvu-with-ds-7608ni-m2-8p-8ch-poe-nvr-6x-ds-2cd2067g3-li2uy-sl-mini-bullet-cameras-4tb-hdd-included",
            "hikvision-6-cameras-8-channel-cctv-kit-2-x-8mp-colorvu-4-x-6mp-acusense-turret-cameras-8ch-8k-nvr-bundle",
            "hikvision-6mp-acusense-cctv-kit-6x-darkfighter-bullet-cameras-ds-2cd2t66g2h-2i-8ch-poe-nvr-with-4tb-ds-7608ni-m2-8p",
            "8mp-hikvision-colorvu-cctv-kit-6-x-outdoor-8mp-colorvu-turret-cameras-8ch-m-series-nvr-3tb-kit",
            "5mp-4ch-hikvision-cctv-kit-6-x-outdoor-turret-dome-cameras-8ch-nvr",
            "5mp-8ch-hikvision-cctv-kit-6-x-exir-bullet-cameras-8ch-nvr",
            "8mp-hikvision-colorvu-cctv-kit-8-x-colorvu-turret-liveguard-cameras-8ch-m-series-nvr-3tb",
            "8mp-hikvision-colorvu-3-0-hybrid-cctv-kit-6-x-liveguard-cameras-8ch-m-series-nvr-4tb",
            "hikvision-6mp-8ch-colorvu-3-0-hybrid-cctv-kit-6-liveguard-turret-cameras-8ch-m-series-poe-nvr-no-hdd-ds-2cd2367g3-lis2uy-sl-ds-7608ni-m2-8p",
            "6mp-hikvision-colorvu-3-0-hybrid-cctv-kit-6-x-liveguard-cameras-8ch-m-series-nvr-4tb",
            "hikvision-2-x-6mp-lifeguard-4-x-6mp-8ch-nvr-cctv-kit-6-turret-cameras-8ch-8k-nvr-bundle"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 7,
          "rankedProductIds": [
            "7591977091129",
            "7591629520953",
            "7591865745465",
            "7591865942073",
            "8168572944441",
            "7591625162809",
            "8168392163385"
          ],
          "rankedProductHandles": [
            "hikvision-6-cameras-8-channel-cctv-kit-2-x-8mp-colorvu-4-x-6mp-acusense-turret-cameras-8ch-8k-nvr-bundle",
            "8mp-8ch-hikvision-cctv-kit-6-x-outdoor-bullet-cameras-8ch-nvr",
            "8mp-hikvision-colorvu-cctv-kit-6-x-outdoor-8mp-colorvu-turret-cameras-8ch-m-series-nvr-3tb-kit",
            "8mp-hikvision-colorvu-cctv-kit-8-x-colorvu-turret-liveguard-cameras-8ch-m-series-nvr-3tb",
            "8mp-hikvision-colorvu-3-0-hybrid-cctv-kit-6-x-liveguard-cameras-8ch-m-series-nvr-4tb",
            "8mp-8ch-hikvision-cctv-kit-6-x-outdoor-vandalproof-domes-8ch-nvr",
            "8mp-8ch-hikvision-cctv-kit-6-x-outdoor-turret-black-shadow-series-8ch-nvr"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 4,
          "rankedProductIds": [
            "7591865942073",
            "7591977091129",
            "7591629520953",
            "7591865745465"
          ],
          "rankedProductHandles": [
            "8mp-hikvision-colorvu-cctv-kit-8-x-colorvu-turret-liveguard-cameras-8ch-m-series-nvr-3tb",
            "hikvision-6-cameras-8-channel-cctv-kit-2-x-8mp-colorvu-4-x-6mp-acusense-turret-cameras-8ch-8k-nvr-bundle",
            "8mp-8ch-hikvision-cctv-kit-6-x-outdoor-bullet-cameras-8ch-nvr",
            "8mp-hikvision-colorvu-cctv-kit-6-x-outdoor-8mp-colorvu-turret-cameras-8ch-m-series-nvr-3tb-kit"
          ]
        }
      }
    },
    "6mp-dahua-eyeball-turret-kit": {
      "collectionHandle": "6mp-dahua-eyeball-turret-kit",
      "collectionProductCount": 9,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 7,
          "rankedProductIds": [
            "8168606236729",
            "8168606662713",
            "8168627863609",
            "8168606826553",
            "8168605614137",
            "8168606892089",
            "8168605155385"
          ],
          "rankedProductHandles": [
            "dahua-6mp-8ch-cctv-kit-6x-smart-dual-light-turret-cameras-with-smd-4-0-mic-8ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4108hs-8p-ai-anz",
            "dahua-6mp-8ch-cctv-kit-8x-smart-dual-light-turret-cameras-with-smd-4-0-mic-8ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4108hs-8p-ai-anz",
            "dahua-6mp-4ch-cctv-kit-4x-smart-dual-light-turret-cameras-with-smd-4-0-mic-4ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4104hs-4p-ai-anz",
            "dahua-6mp-16ch-cctv-kit-8x-smart-dual-light-turret-cameras-with-smd-4-0-mic-16ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4216-16p-ai-anz",
            "dahua-6mp-8ch-cctv-kit-4x-smart-dual-light-turret-cameras-with-smd-4-0-mic-8ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4108hs-8p-ai-anz",
            "dahua-6mp-16ch-cctv-kit-10x-smart-dual-light-turret-cameras-with-smd-4-0-mic-16ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4216-16p-ai-anz",
            "dahua-6mp-4ch-cctv-kit-2x-smart-dual-light-turret-cameras-with-smd-4-0-mic-4ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4104hs-p-ai-anz"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 3,
          "rankedProductIds": [
            "8168606826553",
            "8168606662713",
            "8168606892089"
          ],
          "rankedProductHandles": [
            "dahua-6mp-16ch-cctv-kit-8x-smart-dual-light-turret-cameras-with-smd-4-0-mic-16ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4216-16p-ai-anz",
            "dahua-6mp-8ch-cctv-kit-8x-smart-dual-light-turret-cameras-with-smd-4-0-mic-8ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4108hs-8p-ai-anz",
            "dahua-6mp-16ch-cctv-kit-10x-smart-dual-light-turret-cameras-with-smd-4-0-mic-16ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4216-16p-ai-anz"
          ]
        }
      }
    },
    "6mp-dahua-eyeball-turret-kit-1": {
      "collectionHandle": "6mp-dahua-eyeball-turret-kit-1",
      "collectionProductCount": 11,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "6mp-hikvision-bullet": {
      "collectionHandle": "6mp-hikvision-bullet",
      "collectionProductCount": 22,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 7,
          "rankedProductIds": [
            "8168618262585",
            "7591938981945",
            "8168598569017",
            "8168601190457",
            "7591903199289",
            "8168598700089",
            "7591901823033"
          ],
          "rankedProductHandles": [
            "hikvision-2cd3666g2ht-lizsy-6mp-acusense-smart-hybrid-bullet-camera-with-varifocal-2-7-13-5mm-lens-darkfighter-ir-60m",
            "hikvision-ds-2cd2t67g2h-li-6mp-smart-hybrid-light-colorvu-bullet-camera-black",
            "hikvision-ds-2cd2t66g2h-4i-6-mp-colorvu-hybrid-bullet-camera-4-mm-lens-80-m-ir-black-white",
            "hikvision-ds-2cd2t67g3-lis2uy-sl-6mp-colorvu-3-0-bullet-camera-white",
            "hikvision-ds-2cd2667g2ht-6mp-smart-hybrid-light-colorvu-motorised-vf-bullet-camera-2-8-12-mm",
            "hikvision-ds-2cd2t66g2h-2i-6-mp-colorvu-hybrid-bullet-camera-60-m-ir-black-white",
            "hikvision-ds-2cd2367g2h-liu-6mp-smart-hybrid-light-colorvu-turret-camera-2-8mm"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 11,
          "rankedProductIds": [
            "8168616165433",
            "8168600338489",
            "8168601190457",
            "8168618000441",
            "7591903199289",
            "8168618262585",
            "8168581169209",
            "7591938981945",
            "7591901823033",
            "7591784742969",
            "7591796080697"
          ],
          "rankedProductHandles": [
            "hikvision-6mp-mini-bullet-colorvu-3-0-strobe-audio-ds-2cd2067g3-li2uy-sl",
            "hikvision-ds-2cd3667g3-lizsuy-sl-6mp-colorvu-varifocal-bullet-camera-smart-hybrid-light",
            "hikvision-ds-2cd2t67g3-lis2uy-sl-6mp-colorvu-3-0-bullet-camera-white",
            "hikvision-6mp-acusense-2cd2t66g2h-is2u-sl-bullet-camera-with-audio-strobe-light-2-8mm-lens-ir-60m",
            "hikvision-ds-2cd2667g2ht-6mp-smart-hybrid-light-colorvu-motorised-vf-bullet-camera-2-8-12-mm",
            "hikvision-2cd3666g2ht-lizsy-6mp-acusense-smart-hybrid-bullet-camera-with-varifocal-2-7-13-5mm-lens-darkfighter-ir-60m",
            "hikvision-colorvu-2cd2t67g2p-lsu-sl-6mp-dual-lens-stobe-audio-bullet-camera2-8mm-mic",
            "hikvision-ds-2cd2t67g2h-li-6mp-smart-hybrid-light-colorvu-bullet-camera-black",
            "hikvision-ds-2cd2367g2h-liu-6mp-smart-hybrid-light-colorvu-turret-camera-2-8mm",
            "hikvision-ds-2cd2t66g2-2i-acusense-6mp-exir-outdoor-bullet-cctv-camera-up-to-60m-ir",
            "hikvision-ds-2cd2666g1-izs-6mp-outdoor-acusense-gen-2-motorised-bullet-camera"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 4,
          "rankedProductIds": [
            "7591903199289",
            "8168618262585",
            "8168600338489",
            "7591796080697"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd2667g2ht-6mp-smart-hybrid-light-colorvu-motorised-vf-bullet-camera-2-8-12-mm",
            "hikvision-2cd3666g2ht-lizsy-6mp-acusense-smart-hybrid-bullet-camera-with-varifocal-2-7-13-5mm-lens-darkfighter-ir-60m",
            "hikvision-ds-2cd3667g3-lizsuy-sl-6mp-colorvu-varifocal-bullet-camera-smart-hybrid-light",
            "hikvision-ds-2cd2666g1-izs-6mp-outdoor-acusense-gen-2-motorised-bullet-camera"
          ]
        }
      }
    },
    "6mp-hikvision-dome-cameras": {
      "collectionHandle": "6mp-hikvision-dome-cameras",
      "collectionProductCount": 18,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 3,
          "rankedProductIds": [
            "8168620949561",
            "7591903690809",
            "8168614953017"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd3766g2ht-lizsuy-6mp-smart-hybrid-motorised-dome-camera-with-darkfighter-s-varifocal-2-7-13-5mm-ir-white-light-supplement-up-to-40m-in-white-or-black",
            "hikvision-ds-2cd2767g2ht-6mp-smart-hybrid-light-colorvu-motorised-vf-dome-camera-2-8-12mm",
            "hikvision-ds-2cd2167g3-lis2uy-6mp-smart-hybrid-light-dome-2-8-mm-4-mm-lens-options"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 3,
          "rankedProductIds": [
            "8168412872761",
            "7591777632313",
            "7591674708025"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd2166g2h-isu-6-mp-acusense-darkfighter-fixed-dome-2-8mm-4mm-options-ip67-ik10",
            "hikvision-ds-2cd2166g2-i-6mp-outdoor-dome-cctv-camera-with-acusense",
            "hikvision-ds-2cd2765fwd-izs-6mp-outdoor-motorised-vf-dome-cctv-camera-30m-ir-io-2-8-12mm"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 5,
          "rankedProductIds": [
            "8168620949561",
            "7591903690809",
            "8168615870521",
            "8168394260537",
            "7591674708025"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd3766g2ht-lizsuy-6mp-smart-hybrid-motorised-dome-camera-with-darkfighter-s-varifocal-2-7-13-5mm-ir-white-light-supplement-up-to-40m-in-white-or-black",
            "hikvision-ds-2cd2767g2ht-6mp-smart-hybrid-light-colorvu-motorised-vf-dome-camera-2-8-12mm",
            "hikvision-ds-2cd2766g2t-izs-bnc-blk-6-mp-acusense-motorised-varifocal-dome-w-bnc-output-2-8-12-mm-black",
            "hikvision-ds-2cd2766g2t-izs-bnc-6-mp-acusense-motorised-varifocal-dome-w-bnc-output-2-8-12-mm",
            "hikvision-ds-2cd2765fwd-izs-6mp-outdoor-motorised-vf-dome-cctv-camera-30m-ir-io-2-8-12mm"
          ]
        }
      }
    },
    "6mp-hikvision-mini-bullet": {
      "collectionHandle": "6mp-hikvision-mini-bullet",
      "collectionProductCount": 23,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 3,
          "rankedProductIds": [
            "8168451407929",
            "7591938752569",
            "7591902675001"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd2067g2h-liu-sl-6mp-smart-hybrid-light-colorvu-mini-bullet-camera-2-8mm-4mm",
            "hikvision-ds-2cd2067g2h-6mp-smart-hybrid-light-colorvu-mini-bullet-camera-2-8mm-black",
            "hikvision-ds-2cd2067g2h-6mp-smart-hybrid-light-colorvu-mini-bullet-camera-2-8mm-4mm"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 4,
          "rankedProductIds": [
            "8168616165433",
            "8168611086393",
            "8168404942905",
            "7591938752569"
          ],
          "rankedProductHandles": [
            "hikvision-6mp-mini-bullet-colorvu-3-0-strobe-audio-ds-2cd2067g3-li2uy-sl",
            "hikvision-ds-2cd2066g2h-i2u-sl-6mp-outdoor-acusense-mini-bullet-camera-mic-ir-strobe-audio-alarm-2-8mm-black",
            "hikvision-ds-2cd2066g2h-i2u-sl-6mp-outdoor-acusense-mini-bullet-camera-mic-ir-strobe-audio-alarm-2-8mm",
            "hikvision-ds-2cd2067g2h-6mp-smart-hybrid-light-colorvu-mini-bullet-camera-2-8mm-black"
          ]
        }
      }
    },
    "6mp-hikvision-mini-domes": {
      "collectionHandle": "6mp-hikvision-mini-domes",
      "collectionProductCount": 6,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "6mp-hikvision-packages": {
      "collectionHandle": "6mp-hikvision-packages",
      "collectionProductCount": 23,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 2,
          "rankedProductIds": [
            "7591977091129",
            "7591976304697"
          ],
          "rankedProductHandles": [
            "hikvision-6-cameras-8-channel-cctv-kit-2-x-8mp-colorvu-4-x-6mp-acusense-turret-cameras-8ch-8k-nvr-bundle",
            "hikvision-4-x-6mp-strobe-light-two-way-audio-alarm-cameras-4-channel-nvr-cctv-kit-4-x-colorvu-turret-cameras-4ch-nvr-bundle"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 10,
          "rankedProductIds": [
            "7591976304697",
            "7591977091129",
            "7591705215033",
            "7591623655481",
            "7591585022009",
            "7591698694201",
            "7591584858169",
            "7591976665145",
            "7591647412281",
            "7591647805497"
          ],
          "rankedProductHandles": [
            "hikvision-4-x-6mp-strobe-light-two-way-audio-alarm-cameras-4-channel-nvr-cctv-kit-4-x-colorvu-turret-cameras-4ch-nvr-bundle",
            "hikvision-6-cameras-8-channel-cctv-kit-2-x-8mp-colorvu-4-x-6mp-acusense-turret-cameras-8ch-8k-nvr-bundle",
            "6mp-8ch-hikvision-cctv-kit-8-x-black-outdoor-turret-cameras-8ch-nvr",
            "5mp-4ch-hikvision-cctv-kit-6-x-outdoor-turret-dome-cameras-8ch-nvr",
            "5mp-8ch-hikvision-cctv-kit-6-x-exir-bullet-cameras-8ch-nvr",
            "6mp-4ch-hikvision-cctv-kit-4-x-outdoor-turret-cameras-4ch-nvr",
            "4mp-8ch-hikvision-cctv-kit-8-x-ip-dome-cameras-8ch-nvr",
            "hikvision-2-x-6mp-lifeguard-4-x-6mp-8ch-nvr-cctv-kit-6-turret-cameras-8ch-8k-nvr-bundle",
            "6mp-4ch-hikvision-cctv-kit-2-x-ip-dome-cameras-4ch-nvr",
            "6mp-4ch-hikvision-cctv-kit-2-x-outdoor-turret-cameras-4ch-nvr"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 7,
          "rankedProductIds": [
            "7591705215033",
            "7591794147385",
            "7591977091129",
            "7591976140857",
            "7591627882553",
            "7591584956473",
            "7591584858169"
          ],
          "rankedProductHandles": [
            "6mp-8ch-hikvision-cctv-kit-8-x-black-outdoor-turret-cameras-8ch-nvr",
            "6mp-8ch-hikvision-cctv-kit-8-x-outdoor-turret-cameras-with-acusense-8ch-nvr",
            "hikvision-6-cameras-8-channel-cctv-kit-2-x-8mp-colorvu-4-x-6mp-acusense-turret-cameras-8ch-8k-nvr-bundle",
            "hikvision-10-x-6mp-acusense-turret-camera-and-16-channel-nvr-cctv-kit",
            "5mp-8ch-hikvision-cctv-kit-8-x-mini-bullet-cameras-8ch-nvr",
            "5mp-8ch-hikvision-cctv-kit-8-x-exir-bullet-cameras-8ch-nvr",
            "4mp-8ch-hikvision-cctv-kit-8-x-ip-dome-cameras-8ch-nvr"
          ]
        }
      }
    },
    "6mp-hikvision-special-cameras": {
      "collectionHandle": "6mp-hikvision-special-cameras",
      "collectionProductCount": 1,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "6mp-hikvision-turret-cameras": {
      "collectionHandle": "6mp-hikvision-turret-cameras",
      "collectionProductCount": 58,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 6,
          "rankedProductIds": [
            "8168431222841",
            "8168610955321",
            "7591902216249",
            "8284554297401",
            "7591905394745",
            "8168621506617"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd2367g2h-lisu-sl-6mp-smart-hybrid-light-colorvu-turret-camera-2-8mm-strobe-speaker-black",
            "hikvision-ds-2cd3h67g3-lizsuy-s-6mp-deep-learning-motorised-varifocal-turret-colorvu-3-0security-camera",
            "hikvision-ds-2cd2367g2h-liu-8mp-4k-smart-hybrid-light-colorvu-turret-camera-2-8mm-4mm",
            "hikvision-ds-2cd3h86g3-lizsuy-sl-8mp-dual-illumination-motorised-turret-camera-with-strobe-siren",
            "hikvision-ds-2cd2367g2h-lisu-sl-6mp-smart-hybrid-light-colorvu-turret-camera-2-8mm-strobe-speaker",
            "hikvision-ds-2cd3h66g3-lizsuy-sl-6mp-dual-illumination-turret-camera-with-strobe-light-audio-alarm-motorised-varifocal-2-7-13-5mm-ir-white-light-up-to-40m"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 13,
          "rankedProductIds": [
            "7591855751225",
            "8284554297401",
            "8168431222841",
            "8168621506617",
            "8168610955321",
            "7591905394745",
            "8168617345081",
            "8168610431033",
            "7591792771129",
            "7591776583737",
            "7591805091897",
            "7591792672825",
            "7591624966201"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd2367g2p-lsu-sl-6mp-colorvu-turret-dual-head-strobe-speaker-network-camera",
            "hikvision-ds-2cd3h86g3-lizsuy-sl-8mp-dual-illumination-motorised-turret-camera-with-strobe-siren",
            "hikvision-ds-2cd2367g2h-lisu-sl-6mp-smart-hybrid-light-colorvu-turret-camera-2-8mm-strobe-speaker-black",
            "hikvision-ds-2cd3h66g3-lizsuy-sl-6mp-dual-illumination-turret-camera-with-strobe-light-audio-alarm-motorised-varifocal-2-7-13-5mm-ir-white-light-up-to-40m",
            "hikvision-ds-2cd3h67g3-lizsuy-s-6mp-deep-learning-motorised-varifocal-turret-colorvu-3-0security-camera",
            "hikvision-ds-2cd2367g2h-lisu-sl-6mp-smart-hybrid-light-colorvu-turret-camera-2-8mm-strobe-speaker",
            "hikvision-ds-2cd2366g2h-is2u-sl-blk-6mp-acusense-turret-camera-2-8mm-strobe-siren-black",
            "hikvision-ds-2cd2366g2h-is2u-sl-6mp-acusense-turret-camera-2-8mm-strobe-siren-white-or-black",
            "hikvision-acusense-ds-2cd2366g2-isu-sl-ip-camera-6mp-with-warning-strobe-turret-network-camera-black",
            "hikvision-acusense-ds-2cd2366g2-isu-sl-ip-camera-6mp-with-warning-strobe-turret-network-camera",
            "hikvision-acusense-ds-2cd2366g2-iu-ip-camera-6mp-turret-network-camera-white",
            "hikvision-acusense-ds-2cd2366g2-iu-ip-camera-6mp-turret-network-camera-black",
            "hikvision-hik-2cd2h55fwd-izs-5mp-outdoor-motorised-vf-dome-h-265-30m-ir-io-wdr-ip67-2-8-12mm"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 4,
          "rankedProductIds": [
            "8284554297401",
            "8168621506617",
            "8168610955321",
            "7591624966201"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd3h86g3-lizsuy-sl-8mp-dual-illumination-motorised-turret-camera-with-strobe-siren",
            "hikvision-ds-2cd3h66g3-lizsuy-sl-6mp-dual-illumination-turret-camera-with-strobe-light-audio-alarm-motorised-varifocal-2-7-13-5mm-ir-white-light-up-to-40m",
            "hikvision-ds-2cd3h67g3-lizsuy-s-6mp-deep-learning-motorised-varifocal-turret-colorvu-3-0security-camera",
            "hikvision-hik-2cd2h55fwd-izs-5mp-outdoor-motorised-vf-dome-h-265-30m-ir-io-wdr-ip67-2-8-12mm"
          ]
        }
      }
    },
    "6mp-hikvision-varifocal": {
      "collectionHandle": "6mp-hikvision-varifocal",
      "collectionProductCount": 8,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 4,
          "rankedProductIds": [
            "8168618262585",
            "8168620949561",
            "7591903690809",
            "7591903199289"
          ],
          "rankedProductHandles": [
            "hikvision-2cd3666g2ht-lizsy-6mp-acusense-smart-hybrid-bullet-camera-with-varifocal-2-7-13-5mm-lens-darkfighter-ir-60m",
            "hikvision-ds-2cd3766g2ht-lizsuy-6mp-smart-hybrid-motorised-dome-camera-with-darkfighter-s-varifocal-2-7-13-5mm-ir-white-light-supplement-up-to-40m-in-white-or-black",
            "hikvision-ds-2cd2767g2ht-6mp-smart-hybrid-light-colorvu-motorised-vf-dome-camera-2-8-12mm",
            "hikvision-ds-2cd2667g2ht-6mp-smart-hybrid-light-colorvu-motorised-vf-bullet-camera-2-8-12-mm"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 6,
          "rankedProductIds": [
            "8168600338489",
            "8168618262585",
            "7591903199289",
            "7591817674809",
            "7591674708025",
            "7591624966201"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd3667g3-lizsuy-sl-6mp-colorvu-varifocal-bullet-camera-smart-hybrid-light",
            "hikvision-2cd3666g2ht-lizsy-6mp-acusense-smart-hybrid-bullet-camera-with-varifocal-2-7-13-5mm-lens-darkfighter-ir-60m",
            "hikvision-ds-2cd2667g2ht-6mp-smart-hybrid-light-colorvu-motorised-vf-bullet-camera-2-8-12-mm",
            "hikvision-ds-2cd2h66g2t-izs-6mp-outdoor-motorised-vf-turret-cctv-camera-2-8-12mm-with-acusense",
            "hikvision-ds-2cd2765fwd-izs-6mp-outdoor-motorised-vf-dome-cctv-camera-30m-ir-io-2-8-12mm",
            "hikvision-hik-2cd2h55fwd-izs-5mp-outdoor-motorised-vf-dome-h-265-30m-ir-io-wdr-ip67-2-8-12mm"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 4,
          "rankedProductIds": [
            "8168618262585",
            "8168600338489",
            "7591903199289",
            "8168620949561"
          ],
          "rankedProductHandles": [
            "hikvision-2cd3666g2ht-lizsy-6mp-acusense-smart-hybrid-bullet-camera-with-varifocal-2-7-13-5mm-lens-darkfighter-ir-60m",
            "hikvision-ds-2cd3667g3-lizsuy-sl-6mp-colorvu-varifocal-bullet-camera-smart-hybrid-light",
            "hikvision-ds-2cd2667g2ht-6mp-smart-hybrid-light-colorvu-motorised-vf-bullet-camera-2-8-12-mm",
            "hikvision-ds-2cd3766g2ht-lizsuy-6mp-smart-hybrid-motorised-dome-camera-with-darkfighter-s-varifocal-2-7-13-5mm-ir-white-light-supplement-up-to-40m-in-white-or-black"
          ]
        }
      }
    },
    "6mp-ir-bullet-cameras-1": {
      "collectionHandle": "6mp-ir-bullet-cameras-1",
      "collectionProductCount": 1,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "8-cameras-nvr-package-1": {
      "collectionHandle": "8-cameras-nvr-package-1",
      "collectionProductCount": 29,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 2,
          "rankedProductIds": [
            "7591629750329",
            "8168573075513"
          ],
          "rankedProductHandles": [
            "8mp-8ch-hikvision-cctv-kit-8-x-outdoor-bullet-cameras-8ch-nvr",
            "8mp-hikvision-colorvu-3-0-hybrid-cctv-kit-8-x-liveguard-cameras-8ch-m-series-nvr-4tb"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 18,
          "rankedProductIds": [
            "8284566224953",
            "8284561047609",
            "8284560621625",
            "8284469624889",
            "8284564815929",
            "7591808729145",
            "7591807975481",
            "8284473950265",
            "7591808467001",
            "7591720222777",
            "7591808598073",
            "7591733395513",
            "8168391802937",
            "7591722549305",
            "7591629750329",
            "7591705215033",
            "7591584858169",
            "8168573075513"
          ],
          "rankedProductHandles": [
            "hikvision-8-camera-8mp-acusense-security-kit-with-ds-7608ni-m2-8p-8ch-8-poe-8k-nvr-8x-ds-2cd2086g2h-i2u-sl-fixed-bullet-cameras-2-way-audio-active-strobe-light-no-hdd-included",
            "hikvision-6mp-8ch-cctv-kit-6x-black-liveguard-acusense-turret-cameras-with-strobe-audio-smart-light-8ch-poe-nvr-4tb-ds-2cd2366g2h-is2u-sl-blk-ds-7608ni-m2-8p",
            "hikvision-6mp-8ch-cctv-kit-4x-black-liveguard-acusense-turret-cameras-with-strobe-audio-smart-light-4ch-poe-nvr-ds-2cd2366g2h-is2u-sl-blk-ds-7604ni-m1-4p",
            "hikvision-6mp-8ch-cctv-kit-8x-black-liveguard-acusense-turret-cameras-with-strobe-audio-smart-light-8ch-poe-nvr-4tb-ds-2cd2366g2h-is2u-sl-blk-ds-7608ni-m2-8p",
            "hikvision-8-camera-kit-with-ds-7608ni-m2-8p-8ch-poe-8k-nvr-8x-6mp-colorvu-ds-2cd2067g3-li2uy-sl-mini-bullet-cameras-4tb-hdd-included",
            "hikvision-8mp-acusense-6-x-outdoor-turret-with-strobe-siren-8ch-nvr-cctv-kit-black",
            "hikvision-8mp-acusense-8-x-outdoor-turret-with-strobe-siren-16ch-nvr-cctv-kit",
            "hikvision-8mp-acusense-4-x-outdoor-turret-with-strobe-siren-4ch-nvr-cctv-kit",
            "hikvision-8mp-acusense-8-x-outdoor-turret-with-strobe-siren-16ch-nvr-cctv-kit-white",
            "hikvision-8mp-acusense-8-x-outdoor-turret-with-strobe-siren-8ch-nvr-cctv-kit",
            "hikvision-8mp-acusense-4-x-outdoor-turret-with-strobe-siren-8ch-nvr-cctv-kit-black",
            "hikvision-8mp-acusense-6-x-outdoor-turret-with-strobe-siren-8ch-nvr-cctv-kit",
            "8mp-8ch-hikvision-cctv-kit-8-x-outdoor-turret-cameras-8ch-nvr",
            "hikvision-8mp-acusense-4-x-outdoor-turret-with-strobe-siren-8ch-nvr-cctv-kit",
            "8mp-8ch-hikvision-cctv-kit-8-x-outdoor-bullet-cameras-8ch-nvr",
            "6mp-8ch-hikvision-cctv-kit-8-x-black-outdoor-turret-cameras-8ch-nvr",
            "4mp-8ch-hikvision-cctv-kit-8-x-ip-dome-cameras-8ch-nvr",
            "8mp-hikvision-colorvu-3-0-hybrid-cctv-kit-8-x-liveguard-cameras-8ch-m-series-nvr-4tb"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 18,
          "rankedProductIds": [
            "8168391802937",
            "8284566224953",
            "7591629750329",
            "7591778025529",
            "8168573075513",
            "8168414511161",
            "8284589654073",
            "7591808729145",
            "8284462317625",
            "7591807975481",
            "8284473950265",
            "7591808467001",
            "7591720222777",
            "7591808598073",
            "7591733395513",
            "7591630635065",
            "7591722549305",
            "7591625523257"
          ],
          "rankedProductHandles": [
            "8mp-8ch-hikvision-cctv-kit-8-x-outdoor-turret-cameras-8ch-nvr",
            "hikvision-8-camera-8mp-acusense-security-kit-with-ds-7608ni-m2-8p-8ch-8-poe-8k-nvr-8x-ds-2cd2086g2h-i2u-sl-fixed-bullet-cameras-2-way-audio-active-strobe-light-no-hdd-included",
            "8mp-8ch-hikvision-cctv-kit-8-x-outdoor-bullet-cameras-8ch-nvr",
            "8mp-8ch-hikvision-cctv-kit-8-x-outdoor-acusense-turret-cameras-16ch-nvr-with-3tb",
            "8mp-hikvision-colorvu-3-0-hybrid-cctv-kit-8-x-liveguard-cameras-8ch-m-series-nvr-4tb",
            "8mp-16ch-hikvision-cctv-kit-8-x-outdoor-acusense-turret-cameras-16ch-nvr-with-4tb",
            "hikvision-10-camera-8mp-acusense-ds-2cd2386g2h-iu-turret-kit-with-ds-7616ni-m2-16p-16ch-poe-8k-nvr-no-hdd-included",
            "hikvision-8mp-acusense-6-x-outdoor-turret-with-strobe-siren-8ch-nvr-cctv-kit-black",
            "build-your-own-hikvision-kit",
            "hikvision-8mp-acusense-8-x-outdoor-turret-with-strobe-siren-16ch-nvr-cctv-kit",
            "hikvision-8mp-acusense-4-x-outdoor-turret-with-strobe-siren-4ch-nvr-cctv-kit",
            "hikvision-8mp-acusense-8-x-outdoor-turret-with-strobe-siren-16ch-nvr-cctv-kit-white",
            "hikvision-8mp-acusense-8-x-outdoor-turret-with-strobe-siren-8ch-nvr-cctv-kit",
            "hikvision-8mp-acusense-4-x-outdoor-turret-with-strobe-siren-8ch-nvr-cctv-kit-black",
            "hikvision-8mp-acusense-6-x-outdoor-turret-with-strobe-siren-8ch-nvr-cctv-kit",
            "8mp-8ch-hikvision-cctv-kit-8-x-outdoor-turret-black-shadow-series-8ch-nvr",
            "hikvision-8mp-acusense-4-x-outdoor-turret-with-strobe-siren-8ch-nvr-cctv-kit",
            "8mp-8ch-hikvision-cctv-kit-8-x-outdoor-vandalproof-domes-8ch-nvr"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 14,
          "rankedProductIds": [
            "8284589654073",
            "8168391802937",
            "8284566224953",
            "7591778025529",
            "8324154130489",
            "7591629750329",
            "8284564815929",
            "8168414511161",
            "8284469624889",
            "7591794147385",
            "7591705215033",
            "7591584956473",
            "7591627882553",
            "7591584858169"
          ],
          "rankedProductHandles": [
            "hikvision-10-camera-8mp-acusense-ds-2cd2386g2h-iu-turret-kit-with-ds-7616ni-m2-16p-16ch-poe-8k-nvr-no-hdd-included",
            "8mp-8ch-hikvision-cctv-kit-8-x-outdoor-turret-cameras-8ch-nvr",
            "hikvision-8-camera-8mp-acusense-security-kit-with-ds-7608ni-m2-8p-8ch-8-poe-8k-nvr-8x-ds-2cd2086g2h-i2u-sl-fixed-bullet-cameras-2-way-audio-active-strobe-light-no-hdd-included",
            "8mp-8ch-hikvision-cctv-kit-8-x-outdoor-acusense-turret-cameras-16ch-nvr-with-3tb",
            "hikvision-6mp-8ch-cctv-kit-8x-darkfighter-bullet-cameras-with-acusense-8ch-poe-nvr-with-no-hdd-ds-2cd2t66g2h-2i-ds-7608ni-m2-8p",
            "8mp-8ch-hikvision-cctv-kit-8-x-outdoor-bullet-cameras-8ch-nvr",
            "hikvision-8-camera-kit-with-ds-7608ni-m2-8p-8ch-poe-8k-nvr-8x-6mp-colorvu-ds-2cd2067g3-li2uy-sl-mini-bullet-cameras-4tb-hdd-included",
            "8mp-16ch-hikvision-cctv-kit-8-x-outdoor-acusense-turret-cameras-16ch-nvr-with-4tb",
            "hikvision-6mp-8ch-cctv-kit-8x-black-liveguard-acusense-turret-cameras-with-strobe-audio-smart-light-8ch-poe-nvr-4tb-ds-2cd2366g2h-is2u-sl-blk-ds-7608ni-m2-8p",
            "6mp-8ch-hikvision-cctv-kit-8-x-outdoor-turret-cameras-with-acusense-8ch-nvr",
            "6mp-8ch-hikvision-cctv-kit-8-x-black-outdoor-turret-cameras-8ch-nvr",
            "5mp-8ch-hikvision-cctv-kit-8-x-exir-bullet-cameras-8ch-nvr",
            "5mp-8ch-hikvision-cctv-kit-8-x-mini-bullet-cameras-8ch-nvr",
            "4mp-8ch-hikvision-cctv-kit-8-x-ip-dome-cameras-8ch-nvr"
          ]
        }
      }
    },
    "8-megapixel-ptz-cameras-1": {
      "collectionHandle": "8-megapixel-ptz-cameras-1",
      "collectionProductCount": 7,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 2,
          "rankedProductIds": [
            "8284591095865",
            "7591775174713"
          ],
          "rankedProductHandles": [
            "hikvision-6mp-8mp-tandemvu-ultra-ds-2sf8c848mxg1-elwy-26-ptz-camera-with-colorvu-26x-optical-zoom-ir-500m",
            "hikvision-ds-2df8a836ix-ael"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 2,
          "rankedProductIds": [
            "8284591095865",
            "7591607730233"
          ],
          "rankedProductHandles": [
            "hikvision-6mp-8mp-tandemvu-ultra-ds-2sf8c848mxg1-elwy-26-ptz-camera-with-colorvu-26x-optical-zoom-ir-500m",
            "hikvision-hik-2df8836ivael-8mp-4k-ptz-camera-36x-zoom-200m-ir-ip66-ik10-hi-poe24vac"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 4,
          "rankedProductIds": [
            "8168572158009",
            "7591842611257",
            "7591773274169",
            "7591607730233"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2df8c842ixg1-elwy",
            "hikvision-ds-2df8c835mhs-delw-8mp-4k-ptz-camera-35x-zoom-up-to-300m-ir-ip66-ik10-hi-poe-24vac",
            "hikvision-ds-2df8c842ixs-aelw-4k-ptz-camera-42x-zoom-up-to-500m-ir-ip66-ik10-hi-poe-24vac",
            "hikvision-hik-2df8836ivael-8mp-4k-ptz-camera-36x-zoom-200m-ir-ip66-ik10-hi-poe24vac"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 4,
          "rankedProductIds": [
            "7591842611257",
            "7591773274169",
            "7591607730233",
            "7591775174713"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2df8c835mhs-delw-8mp-4k-ptz-camera-35x-zoom-up-to-300m-ir-ip66-ik10-hi-poe-24vac",
            "hikvision-ds-2df8c842ixs-aelw-4k-ptz-camera-42x-zoom-up-to-500m-ir-ip66-ik10-hi-poe-24vac",
            "hikvision-hik-2df8836ivael-8mp-4k-ptz-camera-36x-zoom-200m-ir-ip66-ik10-hi-poe24vac",
            "hikvision-ds-2df8a836ix-ael"
          ]
        }
      }
    },
    "8mp-4k-hikvision-packages": {
      "collectionHandle": "8mp-4k-hikvision-packages",
      "collectionProductCount": 33,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 13,
          "rankedProductIds": [
            "7591918174265",
            "7591865745465",
            "7591976927289",
            "7591918436409",
            "7591977091129",
            "7591918043193",
            "7591629520953",
            "7591629750329",
            "7591976435769",
            "7591629389881",
            "7591865942073",
            "7591865614393",
            "7591918600249"
          ],
          "rankedProductHandles": [
            "8mp-hikvision-colorvu-hybrid-cctv-kit-6-x-liveguard-cameras-8ch-m-series-nvr-3tb",
            "8mp-hikvision-colorvu-cctv-kit-6-x-outdoor-8mp-colorvu-turret-cameras-8ch-m-series-nvr-3tb-kit",
            "hikvision-4-x-8mp-cameras-8-channel-nvr-cctv-kit-4-x-colorvu-turret-cameras-8ch-8k-nvr-bundle",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-8-x-liveguard-cameras-8ch-m-series-nvr-3tb",
            "hikvision-6-cameras-8-channel-cctv-kit-2-x-8mp-colorvu-4-x-6mp-acusense-turret-cameras-8ch-8k-nvr-bundle",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-4-x-liveguard-cameras-8ch-m-series-nvr-3tb",
            "8mp-8ch-hikvision-cctv-kit-6-x-outdoor-bullet-cameras-8ch-nvr",
            "8mp-8ch-hikvision-cctv-kit-8-x-outdoor-bullet-cameras-8ch-nvr",
            "hikvision-4-x-8mp-strobe-light-two-way-audio-alarm-cameras-8-channel-nvr-cctv-kit-4-x-colorvu-turret-cameras-8ch-8k-nvr-bundle",
            "8mp-4ch-hikvision-cctv-kit-4-x-outdoor-bullet-cameras-4ch-nvr",
            "8mp-hikvision-colorvu-cctv-kit-8-x-colorvu-turret-liveguard-cameras-8ch-m-series-nvr-3tb",
            "8mp-hikvision-colorvu-cctv-kit-4-x-outdoor-8mp-colorvu-turret-cameras-8ch-m-series-nvr-3tb-kit",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-10-x-liveguard-cameras-16ch-m-series-nvr-3tb"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 15,
          "rankedProductIds": [
            "7591976435769",
            "7591808729145",
            "7591918174265",
            "7591733395513",
            "7591865745465",
            "7591720222777",
            "7591918436409",
            "7591865942073",
            "7591865614393",
            "7591918043193",
            "7591807975481",
            "7591808467001",
            "7591808598073",
            "7591722549305",
            "7591918600249"
          ],
          "rankedProductHandles": [
            "hikvision-4-x-8mp-strobe-light-two-way-audio-alarm-cameras-8-channel-nvr-cctv-kit-4-x-colorvu-turret-cameras-8ch-8k-nvr-bundle",
            "hikvision-8mp-acusense-6-x-outdoor-turret-with-strobe-siren-8ch-nvr-cctv-kit-black",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-6-x-liveguard-cameras-8ch-m-series-nvr-3tb",
            "hikvision-8mp-acusense-6-x-outdoor-turret-with-strobe-siren-8ch-nvr-cctv-kit",
            "8mp-hikvision-colorvu-cctv-kit-6-x-outdoor-8mp-colorvu-turret-cameras-8ch-m-series-nvr-3tb-kit",
            "hikvision-8mp-acusense-8-x-outdoor-turret-with-strobe-siren-8ch-nvr-cctv-kit",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-8-x-liveguard-cameras-8ch-m-series-nvr-3tb",
            "8mp-hikvision-colorvu-cctv-kit-8-x-colorvu-turret-liveguard-cameras-8ch-m-series-nvr-3tb",
            "8mp-hikvision-colorvu-cctv-kit-4-x-outdoor-8mp-colorvu-turret-cameras-8ch-m-series-nvr-3tb-kit",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-4-x-liveguard-cameras-8ch-m-series-nvr-3tb",
            "hikvision-8mp-acusense-8-x-outdoor-turret-with-strobe-siren-16ch-nvr-cctv-kit",
            "hikvision-8mp-acusense-8-x-outdoor-turret-with-strobe-siren-16ch-nvr-cctv-kit-white",
            "hikvision-8mp-acusense-4-x-outdoor-turret-with-strobe-siren-8ch-nvr-cctv-kit-black",
            "hikvision-8mp-acusense-4-x-outdoor-turret-with-strobe-siren-8ch-nvr-cctv-kit",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-10-x-liveguard-cameras-16ch-m-series-nvr-3tb"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 32,
          "rankedProductIds": [
            "7591977254969",
            "7591977418809",
            "7591808729145",
            "7591977091129",
            "7591976435769",
            "7591918174265",
            "7591733395513",
            "7591629520953",
            "7591865745465",
            "7591976927289",
            "7591720222777",
            "7591630635065",
            "7591629750329",
            "7591625162809",
            "7591918436409",
            "7591625523257",
            "7591865942073",
            "7591865614393",
            "7591621099577",
            "7591621656633",
            "7591918043193",
            "7591807844409",
            "7591778025529",
            "7591807975481",
            "7591629389881",
            "7591808467001",
            "7591808598073",
            "7591628734521",
            "7591722549305",
            "7591807582265",
            "7591630340153",
            "7591918600249"
          ],
          "rankedProductHandles": [
            "hikvision-6-x-8mp-cameras-8-channel-nvr-cctv-kit-6-acusense-turret-cameras-8ch-8k-nvr-bundle",
            "hikvision-4-x-8mp-cameras-4ch-nvr-cctv-kit-4-acusense-turret-cameras-4ch-4k-nvr",
            "hikvision-8mp-acusense-6-x-outdoor-turret-with-strobe-siren-8ch-nvr-cctv-kit-black",
            "hikvision-6-cameras-8-channel-cctv-kit-2-x-8mp-colorvu-4-x-6mp-acusense-turret-cameras-8ch-8k-nvr-bundle",
            "hikvision-4-x-8mp-strobe-light-two-way-audio-alarm-cameras-8-channel-nvr-cctv-kit-4-x-colorvu-turret-cameras-8ch-8k-nvr-bundle",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-6-x-liveguard-cameras-8ch-m-series-nvr-3tb",
            "hikvision-8mp-acusense-6-x-outdoor-turret-with-strobe-siren-8ch-nvr-cctv-kit",
            "8mp-8ch-hikvision-cctv-kit-6-x-outdoor-bullet-cameras-8ch-nvr",
            "8mp-hikvision-colorvu-cctv-kit-6-x-outdoor-8mp-colorvu-turret-cameras-8ch-m-series-nvr-3tb-kit",
            "hikvision-4-x-8mp-cameras-8-channel-nvr-cctv-kit-4-x-colorvu-turret-cameras-8ch-8k-nvr-bundle",
            "hikvision-8mp-acusense-8-x-outdoor-turret-with-strobe-siren-8ch-nvr-cctv-kit",
            "8mp-8ch-hikvision-cctv-kit-8-x-outdoor-turret-black-shadow-series-8ch-nvr",
            "8mp-8ch-hikvision-cctv-kit-8-x-outdoor-bullet-cameras-8ch-nvr",
            "8mp-8ch-hikvision-cctv-kit-6-x-outdoor-vandalproof-domes-8ch-nvr",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-8-x-liveguard-cameras-8ch-m-series-nvr-3tb",
            "8mp-8ch-hikvision-cctv-kit-8-x-outdoor-vandalproof-domes-8ch-nvr",
            "8mp-hikvision-colorvu-cctv-kit-8-x-colorvu-turret-liveguard-cameras-8ch-m-series-nvr-3tb",
            "8mp-hikvision-colorvu-cctv-kit-4-x-outdoor-8mp-colorvu-turret-cameras-8ch-m-series-nvr-3tb-kit",
            "8mp-4ch-hikvision-cctv-kit-4-x-outdoor-turret-cameras-4ch-nvr",
            "8mp-4ch-hikvision-vandalproof-dome-cctv-kit",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-4-x-liveguard-cameras-8ch-m-series-nvr-3tb",
            "8mp-4ch-hikvision-cctv-kit-4-x-outdoor-turret-black-shadow-series-8ch-nvr",
            "8mp-8ch-hikvision-cctv-kit-8-x-outdoor-acusense-turret-cameras-16ch-nvr-with-3tb",
            "hikvision-8mp-acusense-8-x-outdoor-turret-with-strobe-siren-16ch-nvr-cctv-kit",
            "8mp-4ch-hikvision-cctv-kit-4-x-outdoor-bullet-cameras-4ch-nvr",
            "hikvision-8mp-acusense-8-x-outdoor-turret-with-strobe-siren-16ch-nvr-cctv-kit-white",
            "hikvision-8mp-acusense-4-x-outdoor-turret-with-strobe-siren-8ch-nvr-cctv-kit-black",
            "8mp-4ch-hikvision-cctv-kit-4-x-outdoor-motorised-vf-turrets-4ch-nvr",
            "hikvision-8mp-acusense-4-x-outdoor-turret-with-strobe-siren-8ch-nvr-cctv-kit",
            "8mp-4ch-hikvision-cctv-kit-4-x-outdoor-turret-black-shadow-series-w-acusense-4ch-nvr",
            "8mp-4ch-hikvision-cctv-kit-4-x-outdoor-turret-black-shadow-series-4ch-nvr",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-10-x-liveguard-cameras-16ch-m-series-nvr-3tb"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 18,
          "rankedProductIds": [
            "7591977254969",
            "7591630635065",
            "7591629750329",
            "7591778025529",
            "7591808467001",
            "7591733395513",
            "7591629520953",
            "7591918174265",
            "7591720222777",
            "7591918600249",
            "7591625523257",
            "7591918436409",
            "7591865942073",
            "7591977091129",
            "7591625162809",
            "7591865745465",
            "7591807975481",
            "7591808729145"
          ],
          "rankedProductHandles": [
            "hikvision-6-x-8mp-cameras-8-channel-nvr-cctv-kit-6-acusense-turret-cameras-8ch-8k-nvr-bundle",
            "8mp-8ch-hikvision-cctv-kit-8-x-outdoor-turret-black-shadow-series-8ch-nvr",
            "8mp-8ch-hikvision-cctv-kit-8-x-outdoor-bullet-cameras-8ch-nvr",
            "8mp-8ch-hikvision-cctv-kit-8-x-outdoor-acusense-turret-cameras-16ch-nvr-with-3tb",
            "hikvision-8mp-acusense-8-x-outdoor-turret-with-strobe-siren-16ch-nvr-cctv-kit-white",
            "hikvision-8mp-acusense-6-x-outdoor-turret-with-strobe-siren-8ch-nvr-cctv-kit",
            "8mp-8ch-hikvision-cctv-kit-6-x-outdoor-bullet-cameras-8ch-nvr",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-6-x-liveguard-cameras-8ch-m-series-nvr-3tb",
            "hikvision-8mp-acusense-8-x-outdoor-turret-with-strobe-siren-8ch-nvr-cctv-kit",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-10-x-liveguard-cameras-16ch-m-series-nvr-3tb",
            "8mp-8ch-hikvision-cctv-kit-8-x-outdoor-vandalproof-domes-8ch-nvr",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-8-x-liveguard-cameras-8ch-m-series-nvr-3tb",
            "8mp-hikvision-colorvu-cctv-kit-8-x-colorvu-turret-liveguard-cameras-8ch-m-series-nvr-3tb",
            "hikvision-6-cameras-8-channel-cctv-kit-2-x-8mp-colorvu-4-x-6mp-acusense-turret-cameras-8ch-8k-nvr-bundle",
            "8mp-8ch-hikvision-cctv-kit-6-x-outdoor-vandalproof-domes-8ch-nvr",
            "8mp-hikvision-colorvu-cctv-kit-6-x-outdoor-8mp-colorvu-turret-cameras-8ch-m-series-nvr-3tb-kit",
            "hikvision-8mp-acusense-8-x-outdoor-turret-with-strobe-siren-16ch-nvr-cctv-kit",
            "hikvision-8mp-acusense-6-x-outdoor-turret-with-strobe-siren-8ch-nvr-cctv-kit-black"
          ]
        }
      }
    },
    "8mp-dahua-eyeball-turret-kit": {
      "collectionHandle": "8mp-dahua-eyeball-turret-kit",
      "collectionProductCount": 6,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 2,
          "rankedProductIds": [
            "8168481783865",
            "8168575205433"
          ],
          "rankedProductHandles": [
            "dahua-4-x-8mp-tioc-cctv-kit-full-colour-night-vision-audible-warning-4ch-poe-ai-nvr",
            "dahua-10-x-8mp-dh-ipc-hdw3867em-s-il-anz-fixed-starlight-turret-cameras-16ch-ai-nvr"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 4,
          "rankedProductIds": [
            "8168540536889",
            "8168539357241",
            "8168575205433",
            "8168481783865"
          ],
          "rankedProductHandles": [
            "dahua-8-x-8mp-dh-ipc-hdw3867em-s-il-anz-fixed-starlight-turret-cameras-8ch-ai-nvr",
            "dahua-6-x-dh-ipc-hdw3867em-s-il-anz-starlight-turret-cameras-ai-nvr-cctv-kit",
            "dahua-10-x-8mp-dh-ipc-hdw3867em-s-il-anz-fixed-starlight-turret-cameras-16ch-ai-nvr",
            "dahua-4-x-8mp-tioc-cctv-kit-full-colour-night-vision-audible-warning-4ch-poe-ai-nvr"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 2,
          "rankedProductIds": [
            "8168540536889",
            "8168575205433"
          ],
          "rankedProductHandles": [
            "dahua-8-x-8mp-dh-ipc-hdw3867em-s-il-anz-fixed-starlight-turret-cameras-8ch-ai-nvr",
            "dahua-10-x-8mp-dh-ipc-hdw3867em-s-il-anz-fixed-starlight-turret-cameras-16ch-ai-nvr"
          ]
        }
      }
    },
    "8mp-dahua-eyeball-turret-kit-1": {
      "collectionHandle": "8mp-dahua-eyeball-turret-kit-1",
      "collectionProductCount": 8,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "8mp-dahua-tioc-2-0-kit": {
      "collectionHandle": "8mp-dahua-tioc-2-0-kit",
      "collectionProductCount": 2,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "8mp-dahua-tioc-2-0-kit-1": {
      "collectionHandle": "8mp-dahua-tioc-2-0-kit-1",
      "collectionProductCount": 7,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 4,
          "rankedProductIds": [
            "7591931772985",
            "7591735689273",
            "7591930462265",
            "7591737196601"
          ],
          "rankedProductHandles": [
            "dahua-8-x-8mp-black-tioc-advanced-2-0-with-smd4-0-active-deterrance-turret-kit-with-8ch-wizsense-nvr",
            "dahua-6-x-8mp-dh-ipc-hdw3849hp-as-pv-tioc-with-wizsense-turret-kit-with-8ch-nvr",
            "dahua-4-x-black-8mp-tioc-smd4-0-dh-ipc-hdw3849h-as-pv-anz-turret-kit-with-8ch-nvr",
            "dahua-8-x-8mp-dh-ipc-hdw3849hp-as-pv-tioc-with-wizsense-turret-kit-with-8ch"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 4,
          "rankedProductIds": [
            "7591931772985",
            "7591737196601",
            "7591738966073",
            "7591790706745"
          ],
          "rankedProductHandles": [
            "dahua-8-x-8mp-black-tioc-advanced-2-0-with-smd4-0-active-deterrance-turret-kit-with-8ch-wizsense-nvr",
            "dahua-8-x-8mp-dh-ipc-hdw3849hp-as-pv-tioc-with-wizsense-turret-kit-with-8ch",
            "dahua-4-x-8mp-dh-ipc-hdw3849hp-as-pv-tioc-with-wizsense-turret-kit-with-8ch-nvr",
            "dahua-4-x-6mp-tioc-advanced-2-0-dh-ipc-hdw3649h-as-pv-anz-turret-kit-4ch-nvr"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 4,
          "rankedProductIds": [
            "7591931772985",
            "7591737196601",
            "7591738966073",
            "7591735689273"
          ],
          "rankedProductHandles": [
            "dahua-8-x-8mp-black-tioc-advanced-2-0-with-smd4-0-active-deterrance-turret-kit-with-8ch-wizsense-nvr",
            "dahua-8-x-8mp-dh-ipc-hdw3849hp-as-pv-tioc-with-wizsense-turret-kit-with-8ch",
            "dahua-4-x-8mp-dh-ipc-hdw3849hp-as-pv-tioc-with-wizsense-turret-kit-with-8ch-nvr",
            "dahua-6-x-8mp-dh-ipc-hdw3849hp-as-pv-tioc-with-wizsense-turret-kit-with-8ch-nvr"
          ]
        }
      }
    },
    "8mp-hikvision-bullet-cameras-1": {
      "collectionHandle": "8mp-hikvision-bullet-cameras-1",
      "collectionProductCount": 25,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 15,
          "rankedProductIds": [
            "8168620884025",
            "8168595062841",
            "8168600797241",
            "7591926628409",
            "8168603123769",
            "7591902445625",
            "7591903526969",
            "8168603484217",
            "7591868989497",
            "8168602763321",
            "7591701086265",
            "7591802110009",
            "8168589393977",
            "8168586772537",
            "7591801552953"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd3686g2ht-lizsy-8mp-smart-hybrid-motorised-bullet-camera-with-darkfighter-varifocal-2-7-13-5mm-ir-60m",
            "hikvision-ds-2cd3687g3-lizsuy-sl-8mp-darkfighter-bullet-camera-with-dual-illumination-strobe-light-audio-alarm-2-7-13-5mm",
            "hikvision-ds-2cd3687g3-lizsuy-sl-8mp-darkfighter-bullet-camera-colorvu-strobe-light-audio-alarm-2-7-13-5mm-black",
            "hikvision-ds-2cd2087g2h-liu-sl-8mp-colorvu-mini-bullet-camera-hybrid-light-liveguard-2-8-4mm",
            "hikvision-ds-2cd2t86g2h-4i-bullet-camera-8mp-80m-ir-acusense-darkfighter",
            "hikvision-ds-2cd2t87g2h-8mp-smart-hybrid-light-colorvu-bullet-camera-2-8mm-4mm",
            "hikvision-ds-2cd2687g2ht-8mp-smart-hybrid-light-colorvu-motorised-vf-bullet-camera-2-8-12mm",
            "hikvision-ds-2cd2t86g2h-2i-blk-bullet-camera-8mp-60m-ir-acusense-darkfighter-black",
            "hikvision-8mp-outdoor-colorvu-mini-bullet-camera-hybrid-light-mic-2-8mm",
            "hikvision-ds-2cd2t86g2h-2i-bullet-camera-8-mp-2-8-mm-60-m-ir-acusense-darkfighter",
            "hikvision-ds-2cd2685g1-izs-8mp-outdoor-motorised-vf-bullet-2-8-12mm-with-darkfighter",
            "hikvision-ds-2cd2t86g2-i5-8mp-outdoor-bullet-cctv-camera-50m-ir-powered-by-darkfighter-acusense",
            "hikvision-ds-2cd2t87g3-lis2uy-sl-8mp-colorvu-3-0-bullet-camera-light-speaker-liveguard",
            "hikvision-ds-2cd2087g3-li2uy-8mp-colorvu-3-0-hybrid-mini-bullet-camera",
            "hikvision-ds-2cd2t87g2p-lsu-sl-8mp-colorvu-bullet-4mm-dual-head-strobe-speaker-network-camera"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 10,
          "rankedProductIds": [
            "8168616460345",
            "8168616362041",
            "7591801552953",
            "8168600797241",
            "8168595062841",
            "7591926628409",
            "8168620884025",
            "8168603123769",
            "8168589393977",
            "7591902445625"
          ],
          "rankedProductHandles": [
            "hikvision-8mp-acusense-black-mini-bullet-strobe-audio-ds-2cd2086g2h-i2u-sl-blk-black",
            "hikvision-8mp-acusense-mini-bullet-strobe-audio-ds-2cd2086g2h-i2u-sl",
            "hikvision-ds-2cd2t87g2p-lsu-sl-8mp-colorvu-bullet-4mm-dual-head-strobe-speaker-network-camera",
            "hikvision-ds-2cd3687g3-lizsuy-sl-8mp-darkfighter-bullet-camera-colorvu-strobe-light-audio-alarm-2-7-13-5mm-black",
            "hikvision-ds-2cd3687g3-lizsuy-sl-8mp-darkfighter-bullet-camera-with-dual-illumination-strobe-light-audio-alarm-2-7-13-5mm",
            "hikvision-ds-2cd2087g2h-liu-sl-8mp-colorvu-mini-bullet-camera-hybrid-light-liveguard-2-8-4mm",
            "hikvision-ds-2cd3686g2ht-lizsy-8mp-smart-hybrid-motorised-bullet-camera-with-darkfighter-varifocal-2-7-13-5mm-ir-60m",
            "hikvision-ds-2cd2t86g2h-4i-bullet-camera-8mp-80m-ir-acusense-darkfighter",
            "hikvision-ds-2cd2t87g3-lis2uy-sl-8mp-colorvu-3-0-bullet-camera-light-speaker-liveguard",
            "hikvision-ds-2cd2t87g2h-8mp-smart-hybrid-light-colorvu-bullet-camera-2-8mm-4mm"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 16,
          "rankedProductIds": [
            "8168620884025",
            "8168603123769",
            "7591903526969",
            "8168616460345",
            "8168616362041",
            "7591926628409",
            "8168609316921",
            "8168603484217",
            "8168602763321",
            "8168589393977",
            "8168586772537",
            "8284597813305",
            "7591701086265",
            "7591902445625",
            "7591801552953",
            "7591802110009"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd3686g2ht-lizsy-8mp-smart-hybrid-motorised-bullet-camera-with-darkfighter-varifocal-2-7-13-5mm-ir-60m",
            "hikvision-ds-2cd2t86g2h-4i-bullet-camera-8mp-80m-ir-acusense-darkfighter",
            "hikvision-ds-2cd2687g2ht-8mp-smart-hybrid-light-colorvu-motorised-vf-bullet-camera-2-8-12mm",
            "hikvision-8mp-acusense-black-mini-bullet-strobe-audio-ds-2cd2086g2h-i2u-sl-blk-black",
            "hikvision-8mp-acusense-mini-bullet-strobe-audio-ds-2cd2086g2h-i2u-sl",
            "hikvision-ds-2cd2087g2h-liu-sl-8mp-colorvu-mini-bullet-camera-hybrid-light-liveguard-2-8-4mm",
            "hikvision-ds-2cd2086g2h-iu-8-mp-powered-by-darkfighter-fixed-mini-bullet-network-camera",
            "hikvision-ds-2cd2t86g2h-2i-blk-bullet-camera-8mp-60m-ir-acusense-darkfighter-black",
            "hikvision-ds-2cd2t86g2h-2i-bullet-camera-8-mp-2-8-mm-60-m-ir-acusense-darkfighter",
            "hikvision-ds-2cd2t87g3-lis2uy-sl-8mp-colorvu-3-0-bullet-camera-light-speaker-liveguard",
            "hikvision-ds-2cd2087g3-li2uy-8mp-colorvu-3-0-hybrid-mini-bullet-camera",
            "hikvision-ids-2cd5t87g2-v-xhsy-8mp-deepinviewx-fixed-bullet-camera-with-darkfighter-2-0-perimeter-protection",
            "hikvision-ds-2cd2685g1-izs-8mp-outdoor-motorised-vf-bullet-2-8-12mm-with-darkfighter",
            "hikvision-ds-2cd2t87g2h-8mp-smart-hybrid-light-colorvu-bullet-camera-2-8mm-4mm",
            "hikvision-ds-2cd2t87g2p-lsu-sl-8mp-colorvu-bullet-4mm-dual-head-strobe-speaker-network-camera",
            "hikvision-ds-2cd2t86g2-i5-8mp-outdoor-bullet-cctv-camera-50m-ir-powered-by-darkfighter-acusense"
          ]
        }
      }
    },
    "8mp-hikvision-dome-cameras-1": {
      "collectionHandle": "8mp-hikvision-dome-cameras-1",
      "collectionProductCount": 24,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 6,
          "rankedProductIds": [
            "8168604893241",
            "8168600961081",
            "7690800562233",
            "8168617017401",
            "8168586870841",
            "8168621244473"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd3786g2ht-lizsuy-8mp-smart-hybrid-light-dome-heop-130-db-wdr-dual-illumination-ip67-ik10",
            "hikvision-ds-2cd3787g3t-lizsuy-8-mp-dual-illumination-motorized-varifocal-dome-camera",
            "hikvision-ds-2cd2187g2h-li-8mp-outdoor-colorvu-dome-camera-hybrid-light-mic-2-8mm",
            "hikvision-ds-2cd2187g3-lis2uy-blk-8mp-colorvu-3-0-gen-3-hybrid-dome-camera-black",
            "hikvision-ds-2cd2187g3-lis2uy-8mp-colorvu-3-0-hybrid-dome-camera",
            "hikvision-ds-2cd3787g3t-lizsuy-blk-8mp-colorvu-3-0-dual-illumination-motorised-varifocal-dome-camera-black"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 2,
          "rankedProductIds": [
            "8168617017401",
            "8168604893241"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd2187g3-lis2uy-blk-8mp-colorvu-3-0-gen-3-hybrid-dome-camera-black",
            "hikvision-ds-2cd3786g2ht-lizsuy-8mp-smart-hybrid-light-dome-heop-130-db-wdr-dual-illumination-ip67-ik10"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 13,
          "rankedProductIds": [
            "8168621244473",
            "8168604893241",
            "8168604237881",
            "8168617017401",
            "8284597977145",
            "8168616656953",
            "8168572223545",
            "8168586870841",
            "8168616853561",
            "7591773634617",
            "7591773438009",
            "7591818559545",
            "7591808368697"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd3787g3t-lizsuy-blk-8mp-colorvu-3-0-dual-illumination-motorised-varifocal-dome-camera-black",
            "hikvision-ds-2cd3786g2ht-lizsuy-8mp-smart-hybrid-light-dome-heop-130-db-wdr-dual-illumination-ip67-ik10",
            "hikvision-ids-2cd7586g2-xzhsy-8mp-deepinview-ptrz-motorized-varifocal-dome-darkfighter-2-0-ip67-ik10",
            "hikvision-ds-2cd2187g3-lis2uy-blk-8mp-colorvu-3-0-gen-3-hybrid-dome-camera-black",
            "hikvision-ids-2cd7186g2-izhsy-8mp-deepinview-moto-varifocal-dome-camera-with-8-32mm-lens",
            "hikvision-8mp-acusense-ds-2cd2186g2h-isu-dome-camera-fixed-2-8mm-ir-30m-mic",
            "hikvision-ids-2cd7186g0-izhsy-8mp-deepinview-moto-varifocal-dome-camera",
            "hikvision-ds-2cd2187g3-lis2uy-8mp-colorvu-3-0-hybrid-dome-camera",
            "hikvision-8mp-acusense-ds-2cd2186g2h-isu-blk-dome-camera-fixed-2-8mm-ir-30m-mic-black",
            "hikvision-ds-2cd2186g2-isu-8mp-acusense-outdoor-dome-cctv-camera-30m-ir-2-8mm",
            "hikvision-ds-2cd2186g2-i-8mp-acusense-outdoor-dome-cctv-camera-30m-ir-2-8mm",
            "hikvision-ds-2cd2586g2-is-8mp-outdoor-acusense-mini-dome-cctv-camera-30-ir-with-mic",
            "hikvision-ds-2cd2766g2-izs-6mp-outdoor-acusense-gen-2-motorised-vf-dome-camera-black-shadow-series-2-8-12"
          ]
        }
      }
    },
    "8mp-hikvision-mini-bullet-1": {
      "collectionHandle": "8mp-hikvision-mini-bullet-1",
      "collectionProductCount": 12,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 2,
          "rankedProductIds": [
            "7591902937145",
            "7591802699833"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd2087g2h-8mp-smart-hybrid-light-colorvu-mic-mini-bullet-camera-2-8mm-4mm",
            "hikvision-ds-2cd2t87g2-lsu-sl-8mp-gen2-colorvu-bullet-camera-with-acusense-60m-white-led-siren-strobe"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 5,
          "rankedProductIds": [
            "7591802699833",
            "8168616460345",
            "8168616362041",
            "7591719567417",
            "7591719665721"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd2t87g2-lsu-sl-8mp-gen2-colorvu-bullet-camera-with-acusense-60m-white-led-siren-strobe",
            "hikvision-8mp-acusense-black-mini-bullet-strobe-audio-ds-2cd2086g2h-i2u-sl-blk-black",
            "hikvision-8mp-acusense-mini-bullet-strobe-audio-ds-2cd2086g2h-i2u-sl",
            "hikvision-ds-2cd2086g2-i-8mp-outdoor-acusense-gen-2-mini-bullet-camera-no-speaker-strobe-2-8mm",
            "hikvision-ds-2cd2086g2-i-8mp-outdoor-acusense-gen-2-mini-bullet-camera-no-speaker-strobe-4mm"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 7,
          "rankedProductIds": [
            "7591902937145",
            "8168616460345",
            "8168616362041",
            "8168609316921",
            "7591802699833",
            "7591719567417",
            "7591719665721"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd2087g2h-8mp-smart-hybrid-light-colorvu-mic-mini-bullet-camera-2-8mm-4mm",
            "hikvision-8mp-acusense-black-mini-bullet-strobe-audio-ds-2cd2086g2h-i2u-sl-blk-black",
            "hikvision-8mp-acusense-mini-bullet-strobe-audio-ds-2cd2086g2h-i2u-sl",
            "hikvision-ds-2cd2086g2h-iu-8-mp-powered-by-darkfighter-fixed-mini-bullet-network-camera",
            "hikvision-ds-2cd2t87g2-lsu-sl-8mp-gen2-colorvu-bullet-camera-with-acusense-60m-white-led-siren-strobe",
            "hikvision-ds-2cd2086g2-i-8mp-outdoor-acusense-gen-2-mini-bullet-camera-no-speaker-strobe-2-8mm",
            "hikvision-ds-2cd2086g2-i-8mp-outdoor-acusense-gen-2-mini-bullet-camera-no-speaker-strobe-4mm"
          ]
        }
      }
    },
    "8mp-hikvision-packages": {
      "collectionHandle": "8mp-hikvision-packages",
      "collectionProductCount": 19,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 7,
          "rankedProductIds": [
            "8284589785145",
            "8168572715065",
            "8284554788921",
            "8168573075513",
            "8284554625081",
            "8284589916217",
            "8168572944441"
          ],
          "rankedProductHandles": [
            "hikvision-10-camera-8mp-colorvu-3-0-ds-2cd2387g3-lis2uy-sl-smart-hybrid-light-turret-kit-with-ds-7616ni-m2-16p-16ch-poe-8k-nvr-strobe-speaker-no-hdd-included",
            "8mp-hikvision-colorvu-3-0-hybrid-cctv-kit-4-x-liveguard-cameras-8ch-m-series-nvr-4tb",
            "hikvision-8mp-colorvu-3-0-hybrid-cctv-kit-2-x-liveguard-gen3-cameras-4ch-m-series-nvr",
            "8mp-hikvision-colorvu-3-0-hybrid-cctv-kit-8-x-liveguard-cameras-8ch-m-series-nvr-4tb",
            "hikvision-8mp-colorvu-3-0-hybrid-cctv-kit-4-x-liveguard-gen-3-cameras-8ch-m-series-nvr-no-hdd",
            "hikvision-8mp-acusense-ds-2cd2t86g2-2i-bullet-10-camera-kit-with-ds-7616ni-m2-16p-16ch-poe-8k-nvr-50m-ir-no-hdd-included",
            "8mp-hikvision-colorvu-3-0-hybrid-cctv-kit-6-x-liveguard-cameras-8ch-m-series-nvr-4tb"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 13,
          "rankedProductIds": [
            "8284565897273",
            "8284566224953",
            "8284565569593",
            "8284566650937",
            "8284589785145",
            "8284473950265",
            "8168391802937",
            "8168572715065",
            "8284554788921",
            "8168573075513",
            "8284554625081",
            "8168572944441",
            "8284567765049"
          ],
          "rankedProductHandles": [
            "hikvision-6-camera-8mp-acusense-security-kit-with-ds-7608ni-m2-8p-8ch-8-poe-8k-nvr-6x-ds-2cd2086g2h-i2u-sl-fixed-bullet-cameras-2-way-audio-active-strobe-light-4tb-hdd-included",
            "hikvision-8-camera-8mp-acusense-security-kit-with-ds-7608ni-m2-8p-8ch-8-poe-8k-nvr-8x-ds-2cd2086g2h-i2u-sl-fixed-bullet-cameras-2-way-audio-active-strobe-light-no-hdd-included",
            "hikvision-4-camera-8mp-acusense-security-kit-with-ds-7604ni-m1-4p-4ch-poe-nvr-4x-ds-2cd2086g2h-i2u-sl-fixed-bullet-cameras-2-way-audio-active-strobe-light-no-hdd-included",
            "hikvision-10-camera-8mp-acusense-security-kit-with-ds-7616ni-m2-16p-16ch-16-poe-8k-nvr-10x-ds-2cd2086g2h-i2u-sl-fixed-bullet-cameras-2-way-audio-active-strobe-light-no-hdd-included",
            "hikvision-10-camera-8mp-colorvu-3-0-ds-2cd2387g3-lis2uy-sl-smart-hybrid-light-turret-kit-with-ds-7616ni-m2-16p-16ch-poe-8k-nvr-strobe-speaker-no-hdd-included",
            "hikvision-8mp-acusense-4-x-outdoor-turret-with-strobe-siren-4ch-nvr-cctv-kit",
            "8mp-8ch-hikvision-cctv-kit-8-x-outdoor-turret-cameras-8ch-nvr",
            "8mp-hikvision-colorvu-3-0-hybrid-cctv-kit-4-x-liveguard-cameras-8ch-m-series-nvr-4tb",
            "hikvision-8mp-colorvu-3-0-hybrid-cctv-kit-2-x-liveguard-gen3-cameras-4ch-m-series-nvr",
            "8mp-hikvision-colorvu-3-0-hybrid-cctv-kit-8-x-liveguard-cameras-8ch-m-series-nvr-4tb",
            "hikvision-8mp-colorvu-3-0-hybrid-cctv-kit-4-x-liveguard-gen-3-cameras-8ch-m-series-nvr-no-hdd",
            "8mp-hikvision-colorvu-3-0-hybrid-cctv-kit-6-x-liveguard-cameras-8ch-m-series-nvr-4tb",
            "hikvision-10-camera-8mp-acusense-security-kit-with-ds-7616ni-m2-16p-16ch-16-poe-8k-nvr-10x-ds-2cd2186g2h-isu-fixed-turret-cameras-built-in-microphone-no-hdd-included"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 11,
          "rankedProductIds": [
            "8284565897273",
            "8168391802937",
            "8284566224953",
            "8284565569593",
            "8168572715065",
            "8284554788921",
            "8168573075513",
            "8284589785145",
            "8284554625081",
            "8168414511161",
            "8168572944441"
          ],
          "rankedProductHandles": [
            "hikvision-6-camera-8mp-acusense-security-kit-with-ds-7608ni-m2-8p-8ch-8-poe-8k-nvr-6x-ds-2cd2086g2h-i2u-sl-fixed-bullet-cameras-2-way-audio-active-strobe-light-4tb-hdd-included",
            "8mp-8ch-hikvision-cctv-kit-8-x-outdoor-turret-cameras-8ch-nvr",
            "hikvision-8-camera-8mp-acusense-security-kit-with-ds-7608ni-m2-8p-8ch-8-poe-8k-nvr-8x-ds-2cd2086g2h-i2u-sl-fixed-bullet-cameras-2-way-audio-active-strobe-light-no-hdd-included",
            "hikvision-4-camera-8mp-acusense-security-kit-with-ds-7604ni-m1-4p-4ch-poe-nvr-4x-ds-2cd2086g2h-i2u-sl-fixed-bullet-cameras-2-way-audio-active-strobe-light-no-hdd-included",
            "8mp-hikvision-colorvu-3-0-hybrid-cctv-kit-4-x-liveguard-cameras-8ch-m-series-nvr-4tb",
            "hikvision-8mp-colorvu-3-0-hybrid-cctv-kit-2-x-liveguard-gen3-cameras-4ch-m-series-nvr",
            "8mp-hikvision-colorvu-3-0-hybrid-cctv-kit-8-x-liveguard-cameras-8ch-m-series-nvr-4tb",
            "hikvision-10-camera-8mp-colorvu-3-0-ds-2cd2387g3-lis2uy-sl-smart-hybrid-light-turret-kit-with-ds-7616ni-m2-16p-16ch-poe-8k-nvr-strobe-speaker-no-hdd-included",
            "hikvision-8mp-colorvu-3-0-hybrid-cctv-kit-4-x-liveguard-gen-3-cameras-8ch-m-series-nvr-no-hdd",
            "8mp-16ch-hikvision-cctv-kit-8-x-outdoor-acusense-turret-cameras-16ch-nvr-with-4tb",
            "8mp-hikvision-colorvu-3-0-hybrid-cctv-kit-6-x-liveguard-cameras-8ch-m-series-nvr-4tb"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 10,
          "rankedProductIds": [
            "8284589785145",
            "8284589654073",
            "8284567765049",
            "8284566650937",
            "8168391802937",
            "8284589916217",
            "8284566224953",
            "8168575991865",
            "8284565897273",
            "8168414511161"
          ],
          "rankedProductHandles": [
            "hikvision-10-camera-8mp-colorvu-3-0-ds-2cd2387g3-lis2uy-sl-smart-hybrid-light-turret-kit-with-ds-7616ni-m2-16p-16ch-poe-8k-nvr-strobe-speaker-no-hdd-included",
            "hikvision-10-camera-8mp-acusense-ds-2cd2386g2h-iu-turret-kit-with-ds-7616ni-m2-16p-16ch-poe-8k-nvr-no-hdd-included",
            "hikvision-10-camera-8mp-acusense-security-kit-with-ds-7616ni-m2-16p-16ch-16-poe-8k-nvr-10x-ds-2cd2186g2h-isu-fixed-turret-cameras-built-in-microphone-no-hdd-included",
            "hikvision-10-camera-8mp-acusense-security-kit-with-ds-7616ni-m2-16p-16ch-16-poe-8k-nvr-10x-ds-2cd2086g2h-i2u-sl-fixed-bullet-cameras-2-way-audio-active-strobe-light-no-hdd-included",
            "8mp-8ch-hikvision-cctv-kit-8-x-outdoor-turret-cameras-8ch-nvr",
            "hikvision-8mp-acusense-ds-2cd2t86g2-2i-bullet-10-camera-kit-with-ds-7616ni-m2-16p-16ch-poe-8k-nvr-50m-ir-no-hdd-included",
            "hikvision-8-camera-8mp-acusense-security-kit-with-ds-7608ni-m2-8p-8ch-8-poe-8k-nvr-8x-ds-2cd2086g2h-i2u-sl-fixed-bullet-cameras-2-way-audio-active-strobe-light-no-hdd-included",
            "hikvision-6mp-colorvu-3-0-hybrid-cctv-kit-8-x-liveguard-cameras-8ch-m-series-nvr-4tb",
            "hikvision-6-camera-8mp-acusense-security-kit-with-ds-7608ni-m2-8p-8ch-8-poe-8k-nvr-6x-ds-2cd2086g2h-i2u-sl-fixed-bullet-cameras-2-way-audio-active-strobe-light-4tb-hdd-included",
            "8mp-16ch-hikvision-cctv-kit-8-x-outdoor-acusense-turret-cameras-16ch-nvr-with-4tb"
          ]
        },
        "two-way-audio": {
          "displayName": "Two-way audio",
          "productCount": 4,
          "rankedProductIds": [
            "8284565897273",
            "8284566224953",
            "8284565569593",
            "8284566650937"
          ],
          "rankedProductHandles": [
            "hikvision-6-camera-8mp-acusense-security-kit-with-ds-7608ni-m2-8p-8ch-8-poe-8k-nvr-6x-ds-2cd2086g2h-i2u-sl-fixed-bullet-cameras-2-way-audio-active-strobe-light-4tb-hdd-included",
            "hikvision-8-camera-8mp-acusense-security-kit-with-ds-7608ni-m2-8p-8ch-8-poe-8k-nvr-8x-ds-2cd2086g2h-i2u-sl-fixed-bullet-cameras-2-way-audio-active-strobe-light-no-hdd-included",
            "hikvision-4-camera-8mp-acusense-security-kit-with-ds-7604ni-m1-4p-4ch-poe-nvr-4x-ds-2cd2086g2h-i2u-sl-fixed-bullet-cameras-2-way-audio-active-strobe-light-no-hdd-included",
            "hikvision-10-camera-8mp-acusense-security-kit-with-ds-7616ni-m2-16p-16ch-16-poe-8k-nvr-10x-ds-2cd2086g2h-i2u-sl-fixed-bullet-cameras-2-way-audio-active-strobe-light-no-hdd-included"
          ]
        }
      }
    },
    "8mp-hikvision-special-cameras-1": {
      "collectionHandle": "8mp-hikvision-special-cameras-1",
      "collectionProductCount": 8,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 2,
          "rankedProductIds": [
            "8284591095865",
            "8168626257977"
          ],
          "rankedProductHandles": [
            "hikvision-6mp-8mp-tandemvu-ultra-ds-2sf8c848mxg1-elwy-26-ptz-camera-with-colorvu-26x-optical-zoom-ir-500m",
            "hikvision-ds-2xc3386g0h-lisu-sl-pa-polymer-8mp-anti-corrosion-fixed-turret"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 4,
          "rankedProductIds": [
            "8168604237881",
            "8168572223545",
            "8168626257977",
            "8284591095865"
          ],
          "rankedProductHandles": [
            "hikvision-ids-2cd7586g2-xzhsy-8mp-deepinview-ptrz-motorized-varifocal-dome-darkfighter-2-0-ip67-ik10",
            "hikvision-ids-2cd7186g0-izhsy-8mp-deepinview-moto-varifocal-dome-camera",
            "hikvision-ds-2xc3386g0h-lisu-sl-pa-polymer-8mp-anti-corrosion-fixed-turret",
            "hikvision-6mp-8mp-tandemvu-ultra-ds-2sf8c848mxg1-elwy-26-ptz-camera-with-colorvu-26x-optical-zoom-ir-500m"
          ]
        }
      }
    },
    "8mp-hikvision-turret-cameras-1": {
      "collectionHandle": "8mp-hikvision-turret-cameras-1",
      "collectionProductCount": 61,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 15,
          "rankedProductIds": [
            "8168572649529",
            "8168596406329",
            "8284579692601",
            "8168622096441",
            "7591899660345",
            "7591916011577",
            "7591861747769",
            "8168599519289",
            "8168575565881",
            "7591807123513",
            "7591777140793",
            "7591792508985",
            "7591776911417",
            "8168615739449",
            "7591801126969"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd2387g3-lis2uy-sl-8mp-4k-smart-hybrid-light-colorvu-3-0-turret-camera-with-strobe-speaker",
            "hikvision-ds-2cd2h87g3-lizsy-8mp-smart-hybrid-light-colorvu-varifocal-turret-camera",
            "hikvision-ds-2cd2387g3-lis2uy-srb-8mp-4k-smart-hybrid-light-colorvu-3-0-turret-camera-red-blue-strobe-speaker",
            "hikvision-ds-2cd3h87g3-lizsuy-sl-blk-8-mp-ultra-series-deep-learning-motorised-turret-camera-with-dual-illumination-varifocal-2-7-13-5-mm-ir-white-light-up-to-40-m-black",
            "hikvision-ds-2cd2387g2h-liu-8mp-4k-smart-hybrid-light-colorvu-turret-camera-with-strobe-speaker",
            "hikvision-ds-2cd2387g2h-liu-8mp-4k-smart-hybrid-light-colorvu-turret-camera-2-8mm-black",
            "hikvision-ds-2cd2387g2h-liu-8mp-4k-smart-hybrid-light-colorvu-turret-camera-2-8mm",
            "hikvision-ds-2cd3h87g3-lizsuy-sl-8-mp-ultra-series-deep-learning-turret-camera-with-dual-illumination",
            "hikvision-ds-2cd2367g3-lis2uy-sl-6mp-smart-hybrid-light-colorvu-3-0-turret-camera-with-strobe-speaker",
            "hikvision-ds-2cd2387g2-lsu-sl-8mp-4k-gen2-outdoor-colorvu-turret-camera-with-acusense-mic-30m-strobe-black",
            "hikvision-ds-2cd2387g2-l-8mp-4k-gen2-outdoor-colorvu-turret-camera-with-acusense-30m-2-8mm",
            "hikvision-ds-2cd2387g2-lsu-sl-8mp-4k-gen2-outdoor-colorvu-turret-camera-with-acusense-mic-30m-strobe",
            "hikvision-ds-2cd2387g2-lu-8mp-4k-gen2-outdoor-colorvu-turret-camera-with-acusense-mic-30m-2-8mm",
            "hikvision-ds-2cd2387g3-lis2uy-sl-8mp-colorvu-3-0-turret-camera-with-strobe-speaker-in-black",
            "hikvision-ds-2cd2387g2p-lsu-sl-8mp-colorvu-turret-4mm-dual-head-strobe-speaker-network-camera"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 12,
          "rankedProductIds": [
            "8284579692601",
            "8168572649529",
            "8168615444537",
            "8168575565881",
            "7591807123513",
            "7591792508985",
            "7591899660345",
            "8168615739449",
            "7591801126969",
            "8168617181241",
            "8168622096441",
            "7591776911417"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd2387g3-lis2uy-srb-8mp-4k-smart-hybrid-light-colorvu-3-0-turret-camera-red-blue-strobe-speaker",
            "hikvision-ds-2cd2387g3-lis2uy-sl-8mp-4k-smart-hybrid-light-colorvu-3-0-turret-camera-with-strobe-speaker",
            "hikvision-ds-2cd2367g3-lis2uy-sl-6mp-colorvu-3-0-gen-3-turret-camera-with-strobe-speaker-black",
            "hikvision-ds-2cd2367g3-lis2uy-sl-6mp-smart-hybrid-light-colorvu-3-0-turret-camera-with-strobe-speaker",
            "hikvision-ds-2cd2387g2-lsu-sl-8mp-4k-gen2-outdoor-colorvu-turret-camera-with-acusense-mic-30m-strobe-black",
            "hikvision-ds-2cd2387g2-lsu-sl-8mp-4k-gen2-outdoor-colorvu-turret-camera-with-acusense-mic-30m-strobe",
            "hikvision-ds-2cd2387g2h-liu-8mp-4k-smart-hybrid-light-colorvu-turret-camera-with-strobe-speaker",
            "hikvision-ds-2cd2387g3-lis2uy-sl-8mp-colorvu-3-0-turret-camera-with-strobe-speaker-in-black",
            "hikvision-ds-2cd2387g2p-lsu-sl-8mp-colorvu-turret-4mm-dual-head-strobe-speaker-network-camera",
            "hikvision-ds-2cd2387g2p-lsu-sl-blk-8mp-colorvu-turret-4mm-dual-head-strobe-speaker-network-camera-panoramic-black",
            "hikvision-ds-2cd3h87g3-lizsuy-sl-blk-8-mp-ultra-series-deep-learning-motorised-turret-camera-with-dual-illumination-varifocal-2-7-13-5-mm-ir-white-light-up-to-40-m-black",
            "hikvision-ds-2cd2387g2-lu-8mp-4k-gen2-outdoor-colorvu-turret-camera-with-acusense-mic-30m-2-8mm"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 16,
          "rankedProductIds": [
            "8168622096441",
            "8168596406329",
            "8168599519289",
            "8168572649529",
            "8284597747769",
            "7591622377529",
            "8284579692601",
            "7591807123513",
            "7591777140793",
            "7591792508985",
            "7591776911417",
            "7591899660345",
            "8168615739449",
            "7591916011577",
            "7591861747769",
            "7591697776697"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd3h87g3-lizsuy-sl-blk-8-mp-ultra-series-deep-learning-motorised-turret-camera-with-dual-illumination-varifocal-2-7-13-5-mm-ir-white-light-up-to-40-m-black",
            "hikvision-ds-2cd2h87g3-lizsy-8mp-smart-hybrid-light-colorvu-varifocal-turret-camera",
            "hikvision-ds-2cd3h87g3-lizsuy-sl-8-mp-ultra-series-deep-learning-turret-camera-with-dual-illumination",
            "hikvision-ds-2cd2387g3-lis2uy-sl-8mp-4k-smart-hybrid-light-colorvu-3-0-turret-camera-with-strobe-speaker",
            "hikvision-ids-2cd5387g2-v-xs-8mp-deepinviewx-fixed-turret-camera-with-darkfighter-2-0-human-vehicle-detection-ip67-weather-protection",
            "hikvision-hik-2cd2h85wdizs-8mp-outdoor-motorised-vf-turret-h-265-ir-io-wdr-ip67-2-8-12mm",
            "hikvision-ds-2cd2387g3-lis2uy-srb-8mp-4k-smart-hybrid-light-colorvu-3-0-turret-camera-red-blue-strobe-speaker",
            "hikvision-ds-2cd2387g2-lsu-sl-8mp-4k-gen2-outdoor-colorvu-turret-camera-with-acusense-mic-30m-strobe-black",
            "hikvision-ds-2cd2387g2-l-8mp-4k-gen2-outdoor-colorvu-turret-camera-with-acusense-30m-2-8mm",
            "hikvision-ds-2cd2387g2-lsu-sl-8mp-4k-gen2-outdoor-colorvu-turret-camera-with-acusense-mic-30m-strobe",
            "hikvision-ds-2cd2387g2-lu-8mp-4k-gen2-outdoor-colorvu-turret-camera-with-acusense-mic-30m-2-8mm",
            "hikvision-ds-2cd2387g2h-liu-8mp-4k-smart-hybrid-light-colorvu-turret-camera-with-strobe-speaker",
            "hikvision-ds-2cd2387g3-lis2uy-sl-8mp-colorvu-3-0-turret-camera-with-strobe-speaker-in-black",
            "hikvision-ds-2cd2387g2h-liu-8mp-4k-smart-hybrid-light-colorvu-turret-camera-2-8mm-black",
            "hikvision-ds-2cd2387g2h-liu-8mp-4k-smart-hybrid-light-colorvu-turret-camera-2-8mm",
            "hikvision-ds-2cd2385g1-i-8mp-black-shadow-outdoor-turret-cctv-camera-h-265-30m-ir"
          ]
        }
      }
    },
    "8mp-hikvision-varifocal-cameras-1": {
      "collectionHandle": "8mp-hikvision-varifocal-cameras-1",
      "collectionProductCount": 19,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 12,
          "rankedProductIds": [
            "8168620884025",
            "8168604893241",
            "8168595062841",
            "8168610955321",
            "8168596406329",
            "8168622096441",
            "8168599519289",
            "7591903952953",
            "8168600961081",
            "7591701086265",
            "7591898087481",
            "8168621244473"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd3686g2ht-lizsy-8mp-smart-hybrid-motorised-bullet-camera-with-darkfighter-varifocal-2-7-13-5mm-ir-60m",
            "hikvision-ds-2cd3786g2ht-lizsuy-8mp-smart-hybrid-light-dome-heop-130-db-wdr-dual-illumination-ip67-ik10",
            "hikvision-ds-2cd3687g3-lizsuy-sl-8mp-darkfighter-bullet-camera-with-dual-illumination-strobe-light-audio-alarm-2-7-13-5mm",
            "hikvision-ds-2cd3h67g3-lizsuy-s-6mp-deep-learning-motorised-varifocal-turret-colorvu-3-0security-camera",
            "hikvision-ds-2cd2h87g3-lizsy-8mp-smart-hybrid-light-colorvu-varifocal-turret-camera",
            "hikvision-ds-2cd3h87g3-lizsuy-sl-blk-8-mp-ultra-series-deep-learning-motorised-turret-camera-with-dual-illumination-varifocal-2-7-13-5-mm-ir-white-light-up-to-40-m-black",
            "hikvision-ds-2cd3h87g3-lizsuy-sl-8-mp-ultra-series-deep-learning-turret-camera-with-dual-illumination",
            "hikvision-ds-2cd2787g2ht-8mp-smart-hybrid-light-colorvu-motorised-vf-dome-camera-2-8-12mm",
            "hikvision-ds-2cd3787g3t-lizsuy-8-mp-dual-illumination-motorized-varifocal-dome-camera",
            "hikvision-ds-2cd2685g1-izs-8mp-outdoor-motorised-vf-bullet-2-8-12mm-with-darkfighter",
            "hikvision-ds-2cd2787g2ht-lizs-8mp-4k-smart-hybrid-light-with-colorvu-motorised-vf-dome-cctv-camera",
            "hikvision-ds-2cd3787g3t-lizsuy-blk-8mp-colorvu-3-0-dual-illumination-motorised-varifocal-dome-camera-black"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 5,
          "rankedProductIds": [
            "8168610955321",
            "8168595062841",
            "8168622096441",
            "8168620884025",
            "8168604893241"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd3h67g3-lizsuy-s-6mp-deep-learning-motorised-varifocal-turret-colorvu-3-0security-camera",
            "hikvision-ds-2cd3687g3-lizsuy-sl-8mp-darkfighter-bullet-camera-with-dual-illumination-strobe-light-audio-alarm-2-7-13-5mm",
            "hikvision-ds-2cd3h87g3-lizsuy-sl-blk-8-mp-ultra-series-deep-learning-motorised-turret-camera-with-dual-illumination-varifocal-2-7-13-5-mm-ir-white-light-up-to-40-m-black",
            "hikvision-ds-2cd3686g2ht-lizsy-8mp-smart-hybrid-motorised-bullet-camera-with-darkfighter-varifocal-2-7-13-5mm-ir-60m",
            "hikvision-ds-2cd3786g2ht-lizsuy-8mp-smart-hybrid-light-dome-heop-130-db-wdr-dual-illumination-ip67-ik10"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 13,
          "rankedProductIds": [
            "8168622096441",
            "8168620884025",
            "8168596406329",
            "8168621244473",
            "8168599519289",
            "8168604893241",
            "8284597977145",
            "7591775699001",
            "7591903952953",
            "7591717896249",
            "7591701086265",
            "7591622377529",
            "8168610955321"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd3h87g3-lizsuy-sl-blk-8-mp-ultra-series-deep-learning-motorised-turret-camera-with-dual-illumination-varifocal-2-7-13-5-mm-ir-white-light-up-to-40-m-black",
            "hikvision-ds-2cd3686g2ht-lizsy-8mp-smart-hybrid-motorised-bullet-camera-with-darkfighter-varifocal-2-7-13-5mm-ir-60m",
            "hikvision-ds-2cd2h87g3-lizsy-8mp-smart-hybrid-light-colorvu-varifocal-turret-camera",
            "hikvision-ds-2cd3787g3t-lizsuy-blk-8mp-colorvu-3-0-dual-illumination-motorised-varifocal-dome-camera-black",
            "hikvision-ds-2cd3h87g3-lizsuy-sl-8-mp-ultra-series-deep-learning-turret-camera-with-dual-illumination",
            "hikvision-ds-2cd3786g2ht-lizsuy-8mp-smart-hybrid-light-dome-heop-130-db-wdr-dual-illumination-ip67-ik10",
            "hikvision-ids-2cd7186g2-izhsy-8mp-deepinview-moto-varifocal-dome-camera-with-8-32mm-lens",
            "hikvision-ds-2cd2h86g2-izs-8mp-acusense-motorised-vf-turret-cctv-camera-ir-2-8-12mm",
            "hikvision-ds-2cd2787g2ht-8mp-smart-hybrid-light-colorvu-motorised-vf-dome-camera-2-8-12mm",
            "hikvision-ds-2cd2786g2t-izs-8mp-4k-acusense-ip-outdoor-motorised-vf-dome-cctv-camera-40m-ir-io-2-8-12mm",
            "hikvision-ds-2cd2685g1-izs-8mp-outdoor-motorised-vf-bullet-2-8-12mm-with-darkfighter",
            "hikvision-hik-2cd2h85wdizs-8mp-outdoor-motorised-vf-turret-h-265-ir-io-wdr-ip67-2-8-12mm",
            "hikvision-ds-2cd3h67g3-lizsuy-s-6mp-deep-learning-motorised-varifocal-turret-colorvu-3-0security-camera"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 3,
          "rankedProductIds": [
            "7591775699001",
            "7591898087481",
            "7591717896249"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd2h86g2-izs-8mp-acusense-motorised-vf-turret-cctv-camera-ir-2-8-12mm",
            "hikvision-ds-2cd2787g2ht-lizs-8mp-4k-smart-hybrid-light-with-colorvu-motorised-vf-dome-cctv-camera",
            "hikvision-ds-2cd2786g2t-izs-8mp-4k-acusense-ip-outdoor-motorised-vf-dome-cctv-camera-40m-ir-io-2-8-12mm"
          ]
        }
      }
    },
    "8mp-ir-bullet-cameras-1": {
      "collectionHandle": "8mp-ir-bullet-cameras-1",
      "collectionProductCount": 8,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 3,
          "rankedProductIds": [
            "7591677460537",
            "7591721500729",
            "7591765737529"
          ],
          "rankedProductHandles": [
            "dahua-ipc-hfw1831cp-pir-0280b-8mp-4k-starlight-ip-mini-bullet-fixed-2-8mm-ir-20mwhite-light",
            "dahua-dh-ipc-hfw2831tp-as-0360b-s2-8mp-wdr-ir-mini-bullet-network-camera-with-3-6mm",
            "dahua-8mp-4k-starlight-ip-bullet-motorized-2-7-13-5mm-smd-plusperimeter-protection-ir-distance-60m"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 6,
          "rankedProductIds": [
            "7591765737529",
            "7591677460537",
            "7591721500729",
            "7591713898553",
            "7591665401913",
            "8168591491129"
          ],
          "rankedProductHandles": [
            "dahua-8mp-4k-starlight-ip-bullet-motorized-2-7-13-5mm-smd-plusperimeter-protection-ir-distance-60m",
            "dahua-ipc-hfw1831cp-pir-0280b-8mp-4k-starlight-ip-mini-bullet-fixed-2-8mm-ir-20mwhite-light",
            "dahua-dh-ipc-hfw2831tp-as-0360b-s2-8mp-wdr-ir-mini-bullet-network-camera-with-3-6mm",
            "dahua-dh-ipc-hfw2831sp-s-0280b-s2-8mp-wdr-ir-mini-bullet-network-camera-with-2-8mm",
            "dahua-dh-ipc-hfw1831ep-8mp-wdr-ir-mini-bullet-network-camera-2-8mm-lens",
            "dahua-ipc-hdw5842tm-ase-s3-8mp-wizmind-s-series-fixed-focal-eyeball-network-camera"
          ]
        }
      }
    },
    "axis-bullet-cameras-1": {
      "collectionHandle": "axis-bullet-cameras-1",
      "collectionProductCount": 43,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 2,
          "rankedProductIds": [
            "7591869251641",
            "7591856275513"
          ],
          "rankedProductHandles": [
            "axis-q1786-le-4mp-outdoor-bullet-4-3-137mm-vf-lens-32x-optical-zoom",
            "axis-p1455-le-network-camera-hdtv-1080p-zipstream-wdr-ip67-2-8-8-5mm-lens"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 8,
          "rankedProductIds": [
            "8168599289913",
            "8284544237625",
            "8284492628025",
            "7591750828089",
            "8284515434553",
            "7690797285433",
            "8168599191609",
            "7591869251641"
          ],
          "rankedProductHandles": [
            "axis-02738-001-p1388-le-8-mp-outdoor-box-camera-with-motorised-varifocal-3-9-10mm-lens-edge-deep-learning-analytics",
            "axis-p1518-le-dual-sensor-8mp-2mp-ai-ir-outdoor-box-network-camera",
            "axis-p1468-le-4k-8mp-fixed-bullet-6-13mm-vf-lens-dlpu-wdr-lightfinder-02342-001",
            "axis-q1798-le-10mp-bullet-camera-h-264-5-poe-ir-ik08-ip67-12-48mm-vf-lens",
            "axis-p1487-le-5mp-fixed-bullet-camera-varifocal-lens-optimizedir-03183-001",
            "axis-q1808-le-4k-10mp-outdoor-fixed-bullet-12-48mm-vf-lens-dlpu-wdr-lightfinder-2-0-i",
            "axis-p1387-le-5-mp-outdoor-box-camera-motorised-varifocal-lens-2-8-13mm-edge-deep-learning-analytics",
            "axis-q1786-le-4mp-outdoor-bullet-4-3-137mm-vf-lens-32x-optical-zoom"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 2,
          "rankedProductIds": [
            "7591878787129",
            "7591881998393"
          ],
          "rankedProductHandles": [
            "axis-axis-01161-001-q1785-le-network-camera-hdtv-1080p-80m-ir-zipstream-wdr-poe-4-3-137mm",
            "axis-axis-01997-001-p1455-le-network-camera-hdtv-1080p-zipstream-wdr-ip67-2-8-8-5mm-lens"
          ]
        }
      }
    },
    "axis-dome-cameras-1": {
      "collectionHandle": "axis-dome-cameras-1",
      "collectionProductCount": 127,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 5,
          "rankedProductIds": [
            "8284582477881",
            "7591881375801",
            "7591880982585",
            "7591879802937",
            "7591879311417"
          ],
          "rankedProductHandles": [
            "axis-q3556-lve-4mp-ai-powered-dome-camera-with-varifocal-lens-lightfinder-2-0-forensic-wdr-optimizedir-ip66-ik10-rating",
            "axis-axis-01958-006-q6135-le-2mp-ptz-camera-h-264-65-32x-zoom-50hz-wdr-ip66-nema-4x-nema-ts2",
            "axis-axis-01924-006-q6315-le-ptz-camera-1080p-31x-zoom-poe-ip66-ik10-6-91-214-64mm-vf-lens",
            "axis-axis-01710-001-q6100-e-network-camera-4x-5mp-sensors-50hz-h-264-wdr-ip66-ik10",
            "axis-axis-01681-001-p5655-e-ptz-camera-1080p-h-265-zipstream-ip66-4-3-137-6mm-vf-lens"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 16,
          "rankedProductIds": [
            "7745688830009",
            "8284583002169",
            "8284581953593",
            "7745688600633",
            "8168599060537",
            "8284583231545",
            "8284512518201",
            "8168598962233",
            "8284581232697",
            "8284580937785",
            "7591978401849",
            "7591848673337",
            "8168596111417",
            "8284492595257",
            "8284582707257",
            "8284516057145"
          ],
          "rankedProductHandles": [
            "axis-p3265-lve-3-outdoor-dome-camera-licence-plate-verifier-kit-2-7m-lpr-02812-001",
            "axis-q3628-ve-8mp-ai-powered-dome-camera-with-remote-ptrz-lightfinder-2-0-forensic-wdr-6-2-12-9mm-varifocal-lens",
            "axis-p3288-lv-8mp-ai-powered-dome-camera-with-4-4-14-6mm-varifocal-lens-lightfinder-2-0-forensic-wdr-optimizedir",
            "axis-m3088-v-fixed-8-mp-mini-dome-with-deep-learning",
            "axis-02816-001-m4228-lve-compact-8-mp-4k-outdoor-ai-dome-with-audio-video-analytics",
            "axis-m4328-p-12mp-indoor-panoramic-camera-with-360-overview-deep-learning-analytics-forensic-wdr-built-in-microphone",
            "axis-q6358-le-4k-uhd-outdoor-ai-ptz-security-camera",
            "axis-02678-001-m4218-v-8-mp-4k-uhd-indoor-varifocal-dome-camera-with-deep-learning-wdr",
            "axis-m3128-lve-8mp-ai-powered-dome-camera-with-4k-image-quality-wdr-optimizedir-20m-ip66-outdoor-rating-2",
            "axis-m3128-lve-8mp-ai-powered-dome-camera-with-4k-image-quality-wdr-optimizedir-20m-ip66-outdoor-rating",
            "axis-p1468-le-4k-8mp-fixed-bullet-6-13mm-vf-lens-optimizedir-dlpu-wdr-lightfinder",
            "axis-p3719-ple-15mp-multi-sensor-camera-1440p-360-deg-zipstream-wdr-ip66-3-6-mm",
            "axis-q3538-lve-4k-dome-camera-with-deep-learning-robust-outdoor-design",
            "axis-4k-p37-series-axis-p3738-ple-panoramic-camera-with-deep-learning-analytics-3-18-8-12mm-lens-360-ir",
            "axis-q3626-ve-4mp-ai-powered-dome-camera-with-remote-ptrz-lightfinder-2-0-forensic-wdr-4-3-8-6mm-varifocal-lens",
            "axis-q3558-lve-8mp-advanced-outdoor-dome-camera-with-ai-analytics-03206-001"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 15,
          "rankedProductIds": [
            "8284512518201",
            "7591881375801",
            "7591880982585",
            "8168573993017",
            "7591879311417",
            "7591979909177",
            "8168608694329",
            "8168608071737",
            "8168602173497",
            "8168602075193",
            "8168596209721",
            "8168580153401",
            "7591878590521",
            "7591854211129",
            "7591854080057"
          ],
          "rankedProductHandles": [
            "axis-q6358-le-4k-uhd-outdoor-ai-ptz-security-camera",
            "axis-axis-01958-006-q6135-le-2mp-ptz-camera-h-264-65-32x-zoom-50hz-wdr-ip66-nema-4x-nema-ts2",
            "axis-axis-01924-006-q6315-le-ptz-camera-1080p-31x-zoom-poe-ip66-ik10-6-91-214-64mm-vf-lens",
            "axis-q6078-e-ptz-outdoor-ready-ptz-with-uhd-4k-camera",
            "axis-axis-01681-001-p5655-e-ptz-camera-1080p-h-265-zipstream-ip66-4-3-137-6mm-vf-lens",
            "axis-m5526-e-ptz-camera-indoor-and-outdoor-4-mp-with-10x-zoom-and-focus-recall",
            "axis-p5654-e-mk-ii-ptz-camera-1080p-hdtv-21x-ptz-with-wide-coverage-advanced-analytics",
            "axis-q6300-e-panoramic-camera-360-multi-sensor-security-with-ptz-integration",
            "axis-q6020-e-360-outdoor-panoramic-multi-sensor-camera-with-dlpu-ai-analytics",
            "axis-m5074-compact-indoor-ptz-network-camera-720p-5x-optical-zoom-forensic-wdr",
            "axis-q8752-e-mk-ii-bispectral-ptz-camera-thermal-visual-surveillance",
            "axis-q6010-e-4x-5mp-ptz-dome-camera-50hz-20fps-h-265",
            "axis-axis-01145-001-m5525-e-50hz-ptz-dome-camera-poe-1080p-ip66-4-7-47mm-360deg-vf-lens",
            "axis-q6075-e-ptz-dome-camera-1080p-h-264-zipstream-4-25-170mm-vf-lens",
            "axis-q6074-e-ptz-dome-camera-720p-h-265-50hz-zipstream-4-25-127-5mm-vf-lens"
          ]
        }
      }
    },
    "axis-panoramic-cameras": {
      "collectionHandle": "axis-panoramic-cameras",
      "collectionProductCount": 16,
      "renderedProductLimit": 250,
      "needs": {
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 5,
          "rankedProductIds": [
            "8284492595257",
            "8324142497849",
            "8324141940793",
            "8324097278009",
            "8168608956473"
          ],
          "rankedProductHandles": [
            "axis-4k-p37-series-axis-p3738-ple-panoramic-camera-with-deep-learning-analytics-3-18-8-12mm-lens-360-ir",
            "axis-q3839-pve-29mp-8k-ai-panoramic-multisensor-camera-with-180-coverage",
            "axis-q4809-pve-26mp-10k-ai-panoramic-multisensor-camera-with-180-coverage",
            "axis-p3747-plve-20mp-multidirectional-panoramic-camera-with-4-x-5mp-sensors-360-ir-forensic-wdr-ai-analytics",
            "axis-p3748-plve-4-sensor-4k-panoramic-camera-360-ir-deep-learning-outdoor-rated"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 5,
          "rankedProductIds": [
            "8168438759481",
            "8168438890553",
            "8168601911353",
            "8168608071737",
            "8168602173497"
          ],
          "rankedProductHandles": [
            "axis-m3077-plve-6mp-mini-dome-camera-h-264-poe-1-56mm-180-360-fxed-lens-02018-001",
            "axis-m4308-ple-12mp-outdoor-panoramic-camera-360-deg-ir-mic-ip66-ik10-02100-001",
            "axis-p4705-plve-panoramic-camera-dual-sensor-with-360-ir-and-deep-learning",
            "axis-q6300-e-panoramic-camera-360-multi-sensor-security-with-ptz-integration",
            "axis-q6020-e-360-outdoor-panoramic-multi-sensor-camera-with-dlpu-ai-analytics"
          ]
        }
      }
    },
    "axis-pnhole-cameras": {
      "collectionHandle": "axis-pnhole-cameras",
      "collectionProductCount": 2,
      "renderedProductLimit": 250,
      "needs": {
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 1,
          "rankedProductIds": [
            "8168556363833"
          ],
          "rankedProductHandles": [
            "axis-p1265-mkii-2mp-indoor-modular-pinhole-camera-dlpu-wdr"
          ]
        }
      }
    },
    "axis-ptz-cameras": {
      "collectionHandle": "axis-ptz-cameras",
      "collectionProductCount": 14,
      "renderedProductLimit": 250,
      "needs": {
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 3,
          "rankedProductIds": [
            "8284512518201",
            "8324096819257",
            "8168580153401"
          ],
          "rankedProductHandles": [
            "axis-q6358-le-4k-uhd-outdoor-ai-ptz-security-camera",
            "axis-q6086-e-4mp-outdoor-ptz-camera-with-34x-optical-zoom-lightfinder-2-0-forensic-wdr-ai-analytics",
            "axis-q6010-e-4x-5mp-ptz-dome-camera-50hz-20fps-h-265"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 8,
          "rankedProductIds": [
            "8284512518201",
            "8168598306873",
            "8324140466233",
            "8284493054009",
            "8168573993017",
            "8324096819257",
            "8284545056825",
            "8168438693945"
          ],
          "rankedProductHandles": [
            "axis-q6358-le-4k-uhd-outdoor-ai-ptz-security-camera",
            "axis-q6355-le-outdoor-ptz-camera-31x-zoom-1080p-300m-ir-autotracking-analytics",
            "axis-q6318-le-4k-uhd-ptz-network-camera-with-31x-optical-zoom-ir-laser-focus",
            "axis-q6225-le-ptz-31x-optical-zoom-heavy-duty-ptz-camera-with-long-range-ir-02316-301",
            "axis-q6078-e-ptz-outdoor-ready-ptz-with-uhd-4k-camera",
            "axis-q6086-e-4mp-outdoor-ptz-camera-with-34x-optical-zoom-lightfinder-2-0-forensic-wdr-ai-analytics",
            "axis-tu9002-ptz-joystick-controller-02475-001",
            "axis-q6135-le-2mp-ptz-camera-h-264-65-32x-zoom-50hz-wdr-ip66-nema-4x-amp-nema-ts2-01958-006"
          ]
        }
      }
    },
    "axis-thermal-cameras": {
      "collectionHandle": "axis-thermal-cameras",
      "collectionProductCount": 4,
      "renderedProductLimit": 250,
      "needs": {
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 2,
          "rankedProductIds": [
            "8168608563257",
            "8324139483193"
          ],
          "rankedProductHandles": [
            "axis-q1971-e-thermal-camera-high-sensitivity-24-7-perimeter-detection-verification",
            "axis-q2111-e-thermal-camera-long-range-thermal-cctv"
          ]
        }
      }
    },
    "bosch-cctv-1": {
      "collectionHandle": "bosch-cctv-1",
      "collectionProductCount": 1,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "bullet-cameras": {
      "collectionHandle": "bullet-cameras",
      "collectionProductCount": 6,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "cctv-kit": {
      "collectionHandle": "cctv-kit",
      "collectionProductCount": 1,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "cctv-surveillance-1": {
      "collectionHandle": "cctv-surveillance-1",
      "collectionProductCount": 1002,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "dahua-12mp-bullet-cameras": {
      "collectionHandle": "dahua-12mp-bullet-cameras",
      "collectionProductCount": 2,
      "renderedProductLimit": 250,
      "needs": {
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 1,
          "rankedProductIds": [
            "8168591654969"
          ],
          "rankedProductHandles": [
            "dahua-dh-ipc-hfw71242h-z-ultra-12mp-ai-ir-bullet-camera-with-smart-analytics-wizmind"
          ]
        }
      }
    },
    "dahua-4g-cameras-1": {
      "collectionHandle": "dahua-4g-cameras-1",
      "collectionProductCount": 7,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 2,
          "rankedProductIds": [
            "7591853162553",
            "7591888093241"
          ],
          "rankedProductHandles": [
            "dahua-4mp-sd6c3432xb-hnr-agq-pv-32x-starlight-ir-wizsense-4g-network-ptz-camera",
            "dahua-4mp-dh-sd49425xb-hnr-25x-starlight-ir-ptz-ai-network-camera"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 2,
          "rankedProductIds": [
            "7591853162553",
            "7591795720249"
          ],
          "rankedProductHandles": [
            "dahua-4mp-sd6c3432xb-hnr-agq-pv-32x-starlight-ir-wizsense-4g-network-ptz-camera",
            "dahua-dh-ipc-hfw3241dfp-as-4g-nl668-0280b-2mp-wizsense-4g-network-camera"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 2,
          "rankedProductIds": [
            "7591853162553",
            "7591888093241"
          ],
          "rankedProductHandles": [
            "dahua-4mp-sd6c3432xb-hnr-agq-pv-32x-starlight-ir-wizsense-4g-network-ptz-camera",
            "dahua-4mp-dh-sd49425xb-hnr-25x-starlight-ir-ptz-ai-network-camera"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 3,
          "rankedProductIds": [
            "7591888093241",
            "7591853162553",
            "7591832879161"
          ],
          "rankedProductHandles": [
            "dahua-4mp-dh-sd49425xb-hnr-25x-starlight-ir-ptz-ai-network-camera",
            "dahua-4mp-sd6c3432xb-hnr-agq-pv-32x-starlight-ir-wizsense-4g-network-ptz-camera",
            "dahua-120w-ptz-integrated-solar-monitoring-kit-supplied-with-4g-camera-with-wizsense-and-solar-panel"
          ]
        }
      }
    },
    "dahua-4mp-cameras-1": {
      "collectionHandle": "dahua-4mp-cameras-1",
      "collectionProductCount": 58,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 10,
          "rankedProductIds": [
            "7591853162553",
            "8168572452921",
            "7591690403897",
            "7690795483193",
            "7591715471417",
            "7690795450425",
            "7591777337401",
            "7591888093241",
            "7591706394681",
            "7591846936633"
          ],
          "rankedProductHandles": [
            "dahua-4mp-sd6c3432xb-hnr-agq-pv-32x-starlight-ir-wizsense-4g-network-ptz-camera",
            "dahua-dh-sdt3e410-8p-mb-a-pv1-8mp4mp-10x-starlight-tioc-panoramic-ptz-security-camera",
            "dahua-dh-ipc-hdw5442tmp-led-dahua-ai-4mp-starlight-ip-turret-fixed-white-light-ir-20m-poe",
            "dahua-dh-sdt4e425-8p-gb-apv1-x-spans-8mp4mp-25x-tioc-wizsense-network-ptz-camera",
            "dahua-dh-sd8a840wa-hnf-4k-40x-starlight-ir-ptz-ai-network-camera",
            "dahua-dh-sdt4e425-4f-gb-a-pv1-x-spans-4mp4mp-25x-tioc-wizsense-network-ptz-camera",
            "dahua-dh-sd6c3425xb-hnr-a-pv1-4mp-tioc-ip-25x-ptz-camera-ir-150m",
            "dahua-4mp-dh-sd49425xb-hnr-25x-starlight-ir-ptz-ai-network-camera",
            "dahua-dh-sd5a425xa-hnr-4mp-25x-starlight-ir-ptz-ai-network-camera",
            "dahua-dh-sd4a425db-hny-4mp-25x-ip-starlight-wizsense-ptz-camera"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 16,
          "rankedProductIds": [
            "7591715471417",
            "7690795483193",
            "7690795450425",
            "8168572452921",
            "7745674051641",
            "7591853162553",
            "7591777337401",
            "8284596830265",
            "7591838548025",
            "7591981678649",
            "7591825211449",
            "7591864500281",
            "7591864270905",
            "7591846051897",
            "7591737950265",
            "7591690928185"
          ],
          "rankedProductHandles": [
            "dahua-dh-sd8a840wa-hnf-4k-40x-starlight-ir-ptz-ai-network-camera",
            "dahua-dh-sdt4e425-8p-gb-apv1-x-spans-8mp4mp-25x-tioc-wizsense-network-ptz-camera",
            "dahua-dh-sdt4e425-4f-gb-a-pv1-x-spans-4mp4mp-25x-tioc-wizsense-network-ptz-camera",
            "dahua-dh-sdt3e410-8p-mb-a-pv1-8mp4mp-10x-starlight-tioc-panoramic-ptz-security-camera",
            "dahua-dh-sd3e405db-gny-a-pv1-4mp-5x-tioc-wizsense-network-ptz-camera",
            "dahua-4mp-sd6c3432xb-hnr-agq-pv-32x-starlight-ir-wizsense-4g-network-ptz-camera",
            "dahua-dh-sd6c3425xb-hnr-a-pv1-4mp-tioc-ip-25x-ptz-camera-ir-150m",
            "dahua-sd6e445mb-hnr-a-pv1-4mp-45x-smart-dual-illumination-active-deterrence-network-ptz-camera",
            "dahua-dh-sd5a432xb-hnr-4mp-ip-32x-ptz-camera-with-wizsense",
            "dahua-dh-ipc-wl46a-4mp-wifi-floodlight-camera-240v",
            "dahua-dh-ipc-hfw3466t-as-p-4mp-wide-angle-fixed-bullet-wizsense-network-camera",
            "dahua-dh-ipc-hdbw3466ep-as-aus-4mp-wizsense-starlight-dome",
            "dahua-dh-ipc-hdbw3466rp-zas-aus-4mp-wizsense-motorised-starlight-dome",
            "dahua-6-x-4mp-dh-ipc-hdw3466emp-s-aus-smd-wizsense-camera-kit",
            "dahua-dh-sd1a404xb-gnr-4m-4x-starlight-ir-ptz-ai-network-camera",
            "dahua-dh-ipc-hfw5442tp-s-dahua-ai-4mp-starlight-ip-bullet-fixed-ir-50m-poe"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 16,
          "rankedProductIds": [
            "7591715471417",
            "7690795483193",
            "8168572452921",
            "8168402714681",
            "7591671889977",
            "7591888093241",
            "7591771570233",
            "8284596830265",
            "7690795450425",
            "8168440791097",
            "7745674051641",
            "7591838548025",
            "7591706394681",
            "7591853162553",
            "7591777337401",
            "7591841726521"
          ],
          "rankedProductHandles": [
            "dahua-dh-sd8a840wa-hnf-4k-40x-starlight-ir-ptz-ai-network-camera",
            "dahua-dh-sdt4e425-8p-gb-apv1-x-spans-8mp4mp-25x-tioc-wizsense-network-ptz-camera",
            "dahua-dh-sdt3e410-8p-mb-a-pv1-8mp4mp-10x-starlight-tioc-panoramic-ptz-security-camera",
            "dahua-dh-sd8a840-hnf-pa-4k-40x-starlight-ir-ptz-ai-network-camera",
            "dahua-dh-ipc-hfw2431tp-zs-27135-4mp-wdr-ir-bullet-network-camera-2-7-13-5mm-motorized-lens",
            "dahua-4mp-dh-sd49425xb-hnr-25x-starlight-ir-ptz-ai-network-camera",
            "dahua-dh-sd5a432xa-hnr-4mp-ip-32x-ptz-camera-with-wizsense",
            "dahua-sd6e445mb-hnr-a-pv1-4mp-45x-smart-dual-illumination-active-deterrence-network-ptz-camera",
            "dahua-dh-sdt4e425-4f-gb-a-pv1-x-spans-4mp4mp-25x-tioc-wizsense-network-ptz-camera",
            "dahua-4mp-dh-sd49425xb-hnr-dh-sd49425gb-hnr-25x-starlight-ir-ptz-ai-network-camera",
            "dahua-dh-sd3e405db-gny-a-pv1-4mp-5x-tioc-wizsense-network-ptz-camera",
            "dahua-dh-sd5a432xb-hnr-4mp-ip-32x-ptz-camera-with-wizsense",
            "dahua-dh-sd5a425xa-hnr-4mp-25x-starlight-ir-ptz-ai-network-camera",
            "dahua-4mp-sd6c3432xb-hnr-agq-pv-32x-starlight-ir-wizsense-4g-network-ptz-camera",
            "dahua-dh-sd6c3425xb-hnr-a-pv1-4mp-tioc-ip-25x-ptz-camera-ir-150m",
            "dahua-dh-ipc-hdbw3466r-as-p-4mp-180-degree-camera-dome-wizsense-ir-ip67-12v-poe-2-1mm-lens"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 16,
          "rankedProductIds": [
            "7591715471417",
            "7690795483193",
            "7591888093241",
            "7591771570233",
            "8284596830265",
            "7591838548025",
            "7591706394681",
            "8168600469561",
            "7690795450425",
            "7591853162553",
            "7591777337401",
            "8168574746681",
            "7591846936633",
            "7591820656697",
            "7591656063033",
            "7591841726521"
          ],
          "rankedProductHandles": [
            "dahua-dh-sd8a840wa-hnf-4k-40x-starlight-ir-ptz-ai-network-camera",
            "dahua-dh-sdt4e425-8p-gb-apv1-x-spans-8mp4mp-25x-tioc-wizsense-network-ptz-camera",
            "dahua-4mp-dh-sd49425xb-hnr-25x-starlight-ir-ptz-ai-network-camera",
            "dahua-dh-sd5a432xa-hnr-4mp-ip-32x-ptz-camera-with-wizsense",
            "dahua-sd6e445mb-hnr-a-pv1-4mp-45x-smart-dual-illumination-active-deterrence-network-ptz-camera",
            "dahua-dh-sd5a432xb-hnr-4mp-ip-32x-ptz-camera-with-wizsense",
            "dahua-dh-sd5a425xa-hnr-4mp-25x-starlight-ir-ptz-ai-network-camera",
            "dahua-ipc-hdw5442tp-ze-s3-ai-4mp-turret-motorized-camera-starlight-motorized-lens-ip67",
            "dahua-dh-sdt4e425-4f-gb-a-pv1-x-spans-4mp4mp-25x-tioc-wizsense-network-ptz-camera",
            "dahua-4mp-sd6c3432xb-hnr-agq-pv-32x-starlight-ir-wizsense-4g-network-ptz-camera",
            "dahua-dh-sd6c3425xb-hnr-a-pv1-4mp-tioc-ip-25x-ptz-camera-ir-150m",
            "dahua-dh-ipc-hdbw5441e-ze-hdmi-4mp-hdmi-dome-motorised-camera",
            "dahua-dh-sd4a425db-hny-4mp-25x-ip-starlight-wizsense-ptz-camera",
            "dahua-sd6ce445gb-hnr-4mp-45x-startlight-ir-network-ptz-camera",
            "dahua-dh-sd59430u-hni-4mp-30x-ir-ptz-network-camera",
            "dahua-dh-ipc-hdbw3466r-as-p-4mp-180-degree-camera-dome-wizsense-ir-ip67-12v-poe-2-1mm-lens"
          ]
        }
      }
    },
    "dahua-4mp-dome-cameras": {
      "collectionHandle": "dahua-4mp-dome-cameras",
      "collectionProductCount": 12,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 4,
          "rankedProductIds": [
            "7591981678649",
            "7591864500281",
            "7591864270905",
            "7591656587321"
          ],
          "rankedProductHandles": [
            "dahua-dh-ipc-wl46a-4mp-wifi-floodlight-camera-240v",
            "dahua-dh-ipc-hdbw3466ep-as-aus-4mp-wizsense-starlight-dome",
            "dahua-dh-ipc-hdbw3466rp-zas-aus-4mp-wizsense-motorised-starlight-dome",
            "dahua-dh-ipc-hdbw5431e-ze-4mp-motorised-vf-ir-dome-network-camera"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 2,
          "rankedProductIds": [
            "7591864270905",
            "7591656587321"
          ],
          "rankedProductHandles": [
            "dahua-dh-ipc-hdbw3466rp-zas-aus-4mp-wizsense-motorised-starlight-dome",
            "dahua-dh-ipc-hdbw5431e-ze-4mp-motorised-vf-ir-dome-network-camera"
          ]
        }
      }
    },
    "dahua-4mp-economical-bullet-range-1": {
      "collectionHandle": "dahua-4mp-economical-bullet-range-1",
      "collectionProductCount": 7,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 2,
          "rankedProductIds": [
            "7591796539449",
            "7591690928185"
          ],
          "rankedProductHandles": [
            "dahua-anpr-short-range-motorised-camera-max-8m-distance",
            "dahua-dh-ipc-hfw5442tp-s-dahua-ai-4mp-starlight-ip-bullet-fixed-ir-50m-poe"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 4,
          "rankedProductIds": [
            "7591718027321",
            "8168610201657",
            "7591796539449",
            "7591671889977"
          ],
          "rankedProductHandles": [
            "dahua-dhi-itc237-pw6m-irlzf1050-ai-access-anpr-2-megapixel-full-hd-wdr-anpr-camera-ir-max-40km-hr-10-50mm-motorized-lens",
            "dahua-itc413-pw4d-iz1-anpr-camera-4mp-motorized-vari-focal-ir-license-plate-recognition-2-7-12mm",
            "dahua-anpr-short-range-motorised-camera-max-8m-distance",
            "dahua-dh-ipc-hfw2431tp-zs-27135-4mp-wdr-ir-bullet-network-camera-2-7-13-5mm-motorized-lens"
          ]
        }
      }
    },
    "dahua-4mp-eyeball-economy": {
      "collectionHandle": "dahua-4mp-eyeball-economy",
      "collectionProductCount": 17,
      "renderedProductLimit": 250,
      "needs": {
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 3,
          "rankedProductIds": [
            "7591694532665",
            "7591835697209",
            "7591706918969"
          ],
          "rankedProductHandles": [
            "dahua-dh-ipc-hdw2431tp-zs-s2-4mp-starlight-ip-turret-motorised-2-713-5mm",
            "dahua-dh-ipc-hdw3466tp-zs-aus-4mp-starlight-ip-turret-motorised-2-713-5mm-with-wizsense",
            "dahua-dh-ipc-hdbw5442ep-ze-2712-dahua-ai-4mp-starlight-ip-vandal-dome-motorized-2-7mm12mm"
          ]
        }
      }
    },
    "dahua-5mp-eyeball-cameras-1": {
      "collectionHandle": "dahua-5mp-eyeball-cameras-1",
      "collectionProductCount": 2,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 1,
          "rankedProductIds": [
            "8284475457593"
          ],
          "rankedProductHandles": [
            "dahua-4-x-6mp-dh-ipc-hdw3649h-as-pv-anz-tioc-2-0-with-wizsense-turret-4ch-kit"
          ]
        }
      }
    },
    "dahua-5mp-eyeball-cameras-2": {
      "collectionHandle": "dahua-5mp-eyeball-cameras-2",
      "collectionProductCount": 8,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 3,
          "rankedProductIds": [
            "7591829372985",
            "7591771406393",
            "7591831732281"
          ],
          "rankedProductHandles": [
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3649h-as-pv-anz-6mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3549hp-as-pv-0280b-s3-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3649h-as-pv-anz-blk-6mp-ai-active-deterrence-full-color-starlight-ip-turret-camera-black"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 4,
          "rankedProductIds": [
            "7591831732281",
            "7591829372985",
            "7591771406393",
            "7591941111865"
          ],
          "rankedProductHandles": [
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3649h-as-pv-anz-blk-6mp-ai-active-deterrence-full-color-starlight-ip-turret-camera-black",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3649h-as-pv-anz-6mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3549hp-as-pv-0280b-s3-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-dh-ipc-hdw3649h-as-pv-anz-6mp-motorised-zoom-blue-red-light-ip-turret-camera"
          ]
        }
      }
    },
    "dahua-5mp-hdcvi-domes": {
      "collectionHandle": "dahua-5mp-hdcvi-domes",
      "collectionProductCount": 2,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "dahua-5mp-ip-cameras-1": {
      "collectionHandle": "dahua-5mp-ip-cameras-1",
      "collectionProductCount": 2,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 1,
          "rankedProductIds": [
            "8168400322617"
          ],
          "rankedProductHandles": [
            "dahua-ipc-hdbw3549r1-zas-pv-5mp-smart-dual-light-tioc-motorised-dome-wizsense-network-camera"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 1,
          "rankedProductIds": [
            "8168400322617"
          ],
          "rankedProductHandles": [
            "dahua-ipc-hdbw3549r1-zas-pv-5mp-smart-dual-light-tioc-motorised-dome-wizsense-network-camera"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 1,
          "rankedProductIds": [
            "8168400322617"
          ],
          "rankedProductHandles": [
            "dahua-ipc-hdbw3549r1-zas-pv-5mp-smart-dual-light-tioc-motorised-dome-wizsense-network-camera"
          ]
        }
      }
    },
    "dahua-6mp-ip-cameras": {
      "collectionHandle": "dahua-6mp-ip-cameras",
      "collectionProductCount": 11,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "dahua-6mp-ip-cameras-1": {
      "collectionHandle": "dahua-6mp-ip-cameras-1",
      "collectionProductCount": 28,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 3,
          "rankedProductIds": [
            "7591818199097",
            "7591738048569",
            "7591677886521"
          ],
          "rankedProductHandles": [
            "dahua-dh-ipc-hfw3666ep-as-aus-6mp-bullet-network-camera-50m-ir-2-8mm-with-smd-4-0-wizsense",
            "dahua-dh-ipc-hdbw3841rp-zas-27135-8mp-dome-motorised-network-camera-zoom-function-50m-ir-wizsense",
            "dahua-dh-ipc-hdbw5631rp-ze-27135-blk-6mp-wdr-ir-dome-motorised-network-camera"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 6,
          "rankedProductIds": [
            "7591940128825",
            "7591890092089",
            "7591738048569",
            "7591799652409",
            "7591802044473",
            "7591677886521"
          ],
          "rankedProductHandles": [
            "dahua-dh-ipc-hfw3466ep-as-aus-4mp-bullet-network-camera-50m-ir-2-8mm-with-smd-4-0-wizsense",
            "dahua-dh-ipc-hfw3666tp-zas-aus-6mp-motorised-bullet-network-camera-60m-ir",
            "dahua-dh-ipc-hdbw3841rp-zas-27135-8mp-dome-motorised-network-camera-zoom-function-50m-ir-wizsense",
            "dahua-dh-ipc-hdw3666tp-zs-aus-6mp-motorised-turret-network-camera-40m-ir-with-smd-4-0",
            "dahua-dh-ipc-hdbw3666rp-zas-aus-6mp-motorised-turret-network-camera-40m-ir-with-smd-4-0",
            "dahua-dh-ipc-hdbw5631rp-ze-27135-blk-6mp-wdr-ir-dome-motorised-network-camera"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 4,
          "rankedProductIds": [
            "7591940128825",
            "7591799652409",
            "7591675789369",
            "7591675658297"
          ],
          "rankedProductHandles": [
            "dahua-dh-ipc-hfw3466ep-as-aus-4mp-bullet-network-camera-50m-ir-2-8mm-with-smd-4-0-wizsense",
            "dahua-dh-ipc-hdw3666tp-zs-aus-6mp-motorised-turret-network-camera-40m-ir-with-smd-4-0",
            "dahua-ipc-hfw4631e-se-6mp-wdr-ir-mini-bullet-network-camera",
            "dahua-ipc-hdbw5631rp-ze-27135-6mp-wdr-ir-dome-motorised-network-camera"
          ]
        }
      }
    },
    "dahua-6mp-ir-eyeball-cameras": {
      "collectionHandle": "dahua-6mp-ir-eyeball-cameras",
      "collectionProductCount": 38,
      "renderedProductLimit": 250,
      "needs": {
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 3,
          "rankedProductIds": [
            "8284544303161",
            "7591799652409",
            "7591802044473"
          ],
          "rankedProductHandles": [
            "dahua-dh-ipc-hdw3667t-zs-il-anz-6mp-eyeball-network-camera-with-varifocal-lens-acupick-and-white-light-led-ip67",
            "dahua-dh-ipc-hdw3666tp-zs-aus-6mp-motorised-turret-network-camera-40m-ir-with-smd-4-0",
            "dahua-dh-ipc-hdbw3666rp-zas-aus-6mp-motorised-turret-network-camera-40m-ir-with-smd-4-0"
          ]
        }
      }
    },
    "dahua-6mp-motorised-dome-cameras": {
      "collectionHandle": "dahua-6mp-motorised-dome-cameras",
      "collectionProductCount": 3,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 2,
          "rankedProductIds": [
            "7591738048569",
            "7591677886521"
          ],
          "rankedProductHandles": [
            "dahua-dh-ipc-hdbw3841rp-zas-27135-8mp-dome-motorised-network-camera-zoom-function-50m-ir-wizsense",
            "dahua-dh-ipc-hdbw5631rp-ze-27135-blk-6mp-wdr-ir-dome-motorised-network-camera"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 2,
          "rankedProductIds": [
            "7591738048569",
            "7591677886521"
          ],
          "rankedProductHandles": [
            "dahua-dh-ipc-hdbw3841rp-zas-27135-8mp-dome-motorised-network-camera-zoom-function-50m-ir-wizsense",
            "dahua-dh-ipc-hdbw5631rp-ze-27135-blk-6mp-wdr-ir-dome-motorised-network-camera"
          ]
        }
      }
    },
    "dahua-6mp-tioc-cameras": {
      "collectionHandle": "dahua-6mp-tioc-cameras",
      "collectionProductCount": 4,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 2,
          "rankedProductIds": [
            "8168575336505",
            "8284475457593"
          ],
          "rankedProductHandles": [
            "dahua-ipc-hdw3649h-as-pv-pro-tioc-acupick-6mp-ai-active-deterrence-ip-turret-camera",
            "dahua-4-x-6mp-dh-ipc-hdw3649h-as-pv-anz-tioc-2-0-with-wizsense-turret-4ch-kit"
          ]
        }
      }
    },
    "dahua-6mp-tioc-cctv-kits": {
      "collectionHandle": "dahua-6mp-tioc-cctv-kits",
      "collectionProductCount": 1,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "dahua-8mp-ip-cameras": {
      "collectionHandle": "dahua-8mp-ip-cameras",
      "collectionProductCount": 22,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 10,
          "rankedProductIds": [
            "8168572452921",
            "8168534900793",
            "8168533983289",
            "8168629043257",
            "8168589525049",
            "8168432435257",
            "8324152492089",
            "8168590934073",
            "8168591261753",
            "8168609185849"
          ],
          "rankedProductHandles": [
            "dahua-dh-sdt3e410-8p-mb-a-pv1-8mp4mp-10x-starlight-tioc-panoramic-ptz-security-camera",
            "dahua-dh-ipc-hdw3867em-s-il-anz-with-smart-dual-light-30m-ir-black",
            "dahua-dh-ipc-hdw3867em-s-il-anz-with-smart-warm-light-30m-ir",
            "dahua-dh-ipc-hdbw3867e-as-il-anz-8mp-smart-dual-light-fixed-focal-dome-wizsense-network-camera",
            "dahua-ipc-hfw3867t-zas-il-anz-8mp-8mp-smart-dual-light-vari-focal-bullet-wizsense-motorised",
            "dahua-dh-ipc-hdbw3867r-zas-il-anz-8-mp-smart-dual-light-vari-focal-dome-wizsense-network-camera",
            "dahua-ipc-hfw3667t-zas-il-anz-6mp-smart-dual-light-vari-focal-bullet-wizsense-ip-camera",
            "dahua-dh-ipc-hdw3867t-zs-il-anz-8mp-smart-dual-light-varifocal-turret-network-camera",
            "dahua-ipc-hdw5849h-ase-led-s2-8mp-wizmind-full-color-eyeball-camera-with-warm-led",
            "dahua-dh-ipc-hdbw3867r-zas-il-anz-8-mp-smart-dual-light-vari-focal-dome-wizsense-network-camera-black"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 2,
          "rankedProductIds": [
            "8168629043257",
            "8168572452921"
          ],
          "rankedProductHandles": [
            "dahua-dh-ipc-hdbw3867e-as-il-anz-8mp-smart-dual-light-fixed-focal-dome-wizsense-network-camera",
            "dahua-dh-sdt3e410-8p-mb-a-pv1-8mp4mp-10x-starlight-tioc-panoramic-ptz-security-camera"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 13,
          "rankedProductIds": [
            "8168590934073",
            "8168589525049",
            "8168629043257",
            "8168572452921",
            "8168591261753",
            "8168534900793",
            "8168533983289",
            "8168609185849",
            "8168591654969",
            "8168591491129",
            "8168575008825",
            "8168539357241",
            "8168432435257"
          ],
          "rankedProductHandles": [
            "dahua-dh-ipc-hdw3867t-zs-il-anz-8mp-smart-dual-light-varifocal-turret-network-camera",
            "dahua-ipc-hfw3867t-zas-il-anz-8mp-8mp-smart-dual-light-vari-focal-bullet-wizsense-motorised",
            "dahua-dh-ipc-hdbw3867e-as-il-anz-8mp-smart-dual-light-fixed-focal-dome-wizsense-network-camera",
            "dahua-dh-sdt3e410-8p-mb-a-pv1-8mp4mp-10x-starlight-tioc-panoramic-ptz-security-camera",
            "dahua-ipc-hdw5849h-ase-led-s2-8mp-wizmind-full-color-eyeball-camera-with-warm-led",
            "dahua-dh-ipc-hdw3867em-s-il-anz-with-smart-dual-light-30m-ir-black",
            "dahua-dh-ipc-hdw3867em-s-il-anz-with-smart-warm-light-30m-ir",
            "dahua-dh-ipc-hdbw3867r-zas-il-anz-8-mp-smart-dual-light-vari-focal-dome-wizsense-network-camera-black",
            "dahua-dh-ipc-hfw71242h-z-ultra-12mp-ai-ir-bullet-camera-with-smart-analytics-wizmind",
            "dahua-ipc-hdw5842tm-ase-s3-8mp-wizmind-s-series-fixed-focal-eyeball-network-camera",
            "dahua-ipc-hdbw5842ep-ze-s3-8mp-ir-vari-focal-vandal-proof-dome-wizmind-network-camera",
            "dahua-6-x-dh-ipc-hdw3867em-s-il-anz-starlight-turret-cameras-ai-nvr-cctv-kit",
            "dahua-dh-ipc-hdbw3867r-zas-il-anz-8-mp-smart-dual-light-vari-focal-dome-wizsense-network-camera"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 2,
          "rankedProductIds": [
            "8168575598649",
            "8168572452921"
          ],
          "rankedProductHandles": [
            "dahua-dh-ipc-hdw5842tm-ase-8mp-ir-fixed-focal-eyeball-wizmind-network-camera",
            "dahua-dh-sdt3e410-8p-mb-a-pv1-8mp4mp-10x-starlight-tioc-panoramic-ptz-security-camera"
          ]
        }
      }
    },
    "dahua-8mp-ip-cameras-1": {
      "collectionHandle": "dahua-8mp-ip-cameras-1",
      "collectionProductCount": 33,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 3,
          "rankedProductIds": [
            "7591766753337",
            "7591737327673",
            "7591765737529"
          ],
          "rankedProductHandles": [
            "dahua-dh-ipc-hfw2831tp-zas-27135-s2-8mp-4k-wdr-ir-bullet-motorized-2-713-5mm-lite-starlight",
            "dahua-8mp-dh-ipc-hdw3841tp-zas-4k-starlight-ip-turret-motorised-optical-zoom-wdr-ir-50m-ip67-poe",
            "dahua-8mp-4k-starlight-ip-bullet-motorized-2-7-13-5mm-smd-plusperimeter-protection-ir-distance-60m"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 6,
          "rankedProductIds": [
            "7591677460537",
            "7591737327673",
            "7591832485945",
            "7591721500729",
            "7591765737529",
            "7591676051513"
          ],
          "rankedProductHandles": [
            "dahua-ipc-hfw1831cp-pir-0280b-8mp-4k-starlight-ip-mini-bullet-fixed-2-8mm-ir-20mwhite-light",
            "dahua-8mp-dh-ipc-hdw3841tp-zas-4k-starlight-ip-turret-motorised-optical-zoom-wdr-ir-50m-ip67-poe",
            "dahua-dh-ipc-hfw3866tp-zas-aus-8mp-4k-wdr-ir-bullet-motorised-black",
            "dahua-dh-ipc-hfw2831tp-as-0360b-s2-8mp-wdr-ir-mini-bullet-network-camera-with-3-6mm",
            "dahua-8mp-4k-starlight-ip-bullet-motorized-2-7-13-5mm-smd-plusperimeter-protection-ir-distance-60m",
            "dahua-dh-ipc-hfw2831tp-zs-3711-8mp-wdr-ir-bullet-motorised-network-camera"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 16,
          "rankedProductIds": [
            "7591832354873",
            "7591843070009",
            "7591766753337",
            "7591737327673",
            "7591832485945",
            "7591713996857",
            "7591803093049",
            "7591765737529",
            "7591821869113",
            "7591817904185",
            "7591811973177",
            "7591960379449",
            "7591676051513",
            "7591677460537",
            "7591726121017",
            "7591713898553"
          ],
          "rankedProductHandles": [
            "dahua-8mp-dh-ipc-hdw3866tp-zs-aus-4k-starlight-ip-turret-motorised-wdr-ir-40m-black",
            "dahua-dh-ipc-hfw3866ep-as-aus-8mp-4k-bullet-fixed-starlight-wizsense-camera",
            "dahua-dh-ipc-hfw2831tp-zas-27135-s2-8mp-4k-wdr-ir-bullet-motorized-2-713-5mm-lite-starlight",
            "dahua-8mp-dh-ipc-hdw3841tp-zas-4k-starlight-ip-turret-motorised-optical-zoom-wdr-ir-50m-ip67-poe",
            "dahua-dh-ipc-hfw3866tp-zas-aus-8mp-4k-wdr-ir-bullet-motorised-black",
            "dahua-8mp-dh-ipc-hdw2831tp-zs-27135-s2-4k-starlight-ip-turret-motorizedicrwdrir-40mip67poe",
            "dahua-8mp-dh-ipc-hdw3866tp-zs-aus-4k-starlight-ip-turret-motorised-wdr-ir-50m-ip67-poe",
            "dahua-8mp-4k-starlight-ip-bullet-motorized-2-7-13-5mm-smd-plusperimeter-protection-ir-distance-60m",
            "dahua-dh-ipc-hdw3866emp-s-aus-8mp-turret-2-8mm-wizsense-starlight-smd-4-0-black",
            "dahua-8mp-dh-ipc-hdbw3866rp-zas-aus-4k-starlight-ip-dome-motorised-wdr-ir-40m",
            "dahua-dh-ipc-hdw3866emp-s-aus-8mp-turret-2-8mm-wizsense-starlight-smd-4-0",
            "dahua-8-mp-8-channels-kit-6-x-wizsense-fixed-starlight-turret-cameras-ai-nvr-black",
            "dahua-dh-ipc-hfw2831tp-zs-3711-8mp-wdr-ir-bullet-motorised-network-camera",
            "dahua-ipc-hfw1831cp-pir-0280b-8mp-4k-starlight-ip-mini-bullet-fixed-2-8mm-ir-20mwhite-light",
            "dahua-dh-ipc-hdw3841emp-as-0280b-8mp-eyeball-network-camera-50m-ir-2-8mm-with-smd",
            "dahua-dh-ipc-hfw2831sp-s-0280b-s2-8mp-wdr-ir-mini-bullet-network-camera-with-2-8mm"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 4,
          "rankedProductIds": [
            "7591843070009",
            "7591840940089",
            "7591721500729",
            "7591726121017"
          ],
          "rankedProductHandles": [
            "dahua-dh-ipc-hfw3866ep-as-aus-8mp-4k-bullet-fixed-starlight-wizsense-camera",
            "dahua-8mp-dh-ipc-hdbw3866ep-as-aus-4k-starlight-ip-dome-wdr-ir-30m",
            "dahua-dh-ipc-hfw2831tp-as-0360b-s2-8mp-wdr-ir-mini-bullet-network-camera-with-3-6mm",
            "dahua-dh-ipc-hdw3841emp-as-0280b-8mp-eyeball-network-camera-50m-ir-2-8mm-with-smd"
          ]
        }
      }
    },
    "dahua-8mp-ir-dome-cameras": {
      "collectionHandle": "dahua-8mp-ir-dome-cameras",
      "collectionProductCount": 11,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 2,
          "rankedProductIds": [
            "8168432435257",
            "8168609185849"
          ],
          "rankedProductHandles": [
            "dahua-dh-ipc-hdbw3867r-zas-il-anz-8-mp-smart-dual-light-vari-focal-dome-wizsense-network-camera",
            "dahua-dh-ipc-hdbw3867r-zas-il-anz-8-mp-smart-dual-light-vari-focal-dome-wizsense-network-camera-black"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 4,
          "rankedProductIds": [
            "8168575008825",
            "8168609185849",
            "8168432435257",
            "7591960379449"
          ],
          "rankedProductHandles": [
            "dahua-ipc-hdbw5842ep-ze-s3-8mp-ir-vari-focal-vandal-proof-dome-wizmind-network-camera",
            "dahua-dh-ipc-hdbw3867r-zas-il-anz-8-mp-smart-dual-light-vari-focal-dome-wizsense-network-camera-black",
            "dahua-dh-ipc-hdbw3867r-zas-il-anz-8-mp-smart-dual-light-vari-focal-dome-wizsense-network-camera",
            "dahua-8-mp-8-channels-kit-6-x-wizsense-fixed-starlight-turret-cameras-ai-nvr-black"
          ]
        }
      }
    },
    "dahua-8mp-ir-eyeball-cameras": {
      "collectionHandle": "dahua-8mp-ir-eyeball-cameras",
      "collectionProductCount": 58,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 16,
          "rankedProductIds": [
            "7591857061945",
            "7591770914873",
            "7591829831737",
            "8168553316409",
            "8168425881657",
            "8168406024249",
            "8168534900793",
            "8168533983289",
            "7591800406073",
            "8168629043257",
            "8168590934073",
            "8284512157753",
            "8168591261753",
            "7591737327673",
            "7591945175097",
            "7591864729657"
          ],
          "rankedProductHandles": [
            "dahua-tioc-advanced-2-0-dh-ipc-hdbw3849r1p-zas-pv-27135-8mp-starlight-ip-dome-motorised-2-7-13-5mm",
            "dahua-tioc-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3849h-as-pv-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-dh-ipc-hdw3849h-as-pv-pro-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-3-0-ipc-hdw3849h-as-pv-anz-s2-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-dh-ipc-hdw3849hp-as-pv-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-fixed-2-8mm-mic-speaker-wizsense",
            "dahua-dh-ipc-hdw3867em-s-il-anz-with-smart-dual-light-30m-ir-black",
            "dahua-dh-ipc-hdw3867em-s-il-anz-with-smart-warm-light-30m-ir",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-blk-8mp-ai-active-deterrence-full-color-ip-turret-camera-black",
            "dahua-dh-ipc-hdbw3867e-as-il-anz-8mp-smart-dual-light-fixed-focal-dome-wizsense-network-camera",
            "dahua-dh-ipc-hdw3867t-zs-il-anz-8mp-smart-dual-light-varifocal-turret-network-camera",
            "dahua-ipc-hdw3849h-zas-pv-pro-anz-8mp-4k-wizsense-tioc-pro-vari-focal-eyeball-network-camera",
            "dahua-ipc-hdw5849h-ase-led-s2-8mp-wizmind-full-color-eyeball-camera-with-warm-led",
            "dahua-8mp-dh-ipc-hdw3841tp-zas-4k-starlight-ip-turret-motorised-optical-zoom-wdr-ir-50m-ip67-poe",
            "dahua-dh-ipc-pdw3849-a180-as-pv-anz-blk-tioc-duo-splicing-turret-fixed-camera-black",
            "dahua-dh-ipc-pdw3849-a180-as-pv-anz-tioc-duo-splicing-turret-fixed-camera"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 16,
          "rankedProductIds": [
            "8324155277369",
            "7591770914873",
            "7591800406073",
            "8168553316409",
            "8284512157753",
            "8168629043257",
            "7591945175097",
            "7591864729657",
            "8168425881657",
            "8168406024249",
            "7591947927609",
            "7591830323257",
            "7591829831737",
            "7591932756025",
            "7591945568313",
            "7591737327673"
          ],
          "rankedProductHandles": [
            "dahua-8mp-wizmind-dh-ipc-hdw5859h-ase-pv-pro-pro-series-wizcolor-turret-camera-with-active-deterrence-2-way-audio-60m-ir",
            "dahua-tioc-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-blk-8mp-ai-active-deterrence-full-color-ip-turret-camera-black",
            "dahua-tioc-dh-ipc-hdw3849h-as-pv-pro-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-ipc-hdw3849h-zas-pv-pro-anz-8mp-4k-wizsense-tioc-pro-vari-focal-eyeball-network-camera",
            "dahua-dh-ipc-hdbw3867e-as-il-anz-8mp-smart-dual-light-fixed-focal-dome-wizsense-network-camera",
            "dahua-dh-ipc-pdw3849-a180-as-pv-anz-blk-tioc-duo-splicing-turret-fixed-camera-black",
            "dahua-dh-ipc-pdw3849-a180-as-pv-anz-tioc-duo-splicing-turret-fixed-camera",
            "dahua-tioc-advanced-3-0-ipc-hdw3849h-as-pv-anz-s2-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-dh-ipc-hdw3849hp-as-pv-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-fixed-2-8mm-mic-speaker-wizsense",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3849h-as-pv-anz-8mp-ai-active-deterrence-full-color",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3849h-as-pv-anz-blk-8mp-ai-active-deterrence-full-color-ip-turret-camera-black",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3849h-as-pv-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-dh-ipc-hdw3849h-zas-pv-anz-8mp-ai-active-deterrence-motorised-turret-camera",
            "dahua-tioc-dh-ipc-hdw3849h-zas-pv-anz-8mp-ai-active-deterrence-motorised-turret-camera-black",
            "dahua-8mp-dh-ipc-hdw3841tp-zas-4k-starlight-ip-turret-motorised-optical-zoom-wdr-ir-50m-ip67-poe"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 16,
          "rankedProductIds": [
            "8168590934073",
            "7591770914873",
            "7591800406073",
            "7591832354873",
            "8168553316409",
            "8284512157753",
            "7591737327673",
            "7591932756025",
            "8168629043257",
            "8168591261753",
            "8168534900793",
            "8168533983289",
            "7591713996857",
            "7591945568313",
            "7591945175097",
            "7591864729657"
          ],
          "rankedProductHandles": [
            "dahua-dh-ipc-hdw3867t-zs-il-anz-8mp-smart-dual-light-varifocal-turret-network-camera",
            "dahua-tioc-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-blk-8mp-ai-active-deterrence-full-color-ip-turret-camera-black",
            "dahua-8mp-dh-ipc-hdw3866tp-zs-aus-4k-starlight-ip-turret-motorised-wdr-ir-40m-black",
            "dahua-tioc-dh-ipc-hdw3849h-as-pv-pro-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-ipc-hdw3849h-zas-pv-pro-anz-8mp-4k-wizsense-tioc-pro-vari-focal-eyeball-network-camera",
            "dahua-8mp-dh-ipc-hdw3841tp-zas-4k-starlight-ip-turret-motorised-optical-zoom-wdr-ir-50m-ip67-poe",
            "dahua-tioc-dh-ipc-hdw3849h-zas-pv-anz-8mp-ai-active-deterrence-motorised-turret-camera",
            "dahua-dh-ipc-hdbw3867e-as-il-anz-8mp-smart-dual-light-fixed-focal-dome-wizsense-network-camera",
            "dahua-ipc-hdw5849h-ase-led-s2-8mp-wizmind-full-color-eyeball-camera-with-warm-led",
            "dahua-dh-ipc-hdw3867em-s-il-anz-with-smart-dual-light-30m-ir-black",
            "dahua-dh-ipc-hdw3867em-s-il-anz-with-smart-warm-light-30m-ir",
            "dahua-8mp-dh-ipc-hdw2831tp-zs-27135-s2-4k-starlight-ip-turret-motorizedicrwdrir-40mip67poe",
            "dahua-tioc-dh-ipc-hdw3849h-zas-pv-anz-8mp-ai-active-deterrence-motorised-turret-camera-black",
            "dahua-dh-ipc-pdw3849-a180-as-pv-anz-blk-tioc-duo-splicing-turret-fixed-camera-black",
            "dahua-dh-ipc-pdw3849-a180-as-pv-anz-tioc-duo-splicing-turret-fixed-camera"
          ]
        }
      }
    },
    "dahua-8mp-tioc-cameras": {
      "collectionHandle": "dahua-8mp-tioc-cameras",
      "collectionProductCount": 2,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "dahua-8mp-tioc-cctv-kits": {
      "collectionHandle": "dahua-8mp-tioc-cctv-kits",
      "collectionProductCount": 2,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "dahua-anpr-cameras-automatic-number-plate-recognition-1": {
      "collectionHandle": "dahua-anpr-cameras-automatic-number-plate-recognition-1",
      "collectionProductCount": 4,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 2,
          "rankedProductIds": [
            "7591915520057",
            "7591796539449"
          ],
          "rankedProductHandles": [
            "dahua-dhi-itc413-pw4d-iz3-ai-access-anpr-4mp-8-32mm-k",
            "dahua-anpr-short-range-motorised-camera-max-8m-distance"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 2,
          "rankedProductIds": [
            "7591915520057",
            "8168610201657"
          ],
          "rankedProductHandles": [
            "dahua-dhi-itc413-pw4d-iz3-ai-access-anpr-4mp-8-32mm-k",
            "dahua-itc413-pw4d-iz1-anpr-camera-4mp-motorized-vari-focal-ir-license-plate-recognition-2-7-12mm"
          ]
        }
      }
    },
    "dahua-bullet-cameras-1": {
      "collectionHandle": "dahua-bullet-cameras-1",
      "collectionProductCount": 44,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 11,
          "rankedProductIds": [
            "7591785365561",
            "8168542044217",
            "8284590407737",
            "8168609087545",
            "8168415559737",
            "7591832158265",
            "7591831109689",
            "7591824752697",
            "7591787495481",
            "7591643185209",
            "7591765737529"
          ],
          "rankedProductHandles": [
            "dahua-tioc-advanced-2-0-dh-ipc-hfw3849t1p-as-pv-0280b-s3-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-built-in-mic-speakerip67poe-wizsense",
            "dahua-tioc-dh-ipc-hfw3849t1-as-pv-anz-s2-blk-8mp-ai-active-deterrence-ip-bullet-fixed-2-8mm-black",
            "dahua-ipc-pfw3849s-a180-as-pv-8mp-180-tioc-duo-splicing-bullet-wizsense-network-camera",
            "dahua-ipc-hfw3849t1-as-pv-pro-8mp-smart-dual-light-active-deterrence-fixed-focal-bullet-camera-2-8-mm",
            "dahua-dh-ipc-hfw3849t1-zas-pv-anz-s2-8mp-smart-dual-active-deterrence-vari-focal-bullet-wizsense-network-camera",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-blk-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-black",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm",
            "dahua-tioc-advanced-2-0-dh-ipc-hfw3849t1p-as-pv-0280b-s3-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm",
            "dahua-tioc-2-0-advanced-dh-ipc-hfw3549t1p-as-pv-0280b-s3-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-built-in-mic-speaker-ip67-poe-wizsense",
            "dahua-dh-hac-hfw2802tp-z-dp-4k-starlight-hdcvi-ir-bullet-camera",
            "dahua-8mp-4k-starlight-ip-bullet-motorized-2-7-13-5mm-smd-plusperimeter-protection-ir-distance-60m"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 16,
          "rankedProductIds": [
            "7591787495481",
            "8168598175801",
            "8168542044217",
            "8284590407737",
            "8168609087545",
            "7591932067897",
            "8168415559737",
            "7591832158265",
            "7591831109689",
            "7591830618169",
            "7591824752697",
            "7591915520057",
            "7591804731449",
            "7591785365561",
            "7591677460537",
            "7591818199097"
          ],
          "rankedProductHandles": [
            "dahua-tioc-2-0-advanced-dh-ipc-hfw3549t1p-as-pv-0280b-s3-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-built-in-mic-speaker-ip67-poe-wizsense",
            "dahua-ipc-hfw3667e-as-il-anz-6-mp-smart-dual-light-bullet-camera-wizsense-3-series",
            "dahua-tioc-dh-ipc-hfw3849t1-as-pv-anz-s2-blk-8mp-ai-active-deterrence-ip-bullet-fixed-2-8mm-black",
            "dahua-ipc-pfw3849s-a180-as-pv-8mp-180-tioc-duo-splicing-bullet-wizsense-network-camera",
            "dahua-ipc-hfw3849t1-as-pv-pro-8mp-smart-dual-light-active-deterrence-fixed-focal-bullet-camera-2-8-mm",
            "dahua-tioc-2-0-black-dh-ipc-hfw3649t1-as-pv-anz-6mp-ai-active-deterrence-fixed-lens-bullet-camera",
            "dahua-dh-ipc-hfw3849t1-zas-pv-anz-s2-8mp-smart-dual-active-deterrence-vari-focal-bullet-wizsense-network-camera",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-blk-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-black",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm",
            "dahua-tioc-3-0-advanced-dh-ipc-hfw3649t1-as-pv-anz-6mp-ai-active-deterrence-motorised-bullet-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hfw3849t1p-as-pv-0280b-s3-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm",
            "dahua-dhi-itc413-pw4d-iz3-ai-access-anpr-4mp-8-32mm-k",
            "dahua-tioc-2-0-advanced-dh-ipc-hfw3549t1-zas-pv-5mp-ai-active-deterrence-motorised-bullet-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hfw3849t1p-as-pv-0280b-s3-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-built-in-mic-speakerip67poe-wizsense",
            "dahua-ipc-hfw1831cp-pir-0280b-8mp-4k-starlight-ip-mini-bullet-fixed-2-8mm-ir-20mwhite-light",
            "dahua-dh-ipc-hfw3666ep-as-aus-6mp-bullet-network-camera-50m-ir-2-8mm-with-smd-4-0-wizsense"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 16,
          "rankedProductIds": [
            "7591915520057",
            "8168610201657",
            "7591718027321",
            "7591796539449",
            "8168542044217",
            "8284590407737",
            "8168609087545",
            "8168415559737",
            "7591832158265",
            "7591671889977",
            "7591831109689",
            "7591765737529",
            "8168591654969",
            "7591824752697",
            "8168591491129",
            "7591677460537"
          ],
          "rankedProductHandles": [
            "dahua-dhi-itc413-pw4d-iz3-ai-access-anpr-4mp-8-32mm-k",
            "dahua-itc413-pw4d-iz1-anpr-camera-4mp-motorized-vari-focal-ir-license-plate-recognition-2-7-12mm",
            "dahua-dhi-itc237-pw6m-irlzf1050-ai-access-anpr-2-megapixel-full-hd-wdr-anpr-camera-ir-max-40km-hr-10-50mm-motorized-lens",
            "dahua-anpr-short-range-motorised-camera-max-8m-distance",
            "dahua-tioc-dh-ipc-hfw3849t1-as-pv-anz-s2-blk-8mp-ai-active-deterrence-ip-bullet-fixed-2-8mm-black",
            "dahua-ipc-pfw3849s-a180-as-pv-8mp-180-tioc-duo-splicing-bullet-wizsense-network-camera",
            "dahua-ipc-hfw3849t1-as-pv-pro-8mp-smart-dual-light-active-deterrence-fixed-focal-bullet-camera-2-8-mm",
            "dahua-dh-ipc-hfw3849t1-zas-pv-anz-s2-8mp-smart-dual-active-deterrence-vari-focal-bullet-wizsense-network-camera",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-blk-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-black",
            "dahua-dh-ipc-hfw2431tp-zs-27135-4mp-wdr-ir-bullet-network-camera-2-7-13-5mm-motorized-lens",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm",
            "dahua-8mp-4k-starlight-ip-bullet-motorized-2-7-13-5mm-smd-plusperimeter-protection-ir-distance-60m",
            "dahua-dh-ipc-hfw71242h-z-ultra-12mp-ai-ir-bullet-camera-with-smart-analytics-wizmind",
            "dahua-tioc-advanced-2-0-dh-ipc-hfw3849t1p-as-pv-0280b-s3-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm",
            "dahua-ipc-hdw5842tm-ase-s3-8mp-wizmind-s-series-fixed-focal-eyeball-network-camera",
            "dahua-ipc-hfw1831cp-pir-0280b-8mp-4k-starlight-ip-mini-bullet-fixed-2-8mm-ir-20mwhite-light"
          ]
        }
      }
    },
    "dahua-cctv": {
      "collectionHandle": "dahua-cctv",
      "collectionProductCount": 86,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 8,
          "rankedProductIds": [
            "8168606236729",
            "8168606662713",
            "8168627863609",
            "8168606826553",
            "8168605614137",
            "8168605155385",
            "8168606892089",
            "8168481783865"
          ],
          "rankedProductHandles": [
            "dahua-6mp-8ch-cctv-kit-6x-smart-dual-light-turret-cameras-with-smd-4-0-mic-8ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4108hs-8p-ai-anz",
            "dahua-6mp-8ch-cctv-kit-8x-smart-dual-light-turret-cameras-with-smd-4-0-mic-8ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4108hs-8p-ai-anz",
            "dahua-6mp-4ch-cctv-kit-4x-smart-dual-light-turret-cameras-with-smd-4-0-mic-4ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4104hs-4p-ai-anz",
            "dahua-6mp-16ch-cctv-kit-8x-smart-dual-light-turret-cameras-with-smd-4-0-mic-16ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4216-16p-ai-anz",
            "dahua-6mp-8ch-cctv-kit-4x-smart-dual-light-turret-cameras-with-smd-4-0-mic-8ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4108hs-8p-ai-anz",
            "dahua-6mp-4ch-cctv-kit-2x-smart-dual-light-turret-cameras-with-smd-4-0-mic-4ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4104hs-p-ai-anz",
            "dahua-6mp-16ch-cctv-kit-10x-smart-dual-light-turret-cameras-with-smd-4-0-mic-16ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4216-16p-ai-anz",
            "dahua-4-x-8mp-tioc-cctv-kit-full-colour-night-vision-audible-warning-4ch-poe-ai-nvr"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 3,
          "rankedProductIds": [
            "8168606662713",
            "8168481783865",
            "8168575205433"
          ],
          "rankedProductHandles": [
            "dahua-6mp-8ch-cctv-kit-8x-smart-dual-light-turret-cameras-with-smd-4-0-mic-8ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4108hs-8p-ai-anz",
            "dahua-4-x-8mp-tioc-cctv-kit-full-colour-night-vision-audible-warning-4ch-poe-ai-nvr",
            "dahua-10-x-8mp-dh-ipc-hdw3867em-s-il-anz-fixed-starlight-turret-cameras-16ch-ai-nvr"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 6,
          "rankedProductIds": [
            "8168540536889",
            "8168539357241",
            "8168575205433",
            "8168481783865",
            "8168410021945",
            "8168537227321"
          ],
          "rankedProductHandles": [
            "dahua-8-x-8mp-dh-ipc-hdw3867em-s-il-anz-fixed-starlight-turret-cameras-8ch-ai-nvr",
            "dahua-6-x-dh-ipc-hdw3867em-s-il-anz-starlight-turret-cameras-ai-nvr-cctv-kit",
            "dahua-10-x-8mp-dh-ipc-hdw3867em-s-il-anz-fixed-starlight-turret-cameras-16ch-ai-nvr",
            "dahua-4-x-8mp-tioc-cctv-kit-full-colour-night-vision-audible-warning-4ch-poe-ai-nvr",
            "dahua-10-x-8mp-dh-ipc-hdw3866emp-s-aus-smd-4-0-turret-security-kit-with-16ch-ai-nvr-2-8mm-lens",
            "dahua-4-x-8mp-dh-ipc-hdw3867em-s-il-anz-turret-security-cctv-kit-with-8ch-wizsense-nvr"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 5,
          "rankedProductIds": [
            "8168540536889",
            "8168575205433",
            "8168606826553",
            "8168606662713",
            "8168606892089"
          ],
          "rankedProductHandles": [
            "dahua-8-x-8mp-dh-ipc-hdw3867em-s-il-anz-fixed-starlight-turret-cameras-8ch-ai-nvr",
            "dahua-10-x-8mp-dh-ipc-hdw3867em-s-il-anz-fixed-starlight-turret-cameras-16ch-ai-nvr",
            "dahua-6mp-16ch-cctv-kit-8x-smart-dual-light-turret-cameras-with-smd-4-0-mic-16ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4216-16p-ai-anz",
            "dahua-6mp-8ch-cctv-kit-8x-smart-dual-light-turret-cameras-with-smd-4-0-mic-8ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4108hs-8p-ai-anz",
            "dahua-6mp-16ch-cctv-kit-10x-smart-dual-light-turret-cameras-with-smd-4-0-mic-16ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4216-16p-ai-anz"
          ]
        }
      }
    },
    "dahua-cctv-1": {
      "collectionHandle": "dahua-cctv-1",
      "collectionProductCount": 256,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "dahua-cctv-camera-kits": {
      "collectionHandle": "dahua-cctv-camera-kits",
      "collectionProductCount": 55,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 18,
          "rankedProductIds": [
            "8168606236729",
            "8168606662713",
            "8168627863609",
            "8168606826553",
            "8168605614137",
            "7591735689273",
            "7591957495865",
            "7591959068729",
            "7591737196601",
            "7591931772985",
            "7591958249529",
            "7591738966073",
            "8168605155385",
            "8168606892089",
            "7591930462265",
            "7591735197753",
            "7591790706745",
            "8168481783865"
          ],
          "rankedProductHandles": [
            "dahua-6mp-8ch-cctv-kit-6x-smart-dual-light-turret-cameras-with-smd-4-0-mic-8ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4108hs-8p-ai-anz",
            "dahua-6mp-8ch-cctv-kit-8x-smart-dual-light-turret-cameras-with-smd-4-0-mic-8ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4108hs-8p-ai-anz",
            "dahua-6mp-4ch-cctv-kit-4x-smart-dual-light-turret-cameras-with-smd-4-0-mic-4ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4104hs-4p-ai-anz",
            "dahua-6mp-16ch-cctv-kit-8x-smart-dual-light-turret-cameras-with-smd-4-0-mic-16ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4216-16p-ai-anz",
            "dahua-6mp-8ch-cctv-kit-4x-smart-dual-light-turret-cameras-with-smd-4-0-mic-8ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4108hs-8p-ai-anz",
            "dahua-6-x-8mp-dh-ipc-hdw3849hp-as-pv-tioc-with-wizsense-turret-kit-with-8ch-nvr",
            "dahua-8-mp-8-channels-kit-2-x-8mp-tioc-and-2-x-8mp-turret-cameras-with-8ch-ai-nvr",
            "dahua-8-mp-8-channels-kit-2-x-8mp-tioc-and-2-x-8mp-turret-cameras-with-8ch-ai-nvr-black",
            "dahua-8-x-8mp-dh-ipc-hdw3849hp-as-pv-tioc-with-wizsense-turret-kit-with-8ch",
            "dahua-8-x-8mp-black-tioc-advanced-2-0-with-smd4-0-active-deterrance-turret-kit-with-8ch-wizsense-nvr",
            "dahua-8-mp-16-channels-kit-10-x-wizsense-fixed-starlight-turret-cameras-ai-nvr-black",
            "dahua-4-x-8mp-dh-ipc-hdw3849hp-as-pv-tioc-with-wizsense-turret-kit-with-8ch-nvr",
            "dahua-6mp-4ch-cctv-kit-2x-smart-dual-light-turret-cameras-with-smd-4-0-mic-4ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4104hs-p-ai-anz",
            "dahua-6mp-16ch-cctv-kit-10x-smart-dual-light-turret-cameras-with-smd-4-0-mic-16ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4216-16p-ai-anz",
            "dahua-4-x-black-8mp-tioc-smd4-0-dh-ipc-hdw3849h-as-pv-anz-turret-kit-with-8ch-nvr",
            "dahua-4-x-5mp-dh-ipc-hdw3549hp-as-pv-0280b-tioc-with-wizsense-turret-kit-with-4ch-nvr-2tb-hdd",
            "dahua-4-x-6mp-tioc-advanced-2-0-dh-ipc-hdw3649h-as-pv-anz-turret-kit-4ch-nvr",
            "dahua-4-x-8mp-tioc-cctv-kit-full-colour-night-vision-audible-warning-4ch-poe-ai-nvr"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 18,
          "rankedProductIds": [
            "7591962476601",
            "8168606662713",
            "7591737196601",
            "7591735689273",
            "7591738966073",
            "7591735197753",
            "7591790706745",
            "7591957495865",
            "7591959068729",
            "7690800070713",
            "7591931772985",
            "7591752532025",
            "8168481783865",
            "8168575205433",
            "7591930462265",
            "7591930953785",
            "7591809384505",
            "7591811514425"
          ],
          "rankedProductHandles": [
            "dahua-4-x-8mp-tioc-cctv-kit-full-colour-night-vision-audible-warning-and-two-way-audio-with-poe-ai-nvr",
            "dahua-6mp-8ch-cctv-kit-8x-smart-dual-light-turret-cameras-with-smd-4-0-mic-8ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4108hs-8p-ai-anz",
            "dahua-8-x-8mp-dh-ipc-hdw3849hp-as-pv-tioc-with-wizsense-turret-kit-with-8ch",
            "dahua-6-x-8mp-dh-ipc-hdw3849hp-as-pv-tioc-with-wizsense-turret-kit-with-8ch-nvr",
            "dahua-4-x-8mp-dh-ipc-hdw3849hp-as-pv-tioc-with-wizsense-turret-kit-with-8ch-nvr",
            "dahua-4-x-5mp-dh-ipc-hdw3549hp-as-pv-0280b-tioc-with-wizsense-turret-kit-with-4ch-nvr-2tb-hdd",
            "dahua-4-x-6mp-tioc-advanced-2-0-dh-ipc-hdw3649h-as-pv-anz-turret-kit-4ch-nvr",
            "dahua-8-mp-8-channels-kit-2-x-8mp-tioc-and-2-x-8mp-turret-cameras-with-8ch-ai-nvr",
            "dahua-8-mp-8-channels-kit-2-x-8mp-tioc-and-2-x-8mp-turret-cameras-with-8ch-ai-nvr-black",
            "dahua-8-x-6mp-tioc-dh-ipc-hdw3649h-as-pv-anz-turret-kit-with-8ch-ai-nvr",
            "dahua-8-x-8mp-black-tioc-advanced-2-0-with-smd4-0-active-deterrance-turret-kit-with-8ch-wizsense-nvr",
            "dahua-6-x-8mp-wizsense-turret-kit-with-8ch-pro-nvr-2tb-hdd-2-8mm-lens",
            "dahua-4-x-8mp-tioc-cctv-kit-full-colour-night-vision-audible-warning-4ch-poe-ai-nvr",
            "dahua-10-x-8mp-dh-ipc-hdw3867em-s-il-anz-fixed-starlight-turret-cameras-16ch-ai-nvr",
            "dahua-4-x-black-8mp-tioc-smd4-0-dh-ipc-hdw3849h-as-pv-anz-turret-kit-with-8ch-nvr",
            "dahua-6-x-black-8mp-tioc-with-smd4-0-dh-ipc-hdw3849h-as-pv-anz-active-deterrance-turret-kit-with-8ch-nvr-wizsense",
            "dahua-6-x-6mp-dh-ipc-hdw3666emp-s-aus-smd-4-0-ai-turret-kit-50m-ir-2-8mm-with-smd-8ch-nvr-2tb-hdd-wizsense",
            "dahua-8-x-6mp-dh-ipc-hdw3666emp-s-aus-smd-4-0-ai-turret-kit-50m-ir-2-8mm-with-smd-8ch-nvr"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 18,
          "rankedProductIds": [
            "7591970439225",
            "8168540536889",
            "7591970046009",
            "7591968178233",
            "8168539357241",
            "7591737196601",
            "7591735689273",
            "7591738966073",
            "7591753121849",
            "7591752532025",
            "7591957495865",
            "7591959068729",
            "7591752695865",
            "8168575205433",
            "7591931772985",
            "8168481783865",
            "8168410021945",
            "7591767834681"
          ],
          "rankedProductHandles": [
            "dahua-8-mp-8-channels-kit-6-x-wizsense-fixed-starlight-turret-cameras-ai-nvr",
            "dahua-8-x-8mp-dh-ipc-hdw3867em-s-il-anz-fixed-starlight-turret-cameras-8ch-ai-nvr",
            "dahua-8-mp-4-channels-kit-4-x-wizsense-fixed-starlight-turret-cameras-ai-nvr",
            "dahua-8-mp-4-channels-kit-4-x-wizsense-fixed-starlight-turret-cameras-ai-nvr-black",
            "dahua-6-x-dh-ipc-hdw3867em-s-il-anz-starlight-turret-cameras-ai-nvr-cctv-kit",
            "dahua-8-x-8mp-dh-ipc-hdw3849hp-as-pv-tioc-with-wizsense-turret-kit-with-8ch",
            "dahua-6-x-8mp-dh-ipc-hdw3849hp-as-pv-tioc-with-wizsense-turret-kit-with-8ch-nvr",
            "dahua-4-x-8mp-dh-ipc-hdw3849hp-as-pv-tioc-with-wizsense-turret-kit-with-8ch-nvr",
            "dahua-8-x-8mp-wizsense-turret-kit-with-8ch-pro-nvr-2tb-hdd-2-8mm-lens",
            "dahua-6-x-8mp-wizsense-turret-kit-with-8ch-pro-nvr-2tb-hdd-2-8mm-lens",
            "dahua-8-mp-8-channels-kit-2-x-8mp-tioc-and-2-x-8mp-turret-cameras-with-8ch-ai-nvr",
            "dahua-8-mp-8-channels-kit-2-x-8mp-tioc-and-2-x-8mp-turret-cameras-with-8ch-ai-nvr-black",
            "dahua-4-x-8mp-wizsense-turret-kit-with-8ch-pro-nvr-2tb-hdd-2-8mm-lens",
            "dahua-10-x-8mp-dh-ipc-hdw3867em-s-il-anz-fixed-starlight-turret-cameras-16ch-ai-nvr",
            "dahua-8-x-8mp-black-tioc-advanced-2-0-with-smd4-0-active-deterrance-turret-kit-with-8ch-wizsense-nvr",
            "dahua-4-x-8mp-tioc-cctv-kit-full-colour-night-vision-audible-warning-4ch-poe-ai-nvr",
            "dahua-10-x-8mp-dh-ipc-hdw3866emp-s-aus-smd-4-0-turret-security-kit-with-16ch-ai-nvr-2-8mm-lens",
            "dahua-10-x-8mp-wizsense-turret-security-kit-with-16ch-pro-nvr-2-8mm-lens"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 7,
          "rankedProductIds": [
            "8168540536889",
            "8168575205433",
            "7591958249529",
            "8168606662713",
            "8168606826553",
            "7591970439225",
            "8168606892089"
          ],
          "rankedProductHandles": [
            "dahua-8-x-8mp-dh-ipc-hdw3867em-s-il-anz-fixed-starlight-turret-cameras-8ch-ai-nvr",
            "dahua-10-x-8mp-dh-ipc-hdw3867em-s-il-anz-fixed-starlight-turret-cameras-16ch-ai-nvr",
            "dahua-8-mp-16-channels-kit-10-x-wizsense-fixed-starlight-turret-cameras-ai-nvr-black",
            "dahua-6mp-8ch-cctv-kit-8x-smart-dual-light-turret-cameras-with-smd-4-0-mic-8ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4108hs-8p-ai-anz",
            "dahua-6mp-16ch-cctv-kit-8x-smart-dual-light-turret-cameras-with-smd-4-0-mic-16ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4216-16p-ai-anz",
            "dahua-8-mp-8-channels-kit-6-x-wizsense-fixed-starlight-turret-cameras-ai-nvr",
            "dahua-6mp-16ch-cctv-kit-10x-smart-dual-light-turret-cameras-with-smd-4-0-mic-16ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4216-16p-ai-anz"
          ]
        }
      }
    },
    "dahua-dh-ipc-hdw3641tm-as-6mp-with-smd": {
      "collectionHandle": "dahua-dh-ipc-hdw3641tm-as-6mp-with-smd",
      "collectionProductCount": 27,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 3,
          "rankedProductIds": [
            "7591811514425",
            "7591809384505",
            "7591810007097"
          ],
          "rankedProductHandles": [
            "dahua-8-x-6mp-dh-ipc-hdw3666emp-s-aus-smd-4-0-ai-turret-kit-50m-ir-2-8mm-with-smd-8ch-nvr",
            "dahua-6-x-6mp-dh-ipc-hdw3666emp-s-aus-smd-4-0-ai-turret-kit-50m-ir-2-8mm-with-smd-8ch-nvr-2tb-hdd-wizsense",
            "dahua-4-x-6mp-dh-ipc-hdw3666emp-s-aus-smd-4-0-ai-turret-security-kit-50m-ir-2-8mm-4ch-nvr-2tb-hdd-black"
          ]
        }
      }
    },
    "dahua-dome-camera-packages-1": {
      "collectionHandle": "dahua-dome-camera-packages-1",
      "collectionProductCount": 8,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 2,
          "rankedProductIds": [
            "7591752532025",
            "7591958249529"
          ],
          "rankedProductHandles": [
            "dahua-6-x-8mp-wizsense-turret-kit-with-8ch-pro-nvr-2tb-hdd-2-8mm-lens",
            "dahua-8-mp-16-channels-kit-10-x-wizsense-fixed-starlight-turret-cameras-ai-nvr-black"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 4,
          "rankedProductIds": [
            "8168410021945",
            "7591753121849",
            "8168537227321",
            "7690800005177"
          ],
          "rankedProductHandles": [
            "dahua-10-x-8mp-dh-ipc-hdw3866emp-s-aus-smd-4-0-turret-security-kit-with-16ch-ai-nvr-2-8mm-lens",
            "dahua-8-x-8mp-wizsense-turret-kit-with-8ch-pro-nvr-2tb-hdd-2-8mm-lens",
            "dahua-4-x-8mp-dh-ipc-hdw3867em-s-il-anz-turret-security-cctv-kit-with-8ch-wizsense-nvr",
            "dahua-4-x-8mp-dh-ipc-hdw3866emp-s-aus-turret-security-cctv-kit-with-4ch-wizsense-nvr"
          ]
        }
      }
    },
    "dahua-dome-cameras-1": {
      "collectionHandle": "dahua-dome-cameras-1",
      "collectionProductCount": 33,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 2,
          "rankedProductIds": [
            "8168432435257",
            "8168609185849"
          ],
          "rankedProductHandles": [
            "dahua-dh-ipc-hdbw3867r-zas-il-anz-8-mp-smart-dual-light-vari-focal-dome-wizsense-network-camera",
            "dahua-dh-ipc-hdbw3867r-zas-il-anz-8-mp-smart-dual-light-vari-focal-dome-wizsense-network-camera-black"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 6,
          "rankedProductIds": [
            "7591981678649",
            "7591864500281",
            "7591864270905",
            "7591738048569",
            "7591677886521",
            "7591656587321"
          ],
          "rankedProductHandles": [
            "dahua-dh-ipc-wl46a-4mp-wifi-floodlight-camera-240v",
            "dahua-dh-ipc-hdbw3466ep-as-aus-4mp-wizsense-starlight-dome",
            "dahua-dh-ipc-hdbw3466rp-zas-aus-4mp-wizsense-motorised-starlight-dome",
            "dahua-dh-ipc-hdbw3841rp-zas-27135-8mp-dome-motorised-network-camera-zoom-function-50m-ir-wizsense",
            "dahua-dh-ipc-hdbw5631rp-ze-27135-blk-6mp-wdr-ir-dome-motorised-network-camera",
            "dahua-dh-ipc-hdbw5431e-ze-4mp-motorised-vf-ir-dome-network-camera"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 8,
          "rankedProductIds": [
            "8168575008825",
            "8168609185849",
            "8168432435257",
            "7591738048569",
            "7591960379449",
            "7591864270905",
            "7591677886521",
            "7591656587321"
          ],
          "rankedProductHandles": [
            "dahua-ipc-hdbw5842ep-ze-s3-8mp-ir-vari-focal-vandal-proof-dome-wizmind-network-camera",
            "dahua-dh-ipc-hdbw3867r-zas-il-anz-8-mp-smart-dual-light-vari-focal-dome-wizsense-network-camera-black",
            "dahua-dh-ipc-hdbw3867r-zas-il-anz-8-mp-smart-dual-light-vari-focal-dome-wizsense-network-camera",
            "dahua-dh-ipc-hdbw3841rp-zas-27135-8mp-dome-motorised-network-camera-zoom-function-50m-ir-wizsense",
            "dahua-8-mp-8-channels-kit-6-x-wizsense-fixed-starlight-turret-cameras-ai-nvr-black",
            "dahua-dh-ipc-hdbw3466rp-zas-aus-4mp-wizsense-motorised-starlight-dome",
            "dahua-dh-ipc-hdbw5631rp-ze-27135-blk-6mp-wdr-ir-dome-motorised-network-camera",
            "dahua-dh-ipc-hdbw5431e-ze-4mp-motorised-vf-ir-dome-network-camera"
          ]
        }
      }
    },
    "dahua-dual-light-camera-kits": {
      "collectionHandle": "dahua-dual-light-camera-kits",
      "collectionProductCount": 7,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 4,
          "rankedProductIds": [
            "8168606236729",
            "8168606662713",
            "8168627863609",
            "8168606826553"
          ],
          "rankedProductHandles": [
            "dahua-6mp-8ch-cctv-kit-6x-smart-dual-light-turret-cameras-with-smd-4-0-mic-8ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4108hs-8p-ai-anz",
            "dahua-6mp-8ch-cctv-kit-8x-smart-dual-light-turret-cameras-with-smd-4-0-mic-8ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4108hs-8p-ai-anz",
            "dahua-6mp-4ch-cctv-kit-4x-smart-dual-light-turret-cameras-with-smd-4-0-mic-4ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4104hs-4p-ai-anz",
            "dahua-6mp-16ch-cctv-kit-8x-smart-dual-light-turret-cameras-with-smd-4-0-mic-16ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4216-16p-ai-anz"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 3,
          "rankedProductIds": [
            "8168606826553",
            "8168606662713",
            "8168606892089"
          ],
          "rankedProductHandles": [
            "dahua-6mp-16ch-cctv-kit-8x-smart-dual-light-turret-cameras-with-smd-4-0-mic-16ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4216-16p-ai-anz",
            "dahua-6mp-8ch-cctv-kit-8x-smart-dual-light-turret-cameras-with-smd-4-0-mic-8ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4108hs-8p-ai-anz",
            "dahua-6mp-16ch-cctv-kit-10x-smart-dual-light-turret-cameras-with-smd-4-0-mic-16ch-poe-nvr-dh-ipc-hdw3667em-s-il-anz-dhi-nvr4216-16p-ai-anz"
          ]
        }
      }
    },
    "dahua-eco-savvy-eyeball-cameras-1": {
      "collectionHandle": "dahua-eco-savvy-eyeball-cameras-1",
      "collectionProductCount": 15,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 6,
          "rankedProductIds": [
            "8168534900793",
            "8168629043257",
            "8168590934073",
            "7591737327673",
            "8168591261753",
            "7591642923065"
          ],
          "rankedProductHandles": [
            "dahua-dh-ipc-hdw3867em-s-il-anz-with-smart-dual-light-30m-ir-black",
            "dahua-dh-ipc-hdbw3867e-as-il-anz-8mp-smart-dual-light-fixed-focal-dome-wizsense-network-camera",
            "dahua-dh-ipc-hdw3867t-zs-il-anz-8mp-smart-dual-light-varifocal-turret-network-camera",
            "dahua-8mp-dh-ipc-hdw3841tp-zas-4k-starlight-ip-turret-motorised-optical-zoom-wdr-ir-50m-ip67-poe",
            "dahua-ipc-hdw5849h-ase-led-s2-8mp-wizmind-full-color-eyeball-camera-with-warm-led",
            "dahua-dh-hac-hdw2802tp-z-dp-3711-4k-starlight-hdcvi-ir-eyeball-camera"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 2,
          "rankedProductIds": [
            "8168629043257",
            "7591737327673"
          ],
          "rankedProductHandles": [
            "dahua-dh-ipc-hdbw3867e-as-il-anz-8mp-smart-dual-light-fixed-focal-dome-wizsense-network-camera",
            "dahua-8mp-dh-ipc-hdw3841tp-zas-4k-starlight-ip-turret-motorised-optical-zoom-wdr-ir-50m-ip67-poe"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 9,
          "rankedProductIds": [
            "8168590934073",
            "7591737327673",
            "7591832354873",
            "7591713996857",
            "8168534900793",
            "7591642923065",
            "7591803093049",
            "8168591261753",
            "8168629043257"
          ],
          "rankedProductHandles": [
            "dahua-dh-ipc-hdw3867t-zs-il-anz-8mp-smart-dual-light-varifocal-turret-network-camera",
            "dahua-8mp-dh-ipc-hdw3841tp-zas-4k-starlight-ip-turret-motorised-optical-zoom-wdr-ir-50m-ip67-poe",
            "dahua-8mp-dh-ipc-hdw3866tp-zs-aus-4k-starlight-ip-turret-motorised-wdr-ir-40m-black",
            "dahua-8mp-dh-ipc-hdw2831tp-zs-27135-s2-4k-starlight-ip-turret-motorizedicrwdrir-40mip67poe",
            "dahua-dh-ipc-hdw3867em-s-il-anz-with-smart-dual-light-30m-ir-black",
            "dahua-dh-hac-hdw2802tp-z-dp-3711-4k-starlight-hdcvi-ir-eyeball-camera",
            "dahua-8mp-dh-ipc-hdw3866tp-zs-aus-4k-starlight-ip-turret-motorised-wdr-ir-50m-ip67-poe",
            "dahua-ipc-hdw5849h-ase-led-s2-8mp-wizmind-full-color-eyeball-camera-with-warm-led",
            "dahua-dh-ipc-hdbw3867e-as-il-anz-8mp-smart-dual-light-fixed-focal-dome-wizsense-network-camera"
          ]
        }
      }
    },
    "dahua-eyeball-cameras-1": {
      "collectionHandle": "dahua-eyeball-cameras-1",
      "collectionProductCount": 128,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 16,
          "rankedProductIds": [
            "7591857061945",
            "7591770914873",
            "7591829831737",
            "8168553316409",
            "8168425881657",
            "8168406024249",
            "7591771406393",
            "7591829372985",
            "7591831732281",
            "7591690403897",
            "7591722385465",
            "8168533983289",
            "8168534900793",
            "7591800406073",
            "8168629043257",
            "8284558229561"
          ],
          "rankedProductHandles": [
            "dahua-tioc-advanced-2-0-dh-ipc-hdbw3849r1p-zas-pv-27135-8mp-starlight-ip-dome-motorised-2-7-13-5mm",
            "dahua-tioc-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3849h-as-pv-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-dh-ipc-hdw3849h-as-pv-pro-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-3-0-ipc-hdw3849h-as-pv-anz-s2-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-dh-ipc-hdw3849hp-as-pv-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-fixed-2-8mm-mic-speaker-wizsense",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3549hp-as-pv-0280b-s3-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3649h-as-pv-anz-6mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3649h-as-pv-anz-blk-6mp-ai-active-deterrence-full-color-starlight-ip-turret-camera-black",
            "dahua-dh-ipc-hdw5442tmp-led-dahua-ai-4mp-starlight-ip-turret-fixed-white-light-ir-20m-poe",
            "dahua-tioc-dh-ipc-hdw3549hp-as-pv-0280b-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-turret-fixed-2-8mm-built-in-mic-speakerwdr-micro-sdip67poe",
            "dahua-dh-ipc-hdw3867em-s-il-anz-with-smart-warm-light-30m-ir",
            "dahua-dh-ipc-hdw3867em-s-il-anz-with-smart-dual-light-30m-ir-black",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-blk-8mp-ai-active-deterrence-full-color-ip-turret-camera-black",
            "dahua-dh-ipc-hdbw3867e-as-il-anz-8mp-smart-dual-light-fixed-focal-dome-wizsense-network-camera",
            "dahua-dh-hac-hdw2802tp-a-8mp-4k-hdcvi-turret-camera-2-8mm-fixed-lens-starlight-ir-60m-built-in-mic-ip67"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 16,
          "rankedProductIds": [
            "8324155277369",
            "7591770914873",
            "7591800406073",
            "8284475457593",
            "7591722385465",
            "7591945175097",
            "7591864729657",
            "8284512157753",
            "8168553316409",
            "8168629043257",
            "7591771406393",
            "8168425881657",
            "7591947927609",
            "7591831732281",
            "7591830323257",
            "7591829372985"
          ],
          "rankedProductHandles": [
            "dahua-8mp-wizmind-dh-ipc-hdw5859h-ase-pv-pro-pro-series-wizcolor-turret-camera-with-active-deterrence-2-way-audio-60m-ir",
            "dahua-tioc-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-blk-8mp-ai-active-deterrence-full-color-ip-turret-camera-black",
            "dahua-4-x-6mp-dh-ipc-hdw3649h-as-pv-anz-tioc-2-0-with-wizsense-turret-4ch-kit",
            "dahua-tioc-dh-ipc-hdw3549hp-as-pv-0280b-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-turret-fixed-2-8mm-built-in-mic-speakerwdr-micro-sdip67poe",
            "dahua-dh-ipc-pdw3849-a180-as-pv-anz-blk-tioc-duo-splicing-turret-fixed-camera-black",
            "dahua-dh-ipc-pdw3849-a180-as-pv-anz-tioc-duo-splicing-turret-fixed-camera",
            "dahua-ipc-hdw3849h-zas-pv-pro-anz-8mp-4k-wizsense-tioc-pro-vari-focal-eyeball-network-camera",
            "dahua-tioc-dh-ipc-hdw3849h-as-pv-pro-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-dh-ipc-hdbw3867e-as-il-anz-8mp-smart-dual-light-fixed-focal-dome-wizsense-network-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3549hp-as-pv-0280b-s3-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-3-0-ipc-hdw3849h-as-pv-anz-s2-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3849h-as-pv-anz-8mp-ai-active-deterrence-full-color",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3649h-as-pv-anz-blk-6mp-ai-active-deterrence-full-color-starlight-ip-turret-camera-black",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3849h-as-pv-anz-blk-8mp-ai-active-deterrence-full-color-ip-turret-camera-black",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3649h-as-pv-anz-6mp-ai-active-deterrence-full-color-starlight-ip-turret-camera"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 16,
          "rankedProductIds": [
            "7591770914873",
            "7591800406073",
            "7591832354873",
            "8168590934073",
            "7591737327673",
            "7591932756025",
            "7591713996857",
            "7591945568313",
            "7591642923065",
            "8284558229561",
            "8284512157753",
            "8168553316409",
            "8168629043257",
            "7591765737529",
            "8168425881657",
            "7591947927609"
          ],
          "rankedProductHandles": [
            "dahua-tioc-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-blk-8mp-ai-active-deterrence-full-color-ip-turret-camera-black",
            "dahua-8mp-dh-ipc-hdw3866tp-zs-aus-4k-starlight-ip-turret-motorised-wdr-ir-40m-black",
            "dahua-dh-ipc-hdw3867t-zs-il-anz-8mp-smart-dual-light-varifocal-turret-network-camera",
            "dahua-8mp-dh-ipc-hdw3841tp-zas-4k-starlight-ip-turret-motorised-optical-zoom-wdr-ir-50m-ip67-poe",
            "dahua-tioc-dh-ipc-hdw3849h-zas-pv-anz-8mp-ai-active-deterrence-motorised-turret-camera",
            "dahua-8mp-dh-ipc-hdw2831tp-zs-27135-s2-4k-starlight-ip-turret-motorizedicrwdrir-40mip67poe",
            "dahua-tioc-dh-ipc-hdw3849h-zas-pv-anz-8mp-ai-active-deterrence-motorised-turret-camera-black",
            "dahua-dh-hac-hdw2802tp-z-dp-3711-4k-starlight-hdcvi-ir-eyeball-camera",
            "dahua-dh-hac-hdw2802tp-a-8mp-4k-hdcvi-turret-camera-2-8mm-fixed-lens-starlight-ir-60m-built-in-mic-ip67",
            "dahua-ipc-hdw3849h-zas-pv-pro-anz-8mp-4k-wizsense-tioc-pro-vari-focal-eyeball-network-camera",
            "dahua-tioc-dh-ipc-hdw3849h-as-pv-pro-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-dh-ipc-hdbw3867e-as-il-anz-8mp-smart-dual-light-fixed-focal-dome-wizsense-network-camera",
            "dahua-8mp-4k-starlight-ip-bullet-motorized-2-7-13-5mm-smd-plusperimeter-protection-ir-distance-60m",
            "dahua-tioc-advanced-3-0-ipc-hdw3849h-as-pv-anz-s2-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3849h-as-pv-anz-8mp-ai-active-deterrence-full-color"
          ]
        }
      }
    },
    "dahua-fisheye-cameras-1": {
      "collectionHandle": "dahua-fisheye-cameras-1",
      "collectionProductCount": 4,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "dahua-full-colour-cameras": {
      "collectionHandle": "dahua-full-colour-cameras",
      "collectionProductCount": 9,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 5,
          "rankedProductIds": [
            "8168553316409",
            "8168542044217",
            "8168425881657",
            "8168406024249",
            "8284590407737"
          ],
          "rankedProductHandles": [
            "dahua-tioc-dh-ipc-hdw3849h-as-pv-pro-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-dh-ipc-hfw3849t1-as-pv-anz-s2-blk-8mp-ai-active-deterrence-ip-bullet-fixed-2-8mm-black",
            "dahua-tioc-advanced-3-0-ipc-hdw3849h-as-pv-anz-s2-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-dh-ipc-hdw3849hp-as-pv-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-fixed-2-8mm-mic-speaker-wizsense",
            "dahua-ipc-pfw3849s-a180-as-pv-8mp-180-tioc-duo-splicing-bullet-wizsense-network-camera"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 5,
          "rankedProductIds": [
            "8168553316409",
            "8168575336505",
            "8168542044217",
            "8168425881657",
            "8168406024249"
          ],
          "rankedProductHandles": [
            "dahua-tioc-dh-ipc-hdw3849h-as-pv-pro-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-ipc-hdw3649h-as-pv-pro-tioc-acupick-6mp-ai-active-deterrence-ip-turret-camera",
            "dahua-tioc-dh-ipc-hfw3849t1-as-pv-anz-s2-blk-8mp-ai-active-deterrence-ip-bullet-fixed-2-8mm-black",
            "dahua-tioc-advanced-3-0-ipc-hdw3849h-as-pv-anz-s2-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-dh-ipc-hdw3849hp-as-pv-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-fixed-2-8mm-mic-speaker-wizsense"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 5,
          "rankedProductIds": [
            "8168553316409",
            "8168542044217",
            "8168425881657",
            "8168406024249",
            "8284590407737"
          ],
          "rankedProductHandles": [
            "dahua-tioc-dh-ipc-hdw3849h-as-pv-pro-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-dh-ipc-hfw3849t1-as-pv-anz-s2-blk-8mp-ai-active-deterrence-ip-bullet-fixed-2-8mm-black",
            "dahua-tioc-advanced-3-0-ipc-hdw3849h-as-pv-anz-s2-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-dh-ipc-hdw3849hp-as-pv-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-fixed-2-8mm-mic-speaker-wizsense",
            "dahua-ipc-pfw3849s-a180-as-pv-8mp-180-tioc-duo-splicing-bullet-wizsense-network-camera"
          ]
        }
      }
    },
    "dahua-full-colour-cameras-1": {
      "collectionHandle": "dahua-full-colour-cameras-1",
      "collectionProductCount": 28,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 16,
          "rankedProductIds": [
            "7591857061945",
            "7591785365561",
            "7591829831737",
            "7591770914873",
            "7591832158265",
            "7591831109689",
            "7591824752697",
            "7591829372985",
            "7591787495481",
            "7591771406393",
            "7591831732281",
            "7591690403897",
            "7591722385465",
            "7591800406073",
            "7591947927609",
            "7591945568313"
          ],
          "rankedProductHandles": [
            "dahua-tioc-advanced-2-0-dh-ipc-hdbw3849r1p-zas-pv-27135-8mp-starlight-ip-dome-motorised-2-7-13-5mm",
            "dahua-tioc-advanced-2-0-dh-ipc-hfw3849t1p-as-pv-0280b-s3-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-built-in-mic-speakerip67poe-wizsense",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3849h-as-pv-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-blk-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-black",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm",
            "dahua-tioc-advanced-2-0-dh-ipc-hfw3849t1p-as-pv-0280b-s3-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3649h-as-pv-anz-6mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-2-0-advanced-dh-ipc-hfw3549t1p-as-pv-0280b-s3-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-built-in-mic-speaker-ip67-poe-wizsense",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3549hp-as-pv-0280b-s3-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3649h-as-pv-anz-blk-6mp-ai-active-deterrence-full-color-starlight-ip-turret-camera-black",
            "dahua-dh-ipc-hdw5442tmp-led-dahua-ai-4mp-starlight-ip-turret-fixed-white-light-ir-20m-poe",
            "dahua-tioc-dh-ipc-hdw3549hp-as-pv-0280b-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-turret-fixed-2-8mm-built-in-mic-speakerwdr-micro-sdip67poe",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-blk-8mp-ai-active-deterrence-full-color-ip-turret-camera-black",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3849h-as-pv-anz-8mp-ai-active-deterrence-full-color",
            "dahua-tioc-dh-ipc-hdw3849h-zas-pv-anz-8mp-ai-active-deterrence-motorised-turret-camera-black"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 16,
          "rankedProductIds": [
            "7591787495481",
            "7591770914873",
            "7591800406073",
            "7591945175097",
            "7591947927609",
            "7591864729657",
            "7591932067897",
            "7591832158265",
            "7591945568313",
            "7591941111865",
            "7591831732281",
            "7591932756025",
            "7591831109689",
            "7591830618169",
            "7591830323257",
            "7591722385465"
          ],
          "rankedProductHandles": [
            "dahua-tioc-2-0-advanced-dh-ipc-hfw3549t1p-as-pv-0280b-s3-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-built-in-mic-speaker-ip67-poe-wizsense",
            "dahua-tioc-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-blk-8mp-ai-active-deterrence-full-color-ip-turret-camera-black",
            "dahua-dh-ipc-pdw3849-a180-as-pv-anz-blk-tioc-duo-splicing-turret-fixed-camera-black",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3849h-as-pv-anz-8mp-ai-active-deterrence-full-color",
            "dahua-dh-ipc-pdw3849-a180-as-pv-anz-tioc-duo-splicing-turret-fixed-camera",
            "dahua-tioc-2-0-black-dh-ipc-hfw3649t1-as-pv-anz-6mp-ai-active-deterrence-fixed-lens-bullet-camera",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-blk-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-black",
            "dahua-tioc-dh-ipc-hdw3849h-zas-pv-anz-8mp-ai-active-deterrence-motorised-turret-camera-black",
            "dahua-tioc-dh-ipc-hdw3649h-as-pv-anz-6mp-motorised-zoom-blue-red-light-ip-turret-camera",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3649h-as-pv-anz-blk-6mp-ai-active-deterrence-full-color-starlight-ip-turret-camera-black",
            "dahua-tioc-dh-ipc-hdw3849h-zas-pv-anz-8mp-ai-active-deterrence-motorised-turret-camera",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm",
            "dahua-tioc-3-0-advanced-dh-ipc-hfw3649t1-as-pv-anz-6mp-ai-active-deterrence-motorised-bullet-camera",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3849h-as-pv-anz-blk-8mp-ai-active-deterrence-full-color-ip-turret-camera-black",
            "dahua-tioc-dh-ipc-hdw3549hp-as-pv-0280b-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-turret-fixed-2-8mm-built-in-mic-speakerwdr-micro-sdip67poe"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 15,
          "rankedProductIds": [
            "7591945568313",
            "7591932756025",
            "7591770914873",
            "7591800406073",
            "7591947927609",
            "7591857061945",
            "7591832158265",
            "7591831109689",
            "7591830323257",
            "7591829831737",
            "7591824752697",
            "7591941111865",
            "7591830618169",
            "7591785365561",
            "7591804731449"
          ],
          "rankedProductHandles": [
            "dahua-tioc-dh-ipc-hdw3849h-zas-pv-anz-8mp-ai-active-deterrence-motorised-turret-camera-black",
            "dahua-tioc-dh-ipc-hdw3849h-zas-pv-anz-8mp-ai-active-deterrence-motorised-turret-camera",
            "dahua-tioc-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-blk-8mp-ai-active-deterrence-full-color-ip-turret-camera-black",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3849h-as-pv-anz-8mp-ai-active-deterrence-full-color",
            "dahua-tioc-advanced-2-0-dh-ipc-hdbw3849r1p-zas-pv-27135-8mp-starlight-ip-dome-motorised-2-7-13-5mm",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-blk-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-black",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3849h-as-pv-anz-blk-8mp-ai-active-deterrence-full-color-ip-turret-camera-black",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3849h-as-pv-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hfw3849t1p-as-pv-0280b-s3-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm",
            "dahua-tioc-dh-ipc-hdw3649h-as-pv-anz-6mp-motorised-zoom-blue-red-light-ip-turret-camera",
            "dahua-tioc-3-0-advanced-dh-ipc-hfw3649t1-as-pv-anz-6mp-ai-active-deterrence-motorised-bullet-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hfw3849t1p-as-pv-0280b-s3-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-built-in-mic-speakerip67poe-wizsense",
            "dahua-tioc-2-0-advanced-dh-ipc-hfw3549t1-zas-pv-5mp-ai-active-deterrence-motorised-bullet-camera"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 4,
          "rankedProductIds": [
            "7591722385465",
            "7591847100473",
            "7591847297081",
            "7591720615993"
          ],
          "rankedProductHandles": [
            "dahua-tioc-dh-ipc-hdw3549hp-as-pv-0280b-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-turret-fixed-2-8mm-built-in-mic-speakerwdr-micro-sdip67poe",
            "dahua-dh-ipc-pdw5849-a180-e2-aste-4mp-x-2-full-color-dual-lens-wizmind-network-camera",
            "dahua-dh-ipc-pfw5849-a180-e2-aste-4mp-x-2-full-color-dual-lens-wizmind-bullet-network-camera",
            "dahua-dh-ipc-hfw3449ep-as-led-0360b-4mp-full-color-warm-led-fixed-focal-bullet-wizsense-network-camera"
          ]
        }
      }
    },
    "dahua-hdcvi-bullet-cameras-1": {
      "collectionHandle": "dahua-hdcvi-bullet-cameras-1",
      "collectionProductCount": 1,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "dahua-ip-cameras": {
      "collectionHandle": "dahua-ip-cameras",
      "collectionProductCount": 58,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 16,
          "rankedProductIds": [
            "8284590407737",
            "8168609087545",
            "8168553316409",
            "8168542044217",
            "8168425881657",
            "8168406024249",
            "8168415559737",
            "8168572452921",
            "8168533983289",
            "8168534900793",
            "8168629043257",
            "8168432435257",
            "8324152492089",
            "8168589525049",
            "8284512157753",
            "8168589033529"
          ],
          "rankedProductHandles": [
            "dahua-ipc-pfw3849s-a180-as-pv-8mp-180-tioc-duo-splicing-bullet-wizsense-network-camera",
            "dahua-ipc-hfw3849t1-as-pv-pro-8mp-smart-dual-light-active-deterrence-fixed-focal-bullet-camera-2-8-mm",
            "dahua-tioc-dh-ipc-hdw3849h-as-pv-pro-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-dh-ipc-hfw3849t1-as-pv-anz-s2-blk-8mp-ai-active-deterrence-ip-bullet-fixed-2-8mm-black",
            "dahua-tioc-advanced-3-0-ipc-hdw3849h-as-pv-anz-s2-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-dh-ipc-hdw3849hp-as-pv-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-fixed-2-8mm-mic-speaker-wizsense",
            "dahua-dh-ipc-hfw3849t1-zas-pv-anz-s2-8mp-smart-dual-active-deterrence-vari-focal-bullet-wizsense-network-camera",
            "dahua-dh-sdt3e410-8p-mb-a-pv1-8mp4mp-10x-starlight-tioc-panoramic-ptz-security-camera",
            "dahua-dh-ipc-hdw3867em-s-il-anz-with-smart-warm-light-30m-ir",
            "dahua-dh-ipc-hdw3867em-s-il-anz-with-smart-dual-light-30m-ir-black",
            "dahua-dh-ipc-hdbw3867e-as-il-anz-8mp-smart-dual-light-fixed-focal-dome-wizsense-network-camera",
            "dahua-dh-ipc-hdbw3867r-zas-il-anz-8-mp-smart-dual-light-vari-focal-dome-wizsense-network-camera",
            "dahua-ipc-hfw3667t-zas-il-anz-6mp-smart-dual-light-vari-focal-bullet-wizsense-ip-camera",
            "dahua-ipc-hfw3867t-zas-il-anz-8mp-8mp-smart-dual-light-vari-focal-bullet-wizsense-motorised",
            "dahua-ipc-hdw3849h-zas-pv-pro-anz-8mp-4k-wizsense-tioc-pro-vari-focal-eyeball-network-camera",
            "dahua-dh-ipc-hdw3667em-s-il-anz-6mp-turret-network-camera-acupick-wizsense-spotlight"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 15,
          "rankedProductIds": [
            "8284475457593",
            "8284590407737",
            "8284512157753",
            "8168598175801",
            "8168629043257",
            "8168609087545",
            "8168553316409",
            "8168542044217",
            "8168425881657",
            "8168575336505",
            "8168406024249",
            "8284596830265",
            "8168415559737",
            "8168400322617",
            "8168572452921"
          ],
          "rankedProductHandles": [
            "dahua-4-x-6mp-dh-ipc-hdw3649h-as-pv-anz-tioc-2-0-with-wizsense-turret-4ch-kit",
            "dahua-ipc-pfw3849s-a180-as-pv-8mp-180-tioc-duo-splicing-bullet-wizsense-network-camera",
            "dahua-ipc-hdw3849h-zas-pv-pro-anz-8mp-4k-wizsense-tioc-pro-vari-focal-eyeball-network-camera",
            "dahua-ipc-hfw3667e-as-il-anz-6-mp-smart-dual-light-bullet-camera-wizsense-3-series",
            "dahua-dh-ipc-hdbw3867e-as-il-anz-8mp-smart-dual-light-fixed-focal-dome-wizsense-network-camera",
            "dahua-ipc-hfw3849t1-as-pv-pro-8mp-smart-dual-light-active-deterrence-fixed-focal-bullet-camera-2-8-mm",
            "dahua-tioc-dh-ipc-hdw3849h-as-pv-pro-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-dh-ipc-hfw3849t1-as-pv-anz-s2-blk-8mp-ai-active-deterrence-ip-bullet-fixed-2-8mm-black",
            "dahua-tioc-advanced-3-0-ipc-hdw3849h-as-pv-anz-s2-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-ipc-hdw3649h-as-pv-pro-tioc-acupick-6mp-ai-active-deterrence-ip-turret-camera",
            "dahua-tioc-dh-ipc-hdw3849hp-as-pv-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-fixed-2-8mm-mic-speaker-wizsense",
            "dahua-sd6e445mb-hnr-a-pv1-4mp-45x-smart-dual-illumination-active-deterrence-network-ptz-camera",
            "dahua-dh-ipc-hfw3849t1-zas-pv-anz-s2-8mp-smart-dual-active-deterrence-vari-focal-bullet-wizsense-network-camera",
            "dahua-ipc-hdbw3549r1-zas-pv-5mp-smart-dual-light-tioc-motorised-dome-wizsense-network-camera",
            "dahua-dh-sdt3e410-8p-mb-a-pv1-8mp4mp-10x-starlight-tioc-panoramic-ptz-security-camera"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 16,
          "rankedProductIds": [
            "8168610201657",
            "8168590934073",
            "8168553316409",
            "8284590407737",
            "8284512157753",
            "8168589525049",
            "8168629043257",
            "8168609087545",
            "8168572452921",
            "8168542044217",
            "8168425881657",
            "8168533983289",
            "8168406024249",
            "8168534900793",
            "8284544303161",
            "8168591261753"
          ],
          "rankedProductHandles": [
            "dahua-itc413-pw4d-iz1-anpr-camera-4mp-motorized-vari-focal-ir-license-plate-recognition-2-7-12mm",
            "dahua-dh-ipc-hdw3867t-zs-il-anz-8mp-smart-dual-light-varifocal-turret-network-camera",
            "dahua-tioc-dh-ipc-hdw3849h-as-pv-pro-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-ipc-pfw3849s-a180-as-pv-8mp-180-tioc-duo-splicing-bullet-wizsense-network-camera",
            "dahua-ipc-hdw3849h-zas-pv-pro-anz-8mp-4k-wizsense-tioc-pro-vari-focal-eyeball-network-camera",
            "dahua-ipc-hfw3867t-zas-il-anz-8mp-8mp-smart-dual-light-vari-focal-bullet-wizsense-motorised",
            "dahua-dh-ipc-hdbw3867e-as-il-anz-8mp-smart-dual-light-fixed-focal-dome-wizsense-network-camera",
            "dahua-ipc-hfw3849t1-as-pv-pro-8mp-smart-dual-light-active-deterrence-fixed-focal-bullet-camera-2-8-mm",
            "dahua-dh-sdt3e410-8p-mb-a-pv1-8mp4mp-10x-starlight-tioc-panoramic-ptz-security-camera",
            "dahua-tioc-dh-ipc-hfw3849t1-as-pv-anz-s2-blk-8mp-ai-active-deterrence-ip-bullet-fixed-2-8mm-black",
            "dahua-tioc-advanced-3-0-ipc-hdw3849h-as-pv-anz-s2-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-dh-ipc-hdw3867em-s-il-anz-with-smart-warm-light-30m-ir",
            "dahua-tioc-dh-ipc-hdw3849hp-as-pv-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-fixed-2-8mm-mic-speaker-wizsense",
            "dahua-dh-ipc-hdw3867em-s-il-anz-with-smart-dual-light-30m-ir-black",
            "dahua-dh-ipc-hdw3667t-zs-il-anz-6mp-eyeball-network-camera-with-varifocal-lens-acupick-and-white-light-led-ip67",
            "dahua-ipc-hdw5849h-ase-led-s2-8mp-wizmind-full-color-eyeball-camera-with-warm-led"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 10,
          "rankedProductIds": [
            "8284596830265",
            "8168575598649",
            "8168600469561",
            "8168553316409",
            "8168574746681",
            "8168402714681",
            "8168572452921",
            "8168620720185",
            "8168440791097",
            "8168396357689"
          ],
          "rankedProductHandles": [
            "dahua-sd6e445mb-hnr-a-pv1-4mp-45x-smart-dual-illumination-active-deterrence-network-ptz-camera",
            "dahua-dh-ipc-hdw5842tm-ase-8mp-ir-fixed-focal-eyeball-wizmind-network-camera",
            "dahua-ipc-hdw5442tp-ze-s3-ai-4mp-turret-motorized-camera-starlight-motorized-lens-ip67",
            "dahua-tioc-dh-ipc-hdw3849h-as-pv-pro-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-dh-ipc-hdbw5441e-ze-hdmi-4mp-hdmi-dome-motorised-camera",
            "dahua-dh-sd8a840-hnf-pa-4k-40x-starlight-ir-ptz-ai-network-camera",
            "dahua-dh-sdt3e410-8p-mb-a-pv1-8mp4mp-10x-starlight-tioc-panoramic-ptz-security-camera",
            "dahua-ipc-mfw5241t2-e3-ase-triple-sight-long-range-perimeter-protection-camera",
            "dahua-4mp-dh-sd49425xb-hnr-dh-sd49425gb-hnr-25x-starlight-ir-ptz-ai-network-camera",
            "dahua-ipc-hdw5442emp-ase-s3-dahua-ai-4mp-starlight-ip-turret-fixed-ir-50m-poe-wizmind"
          ]
        }
      }
    },
    "dahua-ip-cameras-1": {
      "collectionHandle": "dahua-ip-cameras-1",
      "collectionProductCount": 166,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 16,
          "rankedProductIds": [
            "7591785365561",
            "7591853162553",
            "7591857061945",
            "7591770914873",
            "7591829831737",
            "7591832158265",
            "7591831109689",
            "7591824752697",
            "7591771406393",
            "7591829372985",
            "7591787495481",
            "7591831732281",
            "7591690403897",
            "7591722385465",
            "7690795483193",
            "7591715471417"
          ],
          "rankedProductHandles": [
            "dahua-tioc-advanced-2-0-dh-ipc-hfw3849t1p-as-pv-0280b-s3-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-built-in-mic-speakerip67poe-wizsense",
            "dahua-4mp-sd6c3432xb-hnr-agq-pv-32x-starlight-ir-wizsense-4g-network-ptz-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hdbw3849r1p-zas-pv-27135-8mp-starlight-ip-dome-motorised-2-7-13-5mm",
            "dahua-tioc-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3849h-as-pv-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-blk-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-black",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm",
            "dahua-tioc-advanced-2-0-dh-ipc-hfw3849t1p-as-pv-0280b-s3-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3549hp-as-pv-0280b-s3-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3649h-as-pv-anz-6mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-2-0-advanced-dh-ipc-hfw3549t1p-as-pv-0280b-s3-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-built-in-mic-speaker-ip67-poe-wizsense",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3649h-as-pv-anz-blk-6mp-ai-active-deterrence-full-color-starlight-ip-turret-camera-black",
            "dahua-dh-ipc-hdw5442tmp-led-dahua-ai-4mp-starlight-ip-turret-fixed-white-light-ir-20m-poe",
            "dahua-tioc-dh-ipc-hdw3549hp-as-pv-0280b-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-turret-fixed-2-8mm-built-in-mic-speakerwdr-micro-sdip67poe",
            "dahua-dh-sdt4e425-8p-gb-apv1-x-spans-8mp4mp-25x-tioc-wizsense-network-ptz-camera",
            "dahua-dh-sd8a840wa-hnf-4k-40x-starlight-ir-ptz-ai-network-camera"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 16,
          "rankedProductIds": [
            "7591787495481",
            "7591770914873",
            "7591800406073",
            "7591715471417",
            "7591722385465",
            "7591945175097",
            "7591864729657",
            "7591771406393",
            "7591947927609",
            "7591932067897",
            "7591832158265",
            "7591831732281",
            "7591831109689",
            "7591830618169",
            "7591830323257",
            "7591829372985"
          ],
          "rankedProductHandles": [
            "dahua-tioc-2-0-advanced-dh-ipc-hfw3549t1p-as-pv-0280b-s3-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-built-in-mic-speaker-ip67-poe-wizsense",
            "dahua-tioc-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-blk-8mp-ai-active-deterrence-full-color-ip-turret-camera-black",
            "dahua-dh-sd8a840wa-hnf-4k-40x-starlight-ir-ptz-ai-network-camera",
            "dahua-tioc-dh-ipc-hdw3549hp-as-pv-0280b-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-turret-fixed-2-8mm-built-in-mic-speakerwdr-micro-sdip67poe",
            "dahua-dh-ipc-pdw3849-a180-as-pv-anz-blk-tioc-duo-splicing-turret-fixed-camera-black",
            "dahua-dh-ipc-pdw3849-a180-as-pv-anz-tioc-duo-splicing-turret-fixed-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3549hp-as-pv-0280b-s3-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3849h-as-pv-anz-8mp-ai-active-deterrence-full-color",
            "dahua-tioc-2-0-black-dh-ipc-hfw3649t1-as-pv-anz-6mp-ai-active-deterrence-fixed-lens-bullet-camera",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-blk-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-black",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3649h-as-pv-anz-blk-6mp-ai-active-deterrence-full-color-starlight-ip-turret-camera-black",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm",
            "dahua-tioc-3-0-advanced-dh-ipc-hfw3649t1-as-pv-anz-6mp-ai-active-deterrence-motorised-bullet-camera",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3849h-as-pv-anz-blk-8mp-ai-active-deterrence-full-color-ip-turret-camera-black",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3649h-as-pv-anz-6mp-ai-active-deterrence-full-color-starlight-ip-turret-camera"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 16,
          "rankedProductIds": [
            "7591915520057",
            "7591718027321",
            "7591796539449",
            "7591715471417",
            "7591770914873",
            "7591800406073",
            "7591832354873",
            "7690795483193",
            "7591737327673",
            "7591932756025",
            "7591766753337",
            "7591713996857",
            "7591945568313",
            "7591843070009",
            "7591765737529",
            "7591947927609"
          ],
          "rankedProductHandles": [
            "dahua-dhi-itc413-pw4d-iz3-ai-access-anpr-4mp-8-32mm-k",
            "dahua-dhi-itc237-pw6m-irlzf1050-ai-access-anpr-2-megapixel-full-hd-wdr-anpr-camera-ir-max-40km-hr-10-50mm-motorized-lens",
            "dahua-anpr-short-range-motorised-camera-max-8m-distance",
            "dahua-dh-sd8a840wa-hnf-4k-40x-starlight-ir-ptz-ai-network-camera",
            "dahua-tioc-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-blk-8mp-ai-active-deterrence-full-color-ip-turret-camera-black",
            "dahua-8mp-dh-ipc-hdw3866tp-zs-aus-4k-starlight-ip-turret-motorised-wdr-ir-40m-black",
            "dahua-dh-sdt4e425-8p-gb-apv1-x-spans-8mp4mp-25x-tioc-wizsense-network-ptz-camera",
            "dahua-8mp-dh-ipc-hdw3841tp-zas-4k-starlight-ip-turret-motorised-optical-zoom-wdr-ir-50m-ip67-poe",
            "dahua-tioc-dh-ipc-hdw3849h-zas-pv-anz-8mp-ai-active-deterrence-motorised-turret-camera",
            "dahua-dh-ipc-hfw2831tp-zas-27135-s2-8mp-4k-wdr-ir-bullet-motorized-2-713-5mm-lite-starlight",
            "dahua-8mp-dh-ipc-hdw2831tp-zs-27135-s2-4k-starlight-ip-turret-motorizedicrwdrir-40mip67poe",
            "dahua-tioc-dh-ipc-hdw3849h-zas-pv-anz-8mp-ai-active-deterrence-motorised-turret-camera-black",
            "dahua-dh-ipc-hfw3866ep-as-aus-8mp-4k-bullet-fixed-starlight-wizsense-camera",
            "dahua-8mp-4k-starlight-ip-bullet-motorized-2-7-13-5mm-smd-plusperimeter-protection-ir-distance-60m",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3849h-as-pv-anz-8mp-ai-active-deterrence-full-color"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 16,
          "rankedProductIds": [
            "7591715471417",
            "7690795483193",
            "7591771570233",
            "7591888093241",
            "7591840940089",
            "7591843070009",
            "7591838548025",
            "7591706394681",
            "7591940128825",
            "7745702035513",
            "7690795450425",
            "7591777337401",
            "7591853162553",
            "7591708033081",
            "7591677722681",
            "7591846936633"
          ],
          "rankedProductHandles": [
            "dahua-dh-sd8a840wa-hnf-4k-40x-starlight-ir-ptz-ai-network-camera",
            "dahua-dh-sdt4e425-8p-gb-apv1-x-spans-8mp4mp-25x-tioc-wizsense-network-ptz-camera",
            "dahua-dh-sd5a432xa-hnr-4mp-ip-32x-ptz-camera-with-wizsense",
            "dahua-4mp-dh-sd49425xb-hnr-25x-starlight-ir-ptz-ai-network-camera",
            "dahua-8mp-dh-ipc-hdbw3866ep-as-aus-4k-starlight-ip-dome-wdr-ir-30m",
            "dahua-dh-ipc-hfw3866ep-as-aus-8mp-4k-bullet-fixed-starlight-wizsense-camera",
            "dahua-dh-sd5a432xb-hnr-4mp-ip-32x-ptz-camera-with-wizsense",
            "dahua-dh-sd5a425xa-hnr-4mp-25x-starlight-ir-ptz-ai-network-camera",
            "dahua-dh-ipc-hfw3466ep-as-aus-4mp-bullet-network-camera-50m-ir-2-8mm-with-smd-4-0-wizsense",
            "dahua-sd1a404db-gny-4mp-4x-starlight-ir-wizsense-network-ptz-camera",
            "dahua-dh-sdt4e425-4f-gb-a-pv1-x-spans-4mp4mp-25x-tioc-wizsense-network-ptz-camera",
            "dahua-dh-sd6c3425xb-hnr-a-pv1-4mp-tioc-ip-25x-ptz-camera-ir-150m",
            "dahua-4mp-sd6c3432xb-hnr-agq-pv-32x-starlight-ir-wizsense-4g-network-ptz-camera",
            "dahua-dh-ipc-hfw3541tp-zs-27135-5mp-lite-ai-motorised-starlight-bullet-perimeter-smd-sd-card-wdr-ir40m-ip67-poe",
            "dahua-dh-sd1a203t-gn-2mp-starlight-ip-ptz-3x-2-7mm8-1mm-vf-lens",
            "dahua-dh-sd4a425db-hny-4mp-25x-ip-starlight-wizsense-ptz-camera"
          ]
        }
      }
    },
    "dahua-lite-ai-smd-series-5mp-cameras-smart-motion-detection": {
      "collectionHandle": "dahua-lite-ai-smd-series-5mp-cameras-smart-motion-detection",
      "collectionProductCount": 7,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 3,
          "rankedProductIds": [
            "8168400322617",
            "7591707967545",
            "7591707836473"
          ],
          "rankedProductHandles": [
            "dahua-ipc-hdbw3549r1-zas-pv-5mp-smart-dual-light-tioc-motorised-dome-wizsense-network-camera",
            "dahua-dh-ipc-hdbw3541rp-zs-27135-5mp-lite-ai-motorised-starlight-dome-perimeter-smd-sd-card-wdr-ir40m-ip67-poe",
            "dahua-ipc-hdbw3541ep-s-0280b-5mp-lite-ai-fixed-starlight-dome-perimeter-smd-sd-card-wdr-ir50m-ip67-poe"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 4,
          "rankedProductIds": [
            "8168400322617",
            "7591708033081",
            "7591707967545",
            "7591763411001"
          ],
          "rankedProductHandles": [
            "dahua-ipc-hdbw3549r1-zas-pv-5mp-smart-dual-light-tioc-motorised-dome-wizsense-network-camera",
            "dahua-dh-ipc-hfw3541tp-zs-27135-5mp-lite-ai-motorised-starlight-bullet-perimeter-smd-sd-card-wdr-ir40m-ip67-poe",
            "dahua-dh-ipc-hdbw3541rp-zs-27135-5mp-lite-ai-motorised-starlight-dome-perimeter-smd-sd-card-wdr-ir40m-ip67-poe",
            "dahua-dh-ipc-hfw3541tp-zas-27135-5mp-lite-ai-motorised-starlight-bullet-perimeter-smd-sd-card-wdr-ir60mip67-poe"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 2,
          "rankedProductIds": [
            "7591708033081",
            "7591707574329"
          ],
          "rankedProductHandles": [
            "dahua-dh-ipc-hfw3541tp-zs-27135-5mp-lite-ai-motorised-starlight-bullet-perimeter-smd-sd-card-wdr-ir40m-ip67-poe",
            "dahua-dh-ipc-hdw3541tp-zas-27135-5mp-lite-ai-motorised-starlight-turret-perimeter-smart-motion-detection-40m-ir-built-in-mic"
          ]
        }
      }
    },
    "dahua-motorised-varifocal-cameras-1": {
      "collectionHandle": "dahua-motorised-varifocal-cameras-1",
      "collectionProductCount": 31,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 3,
          "rankedProductIds": [
            "7591643185209",
            "7591642923065",
            "7591775305785"
          ],
          "rankedProductHandles": [
            "dahua-dh-hac-hfw2802tp-z-dp-4k-starlight-hdcvi-ir-bullet-camera",
            "dahua-dh-hac-hdw2802tp-z-dp-3711-4k-starlight-hdcvi-ir-eyeball-camera",
            "dahua-hac-sd49225i-hc-s3-2mp-25x-starlight-ir-ptz-hdcvi-camera-motorized-4-8120mm-lens"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 8,
          "rankedProductIds": [
            "7745702035513",
            "7591981678649",
            "7591864500281",
            "7591864270905",
            "7591846051897",
            "7591738048569",
            "7591677886521",
            "7591656587321"
          ],
          "rankedProductHandles": [
            "dahua-sd1a404db-gny-4mp-4x-starlight-ir-wizsense-network-ptz-camera",
            "dahua-dh-ipc-wl46a-4mp-wifi-floodlight-camera-240v",
            "dahua-dh-ipc-hdbw3466ep-as-aus-4mp-wizsense-starlight-dome",
            "dahua-dh-ipc-hdbw3466rp-zas-aus-4mp-wizsense-motorised-starlight-dome",
            "dahua-6-x-4mp-dh-ipc-hdw3466emp-s-aus-smd-wizsense-camera-kit",
            "dahua-dh-ipc-hdbw3841rp-zas-27135-8mp-dome-motorised-network-camera-zoom-function-50m-ir-wizsense",
            "dahua-dh-ipc-hdbw5631rp-ze-27135-blk-6mp-wdr-ir-dome-motorised-network-camera",
            "dahua-dh-ipc-hdbw5431e-ze-4mp-motorised-vf-ir-dome-network-camera"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 14,
          "rankedProductIds": [
            "7591713996857",
            "8168575008825",
            "7591642923065",
            "7745702035513",
            "7591738048569",
            "7591841726521",
            "7591835697209",
            "7591820820537",
            "7591864270905",
            "7591846346809",
            "7591846051897",
            "7591694532665",
            "7591677886521",
            "7591656587321"
          ],
          "rankedProductHandles": [
            "dahua-8mp-dh-ipc-hdw2831tp-zs-27135-s2-4k-starlight-ip-turret-motorizedicrwdrir-40mip67poe",
            "dahua-ipc-hdbw5842ep-ze-s3-8mp-ir-vari-focal-vandal-proof-dome-wizmind-network-camera",
            "dahua-dh-hac-hdw2802tp-z-dp-3711-4k-starlight-hdcvi-ir-eyeball-camera",
            "dahua-sd1a404db-gny-4mp-4x-starlight-ir-wizsense-network-ptz-camera",
            "dahua-dh-ipc-hdbw3841rp-zas-27135-8mp-dome-motorised-network-camera-zoom-function-50m-ir-wizsense",
            "dahua-dh-ipc-hdbw3466r-as-p-4mp-180-degree-camera-dome-wizsense-ir-ip67-12v-poe-2-1mm-lens",
            "dahua-dh-ipc-hdw3466tp-zs-aus-4mp-starlight-ip-turret-motorised-2-713-5mm-with-wizsense",
            "dahua-dh-ipc-hdw3466emp-s-aus-smd-4-0full-metal-4mp-wizsense-starlight-eyeball-network-camera-fixed-2-8mm",
            "dahua-dh-ipc-hdbw3466rp-zas-aus-4mp-wizsense-motorised-starlight-dome",
            "dahua-10-x-4mp-dh-ipc-hdw3466emp-s-aus-smd-wizsense-camera-kit",
            "dahua-6-x-4mp-dh-ipc-hdw3466emp-s-aus-smd-wizsense-camera-kit",
            "dahua-dh-ipc-hdw2431tp-zs-s2-4mp-starlight-ip-turret-motorised-2-713-5mm",
            "dahua-dh-ipc-hdbw5631rp-ze-27135-blk-6mp-wdr-ir-dome-motorised-network-camera",
            "dahua-dh-ipc-hdbw5431e-ze-4mp-motorised-vf-ir-dome-network-camera"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 13,
          "rankedProductIds": [
            "7591643185209",
            "7745702035513",
            "7591775305785",
            "7591677722681",
            "7591841726521",
            "8168574746681",
            "7591820820537",
            "7591711375417",
            "7591675658297",
            "7591766261817",
            "7591846346809",
            "7591846051897",
            "7591711506489"
          ],
          "rankedProductHandles": [
            "dahua-dh-hac-hfw2802tp-z-dp-4k-starlight-hdcvi-ir-bullet-camera",
            "dahua-sd1a404db-gny-4mp-4x-starlight-ir-wizsense-network-ptz-camera",
            "dahua-hac-sd49225i-hc-s3-2mp-25x-starlight-ir-ptz-hdcvi-camera-motorized-4-8120mm-lens",
            "dahua-dh-sd1a203t-gn-2mp-starlight-ip-ptz-3x-2-7mm8-1mm-vf-lens",
            "dahua-dh-ipc-hdbw3466r-as-p-4mp-180-degree-camera-dome-wizsense-ir-ip67-12v-poe-2-1mm-lens",
            "dahua-dh-ipc-hdbw5441e-ze-hdmi-4mp-hdmi-dome-motorised-camera",
            "dahua-dh-ipc-hdw3466emp-s-aus-smd-4-0full-metal-4mp-wizsense-starlight-eyeball-network-camera-fixed-2-8mm",
            "dahua-hac-hdbw2501rp-z-27135-5mp-starlight-pro-hdcvi-ir-vandal-dome-wdricr-motorised-2-713-5mmir-30m",
            "dahua-ipc-hdbw5631rp-ze-27135-6mp-wdr-ir-dome-motorised-network-camera",
            "dahua-dh-ipc-hdbw2431rp-zas-27135-s2-4mp-starlight-ip-dome-motorised-2-713-5mm",
            "dahua-10-x-4mp-dh-ipc-hdw3466emp-s-aus-smd-wizsense-camera-kit",
            "dahua-6-x-4mp-dh-ipc-hdw3466emp-s-aus-smd-wizsense-camera-kit",
            "dahua-hac-hfw2501tp-i8-a-0360b-5mp-starlight-pro-hdcvi-ir-bulletwdricr3-6mmir-80m"
          ]
        }
      }
    },
    "dahua-popular-1": {
      "collectionHandle": "dahua-popular-1",
      "collectionProductCount": 69,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 16,
          "rankedProductIds": [
            "7591785365561",
            "7591857061945",
            "7591829831737",
            "8284590407737",
            "8168553316409",
            "8168542044217",
            "8168609087545",
            "8168425881657",
            "7591832158265",
            "7591831109689",
            "7591829372985",
            "8168415559737",
            "7591831732281",
            "8168534900793",
            "8168533983289",
            "8168629043257"
          ],
          "rankedProductHandles": [
            "dahua-tioc-advanced-2-0-dh-ipc-hfw3849t1p-as-pv-0280b-s3-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-built-in-mic-speakerip67poe-wizsense",
            "dahua-tioc-advanced-2-0-dh-ipc-hdbw3849r1p-zas-pv-27135-8mp-starlight-ip-dome-motorised-2-7-13-5mm",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3849h-as-pv-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-ipc-pfw3849s-a180-as-pv-8mp-180-tioc-duo-splicing-bullet-wizsense-network-camera",
            "dahua-tioc-dh-ipc-hdw3849h-as-pv-pro-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-dh-ipc-hfw3849t1-as-pv-anz-s2-blk-8mp-ai-active-deterrence-ip-bullet-fixed-2-8mm-black",
            "dahua-ipc-hfw3849t1-as-pv-pro-8mp-smart-dual-light-active-deterrence-fixed-focal-bullet-camera-2-8-mm",
            "dahua-tioc-advanced-3-0-ipc-hdw3849h-as-pv-anz-s2-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-blk-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-black",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3649h-as-pv-anz-6mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-dh-ipc-hfw3849t1-zas-pv-anz-s2-8mp-smart-dual-active-deterrence-vari-focal-bullet-wizsense-network-camera",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3649h-as-pv-anz-blk-6mp-ai-active-deterrence-full-color-starlight-ip-turret-camera-black",
            "dahua-dh-ipc-hdw3867em-s-il-anz-with-smart-dual-light-30m-ir-black",
            "dahua-dh-ipc-hdw3867em-s-il-anz-with-smart-warm-light-30m-ir",
            "dahua-dh-ipc-hdbw3867e-as-il-anz-8mp-smart-dual-light-fixed-focal-dome-wizsense-network-camera"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 16,
          "rankedProductIds": [
            "8284590407737",
            "8284512157753",
            "8168598175801",
            "8168553316409",
            "8168629043257",
            "8168542044217",
            "8168609087545",
            "7591945175097",
            "7591864729657",
            "8168425881657",
            "7591932067897",
            "7591832158265",
            "7591831732281",
            "7591831109689",
            "7591830618169",
            "7591830323257"
          ],
          "rankedProductHandles": [
            "dahua-ipc-pfw3849s-a180-as-pv-8mp-180-tioc-duo-splicing-bullet-wizsense-network-camera",
            "dahua-ipc-hdw3849h-zas-pv-pro-anz-8mp-4k-wizsense-tioc-pro-vari-focal-eyeball-network-camera",
            "dahua-ipc-hfw3667e-as-il-anz-6-mp-smart-dual-light-bullet-camera-wizsense-3-series",
            "dahua-tioc-dh-ipc-hdw3849h-as-pv-pro-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-dh-ipc-hdbw3867e-as-il-anz-8mp-smart-dual-light-fixed-focal-dome-wizsense-network-camera",
            "dahua-tioc-dh-ipc-hfw3849t1-as-pv-anz-s2-blk-8mp-ai-active-deterrence-ip-bullet-fixed-2-8mm-black",
            "dahua-ipc-hfw3849t1-as-pv-pro-8mp-smart-dual-light-active-deterrence-fixed-focal-bullet-camera-2-8-mm",
            "dahua-dh-ipc-pdw3849-a180-as-pv-anz-blk-tioc-duo-splicing-turret-fixed-camera-black",
            "dahua-dh-ipc-pdw3849-a180-as-pv-anz-tioc-duo-splicing-turret-fixed-camera",
            "dahua-tioc-advanced-3-0-ipc-hdw3849h-as-pv-anz-s2-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-2-0-black-dh-ipc-hfw3649t1-as-pv-anz-6mp-ai-active-deterrence-fixed-lens-bullet-camera",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-blk-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-black",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3649h-as-pv-anz-blk-6mp-ai-active-deterrence-full-color-starlight-ip-turret-camera-black",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm",
            "dahua-tioc-3-0-advanced-dh-ipc-hfw3649t1-as-pv-anz-6mp-ai-active-deterrence-motorised-bullet-camera",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3849h-as-pv-anz-blk-8mp-ai-active-deterrence-full-color-ip-turret-camera-black"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 16,
          "rankedProductIds": [
            "8168590934073",
            "8168553316409",
            "8284590407737",
            "8284558229561",
            "8284512157753",
            "7591932756025",
            "8168629043257",
            "7591945568313",
            "7591843070009",
            "8168542044217",
            "8168609087545",
            "8168534900793",
            "8168533983289",
            "8168425881657",
            "7591940128825",
            "7591832158265"
          ],
          "rankedProductHandles": [
            "dahua-dh-ipc-hdw3867t-zs-il-anz-8mp-smart-dual-light-varifocal-turret-network-camera",
            "dahua-tioc-dh-ipc-hdw3849h-as-pv-pro-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-ipc-pfw3849s-a180-as-pv-8mp-180-tioc-duo-splicing-bullet-wizsense-network-camera",
            "dahua-dh-hac-hdw2802tp-a-8mp-4k-hdcvi-turret-camera-2-8mm-fixed-lens-starlight-ir-60m-built-in-mic-ip67",
            "dahua-ipc-hdw3849h-zas-pv-pro-anz-8mp-4k-wizsense-tioc-pro-vari-focal-eyeball-network-camera",
            "dahua-tioc-dh-ipc-hdw3849h-zas-pv-anz-8mp-ai-active-deterrence-motorised-turret-camera",
            "dahua-dh-ipc-hdbw3867e-as-il-anz-8mp-smart-dual-light-fixed-focal-dome-wizsense-network-camera",
            "dahua-tioc-dh-ipc-hdw3849h-zas-pv-anz-8mp-ai-active-deterrence-motorised-turret-camera-black",
            "dahua-dh-ipc-hfw3866ep-as-aus-8mp-4k-bullet-fixed-starlight-wizsense-camera",
            "dahua-tioc-dh-ipc-hfw3849t1-as-pv-anz-s2-blk-8mp-ai-active-deterrence-ip-bullet-fixed-2-8mm-black",
            "dahua-ipc-hfw3849t1-as-pv-pro-8mp-smart-dual-light-active-deterrence-fixed-focal-bullet-camera-2-8-mm",
            "dahua-dh-ipc-hdw3867em-s-il-anz-with-smart-dual-light-30m-ir-black",
            "dahua-dh-ipc-hdw3867em-s-il-anz-with-smart-warm-light-30m-ir",
            "dahua-tioc-advanced-3-0-ipc-hdw3849h-as-pv-anz-s2-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-dh-ipc-hfw3466ep-as-aus-4mp-bullet-network-camera-50m-ir-2-8mm-with-smd-4-0-wizsense",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-blk-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-black"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 11,
          "rankedProductIds": [
            "7591940128825",
            "7591840940089",
            "7591843070009",
            "7591846936633",
            "8168553316409",
            "7591799652409",
            "7591841726521",
            "7591730970681",
            "7591816822841",
            "7591847100473",
            "7591847297081"
          ],
          "rankedProductHandles": [
            "dahua-dh-ipc-hfw3466ep-as-aus-4mp-bullet-network-camera-50m-ir-2-8mm-with-smd-4-0-wizsense",
            "dahua-8mp-dh-ipc-hdbw3866ep-as-aus-4k-starlight-ip-dome-wdr-ir-30m",
            "dahua-dh-ipc-hfw3866ep-as-aus-8mp-4k-bullet-fixed-starlight-wizsense-camera",
            "dahua-dh-sd4a425db-hny-4mp-25x-ip-starlight-wizsense-ptz-camera",
            "dahua-tioc-dh-ipc-hdw3849h-as-pv-pro-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-dh-ipc-hdw3666tp-zs-aus-6mp-motorised-turret-network-camera-40m-ir-with-smd-4-0",
            "dahua-dh-ipc-hdbw3466r-as-p-4mp-180-degree-camera-dome-wizsense-ir-ip67-12v-poe-2-1mm-lens",
            "dahua-dh-ipc-hdbw2431f-as-s2-4mp-lite-ir-fixed-focal-dome-network-camera",
            "dahua-dh-ipc-hfw3466tp-zas-aus-4mp-wdr-ir-bullet-network-camera-with-2-7-13-5mm-motorized-lens-wizsense",
            "dahua-dh-ipc-pdw5849-a180-e2-aste-4mp-x-2-full-color-dual-lens-wizmind-network-camera",
            "dahua-dh-ipc-pfw5849-a180-e2-aste-4mp-x-2-full-color-dual-lens-wizmind-bullet-network-camera"
          ]
        }
      }
    },
    "dahua-pro-ai-cameras-amp-recorders": {
      "collectionHandle": "dahua-pro-ai-cameras-amp-recorders",
      "collectionProductCount": 69,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 16,
          "rankedProductIds": [
            "7591785365561",
            "7591857061945",
            "7591770914873",
            "7591829831737",
            "8168553316409",
            "8168542044217",
            "8284590407737",
            "8168425881657",
            "8168609087545",
            "8168406024249",
            "7591832158265",
            "7591831109689",
            "8168415559737",
            "7591824752697",
            "8168572452921",
            "7591771406393"
          ],
          "rankedProductHandles": [
            "dahua-tioc-advanced-2-0-dh-ipc-hfw3849t1p-as-pv-0280b-s3-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-built-in-mic-speakerip67poe-wizsense",
            "dahua-tioc-advanced-2-0-dh-ipc-hdbw3849r1p-zas-pv-27135-8mp-starlight-ip-dome-motorised-2-7-13-5mm",
            "dahua-tioc-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3849h-as-pv-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-dh-ipc-hdw3849h-as-pv-pro-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-dh-ipc-hfw3849t1-as-pv-anz-s2-blk-8mp-ai-active-deterrence-ip-bullet-fixed-2-8mm-black",
            "dahua-ipc-pfw3849s-a180-as-pv-8mp-180-tioc-duo-splicing-bullet-wizsense-network-camera",
            "dahua-tioc-advanced-3-0-ipc-hdw3849h-as-pv-anz-s2-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-ipc-hfw3849t1-as-pv-pro-8mp-smart-dual-light-active-deterrence-fixed-focal-bullet-camera-2-8-mm",
            "dahua-tioc-dh-ipc-hdw3849hp-as-pv-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-fixed-2-8mm-mic-speaker-wizsense",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-blk-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-black",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm",
            "dahua-dh-ipc-hfw3849t1-zas-pv-anz-s2-8mp-smart-dual-active-deterrence-vari-focal-bullet-wizsense-network-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hfw3849t1p-as-pv-0280b-s3-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm",
            "dahua-dh-sdt3e410-8p-mb-a-pv1-8mp4mp-10x-starlight-tioc-panoramic-ptz-security-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3549hp-as-pv-0280b-s3-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-turret-camera"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 16,
          "rankedProductIds": [
            "7591787495481",
            "7591770914873",
            "7591800406073",
            "7591715471417",
            "8168575336505",
            "8168553316409",
            "8168542044217",
            "8284512157753",
            "8284590407737",
            "8168425881657",
            "8168609087545",
            "7591722385465",
            "8168406024249",
            "7591945175097",
            "7591864729657",
            "7591771406393"
          ],
          "rankedProductHandles": [
            "dahua-tioc-2-0-advanced-dh-ipc-hfw3549t1p-as-pv-0280b-s3-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-built-in-mic-speaker-ip67-poe-wizsense",
            "dahua-tioc-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-blk-8mp-ai-active-deterrence-full-color-ip-turret-camera-black",
            "dahua-dh-sd8a840wa-hnf-4k-40x-starlight-ir-ptz-ai-network-camera",
            "dahua-ipc-hdw3649h-as-pv-pro-tioc-acupick-6mp-ai-active-deterrence-ip-turret-camera",
            "dahua-tioc-dh-ipc-hdw3849h-as-pv-pro-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-dh-ipc-hfw3849t1-as-pv-anz-s2-blk-8mp-ai-active-deterrence-ip-bullet-fixed-2-8mm-black",
            "dahua-ipc-hdw3849h-zas-pv-pro-anz-8mp-4k-wizsense-tioc-pro-vari-focal-eyeball-network-camera",
            "dahua-ipc-pfw3849s-a180-as-pv-8mp-180-tioc-duo-splicing-bullet-wizsense-network-camera",
            "dahua-tioc-advanced-3-0-ipc-hdw3849h-as-pv-anz-s2-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-ipc-hfw3849t1-as-pv-pro-8mp-smart-dual-light-active-deterrence-fixed-focal-bullet-camera-2-8-mm",
            "dahua-tioc-dh-ipc-hdw3549hp-as-pv-0280b-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-turret-fixed-2-8mm-built-in-mic-speakerwdr-micro-sdip67poe",
            "dahua-tioc-dh-ipc-hdw3849hp-as-pv-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-fixed-2-8mm-mic-speaker-wizsense",
            "dahua-dh-ipc-pdw3849-a180-as-pv-anz-blk-tioc-duo-splicing-turret-fixed-camera-black",
            "dahua-dh-ipc-pdw3849-a180-as-pv-anz-tioc-duo-splicing-turret-fixed-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3549hp-as-pv-0280b-s3-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-turret-camera"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 16,
          "rankedProductIds": [
            "8168610201657",
            "7591915520057",
            "7591718027321",
            "7591796539449",
            "7591715471417",
            "8168553316409",
            "7591770914873",
            "7591800406073",
            "8168572452921",
            "7690795483193",
            "8168542044217",
            "8284512157753",
            "8284590407737",
            "7591932756025",
            "8168425881657",
            "8168609087545"
          ],
          "rankedProductHandles": [
            "dahua-itc413-pw4d-iz1-anpr-camera-4mp-motorized-vari-focal-ir-license-plate-recognition-2-7-12mm",
            "dahua-dhi-itc413-pw4d-iz3-ai-access-anpr-4mp-8-32mm-k",
            "dahua-dhi-itc237-pw6m-irlzf1050-ai-access-anpr-2-megapixel-full-hd-wdr-anpr-camera-ir-max-40km-hr-10-50mm-motorized-lens",
            "dahua-anpr-short-range-motorised-camera-max-8m-distance",
            "dahua-dh-sd8a840wa-hnf-4k-40x-starlight-ir-ptz-ai-network-camera",
            "dahua-tioc-dh-ipc-hdw3849h-as-pv-pro-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-blk-8mp-ai-active-deterrence-full-color-ip-turret-camera-black",
            "dahua-dh-sdt3e410-8p-mb-a-pv1-8mp4mp-10x-starlight-tioc-panoramic-ptz-security-camera",
            "dahua-dh-sdt4e425-8p-gb-apv1-x-spans-8mp4mp-25x-tioc-wizsense-network-ptz-camera",
            "dahua-tioc-dh-ipc-hfw3849t1-as-pv-anz-s2-blk-8mp-ai-active-deterrence-ip-bullet-fixed-2-8mm-black",
            "dahua-ipc-hdw3849h-zas-pv-pro-anz-8mp-4k-wizsense-tioc-pro-vari-focal-eyeball-network-camera",
            "dahua-ipc-pfw3849s-a180-as-pv-8mp-180-tioc-duo-splicing-bullet-wizsense-network-camera",
            "dahua-tioc-dh-ipc-hdw3849h-zas-pv-anz-8mp-ai-active-deterrence-motorised-turret-camera",
            "dahua-tioc-advanced-3-0-ipc-hdw3849h-as-pv-anz-s2-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-ipc-hfw3849t1-as-pv-pro-8mp-smart-dual-light-active-deterrence-fixed-focal-bullet-camera-2-8-mm"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 16,
          "rankedProductIds": [
            "7591715471417",
            "7690795483193",
            "7591771570233",
            "8284596830265",
            "7591838548025",
            "7591706394681",
            "8168600469561",
            "7690795450425",
            "7591777337401",
            "8168553316409",
            "7591820656697",
            "7591722385465",
            "7745674051641",
            "7591729004601",
            "8168402714681",
            "8168572452921"
          ],
          "rankedProductHandles": [
            "dahua-dh-sd8a840wa-hnf-4k-40x-starlight-ir-ptz-ai-network-camera",
            "dahua-dh-sdt4e425-8p-gb-apv1-x-spans-8mp4mp-25x-tioc-wizsense-network-ptz-camera",
            "dahua-dh-sd5a432xa-hnr-4mp-ip-32x-ptz-camera-with-wizsense",
            "dahua-sd6e445mb-hnr-a-pv1-4mp-45x-smart-dual-illumination-active-deterrence-network-ptz-camera",
            "dahua-dh-sd5a432xb-hnr-4mp-ip-32x-ptz-camera-with-wizsense",
            "dahua-dh-sd5a425xa-hnr-4mp-25x-starlight-ir-ptz-ai-network-camera",
            "dahua-ipc-hdw5442tp-ze-s3-ai-4mp-turret-motorized-camera-starlight-motorized-lens-ip67",
            "dahua-dh-sdt4e425-4f-gb-a-pv1-x-spans-4mp4mp-25x-tioc-wizsense-network-ptz-camera",
            "dahua-dh-sd6c3425xb-hnr-a-pv1-4mp-tioc-ip-25x-ptz-camera-ir-150m",
            "dahua-tioc-dh-ipc-hdw3849h-as-pv-pro-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-sd6ce445gb-hnr-4mp-45x-startlight-ir-network-ptz-camera",
            "dahua-tioc-dh-ipc-hdw3549hp-as-pv-0280b-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-turret-fixed-2-8mm-built-in-mic-speakerwdr-micro-sdip67poe",
            "dahua-dh-sd3e405db-gny-a-pv1-4mp-5x-tioc-wizsense-network-ptz-camera",
            "dahua-dh-ipc-hfw5541ep-ze-27135",
            "dahua-dh-sd8a840-hnf-pa-4k-40x-starlight-ir-ptz-ai-network-camera",
            "dahua-dh-sdt3e410-8p-mb-a-pv1-8mp4mp-10x-starlight-tioc-panoramic-ptz-security-camera"
          ]
        }
      }
    },
    "dahua-ptz-cameras-1": {
      "collectionHandle": "dahua-ptz-cameras-1",
      "collectionProductCount": 32,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 13,
          "rankedProductIds": [
            "7591853162553",
            "8324085809209",
            "8168572452921",
            "7690795483193",
            "7591715471417",
            "7690795450425",
            "7591777337401",
            "7591888093241",
            "7591706394681",
            "7591846936633",
            "7591721533497",
            "7591649378361",
            "7591648952377"
          ],
          "rankedProductHandles": [
            "dahua-4mp-sd6c3432xb-hnr-agq-pv-32x-starlight-ir-wizsense-4g-network-ptz-camera",
            "dahua-dh-sd6c3825ga-hnr-a-pv1-8mp-25x-starlight-tioc-wizsense-network-ptz-camera",
            "dahua-dh-sdt3e410-8p-mb-a-pv1-8mp4mp-10x-starlight-tioc-panoramic-ptz-security-camera",
            "dahua-dh-sdt4e425-8p-gb-apv1-x-spans-8mp4mp-25x-tioc-wizsense-network-ptz-camera",
            "dahua-dh-sd8a840wa-hnf-4k-40x-starlight-ir-ptz-ai-network-camera",
            "dahua-dh-sdt4e425-4f-gb-a-pv1-x-spans-4mp4mp-25x-tioc-wizsense-network-ptz-camera",
            "dahua-dh-sd6c3425xb-hnr-a-pv1-4mp-tioc-ip-25x-ptz-camera-ir-150m",
            "dahua-4mp-dh-sd49425xb-hnr-25x-starlight-ir-ptz-ai-network-camera",
            "dahua-dh-sd5a425xa-hnr-4mp-25x-starlight-ir-ptz-ai-network-camera",
            "dahua-dh-sd4a425db-hny-4mp-25x-ip-starlight-wizsense-ptz-camera",
            "dahua-dh-sd6ce445xa-hnr-4mp-45x-starlight-ir-ptz-ai-network-camera",
            "dahua-dh-sd59230u-hni-2mp-30x-starlight-ir-ptz-network-camera",
            "dahua-sd49225db-hny-2mp-25x-starlight-ir-ptz-network-camera-with-wizsense"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 15,
          "rankedProductIds": [
            "7591715471417",
            "8324085809209",
            "7690795483193",
            "7690795450425",
            "7745674051641",
            "8168572452921",
            "7745702035513",
            "7591853162553",
            "7591777337401",
            "7591838548025",
            "8284596830265",
            "7591737950265",
            "7591656292409",
            "7591656063033",
            "7591648952377"
          ],
          "rankedProductHandles": [
            "dahua-dh-sd8a840wa-hnf-4k-40x-starlight-ir-ptz-ai-network-camera",
            "dahua-dh-sd6c3825ga-hnr-a-pv1-8mp-25x-starlight-tioc-wizsense-network-ptz-camera",
            "dahua-dh-sdt4e425-8p-gb-apv1-x-spans-8mp4mp-25x-tioc-wizsense-network-ptz-camera",
            "dahua-dh-sdt4e425-4f-gb-a-pv1-x-spans-4mp4mp-25x-tioc-wizsense-network-ptz-camera",
            "dahua-dh-sd3e405db-gny-a-pv1-4mp-5x-tioc-wizsense-network-ptz-camera",
            "dahua-dh-sdt3e410-8p-mb-a-pv1-8mp4mp-10x-starlight-tioc-panoramic-ptz-security-camera",
            "dahua-sd1a404db-gny-4mp-4x-starlight-ir-wizsense-network-ptz-camera",
            "dahua-4mp-sd6c3432xb-hnr-agq-pv-32x-starlight-ir-wizsense-4g-network-ptz-camera",
            "dahua-dh-sd6c3425xb-hnr-a-pv1-4mp-tioc-ip-25x-ptz-camera-ir-150m",
            "dahua-dh-sd5a432xb-hnr-4mp-ip-32x-ptz-camera-with-wizsense",
            "dahua-sd6e445mb-hnr-a-pv1-4mp-45x-smart-dual-illumination-active-deterrence-network-ptz-camera",
            "dahua-dh-sd1a404xb-gnr-4m-4x-starlight-ir-ptz-ai-network-camera",
            "dahua-dh-sd6al830v-hni-ir-4k-30x-ir-ptz-network-camera",
            "dahua-dh-sd59430u-hni-4mp-30x-ir-ptz-network-camera",
            "dahua-sd49225db-hny-2mp-25x-starlight-ir-ptz-network-camera-with-wizsense"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 16,
          "rankedProductIds": [
            "7591715471417",
            "8324085809209",
            "7690795483193",
            "8168572452921",
            "8168402714681",
            "7745702035513",
            "7591888093241",
            "7591656292409",
            "7591771570233",
            "7690795450425",
            "8168440791097",
            "7745674051641",
            "7591838548025",
            "8284596830265",
            "7591853162553",
            "7591777337401"
          ],
          "rankedProductHandles": [
            "dahua-dh-sd8a840wa-hnf-4k-40x-starlight-ir-ptz-ai-network-camera",
            "dahua-dh-sd6c3825ga-hnr-a-pv1-8mp-25x-starlight-tioc-wizsense-network-ptz-camera",
            "dahua-dh-sdt4e425-8p-gb-apv1-x-spans-8mp4mp-25x-tioc-wizsense-network-ptz-camera",
            "dahua-dh-sdt3e410-8p-mb-a-pv1-8mp4mp-10x-starlight-tioc-panoramic-ptz-security-camera",
            "dahua-dh-sd8a840-hnf-pa-4k-40x-starlight-ir-ptz-ai-network-camera",
            "dahua-sd1a404db-gny-4mp-4x-starlight-ir-wizsense-network-ptz-camera",
            "dahua-4mp-dh-sd49425xb-hnr-25x-starlight-ir-ptz-ai-network-camera",
            "dahua-dh-sd6al830v-hni-ir-4k-30x-ir-ptz-network-camera",
            "dahua-dh-sd5a432xa-hnr-4mp-ip-32x-ptz-camera-with-wizsense",
            "dahua-dh-sdt4e425-4f-gb-a-pv1-x-spans-4mp4mp-25x-tioc-wizsense-network-ptz-camera",
            "dahua-4mp-dh-sd49425xb-hnr-dh-sd49425gb-hnr-25x-starlight-ir-ptz-ai-network-camera",
            "dahua-dh-sd3e405db-gny-a-pv1-4mp-5x-tioc-wizsense-network-ptz-camera",
            "dahua-dh-sd5a432xb-hnr-4mp-ip-32x-ptz-camera-with-wizsense",
            "dahua-sd6e445mb-hnr-a-pv1-4mp-45x-smart-dual-illumination-active-deterrence-network-ptz-camera",
            "dahua-4mp-sd6c3432xb-hnr-agq-pv-32x-starlight-ir-wizsense-4g-network-ptz-camera",
            "dahua-dh-sd6c3425xb-hnr-a-pv1-4mp-tioc-ip-25x-ptz-camera-ir-150m"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 16,
          "rankedProductIds": [
            "7591715471417",
            "7690795483193",
            "7591888093241",
            "7591771570233",
            "7591838548025",
            "8284596830265",
            "7745702035513",
            "7690795450425",
            "7591706394681",
            "7591853162553",
            "7591677722681",
            "7591777337401",
            "7591846936633",
            "7591820656697",
            "8324085809209",
            "7745674051641"
          ],
          "rankedProductHandles": [
            "dahua-dh-sd8a840wa-hnf-4k-40x-starlight-ir-ptz-ai-network-camera",
            "dahua-dh-sdt4e425-8p-gb-apv1-x-spans-8mp4mp-25x-tioc-wizsense-network-ptz-camera",
            "dahua-4mp-dh-sd49425xb-hnr-25x-starlight-ir-ptz-ai-network-camera",
            "dahua-dh-sd5a432xa-hnr-4mp-ip-32x-ptz-camera-with-wizsense",
            "dahua-dh-sd5a432xb-hnr-4mp-ip-32x-ptz-camera-with-wizsense",
            "dahua-sd6e445mb-hnr-a-pv1-4mp-45x-smart-dual-illumination-active-deterrence-network-ptz-camera",
            "dahua-sd1a404db-gny-4mp-4x-starlight-ir-wizsense-network-ptz-camera",
            "dahua-dh-sdt4e425-4f-gb-a-pv1-x-spans-4mp4mp-25x-tioc-wizsense-network-ptz-camera",
            "dahua-dh-sd5a425xa-hnr-4mp-25x-starlight-ir-ptz-ai-network-camera",
            "dahua-4mp-sd6c3432xb-hnr-agq-pv-32x-starlight-ir-wizsense-4g-network-ptz-camera",
            "dahua-dh-sd1a203t-gn-2mp-starlight-ip-ptz-3x-2-7mm8-1mm-vf-lens",
            "dahua-dh-sd6c3425xb-hnr-a-pv1-4mp-tioc-ip-25x-ptz-camera-ir-150m",
            "dahua-dh-sd4a425db-hny-4mp-25x-ip-starlight-wizsense-ptz-camera",
            "dahua-sd6ce445gb-hnr-4mp-45x-startlight-ir-network-ptz-camera",
            "dahua-dh-sd6c3825ga-hnr-a-pv1-8mp-25x-starlight-tioc-wizsense-network-ptz-camera",
            "dahua-dh-sd3e405db-gny-a-pv1-4mp-5x-tioc-wizsense-network-ptz-camera"
          ]
        }
      }
    },
    "dahua-solar-cameras-1": {
      "collectionHandle": "dahua-solar-cameras-1",
      "collectionProductCount": 6,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "dahua-special-kits": {
      "collectionHandle": "dahua-special-kits",
      "collectionProductCount": 11,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 2,
          "rankedProductIds": [
            "8168481783865",
            "8168575205433"
          ],
          "rankedProductHandles": [
            "dahua-4-x-8mp-tioc-cctv-kit-full-colour-night-vision-audible-warning-4ch-poe-ai-nvr",
            "dahua-10-x-8mp-dh-ipc-hdw3867em-s-il-anz-fixed-starlight-turret-cameras-16ch-ai-nvr"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 6,
          "rankedProductIds": [
            "8168540536889",
            "8168539357241",
            "8168575205433",
            "8168481783865",
            "8168410021945",
            "8168537227321"
          ],
          "rankedProductHandles": [
            "dahua-8-x-8mp-dh-ipc-hdw3867em-s-il-anz-fixed-starlight-turret-cameras-8ch-ai-nvr",
            "dahua-6-x-dh-ipc-hdw3867em-s-il-anz-starlight-turret-cameras-ai-nvr-cctv-kit",
            "dahua-10-x-8mp-dh-ipc-hdw3867em-s-il-anz-fixed-starlight-turret-cameras-16ch-ai-nvr",
            "dahua-4-x-8mp-tioc-cctv-kit-full-colour-night-vision-audible-warning-4ch-poe-ai-nvr",
            "dahua-10-x-8mp-dh-ipc-hdw3866emp-s-aus-smd-4-0-turret-security-kit-with-16ch-ai-nvr-2-8mm-lens",
            "dahua-4-x-8mp-dh-ipc-hdw3867em-s-il-anz-turret-security-cctv-kit-with-8ch-wizsense-nvr"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 2,
          "rankedProductIds": [
            "8168540536889",
            "8168575205433"
          ],
          "rankedProductHandles": [
            "dahua-8-x-8mp-dh-ipc-hdw3867em-s-il-anz-fixed-starlight-turret-cameras-8ch-ai-nvr",
            "dahua-10-x-8mp-dh-ipc-hdw3867em-s-il-anz-fixed-starlight-turret-cameras-16ch-ai-nvr"
          ]
        }
      }
    },
    "dahua-special-offers-1": {
      "collectionHandle": "dahua-special-offers-1",
      "collectionProductCount": 44,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 8,
          "rankedProductIds": [
            "7591931772985",
            "7591735689273",
            "7591930462265",
            "7591737196601",
            "7591738966073",
            "7591930953785",
            "7591790706745",
            "7591735197753"
          ],
          "rankedProductHandles": [
            "dahua-8-x-8mp-black-tioc-advanced-2-0-with-smd4-0-active-deterrance-turret-kit-with-8ch-wizsense-nvr",
            "dahua-6-x-8mp-dh-ipc-hdw3849hp-as-pv-tioc-with-wizsense-turret-kit-with-8ch-nvr",
            "dahua-4-x-black-8mp-tioc-smd4-0-dh-ipc-hdw3849h-as-pv-anz-turret-kit-with-8ch-nvr",
            "dahua-8-x-8mp-dh-ipc-hdw3849hp-as-pv-tioc-with-wizsense-turret-kit-with-8ch",
            "dahua-4-x-8mp-dh-ipc-hdw3849hp-as-pv-tioc-with-wizsense-turret-kit-with-8ch-nvr",
            "dahua-6-x-black-8mp-tioc-with-smd4-0-dh-ipc-hdw3849h-as-pv-anz-active-deterrance-turret-kit-with-8ch-nvr-wizsense",
            "dahua-4-x-6mp-tioc-advanced-2-0-dh-ipc-hdw3649h-as-pv-anz-turret-kit-4ch-nvr",
            "dahua-4-x-5mp-dh-ipc-hdw3549hp-as-pv-0280b-tioc-with-wizsense-turret-kit-with-4ch-nvr-2tb-hdd"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 12,
          "rankedProductIds": [
            "7690800070713",
            "7591931772985",
            "7591737196601",
            "7591735689273",
            "7591738966073",
            "7591790706745",
            "7591930953785",
            "7591930462265",
            "7591735197753",
            "7591811514425",
            "7591809384505",
            "7591810007097"
          ],
          "rankedProductHandles": [
            "dahua-8-x-6mp-tioc-dh-ipc-hdw3649h-as-pv-anz-turret-kit-with-8ch-ai-nvr",
            "dahua-8-x-8mp-black-tioc-advanced-2-0-with-smd4-0-active-deterrance-turret-kit-with-8ch-wizsense-nvr",
            "dahua-8-x-8mp-dh-ipc-hdw3849hp-as-pv-tioc-with-wizsense-turret-kit-with-8ch",
            "dahua-6-x-8mp-dh-ipc-hdw3849hp-as-pv-tioc-with-wizsense-turret-kit-with-8ch-nvr",
            "dahua-4-x-8mp-dh-ipc-hdw3849hp-as-pv-tioc-with-wizsense-turret-kit-with-8ch-nvr",
            "dahua-4-x-6mp-tioc-advanced-2-0-dh-ipc-hdw3649h-as-pv-anz-turret-kit-4ch-nvr",
            "dahua-6-x-black-8mp-tioc-with-smd4-0-dh-ipc-hdw3849h-as-pv-anz-active-deterrance-turret-kit-with-8ch-nvr-wizsense",
            "dahua-4-x-black-8mp-tioc-smd4-0-dh-ipc-hdw3849h-as-pv-anz-turret-kit-with-8ch-nvr",
            "dahua-4-x-5mp-dh-ipc-hdw3549hp-as-pv-0280b-tioc-with-wizsense-turret-kit-with-4ch-nvr-2tb-hdd",
            "dahua-8-x-6mp-dh-ipc-hdw3666emp-s-aus-smd-4-0-ai-turret-kit-50m-ir-2-8mm-with-smd-8ch-nvr",
            "dahua-6-x-6mp-dh-ipc-hdw3666emp-s-aus-smd-4-0-ai-turret-kit-50m-ir-2-8mm-with-smd-8ch-nvr-2tb-hdd-wizsense",
            "dahua-4-x-6mp-dh-ipc-hdw3666emp-s-aus-smd-4-0-ai-turret-security-kit-50m-ir-2-8mm-4ch-nvr-2tb-hdd-black"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 6,
          "rankedProductIds": [
            "7591931772985",
            "7591737196601",
            "7591735689273",
            "7591738966073",
            "7591930953785",
            "7591930462265"
          ],
          "rankedProductHandles": [
            "dahua-8-x-8mp-black-tioc-advanced-2-0-with-smd4-0-active-deterrance-turret-kit-with-8ch-wizsense-nvr",
            "dahua-8-x-8mp-dh-ipc-hdw3849hp-as-pv-tioc-with-wizsense-turret-kit-with-8ch",
            "dahua-6-x-8mp-dh-ipc-hdw3849hp-as-pv-tioc-with-wizsense-turret-kit-with-8ch-nvr",
            "dahua-4-x-8mp-dh-ipc-hdw3849hp-as-pv-tioc-with-wizsense-turret-kit-with-8ch-nvr",
            "dahua-6-x-black-8mp-tioc-with-smd4-0-dh-ipc-hdw3849h-as-pv-anz-active-deterrance-turret-kit-with-8ch-nvr-wizsense",
            "dahua-4-x-black-8mp-tioc-smd4-0-dh-ipc-hdw3849h-as-pv-anz-turret-kit-with-8ch-nvr"
          ]
        }
      }
    },
    "dahua-thermal-cameras-1": {
      "collectionHandle": "dahua-thermal-cameras-1",
      "collectionProductCount": 2,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "dahua-tioc-1-1": {
      "collectionHandle": "dahua-tioc-1-1",
      "collectionProductCount": 2,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 1,
          "rankedProductIds": [
            "7591722385465"
          ],
          "rankedProductHandles": [
            "dahua-tioc-dh-ipc-hdw3549hp-as-pv-0280b-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-turret-fixed-2-8mm-built-in-mic-speakerwdr-micro-sdip67poe"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 1,
          "rankedProductIds": [
            "7591722385465"
          ],
          "rankedProductHandles": [
            "dahua-tioc-dh-ipc-hdw3549hp-as-pv-0280b-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-turret-fixed-2-8mm-built-in-mic-speakerwdr-micro-sdip67poe"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 1,
          "rankedProductIds": [
            "7591722385465"
          ],
          "rankedProductHandles": [
            "dahua-tioc-dh-ipc-hdw3549hp-as-pv-0280b-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-turret-fixed-2-8mm-built-in-mic-speakerwdr-micro-sdip67poe"
          ]
        }
      }
    },
    "dahua-tioc-2-0-w-smd4-1": {
      "collectionHandle": "dahua-tioc-2-0-w-smd4-1",
      "collectionProductCount": 37,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 16,
          "rankedProductIds": [
            "8168553316409",
            "7591829831737",
            "8168542044217",
            "8168425881657",
            "8284590407737",
            "8168609087545",
            "7591832158265",
            "7591831109689",
            "7591829372985",
            "7591831732281",
            "7690795483193",
            "7690795450425",
            "8284512157753",
            "8168400322617",
            "7591947927609",
            "7591830323257"
          ],
          "rankedProductHandles": [
            "dahua-tioc-dh-ipc-hdw3849h-as-pv-pro-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3849h-as-pv-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-dh-ipc-hfw3849t1-as-pv-anz-s2-blk-8mp-ai-active-deterrence-ip-bullet-fixed-2-8mm-black",
            "dahua-tioc-advanced-3-0-ipc-hdw3849h-as-pv-anz-s2-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-ipc-pfw3849s-a180-as-pv-8mp-180-tioc-duo-splicing-bullet-wizsense-network-camera",
            "dahua-ipc-hfw3849t1-as-pv-pro-8mp-smart-dual-light-active-deterrence-fixed-focal-bullet-camera-2-8-mm",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-blk-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-black",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3649h-as-pv-anz-6mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3649h-as-pv-anz-blk-6mp-ai-active-deterrence-full-color-starlight-ip-turret-camera-black",
            "dahua-dh-sdt4e425-8p-gb-apv1-x-spans-8mp4mp-25x-tioc-wizsense-network-ptz-camera",
            "dahua-dh-sdt4e425-4f-gb-a-pv1-x-spans-4mp4mp-25x-tioc-wizsense-network-ptz-camera",
            "dahua-ipc-hdw3849h-zas-pv-pro-anz-8mp-4k-wizsense-tioc-pro-vari-focal-eyeball-network-camera",
            "dahua-ipc-hdbw3549r1-zas-pv-5mp-smart-dual-light-tioc-motorised-dome-wizsense-network-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3849h-as-pv-anz-8mp-ai-active-deterrence-full-color",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3849h-as-pv-anz-blk-8mp-ai-active-deterrence-full-color-ip-turret-camera-black"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 16,
          "rankedProductIds": [
            "8168553316409",
            "8284475457593",
            "8168575336505",
            "8168542044217",
            "8168425881657",
            "8284512157753",
            "8284590407737",
            "8168609087545",
            "7591945175097",
            "7591947927609",
            "7690795483193",
            "8168400322617",
            "7690795450425",
            "7591932067897",
            "7591864729657",
            "7591832158265"
          ],
          "rankedProductHandles": [
            "dahua-tioc-dh-ipc-hdw3849h-as-pv-pro-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-4-x-6mp-dh-ipc-hdw3649h-as-pv-anz-tioc-2-0-with-wizsense-turret-4ch-kit",
            "dahua-ipc-hdw3649h-as-pv-pro-tioc-acupick-6mp-ai-active-deterrence-ip-turret-camera",
            "dahua-tioc-dh-ipc-hfw3849t1-as-pv-anz-s2-blk-8mp-ai-active-deterrence-ip-bullet-fixed-2-8mm-black",
            "dahua-tioc-advanced-3-0-ipc-hdw3849h-as-pv-anz-s2-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-ipc-hdw3849h-zas-pv-pro-anz-8mp-4k-wizsense-tioc-pro-vari-focal-eyeball-network-camera",
            "dahua-ipc-pfw3849s-a180-as-pv-8mp-180-tioc-duo-splicing-bullet-wizsense-network-camera",
            "dahua-ipc-hfw3849t1-as-pv-pro-8mp-smart-dual-light-active-deterrence-fixed-focal-bullet-camera-2-8-mm",
            "dahua-dh-ipc-pdw3849-a180-as-pv-anz-blk-tioc-duo-splicing-turret-fixed-camera-black",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3849h-as-pv-anz-8mp-ai-active-deterrence-full-color",
            "dahua-dh-sdt4e425-8p-gb-apv1-x-spans-8mp4mp-25x-tioc-wizsense-network-ptz-camera",
            "dahua-ipc-hdbw3549r1-zas-pv-5mp-smart-dual-light-tioc-motorised-dome-wizsense-network-camera",
            "dahua-dh-sdt4e425-4f-gb-a-pv1-x-spans-4mp4mp-25x-tioc-wizsense-network-ptz-camera",
            "dahua-tioc-2-0-black-dh-ipc-hfw3649t1-as-pv-anz-6mp-ai-active-deterrence-fixed-lens-bullet-camera",
            "dahua-dh-ipc-pdw3849-a180-as-pv-anz-tioc-duo-splicing-turret-fixed-camera",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-blk-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-black"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 16,
          "rankedProductIds": [
            "8168553316409",
            "7690795483193",
            "8168542044217",
            "7591945568313",
            "7591932756025",
            "8168425881657",
            "8284512157753",
            "8284590407737",
            "8168609087545",
            "7591947927609",
            "7591832158265",
            "7591831109689",
            "7591830323257",
            "7591829831737",
            "8168400322617",
            "7690795450425"
          ],
          "rankedProductHandles": [
            "dahua-tioc-dh-ipc-hdw3849h-as-pv-pro-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-dh-sdt4e425-8p-gb-apv1-x-spans-8mp4mp-25x-tioc-wizsense-network-ptz-camera",
            "dahua-tioc-dh-ipc-hfw3849t1-as-pv-anz-s2-blk-8mp-ai-active-deterrence-ip-bullet-fixed-2-8mm-black",
            "dahua-tioc-dh-ipc-hdw3849h-zas-pv-anz-8mp-ai-active-deterrence-motorised-turret-camera-black",
            "dahua-tioc-dh-ipc-hdw3849h-zas-pv-anz-8mp-ai-active-deterrence-motorised-turret-camera",
            "dahua-tioc-advanced-3-0-ipc-hdw3849h-as-pv-anz-s2-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-ipc-hdw3849h-zas-pv-pro-anz-8mp-4k-wizsense-tioc-pro-vari-focal-eyeball-network-camera",
            "dahua-ipc-pfw3849s-a180-as-pv-8mp-180-tioc-duo-splicing-bullet-wizsense-network-camera",
            "dahua-ipc-hfw3849t1-as-pv-pro-8mp-smart-dual-light-active-deterrence-fixed-focal-bullet-camera-2-8-mm",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3849h-as-pv-anz-8mp-ai-active-deterrence-full-color",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-blk-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-black",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3849h-as-pv-anz-blk-8mp-ai-active-deterrence-full-color-ip-turret-camera-black",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3849h-as-pv-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-ipc-hdbw3549r1-zas-pv-5mp-smart-dual-light-tioc-motorised-dome-wizsense-network-camera",
            "dahua-dh-sdt4e425-4f-gb-a-pv1-x-spans-4mp4mp-25x-tioc-wizsense-network-ptz-camera"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 3,
          "rankedProductIds": [
            "7690795483193",
            "7690795450425",
            "8168553316409"
          ],
          "rankedProductHandles": [
            "dahua-dh-sdt4e425-8p-gb-apv1-x-spans-8mp4mp-25x-tioc-wizsense-network-ptz-camera",
            "dahua-dh-sdt4e425-4f-gb-a-pv1-x-spans-4mp4mp-25x-tioc-wizsense-network-ptz-camera",
            "dahua-tioc-dh-ipc-hdw3849h-as-pv-pro-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera"
          ]
        }
      }
    },
    "dahua-tioc-2-1": {
      "collectionHandle": "dahua-tioc-2-1",
      "collectionProductCount": 16,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 9,
          "rankedProductIds": [
            "7591785365561",
            "7591857061945",
            "7591770914873",
            "8168406024249",
            "8168415559737",
            "7591824752697",
            "7591787495481",
            "8168572452921",
            "7591771406393"
          ],
          "rankedProductHandles": [
            "dahua-tioc-advanced-2-0-dh-ipc-hfw3849t1p-as-pv-0280b-s3-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-built-in-mic-speakerip67poe-wizsense",
            "dahua-tioc-advanced-2-0-dh-ipc-hdbw3849r1p-zas-pv-27135-8mp-starlight-ip-dome-motorised-2-7-13-5mm",
            "dahua-tioc-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-dh-ipc-hdw3849hp-as-pv-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-fixed-2-8mm-mic-speaker-wizsense",
            "dahua-dh-ipc-hfw3849t1-zas-pv-anz-s2-8mp-smart-dual-active-deterrence-vari-focal-bullet-wizsense-network-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hfw3849t1p-as-pv-0280b-s3-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm",
            "dahua-tioc-2-0-advanced-dh-ipc-hfw3549t1p-as-pv-0280b-s3-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-built-in-mic-speaker-ip67-poe-wizsense",
            "dahua-dh-sdt3e410-8p-mb-a-pv1-8mp4mp-10x-starlight-tioc-panoramic-ptz-security-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3549hp-as-pv-0280b-s3-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-turret-camera"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 9,
          "rankedProductIds": [
            "7591787495481",
            "7591770914873",
            "7591800406073",
            "8168406024249",
            "8168415559737",
            "7591824752697",
            "7690795483193",
            "7690795450425",
            "7591771406393"
          ],
          "rankedProductHandles": [
            "dahua-tioc-2-0-advanced-dh-ipc-hfw3549t1p-as-pv-0280b-s3-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-built-in-mic-speaker-ip67-poe-wizsense",
            "dahua-tioc-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-blk-8mp-ai-active-deterrence-full-color-ip-turret-camera-black",
            "dahua-tioc-dh-ipc-hdw3849hp-as-pv-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-fixed-2-8mm-mic-speaker-wizsense",
            "dahua-dh-ipc-hfw3849t1-zas-pv-anz-s2-8mp-smart-dual-active-deterrence-vari-focal-bullet-wizsense-network-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hfw3849t1p-as-pv-0280b-s3-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm",
            "dahua-dh-sdt4e425-8p-gb-apv1-x-spans-8mp4mp-25x-tioc-wizsense-network-ptz-camera",
            "dahua-dh-sdt4e425-4f-gb-a-pv1-x-spans-4mp4mp-25x-tioc-wizsense-network-ptz-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3549hp-as-pv-0280b-s3-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-turret-camera"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 9,
          "rankedProductIds": [
            "7690795483193",
            "7591770914873",
            "7591800406073",
            "8168572452921",
            "8168406024249",
            "7591857061945",
            "8168415559737",
            "7591824752697",
            "7591785365561"
          ],
          "rankedProductHandles": [
            "dahua-dh-sdt4e425-8p-gb-apv1-x-spans-8mp4mp-25x-tioc-wizsense-network-ptz-camera",
            "dahua-tioc-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-blk-8mp-ai-active-deterrence-full-color-ip-turret-camera-black",
            "dahua-dh-sdt3e410-8p-mb-a-pv1-8mp4mp-10x-starlight-tioc-panoramic-ptz-security-camera",
            "dahua-tioc-dh-ipc-hdw3849hp-as-pv-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-fixed-2-8mm-mic-speaker-wizsense",
            "dahua-tioc-advanced-2-0-dh-ipc-hdbw3849r1p-zas-pv-27135-8mp-starlight-ip-dome-motorised-2-7-13-5mm",
            "dahua-dh-ipc-hfw3849t1-zas-pv-anz-s2-8mp-smart-dual-active-deterrence-vari-focal-bullet-wizsense-network-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hfw3849t1p-as-pv-0280b-s3-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm",
            "dahua-tioc-advanced-2-0-dh-ipc-hfw3849t1p-as-pv-0280b-s3-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-built-in-mic-speakerip67poe-wizsense"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 5,
          "rankedProductIds": [
            "7690795483193",
            "7690795450425",
            "7591777337401",
            "7745674051641",
            "8168572452921"
          ],
          "rankedProductHandles": [
            "dahua-dh-sdt4e425-8p-gb-apv1-x-spans-8mp4mp-25x-tioc-wizsense-network-ptz-camera",
            "dahua-dh-sdt4e425-4f-gb-a-pv1-x-spans-4mp4mp-25x-tioc-wizsense-network-ptz-camera",
            "dahua-dh-sd6c3425xb-hnr-a-pv1-4mp-tioc-ip-25x-ptz-camera-ir-150m",
            "dahua-dh-sd3e405db-gny-a-pv1-4mp-5x-tioc-wizsense-network-ptz-camera",
            "dahua-dh-sdt3e410-8p-mb-a-pv1-8mp4mp-10x-starlight-tioc-panoramic-ptz-security-camera"
          ]
        }
      }
    },
    "dahua-tioc-security-cameras-suppliers": {
      "collectionHandle": "dahua-tioc-security-cameras-suppliers",
      "collectionProductCount": 56,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 16,
          "rankedProductIds": [
            "7591785365561",
            "7591857061945",
            "7591770914873",
            "7591829831737",
            "8168553316409",
            "8168542044217",
            "8284590407737",
            "8168609087545",
            "8168425881657",
            "8168406024249",
            "8168572452921",
            "8168415559737",
            "7591832158265",
            "7591831109689",
            "7591824752697",
            "7591771406393"
          ],
          "rankedProductHandles": [
            "dahua-tioc-advanced-2-0-dh-ipc-hfw3849t1p-as-pv-0280b-s3-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-built-in-mic-speakerip67poe-wizsense",
            "dahua-tioc-advanced-2-0-dh-ipc-hdbw3849r1p-zas-pv-27135-8mp-starlight-ip-dome-motorised-2-7-13-5mm",
            "dahua-tioc-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3849h-as-pv-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-dh-ipc-hdw3849h-as-pv-pro-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-dh-ipc-hfw3849t1-as-pv-anz-s2-blk-8mp-ai-active-deterrence-ip-bullet-fixed-2-8mm-black",
            "dahua-ipc-pfw3849s-a180-as-pv-8mp-180-tioc-duo-splicing-bullet-wizsense-network-camera",
            "dahua-ipc-hfw3849t1-as-pv-pro-8mp-smart-dual-light-active-deterrence-fixed-focal-bullet-camera-2-8-mm",
            "dahua-tioc-advanced-3-0-ipc-hdw3849h-as-pv-anz-s2-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-dh-ipc-hdw3849hp-as-pv-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-fixed-2-8mm-mic-speaker-wizsense",
            "dahua-dh-sdt3e410-8p-mb-a-pv1-8mp4mp-10x-starlight-tioc-panoramic-ptz-security-camera",
            "dahua-dh-ipc-hfw3849t1-zas-pv-anz-s2-8mp-smart-dual-active-deterrence-vari-focal-bullet-wizsense-network-camera",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-blk-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-black",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm",
            "dahua-tioc-advanced-2-0-dh-ipc-hfw3849t1p-as-pv-0280b-s3-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3549hp-as-pv-0280b-s3-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-turret-camera"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 16,
          "rankedProductIds": [
            "7591787495481",
            "7591770914873",
            "7591800406073",
            "8284475457593",
            "8168575336505",
            "8168553316409",
            "8168542044217",
            "8284512157753",
            "8284590407737",
            "8168609087545",
            "8168425881657",
            "8168406024249",
            "7591722385465",
            "7591945175097",
            "7591864729657",
            "7591947927609"
          ],
          "rankedProductHandles": [
            "dahua-tioc-2-0-advanced-dh-ipc-hfw3549t1p-as-pv-0280b-s3-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-built-in-mic-speaker-ip67-poe-wizsense",
            "dahua-tioc-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-blk-8mp-ai-active-deterrence-full-color-ip-turret-camera-black",
            "dahua-4-x-6mp-dh-ipc-hdw3649h-as-pv-anz-tioc-2-0-with-wizsense-turret-4ch-kit",
            "dahua-ipc-hdw3649h-as-pv-pro-tioc-acupick-6mp-ai-active-deterrence-ip-turret-camera",
            "dahua-tioc-dh-ipc-hdw3849h-as-pv-pro-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-dh-ipc-hfw3849t1-as-pv-anz-s2-blk-8mp-ai-active-deterrence-ip-bullet-fixed-2-8mm-black",
            "dahua-ipc-hdw3849h-zas-pv-pro-anz-8mp-4k-wizsense-tioc-pro-vari-focal-eyeball-network-camera",
            "dahua-ipc-pfw3849s-a180-as-pv-8mp-180-tioc-duo-splicing-bullet-wizsense-network-camera",
            "dahua-ipc-hfw3849t1-as-pv-pro-8mp-smart-dual-light-active-deterrence-fixed-focal-bullet-camera-2-8-mm",
            "dahua-tioc-advanced-3-0-ipc-hdw3849h-as-pv-anz-s2-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-dh-ipc-hdw3849hp-as-pv-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-fixed-2-8mm-mic-speaker-wizsense",
            "dahua-tioc-dh-ipc-hdw3549hp-as-pv-0280b-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-turret-fixed-2-8mm-built-in-mic-speakerwdr-micro-sdip67poe",
            "dahua-dh-ipc-pdw3849-a180-as-pv-anz-blk-tioc-duo-splicing-turret-fixed-camera-black",
            "dahua-dh-ipc-pdw3849-a180-as-pv-anz-tioc-duo-splicing-turret-fixed-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3849h-as-pv-anz-8mp-ai-active-deterrence-full-color"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 16,
          "rankedProductIds": [
            "8168553316409",
            "7591770914873",
            "7591800406073",
            "8168572452921",
            "7690795483193",
            "8168542044217",
            "8284512157753",
            "8284590407737",
            "8168609087545",
            "8168425881657",
            "7591932756025",
            "8168406024249",
            "7591945568313",
            "7591947927609",
            "8168415559737",
            "7591832158265"
          ],
          "rankedProductHandles": [
            "dahua-tioc-dh-ipc-hdw3849h-as-pv-pro-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-blk-8mp-ai-active-deterrence-full-color-ip-turret-camera-black",
            "dahua-dh-sdt3e410-8p-mb-a-pv1-8mp4mp-10x-starlight-tioc-panoramic-ptz-security-camera",
            "dahua-dh-sdt4e425-8p-gb-apv1-x-spans-8mp4mp-25x-tioc-wizsense-network-ptz-camera",
            "dahua-tioc-dh-ipc-hfw3849t1-as-pv-anz-s2-blk-8mp-ai-active-deterrence-ip-bullet-fixed-2-8mm-black",
            "dahua-ipc-hdw3849h-zas-pv-pro-anz-8mp-4k-wizsense-tioc-pro-vari-focal-eyeball-network-camera",
            "dahua-ipc-pfw3849s-a180-as-pv-8mp-180-tioc-duo-splicing-bullet-wizsense-network-camera",
            "dahua-ipc-hfw3849t1-as-pv-pro-8mp-smart-dual-light-active-deterrence-fixed-focal-bullet-camera-2-8-mm",
            "dahua-tioc-advanced-3-0-ipc-hdw3849h-as-pv-anz-s2-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-dh-ipc-hdw3849h-zas-pv-anz-8mp-ai-active-deterrence-motorised-turret-camera",
            "dahua-tioc-dh-ipc-hdw3849hp-as-pv-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-fixed-2-8mm-mic-speaker-wizsense",
            "dahua-tioc-dh-ipc-hdw3849h-zas-pv-anz-8mp-ai-active-deterrence-motorised-turret-camera-black",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3849h-as-pv-anz-8mp-ai-active-deterrence-full-color",
            "dahua-dh-ipc-hfw3849t1-zas-pv-anz-s2-8mp-smart-dual-active-deterrence-vari-focal-bullet-wizsense-network-camera",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-blk-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-black"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 9,
          "rankedProductIds": [
            "7690795483193",
            "7690795450425",
            "8168553316409",
            "7591777337401",
            "7591722385465",
            "7745674051641",
            "8168572452921",
            "7591847100473",
            "7591847297081"
          ],
          "rankedProductHandles": [
            "dahua-dh-sdt4e425-8p-gb-apv1-x-spans-8mp4mp-25x-tioc-wizsense-network-ptz-camera",
            "dahua-dh-sdt4e425-4f-gb-a-pv1-x-spans-4mp4mp-25x-tioc-wizsense-network-ptz-camera",
            "dahua-tioc-dh-ipc-hdw3849h-as-pv-pro-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-dh-sd6c3425xb-hnr-a-pv1-4mp-tioc-ip-25x-ptz-camera-ir-150m",
            "dahua-tioc-dh-ipc-hdw3549hp-as-pv-0280b-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-turret-fixed-2-8mm-built-in-mic-speakerwdr-micro-sdip67poe",
            "dahua-dh-sd3e405db-gny-a-pv1-4mp-5x-tioc-wizsense-network-ptz-camera",
            "dahua-dh-sdt3e410-8p-mb-a-pv1-8mp4mp-10x-starlight-tioc-panoramic-ptz-security-camera",
            "dahua-dh-ipc-pdw5849-a180-e2-aste-4mp-x-2-full-color-dual-lens-wizmind-network-camera",
            "dahua-dh-ipc-pfw5849-a180-e2-aste-4mp-x-2-full-color-dual-lens-wizmind-bullet-network-camera"
          ]
        }
      }
    },
    "dahua-wizcolor": {
      "collectionHandle": "dahua-wizcolor",
      "collectionProductCount": 8,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "dahua-wizcolor-cctv-kits": {
      "collectionHandle": "dahua-wizcolor-cctv-kits",
      "collectionProductCount": 6,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "dahua-wizmind-cameras-1": {
      "collectionHandle": "dahua-wizmind-cameras-1",
      "collectionProductCount": 18,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 3,
          "rankedProductIds": [
            "8324155277369",
            "7745669627961",
            "7591690928185"
          ],
          "rankedProductHandles": [
            "dahua-8mp-wizmind-dh-ipc-hdw5859h-ase-pv-pro-pro-series-wizcolor-turret-camera-with-active-deterrence-2-way-audio-60m-ir",
            "dahua-dh-ipc-hdw5541tm-ase-5mp-ai-active-deterrence-starlight-ip-turret-fixed-2-8mm",
            "dahua-dh-ipc-hfw5442tp-s-dahua-ai-4mp-starlight-ip-bullet-fixed-ir-50m-poe"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 4,
          "rankedProductIds": [
            "8168591261753",
            "8168591491129",
            "7591729004601",
            "7591706918969"
          ],
          "rankedProductHandles": [
            "dahua-ipc-hdw5849h-ase-led-s2-8mp-wizmind-full-color-eyeball-camera-with-warm-led",
            "dahua-ipc-hdw5842tm-ase-s3-8mp-wizmind-s-series-fixed-focal-eyeball-network-camera",
            "dahua-dh-ipc-hfw5541ep-ze-27135",
            "dahua-dh-ipc-hdbw5442ep-ze-2712-dahua-ai-4mp-starlight-ip-vandal-dome-motorized-2-7mm12mm"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 5,
          "rankedProductIds": [
            "8168575598649",
            "8168600469561",
            "7591729004601",
            "8168620720185",
            "8168396357689"
          ],
          "rankedProductHandles": [
            "dahua-dh-ipc-hdw5842tm-ase-8mp-ir-fixed-focal-eyeball-wizmind-network-camera",
            "dahua-ipc-hdw5442tp-ze-s3-ai-4mp-turret-motorized-camera-starlight-motorized-lens-ip67",
            "dahua-dh-ipc-hfw5541ep-ze-27135",
            "dahua-ipc-mfw5241t2-e3-ase-triple-sight-long-range-perimeter-protection-camera",
            "dahua-ipc-hdw5442emp-ase-s3-dahua-ai-4mp-starlight-ip-turret-fixed-ir-50m-poe-wizmind"
          ]
        }
      }
    },
    "dahua-wizsense-cameras-1": {
      "collectionHandle": "dahua-wizsense-cameras-1",
      "collectionProductCount": 100,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 16,
          "rankedProductIds": [
            "7591785365561",
            "7591857061945",
            "7591770914873",
            "7591829831737",
            "8168553316409",
            "8284590407737",
            "8168542044217",
            "8168609087545",
            "8168425881657",
            "7591832158265",
            "7591831109689",
            "8168406024249",
            "7591824752697",
            "7591771406393",
            "7591829372985",
            "7591787495481"
          ],
          "rankedProductHandles": [
            "dahua-tioc-advanced-2-0-dh-ipc-hfw3849t1p-as-pv-0280b-s3-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-built-in-mic-speakerip67poe-wizsense",
            "dahua-tioc-advanced-2-0-dh-ipc-hdbw3849r1p-zas-pv-27135-8mp-starlight-ip-dome-motorised-2-7-13-5mm",
            "dahua-tioc-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3849h-as-pv-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-dh-ipc-hdw3849h-as-pv-pro-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-ipc-pfw3849s-a180-as-pv-8mp-180-tioc-duo-splicing-bullet-wizsense-network-camera",
            "dahua-tioc-dh-ipc-hfw3849t1-as-pv-anz-s2-blk-8mp-ai-active-deterrence-ip-bullet-fixed-2-8mm-black",
            "dahua-ipc-hfw3849t1-as-pv-pro-8mp-smart-dual-light-active-deterrence-fixed-focal-bullet-camera-2-8-mm",
            "dahua-tioc-advanced-3-0-ipc-hdw3849h-as-pv-anz-s2-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-blk-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-black",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm",
            "dahua-tioc-dh-ipc-hdw3849hp-as-pv-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-fixed-2-8mm-mic-speaker-wizsense",
            "dahua-tioc-advanced-2-0-dh-ipc-hfw3849t1p-as-pv-0280b-s3-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3549hp-as-pv-0280b-s3-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3649h-as-pv-anz-6mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-2-0-advanced-dh-ipc-hfw3549t1p-as-pv-0280b-s3-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-built-in-mic-speaker-ip67-poe-wizsense"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 16,
          "rankedProductIds": [
            "7591787495481",
            "7591770914873",
            "7591800406073",
            "8284475457593",
            "8168598175801",
            "8168575336505",
            "8168553316409",
            "8284590407737",
            "7591722385465",
            "8284512157753",
            "8168542044217",
            "8168609087545",
            "7591945175097",
            "7591864729657",
            "7591771406393",
            "8168425881657"
          ],
          "rankedProductHandles": [
            "dahua-tioc-2-0-advanced-dh-ipc-hfw3549t1p-as-pv-0280b-s3-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-built-in-mic-speaker-ip67-poe-wizsense",
            "dahua-tioc-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-blk-8mp-ai-active-deterrence-full-color-ip-turret-camera-black",
            "dahua-4-x-6mp-dh-ipc-hdw3649h-as-pv-anz-tioc-2-0-with-wizsense-turret-4ch-kit",
            "dahua-ipc-hfw3667e-as-il-anz-6-mp-smart-dual-light-bullet-camera-wizsense-3-series",
            "dahua-ipc-hdw3649h-as-pv-pro-tioc-acupick-6mp-ai-active-deterrence-ip-turret-camera",
            "dahua-tioc-dh-ipc-hdw3849h-as-pv-pro-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-ipc-pfw3849s-a180-as-pv-8mp-180-tioc-duo-splicing-bullet-wizsense-network-camera",
            "dahua-tioc-dh-ipc-hdw3549hp-as-pv-0280b-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-turret-fixed-2-8mm-built-in-mic-speakerwdr-micro-sdip67poe",
            "dahua-ipc-hdw3849h-zas-pv-pro-anz-8mp-4k-wizsense-tioc-pro-vari-focal-eyeball-network-camera",
            "dahua-tioc-dh-ipc-hfw3849t1-as-pv-anz-s2-blk-8mp-ai-active-deterrence-ip-bullet-fixed-2-8mm-black",
            "dahua-ipc-hfw3849t1-as-pv-pro-8mp-smart-dual-light-active-deterrence-fixed-focal-bullet-camera-2-8-mm",
            "dahua-dh-ipc-pdw3849-a180-as-pv-anz-blk-tioc-duo-splicing-turret-fixed-camera-black",
            "dahua-dh-ipc-pdw3849-a180-as-pv-anz-tioc-duo-splicing-turret-fixed-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3549hp-as-pv-0280b-s3-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-3-0-ipc-hdw3849h-as-pv-anz-s2-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 16,
          "rankedProductIds": [
            "7591770914873",
            "8168553316409",
            "7591800406073",
            "7591932756025",
            "8284590407737",
            "7591945568313",
            "8284512157753",
            "8168542044217",
            "8168609087545",
            "7591765737529",
            "8168425881657",
            "7591947927609",
            "7591832158265",
            "7591831109689",
            "7591830323257",
            "8168406024249"
          ],
          "rankedProductHandles": [
            "dahua-tioc-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-dh-ipc-hdw3849h-as-pv-pro-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3849hp-as-pv-0280b-s3-blk-8mp-ai-active-deterrence-full-color-ip-turret-camera-black",
            "dahua-tioc-dh-ipc-hdw3849h-zas-pv-anz-8mp-ai-active-deterrence-motorised-turret-camera",
            "dahua-ipc-pfw3849s-a180-as-pv-8mp-180-tioc-duo-splicing-bullet-wizsense-network-camera",
            "dahua-tioc-dh-ipc-hdw3849h-zas-pv-anz-8mp-ai-active-deterrence-motorised-turret-camera-black",
            "dahua-ipc-hdw3849h-zas-pv-pro-anz-8mp-4k-wizsense-tioc-pro-vari-focal-eyeball-network-camera",
            "dahua-tioc-dh-ipc-hfw3849t1-as-pv-anz-s2-blk-8mp-ai-active-deterrence-ip-bullet-fixed-2-8mm-black",
            "dahua-ipc-hfw3849t1-as-pv-pro-8mp-smart-dual-light-active-deterrence-fixed-focal-bullet-camera-2-8-mm",
            "dahua-8mp-4k-starlight-ip-bullet-motorized-2-7-13-5mm-smd-plusperimeter-protection-ir-distance-60m",
            "dahua-tioc-advanced-3-0-ipc-hdw3849h-as-pv-anz-s2-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-advanced-2-0-dh-ipc-hdw3849h-as-pv-anz-8mp-ai-active-deterrence-full-color",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-blk-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm-black",
            "dahua-tioc-advanced-3-0-dh-ipc-hfw3849t1-as-pv-anz-8mp-ai-active-deterrence-full-color-starlight-ip-bullet-fixed-2-8mm",
            "dahua-tioc-advanced-3-0-dh-ipc-hdw3849h-as-pv-anz-blk-8mp-ai-active-deterrence-full-color-ip-turret-camera-black",
            "dahua-tioc-dh-ipc-hdw3849hp-as-pv-dahua-8mp-ai-active-deterrence-full-color-starlight-ip-turret-fixed-2-8mm-mic-speaker-wizsense"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 8,
          "rankedProductIds": [
            "7591940128825",
            "7591799652409",
            "8168553316409",
            "7591722385465",
            "7591847100473",
            "7591847297081",
            "7591726121017",
            "7591720615993"
          ],
          "rankedProductHandles": [
            "dahua-dh-ipc-hfw3466ep-as-aus-4mp-bullet-network-camera-50m-ir-2-8mm-with-smd-4-0-wizsense",
            "dahua-dh-ipc-hdw3666tp-zs-aus-6mp-motorised-turret-network-camera-40m-ir-with-smd-4-0",
            "dahua-tioc-dh-ipc-hdw3849h-as-pv-pro-anz-8mp-ai-active-deterrence-full-color-starlight-ip-turret-camera",
            "dahua-tioc-dh-ipc-hdw3549hp-as-pv-0280b-dahua-5mp-ai-active-deterrence-full-color-starlight-ip-turret-fixed-2-8mm-built-in-mic-speakerwdr-micro-sdip67poe",
            "dahua-dh-ipc-pdw5849-a180-e2-aste-4mp-x-2-full-color-dual-lens-wizmind-network-camera",
            "dahua-dh-ipc-pfw5849-a180-e2-aste-4mp-x-2-full-color-dual-lens-wizmind-bullet-network-camera",
            "dahua-dh-ipc-hdw3841emp-as-0280b-8mp-eyeball-network-camera-50m-ir-2-8mm-with-smd",
            "dahua-dh-ipc-hfw3449ep-as-led-0360b-4mp-full-color-warm-led-fixed-focal-bullet-wizsense-network-camera"
          ]
        }
      }
    },
    "dahua3666-1": {
      "collectionHandle": "dahua3666-1",
      "collectionProductCount": 6,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "darkfighter-ptz-cameras-1": {
      "collectionHandle": "darkfighter-ptz-cameras-1",
      "collectionProductCount": 3,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 2,
          "rankedProductIds": [
            "8284591095865",
            "7591653507129"
          ],
          "rankedProductHandles": [
            "hikvision-6mp-8mp-tandemvu-ultra-ds-2sf8c848mxg1-elwy-26-ptz-camera-with-colorvu-26x-optical-zoom-ir-500m",
            "hikvision-ds-2de4a204iwde-2mp-darkfighter-ir-ptz-camera-4x-optical-zoom-50m-ir-8-32mm"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 2,
          "rankedProductIds": [
            "8284591095865",
            "7591653507129"
          ],
          "rankedProductHandles": [
            "hikvision-6mp-8mp-tandemvu-ultra-ds-2sf8c848mxg1-elwy-26-ptz-camera-with-colorvu-26x-optical-zoom-ir-500m",
            "hikvision-ds-2de4a204iwde-2mp-darkfighter-ir-ptz-camera-4x-optical-zoom-50m-ir-8-32mm"
          ]
        }
      }
    },
    "ezviz-1": {
      "collectionHandle": "ezviz-1",
      "collectionProductCount": 4,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 2,
          "rankedProductIds": [
            "7745685127225",
            "7745684537401"
          ],
          "rankedProductHandles": [
            "ezviz-eb8-4g-3mp-solar-panel-kit-outdoor-pan-tilt-battery-camera-with-auto-tracking-ir-night-vision-colour-night-vision-two-way-talk-motion-pir-motion-and-smart-human-detection",
            "ezviz-eb3-3mp-outdoor-wireless-security-spot-light-camera-solar-panel-kit-aov"
          ]
        }
      }
    },
    "fisheye-cameras-1": {
      "collectionHandle": "fisheye-cameras-1",
      "collectionProductCount": 5,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "fisheye-dome-cameras": {
      "collectionHandle": "fisheye-dome-cameras",
      "collectionProductCount": 1,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "fixed-dome-cameras": {
      "collectionHandle": "fixed-dome-cameras",
      "collectionProductCount": 7,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "hanwha-4mp-cameras": {
      "collectionHandle": "hanwha-4mp-cameras",
      "collectionProductCount": 7,
      "renderedProductLimit": 250,
      "needs": {
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 4,
          "rankedProductIds": [
            "8284541386809",
            "8284557803577",
            "8284558032953",
            "8284557443129"
          ],
          "rankedProductHandles": [
            "hanwha-vision-xnp-c6403r-4mp-ptz-network-camera-outdoor-ai-analytics",
            "hanwha-vision-pno-a7082r-4mp-ai-bullet-camera-with-4-6-9-35mm-motorized-varifocal-lens-60m-wiseir-extreme-wdr-ip66-ip67-ik10-nema-4x",
            "hanwha-vision-pnd-a7082rv-4mp-ai-indoor-vandal-dome-camera-with-4-6-9-35mm-motorized-varifocal-lens-60m-wiseir-dual-sd-slots-ik10",
            "hanwha-vision-pnv-a7082rz-4mp-ai-outdoor-vandal-dome-camera-with-4-6-9-35mm-motorized-varifocal-lens-30m-wiseir-ip66-ip67-ik11-nema-4x"
          ]
        }
      }
    },
    "hanwha-5mp-cameras": {
      "collectionHandle": "hanwha-5mp-cameras",
      "collectionProductCount": 17,
      "renderedProductLimit": 250,
      "needs": {
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 2,
          "rankedProductIds": [
            "8168620621881",
            "8168620490809"
          ],
          "rankedProductHandles": [
            "hanwha-xno-a8084r-5mp-ai-ir-outdoor-vandal-bullet-camera-3-3-9-3-mm-motorised-varifocal-lens",
            "hanwha-xnd-a8084rv-5mp-ai-ir-indoor-dome-camera-3-3-9-3-mm-varifocal-lens"
          ]
        }
      }
    },
    "hanwha-8mp": {
      "collectionHandle": "hanwha-8mp",
      "collectionProductCount": 23,
      "renderedProductLimit": 250,
      "needs": {
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 13,
          "rankedProductIds": [
            "8284557672505",
            "8284557606969",
            "8284557312057",
            "8284557148217",
            "8284541222969",
            "8168620687417",
            "8168619573305",
            "8168609710137",
            "8284550365241",
            "8284549513273",
            "8284541190201",
            "8284548890681",
            "8284548726841"
          ],
          "rankedProductHandles": [
            "hanwha-vision-pno-a9082r-8mp-ai-bullet-camera-with-5-9-13-3mm-motorized-varifocal-lens-60m-wiseir-wdr-ip66-ip67-ik10-nema-4x",
            "hanwha-vision-pno-a9092r-8mp-ai-long-range-bullet-camera-with-15-50mm-motorized-varifocal-lens-120m-wiseir-wdr-ip66-ip67-ik10-nema-4x",
            "hanwha-vision-pnv-a9082rz-8mp-ai-outdoor-vandal-dome-camera-with-5-9-13-3mm-motorized-varifocal-lens-50m-wiseir-wdr-ip66-ip67-ik11-nema-4x",
            "hanwha-vision-qno-c9083r-8mp-ai-ir-bullet-camera-with-3-2-10-2mm-motorized-varifocal-lens-30m-ir-120db-wdr-ai-object-detection-ip66-ik10",
            "hanwha-vision-xno-c9083r-8mp-ir-bullet-ai-camera-motorized-varifocal-analytics",
            "hanwha-xno-a9084r-8mp-ai-ir-outdoor-vandal-bullet-camera-4-4-9-3-mm-motorised-varifocal-lens",
            "hanwha-xnd-a9084rv-8mp-ai-ir-varifocal-indoor-dome-camera-4-4-9-3-mm-lens",
            "hanwha-vision-qnv-c9083r-8mp-ai-ir-vandal-dome-camera-motorised-zoom-rugged-smart-surveillance",
            "hanwha-vision-xnd-c9083rv-x-core-4k-h-265-nw-ir-dome-ai-camera",
            "hanwha-vision-xnv-c9083r-x-core-4k-h-265-nw-ir-vandal-dome-ai-camera",
            "hanwha-vision-qno-c8083r-8mp-ir-bullet-ai-camera-advanced-analytics",
            "hanwha-vision-xnv-a9084r-x-series-8mp-vandal-dome-ai-camera",
            "hanwha-vision-xnd-a9085rv-x-series-8mp-ai-ir-modular-dome-camera"
          ]
        }
      }
    },
    "hanwha-ai-cameras": {
      "collectionHandle": "hanwha-ai-cameras",
      "collectionProductCount": 52,
      "renderedProductLimit": 250,
      "needs": {
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 16,
          "rankedProductIds": [
            "8284557672505",
            "8284557606969",
            "8284557312057",
            "8284557148217",
            "8284541222969",
            "8168609710137",
            "8284557803577",
            "8284558032953",
            "8284541190201",
            "8168589230137",
            "8284557443129",
            "8284550365241",
            "8284549513273",
            "8284548890681",
            "8284548726841",
            "8284548366393"
          ],
          "rankedProductHandles": [
            "hanwha-vision-pno-a9082r-8mp-ai-bullet-camera-with-5-9-13-3mm-motorized-varifocal-lens-60m-wiseir-wdr-ip66-ip67-ik10-nema-4x",
            "hanwha-vision-pno-a9092r-8mp-ai-long-range-bullet-camera-with-15-50mm-motorized-varifocal-lens-120m-wiseir-wdr-ip66-ip67-ik10-nema-4x",
            "hanwha-vision-pnv-a9082rz-8mp-ai-outdoor-vandal-dome-camera-with-5-9-13-3mm-motorized-varifocal-lens-50m-wiseir-wdr-ip66-ip67-ik11-nema-4x",
            "hanwha-vision-qno-c9083r-8mp-ai-ir-bullet-camera-with-3-2-10-2mm-motorized-varifocal-lens-30m-ir-120db-wdr-ai-object-detection-ip66-ik10",
            "hanwha-vision-xno-c9083r-8mp-ir-bullet-ai-camera-motorized-varifocal-analytics",
            "hanwha-vision-qnv-c9083r-8mp-ai-ir-vandal-dome-camera-motorised-zoom-rugged-smart-surveillance",
            "hanwha-vision-pno-a7082r-4mp-ai-bullet-camera-with-4-6-9-35mm-motorized-varifocal-lens-60m-wiseir-extreme-wdr-ip66-ip67-ik10-nema-4x",
            "hanwha-vision-pnd-a7082rv-4mp-ai-indoor-vandal-dome-camera-with-4-6-9-35mm-motorized-varifocal-lens-60m-wiseir-dual-sd-slots-ik10",
            "hanwha-vision-qno-c8083r-8mp-ir-bullet-ai-camera-advanced-analytics",
            "hanwha-pno-a9081r-4k-ai-ir-bullet-network-camera",
            "hanwha-vision-pnv-a7082rz-4mp-ai-outdoor-vandal-dome-camera-with-4-6-9-35mm-motorized-varifocal-lens-30m-wiseir-ip66-ip67-ik11-nema-4x",
            "hanwha-vision-xnd-c9083rv-x-core-4k-h-265-nw-ir-dome-ai-camera",
            "hanwha-vision-xnv-c9083r-x-core-4k-h-265-nw-ir-vandal-dome-ai-camera",
            "hanwha-vision-xnv-a9084r-x-series-8mp-vandal-dome-ai-camera",
            "hanwha-vision-xnd-a9085rv-x-series-8mp-ai-ir-modular-dome-camera",
            "hanwha-vision-xnv-a9085r-x-series-8mp-ai-ir-modular-vandal-dome-camera"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 6,
          "rankedProductIds": [
            "8284549251129",
            "8284549152825",
            "8284549054521",
            "8284541386809",
            "8284541091897",
            "8284540338233"
          ],
          "rankedProductHandles": [
            "hanwha-vision-xnp-c6403rw-2mp-ai-ptz-camera-with-built-in-wiper-and-40x-zoom-powered-by-wisenet7",
            "hanwha-vision-xnp-c8303rw-6mp-ai-ptz-camera-with-built-in-wiper-and-30x-zoom-powered-by-wisenet7",
            "hanwha-vision-xnp-c8253r-6mp-ai-ptz-camera-with-25x-zoom-powered-by-wisenet7",
            "hanwha-vision-xnp-c6403r-4mp-ptz-network-camera-outdoor-ai-analytics",
            "hanwha-vision-xnp-c9303rw-3mp-ptz-network-camera-with-wiper-outdoor-surveillance",
            "hanwha-vision-pnm-c34404rqpz-4k-4ch-ptrz-2mp-40x-ptz-ai-camera"
          ]
        }
      }
    },
    "hanwha-analog-cameras-1": {
      "collectionHandle": "hanwha-analog-cameras-1",
      "collectionProductCount": 9,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "hanwha-cctv-packages-1": {
      "collectionHandle": "hanwha-cctv-packages-1",
      "collectionProductCount": 7,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "hanwha-coax-1": {
      "collectionHandle": "hanwha-coax-1",
      "collectionProductCount": 3,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "hanwha-covert-cameras-1": {
      "collectionHandle": "hanwha-covert-cameras-1",
      "collectionProductCount": 1,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "hanwha-indoor-cameras-1": {
      "collectionHandle": "hanwha-indoor-cameras-1",
      "collectionProductCount": 60,
      "renderedProductLimit": 250,
      "needs": {
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 13,
          "rankedProductIds": [
            "8284557672505",
            "8284557606969",
            "8284557312057",
            "8284557148217",
            "8168619573305",
            "8284557803577",
            "8284558032953",
            "8284557443129",
            "8284550365241",
            "8284549513273",
            "8284548890681",
            "8284548726841",
            "8168620490809"
          ],
          "rankedProductHandles": [
            "hanwha-vision-pno-a9082r-8mp-ai-bullet-camera-with-5-9-13-3mm-motorized-varifocal-lens-60m-wiseir-wdr-ip66-ip67-ik10-nema-4x",
            "hanwha-vision-pno-a9092r-8mp-ai-long-range-bullet-camera-with-15-50mm-motorized-varifocal-lens-120m-wiseir-wdr-ip66-ip67-ik10-nema-4x",
            "hanwha-vision-pnv-a9082rz-8mp-ai-outdoor-vandal-dome-camera-with-5-9-13-3mm-motorized-varifocal-lens-50m-wiseir-wdr-ip66-ip67-ik11-nema-4x",
            "hanwha-vision-qno-c9083r-8mp-ai-ir-bullet-camera-with-3-2-10-2mm-motorized-varifocal-lens-30m-ir-120db-wdr-ai-object-detection-ip66-ik10",
            "hanwha-xnd-a9084rv-8mp-ai-ir-varifocal-indoor-dome-camera-4-4-9-3-mm-lens",
            "hanwha-vision-pno-a7082r-4mp-ai-bullet-camera-with-4-6-9-35mm-motorized-varifocal-lens-60m-wiseir-extreme-wdr-ip66-ip67-ik10-nema-4x",
            "hanwha-vision-pnd-a7082rv-4mp-ai-indoor-vandal-dome-camera-with-4-6-9-35mm-motorized-varifocal-lens-60m-wiseir-dual-sd-slots-ik10",
            "hanwha-vision-pnv-a7082rz-4mp-ai-outdoor-vandal-dome-camera-with-4-6-9-35mm-motorized-varifocal-lens-30m-wiseir-ip66-ip67-ik11-nema-4x",
            "hanwha-vision-xnd-c9083rv-x-core-4k-h-265-nw-ir-dome-ai-camera",
            "hanwha-vision-xnv-c9083r-x-core-4k-h-265-nw-ir-vandal-dome-ai-camera",
            "hanwha-vision-xnv-a9084r-x-series-8mp-vandal-dome-ai-camera",
            "hanwha-vision-xnd-a9085rv-x-series-8mp-ai-ir-modular-dome-camera",
            "hanwha-xnd-a8084rv-5mp-ai-ir-indoor-dome-camera-3-3-9-3-mm-varifocal-lens"
          ]
        }
      }
    },
    "hanwha-multi-directional-camera": {
      "collectionHandle": "hanwha-multi-directional-camera",
      "collectionProductCount": 1,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "hanwha-outdoor-cameras-1": {
      "collectionHandle": "hanwha-outdoor-cameras-1",
      "collectionProductCount": 119,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 4,
          "rankedProductIds": [
            "7591954710585",
            "7591840841785",
            "7591836418105",
            "7591836057657"
          ],
          "rankedProductHandles": [
            "hanwha-vision-hv-hcp-6320ha-full-hd-1080p-analog-hd-32x-outdoor-ptz-dome-camera",
            "hanwha-wisenet-pno-a9081rlp-4k-outdoor-bullet-camera-with-lpr-30fps-120db-wdr-30m-ir-4-5-10mm",
            "hanwha-wisenet-han-xnp-9300rw-4k-outdoor-ir-ptz-camera-h-265-30x-zoom-wiper-5-150mm",
            "hanwha-wisenet-han-xnp-6400rw-2mp-outdoor-ptz-ir-camera-h-265-40x-zoom-wiper-4-25-170mm"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 16,
          "rankedProductIds": [
            "8284557672505",
            "8284557606969",
            "8284557312057",
            "8284557148217",
            "8284541222969",
            "8168620687417",
            "7591836418105",
            "8324156751929",
            "8168609710137",
            "8284557803577",
            "7690789158969",
            "8284541190201",
            "8168589230137",
            "7591919484985",
            "7591840841785",
            "7591836778553"
          ],
          "rankedProductHandles": [
            "hanwha-vision-pno-a9082r-8mp-ai-bullet-camera-with-5-9-13-3mm-motorized-varifocal-lens-60m-wiseir-wdr-ip66-ip67-ik10-nema-4x",
            "hanwha-vision-pno-a9092r-8mp-ai-long-range-bullet-camera-with-15-50mm-motorized-varifocal-lens-120m-wiseir-wdr-ip66-ip67-ik10-nema-4x",
            "hanwha-vision-pnv-a9082rz-8mp-ai-outdoor-vandal-dome-camera-with-5-9-13-3mm-motorized-varifocal-lens-50m-wiseir-wdr-ip66-ip67-ik11-nema-4x",
            "hanwha-vision-qno-c9083r-8mp-ai-ir-bullet-camera-with-3-2-10-2mm-motorized-varifocal-lens-30m-ir-120db-wdr-ai-object-detection-ip66-ik10",
            "hanwha-vision-xno-c9083r-8mp-ir-bullet-ai-camera-motorized-varifocal-analytics",
            "hanwha-xno-a9084r-8mp-ai-ir-outdoor-vandal-bullet-camera-4-4-9-3-mm-motorised-varifocal-lens",
            "hanwha-wisenet-han-xnp-9300rw-4k-outdoor-ir-ptz-camera-h-265-30x-zoom-wiper-5-150mm",
            "hanwha-vision-pnm-a13022rv-13mp-ai-ir-panoramic-network-camera",
            "hanwha-vision-qnv-c9083r-8mp-ai-ir-vandal-dome-camera-motorised-zoom-rugged-smart-surveillance",
            "hanwha-vision-pno-a7082r-4mp-ai-bullet-camera-with-4-6-9-35mm-motorized-varifocal-lens-60m-wiseir-extreme-wdr-ip66-ip67-ik10-nema-4x",
            "hanwha-wisenet-2x-6mp-outdoor-ai-multi-directional-camera-2ch-3-54-6-69mm",
            "hanwha-vision-qno-c8083r-8mp-ir-bullet-ai-camera-advanced-analytics",
            "hanwha-pno-a9081r-4k-ai-ir-bullet-network-camera",
            "hanwha-xno-9082r-wisenet-4k-outdoor-bullet-camera-h-265-30fps-wdr-ir-ip67-2-8-8-4mm",
            "hanwha-wisenet-pno-a9081rlp-4k-outdoor-bullet-camera-with-lpr-30fps-120db-wdr-30m-ir-4-5-10mm",
            "hanwha-wisenet-pno-9080r-4k-outdoor-bullet-camera-h-265-30fps-120db-wdr-30m-ir-4-5-10mm"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 16,
          "rankedProductIds": [
            "7690789158969",
            "8168416706617",
            "7591836418105",
            "7591954710585",
            "7591835893817",
            "8284549251129",
            "8284549152825",
            "8284549054521",
            "8284541386809",
            "8284541091897",
            "8284540338233",
            "7591836614713",
            "7591836352569",
            "7591836057657",
            "7591936524345",
            "7591743750201"
          ],
          "rankedProductHandles": [
            "hanwha-wisenet-2x-6mp-outdoor-ai-multi-directional-camera-2ch-3-54-6-69mm",
            "hanwha-vision-pnm-9084qz-8mp-4-sensor-multi-directional-ptrz-ip-camera-intelligent-analytics-wdr-ip66",
            "hanwha-wisenet-han-xnp-9300rw-4k-outdoor-ir-ptz-camera-h-265-30x-zoom-wiper-5-150mm",
            "hanwha-vision-hv-hcp-6320ha-full-hd-1080p-analog-hd-32x-outdoor-ptz-dome-camera",
            "hanwha-wisenet-qnp-6250r-2mp-outdoor-ir-ptz-camera-25x-zoom-ik10-ip66-4-44-111mm",
            "hanwha-vision-xnp-c6403rw-2mp-ai-ptz-camera-with-built-in-wiper-and-40x-zoom-powered-by-wisenet7",
            "hanwha-vision-xnp-c8303rw-6mp-ai-ptz-camera-with-built-in-wiper-and-30x-zoom-powered-by-wisenet7",
            "hanwha-vision-xnp-c8253r-6mp-ai-ptz-camera-with-25x-zoom-powered-by-wisenet7",
            "hanwha-vision-xnp-c6403r-4mp-ptz-network-camera-outdoor-ai-analytics",
            "hanwha-vision-xnp-c9303rw-3mp-ptz-network-camera-with-wiper-outdoor-surveillance",
            "hanwha-vision-pnm-c34404rqpz-4k-4ch-ptrz-2mp-40x-ptz-ai-camera",
            "hanwha-wisenet-han-xnp-6371rh-2mp-outdoor-ir-ptz-camera-h-265-37x-zoom-wdr-ip66-ik10-6-222mm",
            "hanwha-wisenet-han-xnp-8300rw-6mp-outdoor-ir-ptz-camera-h-265-30x-zoom-wiper-5-150mm",
            "hanwha-wisenet-han-xnp-6400rw-2mp-outdoor-ptz-ir-camera-h-265-40x-zoom-wiper-4-25-170mm",
            "hanwha-wisenet-qnp-6250h-2mp-indoor-ir-ptz-camera-25x-zoom-ip66-4-44-111mm",
            "hanwha-wisenet-new-q-5mp-outdoor-flateye-camera-h-265-wdr-20m-ir-ip67-2-8mm"
          ]
        }
      }
    },
    "hanwha-p-series": {
      "collectionHandle": "hanwha-p-series",
      "collectionProductCount": 13,
      "renderedProductLimit": 250,
      "needs": {
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 10,
          "rankedProductIds": [
            "8284557672505",
            "8284557606969",
            "8284557312057",
            "8168609710137",
            "8324156751929",
            "8168589230137",
            "8284557803577",
            "8284558032953",
            "8168618524729",
            "8284557443129"
          ],
          "rankedProductHandles": [
            "hanwha-vision-pno-a9082r-8mp-ai-bullet-camera-with-5-9-13-3mm-motorized-varifocal-lens-60m-wiseir-wdr-ip66-ip67-ik10-nema-4x",
            "hanwha-vision-pno-a9092r-8mp-ai-long-range-bullet-camera-with-15-50mm-motorized-varifocal-lens-120m-wiseir-wdr-ip66-ip67-ik10-nema-4x",
            "hanwha-vision-pnv-a9082rz-8mp-ai-outdoor-vandal-dome-camera-with-5-9-13-3mm-motorized-varifocal-lens-50m-wiseir-wdr-ip66-ip67-ik11-nema-4x",
            "hanwha-vision-qnv-c9083r-8mp-ai-ir-vandal-dome-camera-motorised-zoom-rugged-smart-surveillance",
            "hanwha-vision-pnm-a13022rv-13mp-ai-ir-panoramic-network-camera",
            "hanwha-pno-a9081r-4k-ai-ir-bullet-network-camera",
            "hanwha-vision-pno-a7082r-4mp-ai-bullet-camera-with-4-6-9-35mm-motorized-varifocal-lens-60m-wiseir-extreme-wdr-ip66-ip67-ik10-nema-4x",
            "hanwha-vision-pnd-a7082rv-4mp-ai-indoor-vandal-dome-camera-with-4-6-9-35mm-motorized-varifocal-lens-60m-wiseir-dual-sd-slots-ik10",
            "hanwha-vision-pno-a9081rlp-4k-lpr-anpr-ir-bullet-camera",
            "hanwha-vision-pnv-a7082rz-4mp-ai-outdoor-vandal-dome-camera-with-4-6-9-35mm-motorized-varifocal-lens-30m-wiseir-ip66-ip67-ik11-nema-4x"
          ]
        }
      }
    },
    "hanwha-panoramic": {
      "collectionHandle": "hanwha-panoramic",
      "collectionProductCount": 3,
      "renderedProductLimit": 250,
      "needs": {
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 2,
          "rankedProductIds": [
            "8324156751929",
            "8284541288505"
          ],
          "rankedProductHandles": [
            "hanwha-vision-pnm-a13022rv-13mp-ai-ir-panoramic-network-camera",
            "hanwha-vision-pnm-c9022rv-2-sensor-8mp-4k-multi-directional-ai-camera"
          ]
        }
      }
    },
    "hanwha-ptzs-1": {
      "collectionHandle": "hanwha-ptzs-1",
      "collectionProductCount": 18,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 3,
          "rankedProductIds": [
            "7591954710585",
            "7591836418105",
            "7591836057657"
          ],
          "rankedProductHandles": [
            "hanwha-vision-hv-hcp-6320ha-full-hd-1080p-analog-hd-32x-outdoor-ptz-dome-camera",
            "hanwha-wisenet-han-xnp-9300rw-4k-outdoor-ir-ptz-camera-h-265-30x-zoom-wiper-5-150mm",
            "hanwha-wisenet-han-xnp-6400rw-2mp-outdoor-ptz-ir-camera-h-265-40x-zoom-wiper-4-25-170mm"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 3,
          "rankedProductIds": [
            "7591836418105",
            "8284541386809",
            "7591836352569"
          ],
          "rankedProductHandles": [
            "hanwha-wisenet-han-xnp-9300rw-4k-outdoor-ir-ptz-camera-h-265-30x-zoom-wiper-5-150mm",
            "hanwha-vision-xnp-c6403r-4mp-ptz-network-camera-outdoor-ai-analytics",
            "hanwha-wisenet-han-xnp-8300rw-6mp-outdoor-ir-ptz-camera-h-265-30x-zoom-wiper-5-150mm"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 10,
          "rankedProductIds": [
            "8168416706617",
            "7591836418105",
            "8284539617337",
            "8284549251129",
            "8284549152825",
            "8284549054521",
            "8284541386809",
            "8284541091897",
            "8284540338233",
            "7591954710585"
          ],
          "rankedProductHandles": [
            "hanwha-vision-pnm-9084qz-8mp-4-sensor-multi-directional-ptrz-ip-camera-intelligent-analytics-wdr-ip66",
            "hanwha-wisenet-han-xnp-9300rw-4k-outdoor-ir-ptz-camera-h-265-30x-zoom-wiper-5-150mm",
            "hanwha-vision-xnp-c9253r-8mp-25x-ai-ptz-plus-ir-network-camera",
            "hanwha-vision-xnp-c6403rw-2mp-ai-ptz-camera-with-built-in-wiper-and-40x-zoom-powered-by-wisenet7",
            "hanwha-vision-xnp-c8303rw-6mp-ai-ptz-camera-with-built-in-wiper-and-30x-zoom-powered-by-wisenet7",
            "hanwha-vision-xnp-c8253r-6mp-ai-ptz-camera-with-25x-zoom-powered-by-wisenet7",
            "hanwha-vision-xnp-c6403r-4mp-ptz-network-camera-outdoor-ai-analytics",
            "hanwha-vision-xnp-c9303rw-3mp-ptz-network-camera-with-wiper-outdoor-surveillance",
            "hanwha-vision-pnm-c34404rqpz-4k-4ch-ptrz-2mp-40x-ptz-ai-camera",
            "hanwha-vision-hv-hcp-6320ha-full-hd-1080p-analog-hd-32x-outdoor-ptz-dome-camera"
          ]
        }
      }
    },
    "hanwha-q-series": {
      "collectionHandle": "hanwha-q-series",
      "collectionProductCount": 8,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "hanwha-varifocal": {
      "collectionHandle": "hanwha-varifocal",
      "collectionProductCount": 1,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "hanwha-wave-licenses-1": {
      "collectionHandle": "hanwha-wave-licenses-1",
      "collectionProductCount": 7,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "hanwha-x-series": {
      "collectionHandle": "hanwha-x-series",
      "collectionProductCount": 18,
      "renderedProductLimit": 250,
      "needs": {
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 8,
          "rankedProductIds": [
            "8168620687417",
            "8168619573305",
            "8284548890681",
            "8284548726841",
            "8284548366393",
            "8284548104249",
            "8168620621881",
            "8168620490809"
          ],
          "rankedProductHandles": [
            "hanwha-xno-a9084r-8mp-ai-ir-outdoor-vandal-bullet-camera-4-4-9-3-mm-motorised-varifocal-lens",
            "hanwha-xnd-a9084rv-8mp-ai-ir-varifocal-indoor-dome-camera-4-4-9-3-mm-lens",
            "hanwha-vision-xnv-a9084r-x-series-8mp-vandal-dome-ai-camera",
            "hanwha-vision-xnd-a9085rv-x-series-8mp-ai-ir-modular-dome-camera",
            "hanwha-vision-xnv-a9085r-x-series-8mp-ai-ir-modular-vandal-dome-camera",
            "hanwha-vision-xno-c8083r-6mp-ai-ir-bullet-network-camera-4-4-9-3mm-motorised-lens",
            "hanwha-xno-a8084r-5mp-ai-ir-outdoor-vandal-bullet-camera-3-3-9-3-mm-motorised-varifocal-lens",
            "hanwha-xnd-a8084rv-5mp-ai-ir-indoor-dome-camera-3-3-9-3-mm-varifocal-lens"
          ]
        }
      }
    },
    "hd-cvi-1": {
      "collectionHandle": "hd-cvi-1",
      "collectionProductCount": 2,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 1,
          "rankedProductIds": [
            "7591775305785"
          ],
          "rankedProductHandles": [
            "dahua-hac-sd49225i-hc-s3-2mp-25x-starlight-ir-ptz-hdcvi-camera-motorized-4-8120mm-lens"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 1,
          "rankedProductIds": [
            "7591775305785"
          ],
          "rankedProductHandles": [
            "dahua-hac-sd49225i-hc-s3-2mp-25x-starlight-ir-ptz-hdcvi-camera-motorized-4-8120mm-lens"
          ]
        }
      }
    },
    "hdcvi-surveillance-cameras-1": {
      "collectionHandle": "hdcvi-surveillance-cameras-1",
      "collectionProductCount": 3,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "hikvision-12mp-cameras-1": {
      "collectionHandle": "hikvision-12mp-cameras-1",
      "collectionProductCount": 10,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 2,
          "rankedProductIds": [
            "8324132470841",
            "7591715143737"
          ],
          "rankedProductHandles": [
            "hikvision-12mp-colorvu-deepinview-ai-turret-camera-with-smart-hybrid-light-motorised-varifocal-lens-audio",
            "hikvision-ds-2cd63c5g0-ivs-12mp-outdoor-fisheye-camera-immervision-lens-15m-ir-built-in-mic-ip66-1-29mm"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 6,
          "rankedProductIds": [
            "8324132470841",
            "8168573435961",
            "7591666548793",
            "7591602192441",
            "7591586463801",
            "7591715143737"
          ],
          "rankedProductHandles": [
            "hikvision-12mp-colorvu-deepinview-ai-turret-camera-with-smart-hybrid-light-motorised-varifocal-lens-audio",
            "hikvision-ids-2cd7ac5g0-izhs-12mp-deepinview-moto-varifocal-bullet-camera",
            "hikvision-ds-2cd55c5g0-izh-12mp-ir-vf-dome-network-camera",
            "hikvision-hik-2cd4ac5f-iz2-12mp-outdoor-bullet-camera-h-264-15fps-50m-exir-dwdr-ip67-2-8-12mm",
            "hikvision-ds-2cd5ac5g0-izhs-12mp-vf-bullet-camera",
            "hikvision-ds-2cd63c5g0-ivs-12mp-outdoor-fisheye-camera-immervision-lens-15m-ir-built-in-mic-ip66-1-29mm"
          ]
        }
      }
    },
    "hikvision-4mp-cameras-1": {
      "collectionHandle": "hikvision-4mp-cameras-1",
      "collectionProductCount": 58,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 8,
          "rankedProductIds": [
            "7591841366073",
            "8168624029753",
            "7591844741177",
            "8284598108217",
            "8284598009913",
            "7837229809721",
            "7690800627769",
            "7591876427833"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2se4c425mwg-e-14f0-4mp-tandemvu-colorvu-ptz",
            "hikvision-ds-2df8c435mhs-delw-4mp-35x-darkfighterx-ptz-camera-dual-sensor-ir-300m-ip67-ik10",
            "hikvision-ds-2de7a412mcg-eb-4mp-7-inch-4-mp-12x-colorvu-network-speed-dome",
            "hikvision-4mp-deepinview-ids-2cd7a46g2-v-xzhsy-bullet-camera-with-darkfighter-ai-perimeter-protection-2-8-12mm-motorised-varifocal-lens-ir-100m",
            "hikvision-ids-2cd7a45g2-izhsy-4mp-deepinview-moto-varifocal-bullet-camera-with-25x-zoom-darkfighter-2-0-200m-ir",
            "hikvision-ds-2df8c442ixg-elw-8c-series-4mp-42x-darkfighter-ir-network-speed-dome-ptz",
            "hikvision-ds-2xc6047g0-ls-4mp-outdoor-colorvu-bullet-camera-anti-corrosion-polymer-ip68-4mm",
            "hikvision-ds-2df8c425mhs-delw-4-mp-25x-darkfighterx-ir-network-speed-dome-300m-ir"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 10,
          "rankedProductIds": [
            "8284591226937",
            "7591774912569",
            "8284541976633",
            "8284598173753",
            "8168622555193",
            "7591895466041",
            "7591727202361",
            "7837247209529",
            "7591866892345",
            "7591644692537"
          ],
          "rankedProductHandles": [
            "hikvision-4mp-colorvu-ds-2xs3q47g1-ldh-4g-solar-powered-pt-camera-with-4g-two-way-audio-built-in-battery-solar-panel",
            "hikvision-ds-2cd2347g2-lsu-sl-4mp-gen2-colorvu-turret-camera-acusense-speaker-strobe-mic-30m-white-led-2-8mm",
            "hikvision-ptz-nd4404-slaus-dual-lens-4mp4mp-ptz-ip-camera-with-4x-optical-zoom-darkfighter-low-light-active-strobe-audio-alarm",
            "hikvision-4mp-deepinview-ids-2cd8a47g0-sc-zy-self-cleaning-bullet-camera-with-colorvu-2-8-12mm-motorised-varifocal-lens-smart-detection",
            "hikvision-ds-2xc3646g0h-lizsupa-anti-corrosion-vari-focal-bullet-camera-2-7-13-5mm",
            "hikvision-ds-2cd2t47g2-lsu-sl-4mp-gen2-outdoor-colorvu-bullet-camera-liveguard-60m-white-led-2-8mm",
            "hikvision-ds-2cd2347g2-lu-4mp-gen2-outdoor-colorvu-turret-camera-with-acusense-mic-30m-white-led-2-8mm",
            "hikvision-ds-2td4137t-9w-thermographic-thermal-optical-bi-spectrum-network-speed-dome",
            "hikvision-acusense-ptz-4mp-6-252mm-42x-optical-16-x-digital-400m-ir-ip67-face-capture-white",
            "hikvision-ds-2de4a425iw-de-4mp-outdoor-ptz-camera-25x-zoom-50m-ir"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 16,
          "rankedProductIds": [
            "8284541681721",
            "8168624029753",
            "7591866073145",
            "7591844577337",
            "8284598173753",
            "8284591226937",
            "8284541976633",
            "8284598108217",
            "8284598009913",
            "7591858307129",
            "8168581038137",
            "7591866892345",
            "7591721828409",
            "8284590473273",
            "8284598140985",
            "7591644692537"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2st5c432mwg-e-26pa-4mp-32x-zoom-tandemvu-anti-corrosion-ptz-ip-camera-with-acusense-darkfighter-technology",
            "hikvision-ds-2df8c435mhs-delw-4mp-35x-darkfighterx-ptz-camera-dual-sensor-ir-300m-ip67-ik10",
            "hikvision-ds-2cd2e43g2-u-4mp-acusense-gen-2-mini-dome-camera-in-ceiling-h-265-wdr-2-8mm",
            "hikvision-ds-2de4a425iwg-e-4mp-outdoor-ptz-camera-25x-zoom-50m-ir-with-ai-tracking",
            "hikvision-4mp-deepinview-ids-2cd8a47g0-sc-zy-self-cleaning-bullet-camera-with-colorvu-2-8-12mm-motorised-varifocal-lens-smart-detection",
            "hikvision-4mp-colorvu-ds-2xs3q47g1-ldh-4g-solar-powered-pt-camera-with-4g-two-way-audio-built-in-battery-solar-panel",
            "hikvision-ptz-nd4404-slaus-dual-lens-4mp4mp-ptz-ip-camera-with-4x-optical-zoom-darkfighter-low-light-active-strobe-audio-alarm",
            "hikvision-4mp-deepinview-ids-2cd7a46g2-v-xzhsy-bullet-camera-with-darkfighter-ai-perimeter-protection-2-8-12mm-motorised-varifocal-lens-ir-100m",
            "hikvision-ids-2cd7a45g2-izhsy-4mp-deepinview-moto-varifocal-bullet-camera-with-25x-zoom-darkfighter-2-0-200m-ir",
            "hikvision-4mp-tandemvu-ptz-camera-24-7-colour-180-deg-overview-42x-zoom",
            "hikvision-acusense-ds-2cd2346g2p-isu-sl-panoramic-4mp-turret-camera-fixed-2-8mm-ir-30m-mic",
            "hikvision-acusense-ptz-4mp-6-252mm-42x-optical-16-x-digital-400m-ir-ip67-face-capture-white",
            "hikvision-ds-2df8442ixs-ael-4mp-outdoor-hfr-ptz-camera-wdr-42x-zoom-ip67-500m-ir-hipoe",
            "hikvision-4mp-acusense-ds-2de2a404iwg1-e-mini-outdoor-ptz-camera-with-4x-optical-zoom-ir-20m-ip66",
            "hikvision-4mp-deepinview-ids-2cd8a46g0-iz-uh-dome-camera-with-ai-detection-2-8-12mm-motorised-varifocal-lens-ir-40m",
            "hikvision-ds-2de4a425iw-de-4mp-outdoor-ptz-camera-25x-zoom-50m-ir"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 16,
          "rankedProductIds": [
            "7591841366073",
            "8168624029753",
            "7591924039737",
            "7591866073145",
            "7591607631929",
            "7591858307129",
            "7591866892345",
            "7591721828409",
            "7837229809721",
            "8284591325241",
            "7591793262649",
            "8168581038137",
            "7745682243641",
            "7591844577337",
            "8284541681721",
            "8284541976633"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2se4c425mwg-e-14f0-4mp-tandemvu-colorvu-ptz",
            "hikvision-ds-2df8c435mhs-delw-4mp-35x-darkfighterx-ptz-camera-dual-sensor-ir-300m-ip67-ik10",
            "hikvision-ds-2sf8c442mxg-elw-26-4mp-tandemvu-ptz-camera-24-7-colour-42x-zoom",
            "hikvision-ds-2cd2e43g2-u-4mp-acusense-gen-2-mini-dome-camera-in-ceiling-h-265-wdr-2-8mm",
            "hikvision-ds-2df8436ix-ael-4mp-outdoor-hfr-ptz-camera-wdr-36x-zoom-wiper-ip66-200m-ir-hipoe",
            "hikvision-4mp-tandemvu-ptz-camera-24-7-colour-180-deg-overview-42x-zoom",
            "hikvision-acusense-ptz-4mp-6-252mm-42x-optical-16-x-digital-400m-ir-ip67-face-capture-white",
            "hikvision-ds-2df8442ixs-ael-4mp-outdoor-hfr-ptz-camera-wdr-42x-zoom-ip67-500m-ir-hipoe",
            "hikvision-ds-2df8c442ixg-elw-8c-series-4mp-42x-darkfighter-ir-network-speed-dome-ptz",
            "hikvision-4mp-special-series-ds-2xt6445g2-l-c08-high-temperature-camera-with-white-light-10m-120db-wdr-ip67",
            "hikvision-ds-2df6a436x-ael-ptz-8mp42x-ip676-252mm500m-ir-vehicle-human-tracking",
            "hikvision-acusense-ds-2cd2346g2p-isu-sl-panoramic-4mp-turret-camera-fixed-2-8mm-ir-30m-mic",
            "hikvision-ds-2se4c425mwg-e-14f0-64mp-tandemvu-ir-panoramic-ptz",
            "hikvision-ds-2de4a425iwg-e-4mp-outdoor-ptz-camera-25x-zoom-50m-ir-with-ai-tracking",
            "hikvision-ds-2st5c432mwg-e-26pa-4mp-32x-zoom-tandemvu-anti-corrosion-ptz-ip-camera-with-acusense-darkfighter-technology",
            "hikvision-ptz-nd4404-slaus-dual-lens-4mp4mp-ptz-ip-camera-with-4x-optical-zoom-darkfighter-low-light-active-strobe-audio-alarm"
          ]
        },
        "two-way-audio": {
          "displayName": "Two-way audio",
          "productCount": 2,
          "rankedProductIds": [
            "8284591226937",
            "8284591292473"
          ],
          "rankedProductHandles": [
            "hikvision-4mp-colorvu-ds-2xs3q47g1-ldh-4g-solar-powered-pt-camera-with-4g-two-way-audio-built-in-battery-solar-panel",
            "hikvision-4mp-colorvu-ds-2xs3q47g1-ldwh-c18s40-b-solar-pt-camera-bundle-kit-with-sma-adapter-af003-100-waterproof-sealing-tape-two-way-audio"
          ]
        }
      }
    },
    "hikvision-6mp-bullet-kits": {
      "collectionHandle": "hikvision-6mp-bullet-kits",
      "collectionProductCount": 7,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "hikvision-6mp-cameras": {
      "collectionHandle": "hikvision-6mp-cameras",
      "collectionProductCount": 85,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 16,
          "rankedProductIds": [
            "8168618262585",
            "8168620949561",
            "7591938981945",
            "8168610955321",
            "7591903199289",
            "7591903690809",
            "8168601190457",
            "8168451407929",
            "7591902216249",
            "7591901823033",
            "7591905394745",
            "7591938752569",
            "7591902675001",
            "8284554297401",
            "8168621506617",
            "8168614953017"
          ],
          "rankedProductHandles": [
            "hikvision-2cd3666g2ht-lizsy-6mp-acusense-smart-hybrid-bullet-camera-with-varifocal-2-7-13-5mm-lens-darkfighter-ir-60m",
            "hikvision-ds-2cd3766g2ht-lizsuy-6mp-smart-hybrid-motorised-dome-camera-with-darkfighter-s-varifocal-2-7-13-5mm-ir-white-light-supplement-up-to-40m-in-white-or-black",
            "hikvision-ds-2cd2t67g2h-li-6mp-smart-hybrid-light-colorvu-bullet-camera-black",
            "hikvision-ds-2cd3h67g3-lizsuy-s-6mp-deep-learning-motorised-varifocal-turret-colorvu-3-0security-camera",
            "hikvision-ds-2cd2667g2ht-6mp-smart-hybrid-light-colorvu-motorised-vf-bullet-camera-2-8-12-mm",
            "hikvision-ds-2cd2767g2ht-6mp-smart-hybrid-light-colorvu-motorised-vf-dome-camera-2-8-12mm",
            "hikvision-ds-2cd2t67g3-lis2uy-sl-6mp-colorvu-3-0-bullet-camera-white",
            "hikvision-ds-2cd2067g2h-liu-sl-6mp-smart-hybrid-light-colorvu-mini-bullet-camera-2-8mm-4mm",
            "hikvision-ds-2cd2367g2h-liu-8mp-4k-smart-hybrid-light-colorvu-turret-camera-2-8mm-4mm",
            "hikvision-ds-2cd2367g2h-liu-6mp-smart-hybrid-light-colorvu-turret-camera-2-8mm",
            "hikvision-ds-2cd2367g2h-lisu-sl-6mp-smart-hybrid-light-colorvu-turret-camera-2-8mm-strobe-speaker",
            "hikvision-ds-2cd2067g2h-6mp-smart-hybrid-light-colorvu-mini-bullet-camera-2-8mm-black",
            "hikvision-ds-2cd2067g2h-6mp-smart-hybrid-light-colorvu-mini-bullet-camera-2-8mm-4mm",
            "hikvision-ds-2cd3h86g3-lizsuy-sl-8mp-dual-illumination-motorised-turret-camera-with-strobe-siren",
            "hikvision-ds-2cd3h66g3-lizsuy-sl-6mp-dual-illumination-turret-camera-with-strobe-light-audio-alarm-motorised-varifocal-2-7-13-5mm-ir-white-light-up-to-40m",
            "hikvision-ds-2cd2167g3-lis2uy-6mp-smart-hybrid-light-dome-2-8-mm-4-mm-lens-options"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 16,
          "rankedProductIds": [
            "8168616165433",
            "8168610955321",
            "8168600338489",
            "8168621506617",
            "8284554297401",
            "8168601190457",
            "7591905394745",
            "8168618000441",
            "8168611086393",
            "8168404942905",
            "7591903199289",
            "8168581169209",
            "8168618262585",
            "7591938981945",
            "7591901823033",
            "7591938752569"
          ],
          "rankedProductHandles": [
            "hikvision-6mp-mini-bullet-colorvu-3-0-strobe-audio-ds-2cd2067g3-li2uy-sl",
            "hikvision-ds-2cd3h67g3-lizsuy-s-6mp-deep-learning-motorised-varifocal-turret-colorvu-3-0security-camera",
            "hikvision-ds-2cd3667g3-lizsuy-sl-6mp-colorvu-varifocal-bullet-camera-smart-hybrid-light",
            "hikvision-ds-2cd3h66g3-lizsuy-sl-6mp-dual-illumination-turret-camera-with-strobe-light-audio-alarm-motorised-varifocal-2-7-13-5mm-ir-white-light-up-to-40m",
            "hikvision-ds-2cd3h86g3-lizsuy-sl-8mp-dual-illumination-motorised-turret-camera-with-strobe-siren",
            "hikvision-ds-2cd2t67g3-lis2uy-sl-6mp-colorvu-3-0-bullet-camera-white",
            "hikvision-ds-2cd2367g2h-lisu-sl-6mp-smart-hybrid-light-colorvu-turret-camera-2-8mm-strobe-speaker",
            "hikvision-6mp-acusense-2cd2t66g2h-is2u-sl-bullet-camera-with-audio-strobe-light-2-8mm-lens-ir-60m",
            "hikvision-ds-2cd2066g2h-i2u-sl-6mp-outdoor-acusense-mini-bullet-camera-mic-ir-strobe-audio-alarm-2-8mm-black",
            "hikvision-ds-2cd2066g2h-i2u-sl-6mp-outdoor-acusense-mini-bullet-camera-mic-ir-strobe-audio-alarm-2-8mm",
            "hikvision-ds-2cd2667g2ht-6mp-smart-hybrid-light-colorvu-motorised-vf-bullet-camera-2-8-12-mm",
            "hikvision-colorvu-2cd2t67g2p-lsu-sl-6mp-dual-lens-stobe-audio-bullet-camera2-8mm-mic",
            "hikvision-2cd3666g2ht-lizsy-6mp-acusense-smart-hybrid-bullet-camera-with-varifocal-2-7-13-5mm-lens-darkfighter-ir-60m",
            "hikvision-ds-2cd2t67g2h-li-6mp-smart-hybrid-light-colorvu-bullet-camera-black",
            "hikvision-ds-2cd2367g2h-liu-6mp-smart-hybrid-light-colorvu-turret-camera-2-8mm",
            "hikvision-ds-2cd2067g2h-6mp-smart-hybrid-light-colorvu-mini-bullet-camera-2-8mm-black"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 10,
          "rankedProductIds": [
            "8284554297401",
            "7591903199289",
            "8168610955321",
            "8168600338489",
            "8168618262585",
            "8168621506617",
            "8168620949561",
            "7591903690809",
            "7591674708025",
            "7591624966201"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd3h86g3-lizsuy-sl-8mp-dual-illumination-motorised-turret-camera-with-strobe-siren",
            "hikvision-ds-2cd2667g2ht-6mp-smart-hybrid-light-colorvu-motorised-vf-bullet-camera-2-8-12-mm",
            "hikvision-ds-2cd3h67g3-lizsuy-s-6mp-deep-learning-motorised-varifocal-turret-colorvu-3-0security-camera",
            "hikvision-ds-2cd3667g3-lizsuy-sl-6mp-colorvu-varifocal-bullet-camera-smart-hybrid-light",
            "hikvision-2cd3666g2ht-lizsy-6mp-acusense-smart-hybrid-bullet-camera-with-varifocal-2-7-13-5mm-lens-darkfighter-ir-60m",
            "hikvision-ds-2cd3h66g3-lizsuy-sl-6mp-dual-illumination-turret-camera-with-strobe-light-audio-alarm-motorised-varifocal-2-7-13-5mm-ir-white-light-up-to-40m",
            "hikvision-ds-2cd3766g2ht-lizsuy-6mp-smart-hybrid-motorised-dome-camera-with-darkfighter-s-varifocal-2-7-13-5mm-ir-white-light-supplement-up-to-40m-in-white-or-black",
            "hikvision-ds-2cd2767g2ht-6mp-smart-hybrid-light-colorvu-motorised-vf-dome-camera-2-8-12mm",
            "hikvision-ds-2cd2765fwd-izs-6mp-outdoor-motorised-vf-dome-cctv-camera-30m-ir-io-2-8-12mm",
            "hikvision-hik-2cd2h55fwd-izs-5mp-outdoor-motorised-vf-dome-h-265-30m-ir-io-wdr-ip67-2-8-12mm"
          ]
        }
      }
    },
    "hikvision-6mp-dome-kits": {
      "collectionHandle": "hikvision-6mp-dome-kits",
      "collectionProductCount": 5,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "hikvision-6mp-mini-cameras-kits": {
      "collectionHandle": "hikvision-6mp-mini-cameras-kits",
      "collectionProductCount": 11,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 2,
          "rankedProductIds": [
            "8284564062265",
            "8284563669049"
          ],
          "rankedProductHandles": [
            "hikvision-6-camera-6mp-smart-hybrid-light-security-kit-with-ds-2cd2067g3-li2uy-sl-cameras-ds-7608ni-m2-8p-8-channel-8-poe-nvr-no-hdd",
            "hikvision-6mp-smart-hybrid-light-ds-2cd2067g3-li2uy-sl-4-camera-kit-with-ds-7604ni-m1-4p-4-channel-poe-nvr-no-hdd"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 4,
          "rankedProductIds": [
            "8284565340217",
            "8284564455481",
            "8284564815929",
            "8284563669049"
          ],
          "rankedProductHandles": [
            "hikvision-10-camera-6mp-colorvu-security-kit-with-ds-7616ni-m2-16p-16ch-16-poe-8k-nvr-10x-ds-2cd2067g3-li2uy-sl-fixed-mini-bullet-cameras-dual-microphones-active-strobe-light-no-hdd-included",
            "hikvision-6-camera-kit-6mp-colorvu-with-ds-7608ni-m2-8p-8ch-poe-nvr-6x-ds-2cd2067g3-li2uy-sl-mini-bullet-cameras-4tb-hdd-included",
            "hikvision-8-camera-kit-with-ds-7608ni-m2-8p-8ch-poe-8k-nvr-8x-6mp-colorvu-ds-2cd2067g3-li2uy-sl-mini-bullet-cameras-4tb-hdd-included",
            "hikvision-6mp-smart-hybrid-light-ds-2cd2067g3-li2uy-sl-4-camera-kit-with-ds-7604ni-m1-4p-4-channel-poe-nvr-no-hdd"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 4,
          "rankedProductIds": [
            "8284564815929",
            "8284565340217",
            "8284566945849",
            "7591627882553"
          ],
          "rankedProductHandles": [
            "hikvision-8-camera-kit-with-ds-7608ni-m2-8p-8ch-poe-8k-nvr-8x-6mp-colorvu-ds-2cd2067g3-li2uy-sl-mini-bullet-cameras-4tb-hdd-included",
            "hikvision-10-camera-6mp-colorvu-security-kit-with-ds-7616ni-m2-16p-16ch-16-poe-8k-nvr-10x-ds-2cd2067g3-li2uy-sl-fixed-mini-bullet-cameras-dual-microphones-active-strobe-light-no-hdd-included",
            "hikvision-10-camera-6mp-acusense-security-kit-with-ds-7616ni-m2-16p-16ch-16-poe-8k-nvr-10x-ds-2cd2066g2h-iu-fixed-mini-bullet-cameras-built-in-microphone-no-hdd-included",
            "5mp-8ch-hikvision-cctv-kit-8-x-mini-bullet-cameras-8ch-nvr"
          ]
        }
      }
    },
    "hikvision-6mp-turret-kits": {
      "collectionHandle": "hikvision-6mp-turret-kits",
      "collectionProductCount": 25,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "hikvision-8mp-4k-cameras": {
      "collectionHandle": "hikvision-8mp-4k-cameras",
      "collectionProductCount": 48,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 16,
          "rankedProductIds": [
            "8168620884025",
            "8284591095865",
            "8168604893241",
            "8168572649529",
            "8284579692601",
            "8168596406329",
            "8168622096441",
            "8168599519289",
            "8168600961081",
            "8168575565881",
            "8168626257977",
            "8168586772537",
            "8168617017401",
            "8168586870841",
            "8168621244473",
            "8168615739449"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd3686g2ht-lizsy-8mp-smart-hybrid-motorised-bullet-camera-with-darkfighter-varifocal-2-7-13-5mm-ir-60m",
            "hikvision-6mp-8mp-tandemvu-ultra-ds-2sf8c848mxg1-elwy-26-ptz-camera-with-colorvu-26x-optical-zoom-ir-500m",
            "hikvision-ds-2cd3786g2ht-lizsuy-8mp-smart-hybrid-light-dome-heop-130-db-wdr-dual-illumination-ip67-ik10",
            "hikvision-ds-2cd2387g3-lis2uy-sl-8mp-4k-smart-hybrid-light-colorvu-3-0-turret-camera-with-strobe-speaker",
            "hikvision-ds-2cd2387g3-lis2uy-srb-8mp-4k-smart-hybrid-light-colorvu-3-0-turret-camera-red-blue-strobe-speaker",
            "hikvision-ds-2cd2h87g3-lizsy-8mp-smart-hybrid-light-colorvu-varifocal-turret-camera",
            "hikvision-ds-2cd3h87g3-lizsuy-sl-blk-8-mp-ultra-series-deep-learning-motorised-turret-camera-with-dual-illumination-varifocal-2-7-13-5-mm-ir-white-light-up-to-40-m-black",
            "hikvision-ds-2cd3h87g3-lizsuy-sl-8-mp-ultra-series-deep-learning-turret-camera-with-dual-illumination",
            "hikvision-ds-2cd3787g3t-lizsuy-8-mp-dual-illumination-motorized-varifocal-dome-camera",
            "hikvision-ds-2cd2367g3-lis2uy-sl-6mp-smart-hybrid-light-colorvu-3-0-turret-camera-with-strobe-speaker",
            "hikvision-ds-2xc3386g0h-lisu-sl-pa-polymer-8mp-anti-corrosion-fixed-turret",
            "hikvision-ds-2cd2087g3-li2uy-8mp-colorvu-3-0-hybrid-mini-bullet-camera",
            "hikvision-ds-2cd2187g3-lis2uy-blk-8mp-colorvu-3-0-gen-3-hybrid-dome-camera-black",
            "hikvision-ds-2cd2187g3-lis2uy-8mp-colorvu-3-0-hybrid-dome-camera",
            "hikvision-ds-2cd3787g3t-lizsuy-blk-8mp-colorvu-3-0-dual-illumination-motorised-varifocal-dome-camera-black",
            "hikvision-ds-2cd2387g3-lis2uy-sl-8mp-colorvu-3-0-turret-camera-with-strobe-speaker-in-black"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 12,
          "rankedProductIds": [
            "8284579692601",
            "8168572649529",
            "8168615444537",
            "8168575565881",
            "8168616460345",
            "8168616362041",
            "8168615739449",
            "8284591095865",
            "8168622096441",
            "8168617017401",
            "8168620884025",
            "8168604893241"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd2387g3-lis2uy-srb-8mp-4k-smart-hybrid-light-colorvu-3-0-turret-camera-red-blue-strobe-speaker",
            "hikvision-ds-2cd2387g3-lis2uy-sl-8mp-4k-smart-hybrid-light-colorvu-3-0-turret-camera-with-strobe-speaker",
            "hikvision-ds-2cd2367g3-lis2uy-sl-6mp-colorvu-3-0-gen-3-turret-camera-with-strobe-speaker-black",
            "hikvision-ds-2cd2367g3-lis2uy-sl-6mp-smart-hybrid-light-colorvu-3-0-turret-camera-with-strobe-speaker",
            "hikvision-8mp-acusense-black-mini-bullet-strobe-audio-ds-2cd2086g2h-i2u-sl-blk-black",
            "hikvision-8mp-acusense-mini-bullet-strobe-audio-ds-2cd2086g2h-i2u-sl",
            "hikvision-ds-2cd2387g3-lis2uy-sl-8mp-colorvu-3-0-turret-camera-with-strobe-speaker-in-black",
            "hikvision-6mp-8mp-tandemvu-ultra-ds-2sf8c848mxg1-elwy-26-ptz-camera-with-colorvu-26x-optical-zoom-ir-500m",
            "hikvision-ds-2cd3h87g3-lizsuy-sl-blk-8-mp-ultra-series-deep-learning-motorised-turret-camera-with-dual-illumination-varifocal-2-7-13-5-mm-ir-white-light-up-to-40-m-black",
            "hikvision-ds-2cd2187g3-lis2uy-blk-8mp-colorvu-3-0-gen-3-hybrid-dome-camera-black",
            "hikvision-ds-2cd3686g2ht-lizsy-8mp-smart-hybrid-motorised-bullet-camera-with-darkfighter-varifocal-2-7-13-5mm-ir-60m",
            "hikvision-ds-2cd3786g2ht-lizsuy-8mp-smart-hybrid-light-dome-heop-130-db-wdr-dual-illumination-ip67-ik10"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 16,
          "rankedProductIds": [
            "8168572158009",
            "8168622096441",
            "8168572649529",
            "8168596406329",
            "8168616656953",
            "8168620884025",
            "8168599519289",
            "8168621244473",
            "8284597813305",
            "8168604893241",
            "8284597747769",
            "8168604237881",
            "8284591095865",
            "8168572223545",
            "8284579692601",
            "8168626257977"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2df8c842ixg1-elwy",
            "hikvision-ds-2cd3h87g3-lizsuy-sl-blk-8-mp-ultra-series-deep-learning-motorised-turret-camera-with-dual-illumination-varifocal-2-7-13-5-mm-ir-white-light-up-to-40-m-black",
            "hikvision-ds-2cd2387g3-lis2uy-sl-8mp-4k-smart-hybrid-light-colorvu-3-0-turret-camera-with-strobe-speaker",
            "hikvision-ds-2cd2h87g3-lizsy-8mp-smart-hybrid-light-colorvu-varifocal-turret-camera",
            "hikvision-8mp-acusense-ds-2cd2186g2h-isu-dome-camera-fixed-2-8mm-ir-30m-mic",
            "hikvision-ds-2cd3686g2ht-lizsy-8mp-smart-hybrid-motorised-bullet-camera-with-darkfighter-varifocal-2-7-13-5mm-ir-60m",
            "hikvision-ds-2cd3h87g3-lizsuy-sl-8-mp-ultra-series-deep-learning-turret-camera-with-dual-illumination",
            "hikvision-ds-2cd3787g3t-lizsuy-blk-8mp-colorvu-3-0-dual-illumination-motorised-varifocal-dome-camera-black",
            "hikvision-ids-2cd5t87g2-v-xhsy-8mp-deepinviewx-fixed-bullet-camera-with-darkfighter-2-0-perimeter-protection",
            "hikvision-ds-2cd3786g2ht-lizsuy-8mp-smart-hybrid-light-dome-heop-130-db-wdr-dual-illumination-ip67-ik10",
            "hikvision-ids-2cd5387g2-v-xs-8mp-deepinviewx-fixed-turret-camera-with-darkfighter-2-0-human-vehicle-detection-ip67-weather-protection",
            "hikvision-ids-2cd7586g2-xzhsy-8mp-deepinview-ptrz-motorized-varifocal-dome-darkfighter-2-0-ip67-ik10",
            "hikvision-6mp-8mp-tandemvu-ultra-ds-2sf8c848mxg1-elwy-26-ptz-camera-with-colorvu-26x-optical-zoom-ir-500m",
            "hikvision-ids-2cd7186g0-izhsy-8mp-deepinview-moto-varifocal-dome-camera",
            "hikvision-ds-2cd2387g3-lis2uy-srb-8mp-4k-smart-hybrid-light-colorvu-3-0-turret-camera-red-blue-strobe-speaker",
            "hikvision-ds-2xc3386g0h-lisu-sl-pa-polymer-8mp-anti-corrosion-fixed-turret"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 3,
          "rankedProductIds": [
            "8284591095865",
            "8168625471545",
            "8168572158009"
          ],
          "rankedProductHandles": [
            "hikvision-6mp-8mp-tandemvu-ultra-ds-2sf8c848mxg1-elwy-26-ptz-camera-with-colorvu-26x-optical-zoom-ir-500m",
            "hikvision-32mp-180-panovu-ds-2cd6984g1-ihsuy-nfc-multisensor-4-directional-camera-2-8mm-lens-ir-20m",
            "hikvision-ds-2df8c842ixg1-elwy"
          ]
        }
      }
    },
    "hikvision-8mp-4k-cameras-1": {
      "collectionHandle": "hikvision-8mp-4k-cameras-1",
      "collectionProductCount": 51,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 5,
          "rankedProductIds": [
            "7591926628409",
            "7591899660345",
            "7690800562233",
            "7591868989497",
            "7591701086265"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd2087g2h-liu-sl-8mp-colorvu-mini-bullet-camera-hybrid-light-liveguard-2-8-4mm",
            "hikvision-ds-2cd2387g2h-liu-8mp-4k-smart-hybrid-light-colorvu-turret-camera-with-strobe-speaker",
            "hikvision-ds-2cd2187g2h-li-8mp-outdoor-colorvu-dome-camera-hybrid-light-mic-2-8mm",
            "hikvision-8mp-outdoor-colorvu-mini-bullet-camera-hybrid-light-mic-2-8mm",
            "hikvision-ds-2cd2685g1-izs-8mp-outdoor-motorised-vf-bullet-2-8-12mm-with-darkfighter"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 2,
          "rankedProductIds": [
            "7591899660345",
            "7591926628409"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd2387g2h-liu-8mp-4k-smart-hybrid-light-colorvu-turret-camera-with-strobe-speaker",
            "hikvision-ds-2cd2087g2h-liu-sl-8mp-colorvu-mini-bullet-camera-hybrid-light-liveguard-2-8-4mm"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 10,
          "rankedProductIds": [
            "7591926628409",
            "7591899660345",
            "7591701086265",
            "7591622377529",
            "7591620640825",
            "7591697776697",
            "7591697481785",
            "7591624638521",
            "7591624081465",
            "7591818559545"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd2087g2h-liu-sl-8mp-colorvu-mini-bullet-camera-hybrid-light-liveguard-2-8-4mm",
            "hikvision-ds-2cd2387g2h-liu-8mp-4k-smart-hybrid-light-colorvu-turret-camera-with-strobe-speaker",
            "hikvision-ds-2cd2685g1-izs-8mp-outdoor-motorised-vf-bullet-2-8-12mm-with-darkfighter",
            "hikvision-hik-2cd2h85wdizs-8mp-outdoor-motorised-vf-turret-h-265-ir-io-wdr-ip67-2-8-12mm",
            "hikvision-hik-2cd2t85wdi54-8mp-outdoor-bullet-camera-h-265-50m-ir-120db-wdr-ip67-4mm",
            "hikvision-ds-2cd2385g1-i-8mp-black-shadow-outdoor-turret-cctv-camera-h-265-30m-ir",
            "hikvision-ds-2cd2385g1-i-8mp-outdoor-turret-cctv-camera-h-265-30m-ir",
            "hikvision-hik-2cd2385-4blk-8mp-shadow-series-outdoor-turret-camera-30m-ir-120db-wdr-ip67-4mm",
            "hikvision-hik-2cd2385-2blk-8mp-shadow-series-outdoor-turret-camera-30m-ir-120db-wdr-ip67-2-8mm",
            "hikvision-ds-2cd2586g2-is-8mp-outdoor-acusense-mini-dome-cctv-camera-30-ir-with-mic"
          ]
        }
      }
    },
    "hikvision-8mp-bullet-kits-1": {
      "collectionHandle": "hikvision-8mp-bullet-kits-1",
      "collectionProductCount": 4,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "hikvision-8mp-dome-kits-1": {
      "collectionHandle": "hikvision-8mp-dome-kits-1",
      "collectionProductCount": 4,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "hikvision-8mp-turret-kits-1": {
      "collectionHandle": "hikvision-8mp-turret-kits-1",
      "collectionProductCount": 36,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "hikvision-8mp-varifocal-kits-1": {
      "collectionHandle": "hikvision-8mp-varifocal-kits-1",
      "collectionProductCount": 1,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "hikvision-acusense-cameras-amp-nvrs": {
      "collectionHandle": "hikvision-acusense-cameras-amp-nvrs",
      "collectionProductCount": 130,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 16,
          "rankedProductIds": [
            "7591938981945",
            "7591926628409",
            "8168572649529",
            "8284579692601",
            "7591841366073",
            "7591899660345",
            "7591903199289",
            "7591844741177",
            "7591903690809",
            "8168601190457",
            "7591868989497",
            "8168451407929",
            "7591902216249",
            "7690800562233",
            "7591901823033",
            "7591905394745"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd2t67g2h-li-6mp-smart-hybrid-light-colorvu-bullet-camera-black",
            "hikvision-ds-2cd2087g2h-liu-sl-8mp-colorvu-mini-bullet-camera-hybrid-light-liveguard-2-8-4mm",
            "hikvision-ds-2cd2387g3-lis2uy-sl-8mp-4k-smart-hybrid-light-colorvu-3-0-turret-camera-with-strobe-speaker",
            "hikvision-ds-2cd2387g3-lis2uy-srb-8mp-4k-smart-hybrid-light-colorvu-3-0-turret-camera-red-blue-strobe-speaker",
            "hikvision-ds-2se4c425mwg-e-14f0-4mp-tandemvu-colorvu-ptz",
            "hikvision-ds-2cd2387g2h-liu-8mp-4k-smart-hybrid-light-colorvu-turret-camera-with-strobe-speaker",
            "hikvision-ds-2cd2667g2ht-6mp-smart-hybrid-light-colorvu-motorised-vf-bullet-camera-2-8-12-mm",
            "hikvision-ds-2de7a412mcg-eb-4mp-7-inch-4-mp-12x-colorvu-network-speed-dome",
            "hikvision-ds-2cd2767g2ht-6mp-smart-hybrid-light-colorvu-motorised-vf-dome-camera-2-8-12mm",
            "hikvision-ds-2cd2t67g3-lis2uy-sl-6mp-colorvu-3-0-bullet-camera-white",
            "hikvision-8mp-outdoor-colorvu-mini-bullet-camera-hybrid-light-mic-2-8mm",
            "hikvision-ds-2cd2067g2h-liu-sl-6mp-smart-hybrid-light-colorvu-mini-bullet-camera-2-8mm-4mm",
            "hikvision-ds-2cd2367g2h-liu-8mp-4k-smart-hybrid-light-colorvu-turret-camera-2-8mm-4mm",
            "hikvision-ds-2cd2187g2h-li-8mp-outdoor-colorvu-dome-camera-hybrid-light-mic-2-8mm",
            "hikvision-ds-2cd2367g2h-liu-6mp-smart-hybrid-light-colorvu-turret-camera-2-8mm",
            "hikvision-ds-2cd2367g2h-lisu-sl-6mp-smart-hybrid-light-colorvu-turret-camera-2-8mm-strobe-speaker"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 16,
          "rankedProductIds": [
            "8284579692601",
            "7591774912569",
            "7591855751225",
            "8168572649529",
            "8168600338489",
            "8168601190457",
            "7591905394745",
            "7591899660345",
            "8168615444537",
            "8168575565881",
            "7591807221817",
            "8168402780217",
            "8168598765625",
            "8168417591353",
            "8168404942905",
            "7591807451193"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd2387g3-lis2uy-srb-8mp-4k-smart-hybrid-light-colorvu-3-0-turret-camera-red-blue-strobe-speaker",
            "hikvision-ds-2cd2347g2-lsu-sl-4mp-gen2-colorvu-turret-camera-acusense-speaker-strobe-mic-30m-white-led-2-8mm",
            "hikvision-ds-2cd2367g2p-lsu-sl-6mp-colorvu-turret-dual-head-strobe-speaker-network-camera",
            "hikvision-ds-2cd2387g3-lis2uy-sl-8mp-4k-smart-hybrid-light-colorvu-3-0-turret-camera-with-strobe-speaker",
            "hikvision-ds-2cd3667g3-lizsuy-sl-6mp-colorvu-varifocal-bullet-camera-smart-hybrid-light",
            "hikvision-ds-2cd2t67g3-lis2uy-sl-6mp-colorvu-3-0-bullet-camera-white",
            "hikvision-ds-2cd2367g2h-lisu-sl-6mp-smart-hybrid-light-colorvu-turret-camera-2-8mm-strobe-speaker",
            "hikvision-ds-2cd2387g2h-liu-8mp-4k-smart-hybrid-light-colorvu-turret-camera-with-strobe-speaker",
            "hikvision-ds-2cd2367g3-lis2uy-sl-6mp-colorvu-3-0-gen-3-turret-camera-with-strobe-speaker-black",
            "hikvision-ds-2cd2367g3-lis2uy-sl-6mp-smart-hybrid-light-colorvu-3-0-turret-camera-with-strobe-speaker",
            "hikvision-acusense-ds-2cd2386g2-isu-sl-ip-camera-8mp-4k-with-sound-strobe-turret-camera-black",
            "hikvision-8mp-acusense-ds-2cd2386g2-isu-sl-ip-turret-camera-4k-with-strobe-audio-fixed-turret-network-camera",
            "hikvision-ds-2cd2386g2h-is2u-sl-8-mp-acusense-turret-camera-with-strobe-light-audio-and-smart-detection",
            "hikvision-acusense-ds-2cd2t66g2-izsu-sl-ip-camera-6mp-with-audible-warning-strobe-bullet-network-camera",
            "hikvision-ds-2cd2066g2h-i2u-sl-6mp-outdoor-acusense-mini-bullet-camera-mic-ir-strobe-audio-alarm-2-8mm",
            "hikvision-acusense-ds-2cd2t66g2-isu-sl-ip-camera-6mp-with-audible-warning-strobe-bullet-network-camera"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 16,
          "rankedProductIds": [
            "8168599879737",
            "8168572649529",
            "7591807221817",
            "8168573435961",
            "7591726514233",
            "7591903199289",
            "7591926628409",
            "8168554889273",
            "7591716651065",
            "7591866073145",
            "8168586772537",
            "8168617017401",
            "8168586870841",
            "8284579692601",
            "8168402780217",
            "7591932231737"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd2386g2h-iu-8mp-4k-acusense-turret-network-camera-with-mic",
            "hikvision-ds-2cd2387g3-lis2uy-sl-8mp-4k-smart-hybrid-light-colorvu-3-0-turret-camera-with-strobe-speaker",
            "hikvision-acusense-ds-2cd2386g2-isu-sl-ip-camera-8mp-4k-with-sound-strobe-turret-camera-black",
            "hikvision-ids-2cd7ac5g0-izhs-12mp-deepinview-moto-varifocal-bullet-camera",
            "hikvision-acusense-ds-2cd2686g2t-izs-ip-camera-8mp-4k-varifocal-bullet-camera",
            "hikvision-ds-2cd2667g2ht-6mp-smart-hybrid-light-colorvu-motorised-vf-bullet-camera-2-8-12-mm",
            "hikvision-ds-2cd2087g2h-liu-sl-8mp-colorvu-mini-bullet-camera-hybrid-light-liveguard-2-8-4mm",
            "hikvision-ds-2cd3686g3-lizsuy-sl-8mp-dual-illumination-strobe-light-and-audible-warning-motorized-varifocal-bullet-camera",
            "hikvision-acusense-ds-2cd2686g2-izsu-sl-ip-camera-8mp-4k-with-audible-warning-strobe-varifocal-bullet-camera",
            "hikvision-ds-2cd2e43g2-u-4mp-acusense-gen-2-mini-dome-camera-in-ceiling-h-265-wdr-2-8mm",
            "hikvision-ds-2cd2087g3-li2uy-8mp-colorvu-3-0-hybrid-mini-bullet-camera",
            "hikvision-ds-2cd2187g3-lis2uy-blk-8mp-colorvu-3-0-gen-3-hybrid-dome-camera-black",
            "hikvision-ds-2cd2187g3-lis2uy-8mp-colorvu-3-0-hybrid-dome-camera",
            "hikvision-ds-2cd2387g3-lis2uy-srb-8mp-4k-smart-hybrid-light-colorvu-3-0-turret-camera-red-blue-strobe-speaker",
            "hikvision-8mp-acusense-ds-2cd2386g2-isu-sl-ip-turret-camera-4k-with-strobe-audio-fixed-turret-network-camera",
            "hikvision-acusense-black-ds-2cd2386g2-iu-ip-camera-8mp-4k-turret-network-camera-with-mic"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 12,
          "rankedProductIds": [
            "7591841366073",
            "7591924039737",
            "7591807221817",
            "7591858307129",
            "7591866073145",
            "7837229809721",
            "7745682243641",
            "7591807451193",
            "7591688732729",
            "7591688896569",
            "8284590473273",
            "7591734018105"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2se4c425mwg-e-14f0-4mp-tandemvu-colorvu-ptz",
            "hikvision-ds-2sf8c442mxg-elw-26-4mp-tandemvu-ptz-camera-24-7-colour-42x-zoom",
            "hikvision-acusense-ds-2cd2386g2-isu-sl-ip-camera-8mp-4k-with-sound-strobe-turret-camera-black",
            "hikvision-4mp-tandemvu-ptz-camera-24-7-colour-180-deg-overview-42x-zoom",
            "hikvision-ds-2cd2e43g2-u-4mp-acusense-gen-2-mini-dome-camera-in-ceiling-h-265-wdr-2-8mm",
            "hikvision-ds-2df8c442ixg-elw-8c-series-4mp-42x-darkfighter-ir-network-speed-dome-ptz",
            "hikvision-ds-2se4c425mwg-e-14f0-64mp-tandemvu-ir-panoramic-ptz",
            "hikvision-acusense-ds-2cd2t66g2-isu-sl-ip-camera-6mp-with-audible-warning-strobe-bullet-network-camera",
            "hikvision-accusense-ds-2cd2346g1-sl-ip-camera-4mp-2-8mm-lens-inbuilt-audio-speaker-strobe",
            "hikvision-accusense-ds-2cd2t46g1-4i-sl-ip-bullet-camera-4mp-2-8mm-lens-inbuilt-audio-speaker-strobe",
            "hikvision-4mp-acusense-ds-2de2a404iwg1-e-mini-outdoor-ptz-camera-with-4x-optical-zoom-ir-20m-ip66",
            "hikvision-ds-2de3a400bw-de-colorvu-4mp-outdoor-pan-tilt-network-dome-camera"
          ]
        }
      }
    },
    "hikvision-anpr-number-plate-recoginition-cameras-amp-licenses": {
      "collectionHandle": "hikvision-anpr-number-plate-recoginition-cameras-amp-licenses",
      "collectionProductCount": 10,
      "renderedProductLimit": 250,
      "needs": {
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 5,
          "rankedProductIds": [
            "7591899856953",
            "7591731167289",
            "7591805255737",
            "7591805485113",
            "7591709147193"
          ],
          "rankedProductHandles": [
            "hikvision-ids-2cd8a66g0-xzhsy-8mp-outdoor-tandemvu-bullet-camera-colorvu-anpr-ip67-10-to-50-mm",
            "hikvision-ids-tcv907-bir-9-mp-anpr-all-rounder-traffic-camera",
            "hikvision-ids-2cd7a46g0-p-izhsy-4mp-anpr-bullet-camera-wiegand-output-26bit-h-265-ip67-ik10-2-8-12mm",
            "hikvision-ids-2cd7a46g0-p-izhsy-4mp-anpr-bullet-camera-wiegand-output-26bit-h-265-ip67-ik10-8mm-32mm",
            "hikvision-ids-tcm403-a-4mp-anpr-smart-surveillance-capture-unit"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 2,
          "rankedProductIds": [
            "7591794769977",
            "7591696498745"
          ],
          "rankedProductHandles": [
            "hikvision-ids-mcd202-b-ptz-2-mp-network-portable-ir-speed-dome-4g",
            "hikvision-ds-mh6171i-ptz-2mp-4-5-135mm-lens-size-60m-ir-6hrs-battery-4g-camera"
          ]
        }
      }
    },
    "hikvision-anpr-number-plate-recoginition-cameras-licenses": {
      "collectionHandle": "hikvision-anpr-number-plate-recoginition-cameras-licenses",
      "collectionProductCount": 14,
      "renderedProductLimit": 250,
      "needs": {
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 11,
          "rankedProductIds": [
            "8284541681721",
            "8168581890105",
            "8168618655801",
            "8168598143033",
            "8168599322681",
            "8168629108793",
            "8168618557497",
            "8168618491961",
            "8168602402873",
            "8168595783737",
            "8168618393657"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2st5c432mwg-e-26pa-4mp-32x-zoom-tandemvu-anti-corrosion-ptz-ip-camera-with-acusense-darkfighter-technology",
            "hikvision-anti-corrosion-ds-2xc6686g0-p-izhr-8mp-anpr-bullet-camera-vari-2-8-12mm-ir-60m",
            "hikvision-ids-2cd7a46g2-p-izhsy-4-mp-deepinview-anpr-bullet-camera-2-8-12-mm-varifocal-lens",
            "hikvision-ids-2cd7a45g2-p-izhsy-deepinview-4-mp-anpr-bullet-camera-anpr-25x-zoom-ik10-nema-4x",
            "ds-tcg406-e-5-mp-intelligent-entrance-anpr-camera",
            "hikvision-ids-2cd7347g0-p-xs-4-mp-deepinview-anpr-hybrid-light-turret-camera-fixed-4-mm",
            "hikvision-ids-2cd7a46g2-p-izhsy-4-mp-deepinview-anpr-bullet-camera-8-32-mm-variant",
            "hikvision-ids-2cd8a46g2-xzhsy-4-mp-dual-channel-deepinview-multi-sensor-bullet-camera-8-32-mm-lens-variant",
            "hikvision-ids-2cd7547g0-p-xzhsy-deepinview-4-mp-anpr-moto-varifocal-dome-camera-2-8-12-mm-darkfighters-wdr-ip67-ik10",
            "hikvision-ids-mcd402-e-4g-dual-lens-anpr-portable-speed-dome-with-36x-zoom-ai-detection",
            "hikvision-ids-mcd402-es-4g-dual-lens-anpr-portable-speed-dome-kit"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 3,
          "rankedProductIds": [
            "8284541681721",
            "8168595783737",
            "8168618393657"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2st5c432mwg-e-26pa-4mp-32x-zoom-tandemvu-anti-corrosion-ptz-ip-camera-with-acusense-darkfighter-technology",
            "hikvision-ids-mcd402-e-4g-dual-lens-anpr-portable-speed-dome-with-36x-zoom-ai-detection",
            "hikvision-ids-mcd402-es-4g-dual-lens-anpr-portable-speed-dome-kit"
          ]
        }
      }
    },
    "hikvision-body-cameras-1": {
      "collectionHandle": "hikvision-body-cameras-1",
      "collectionProductCount": 10,
      "renderedProductLimit": 250,
      "needs": {
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 2,
          "rankedProductIds": [
            "8284535160889",
            "7591709933625"
          ],
          "rankedProductHandles": [
            "hikvision-ds-mcw409-body-worn-camera-4g-wifi-rugged-evidence-recording-camera",
            "hikvision-ds-mh2111-32g-body-worn-camera-1080p-16mp-snapshots-mh2111"
          ]
        }
      }
    },
    "hikvision-bullet-cameras": {
      "collectionHandle": "hikvision-bullet-cameras",
      "collectionProductCount": 89,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 6,
          "rankedProductIds": [
            "7591701086265",
            "8324132470841",
            "8284598108217",
            "8284598009913",
            "7591646887993",
            "7591672840249"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd2685g1-izs-8mp-outdoor-motorised-vf-bullet-2-8-12mm-with-darkfighter",
            "hikvision-12mp-colorvu-deepinview-ai-turret-camera-with-smart-hybrid-light-motorised-varifocal-lens-audio",
            "hikvision-4mp-deepinview-ids-2cd7a46g2-v-xzhsy-bullet-camera-with-darkfighter-ai-perimeter-protection-2-8-12mm-motorised-varifocal-lens-ir-100m",
            "hikvision-ids-2cd7a45g2-izhsy-4mp-deepinview-moto-varifocal-bullet-camera-with-25x-zoom-darkfighter-2-0-200m-ir",
            "hikvision-ds-2cd5a26g0-izs-2mp-outdoor-darkfighter-bullet-camera-ir-140db-wdr-vca-60fps-2-8-12mm",
            "hikvision-ds-2cd6626b-izhr-2mp-anti-corrosion-outdoor-darkfighter-bullet-camera-ip67-2-8-12mm"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 11,
          "rankedProductIds": [
            "8168616165433",
            "8168616460345",
            "8168616362041",
            "8168554889273",
            "8324132470841",
            "8284598173753",
            "7591578763321",
            "8168581169209",
            "7591672840249",
            "7591585939513",
            "7591585579065"
          ],
          "rankedProductHandles": [
            "hikvision-6mp-mini-bullet-colorvu-3-0-strobe-audio-ds-2cd2067g3-li2uy-sl",
            "hikvision-8mp-acusense-black-mini-bullet-strobe-audio-ds-2cd2086g2h-i2u-sl-blk-black",
            "hikvision-8mp-acusense-mini-bullet-strobe-audio-ds-2cd2086g2h-i2u-sl",
            "hikvision-ds-2cd3686g3-lizsuy-sl-8mp-dual-illumination-strobe-light-and-audible-warning-motorized-varifocal-bullet-camera",
            "hikvision-12mp-colorvu-deepinview-ai-turret-camera-with-smart-hybrid-light-motorised-varifocal-lens-audio",
            "hikvision-4mp-deepinview-ids-2cd8a47g0-sc-zy-self-cleaning-bullet-camera-with-colorvu-2-8-12mm-motorised-varifocal-lens-smart-detection",
            "hikvision-ds-2cd4a25fwdiz-outdoor-bullet-camera",
            "hikvision-colorvu-2cd2t67g2p-lsu-sl-6mp-dual-lens-stobe-audio-bullet-camera2-8mm-mic",
            "hikvision-ds-2cd6626b-izhr-2mp-anti-corrosion-outdoor-darkfighter-bullet-camera-ip67-2-8-12mm",
            "hikvision-hik-2cd4626izhs2-2mp-outdoor-darkfighter-rugged-bullet-camera-70m-ir-2-8-12mm",
            "hikvision-hik-2cd4a25izhs2-2mp-lightfighter-bullet-cameras-2-8-12mm"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 16,
          "rankedProductIds": [
            "8168581890105",
            "7591731167289",
            "8168598143033",
            "8168599322681",
            "8168572518457",
            "8324132470841",
            "8168573435961",
            "8168616460345",
            "8168616362041",
            "7591772127289",
            "8284598173753",
            "8168554889273",
            "7591701086265",
            "8284597813305",
            "8168596373561",
            "7591620640825"
          ],
          "rankedProductHandles": [
            "hikvision-anti-corrosion-ds-2xc6686g0-p-izhr-8mp-anpr-bullet-camera-vari-2-8-12mm-ir-60m",
            "hikvision-ids-tcv907-bir-9-mp-anpr-all-rounder-traffic-camera",
            "hikvision-ids-2cd7a45g2-p-izhsy-deepinview-4-mp-anpr-bullet-camera-anpr-25x-zoom-ik10-nema-4x",
            "ds-tcg406-e-5-mp-intelligent-entrance-anpr-camera",
            "hikvision-ids-2cd7a45g0-p-izhsy-4-7-118mm-4mp-bullet-anpr-4-7-118mm-200m-ir-heater-nema-4x-60fps",
            "hikvision-12mp-colorvu-deepinview-ai-turret-camera-with-smart-hybrid-light-motorised-varifocal-lens-audio",
            "hikvision-ids-2cd7ac5g0-izhs-12mp-deepinview-moto-varifocal-bullet-camera",
            "hikvision-8mp-acusense-black-mini-bullet-strobe-audio-ds-2cd2086g2h-i2u-sl-blk-black",
            "hikvision-8mp-acusense-mini-bullet-strobe-audio-ds-2cd2086g2h-i2u-sl",
            "hikvision-ids-2cd7a86g0-izhs-4k-deepinview-moto-varifocal-bullet-camera",
            "hikvision-4mp-deepinview-ids-2cd8a47g0-sc-zy-self-cleaning-bullet-camera-with-colorvu-2-8-12mm-motorised-varifocal-lens-smart-detection",
            "hikvision-ds-2cd3686g3-lizsuy-sl-8mp-dual-illumination-strobe-light-and-audible-warning-motorized-varifocal-bullet-camera",
            "hikvision-ds-2cd2685g1-izs-8mp-outdoor-motorised-vf-bullet-2-8-12mm-with-darkfighter",
            "hikvision-ids-2cd5t87g2-v-xhsy-8mp-deepinviewx-fixed-bullet-camera-with-darkfighter-2-0-perimeter-protection",
            "hikvision-ds-2cd3a46g2t-izhs-4mp-acusense-varifocal-bullet-camera-with-deep-learning",
            "hikvision-hik-2cd2t85wdi54-8mp-outdoor-bullet-camera-h-265-50m-ir-120db-wdr-ip67-4mm"
          ]
        }
      }
    },
    "hikvision-camera-lenses-2": {
      "collectionHandle": "hikvision-camera-lenses-2",
      "collectionProductCount": 8,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "hikvision-cctv-camera-kits": {
      "collectionHandle": "hikvision-cctv-camera-kits",
      "collectionProductCount": 105,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 18,
          "rankedProductIds": [
            "7591977091129",
            "7591629520953",
            "7591918174265",
            "7591629750329",
            "8284564062265",
            "8284563669049",
            "8284589785145",
            "7591629389881",
            "7591865745465",
            "7591976304697",
            "7591976435769",
            "8168572715065",
            "7591918436409",
            "7591865942073",
            "7591865614393",
            "7591976927289",
            "7591918043193",
            "8284589916217"
          ],
          "rankedProductHandles": [
            "hikvision-6-cameras-8-channel-cctv-kit-2-x-8mp-colorvu-4-x-6mp-acusense-turret-cameras-8ch-8k-nvr-bundle",
            "8mp-8ch-hikvision-cctv-kit-6-x-outdoor-bullet-cameras-8ch-nvr",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-6-x-liveguard-cameras-8ch-m-series-nvr-3tb",
            "8mp-8ch-hikvision-cctv-kit-8-x-outdoor-bullet-cameras-8ch-nvr",
            "hikvision-6-camera-6mp-smart-hybrid-light-security-kit-with-ds-2cd2067g3-li2uy-sl-cameras-ds-7608ni-m2-8p-8-channel-8-poe-nvr-no-hdd",
            "hikvision-6mp-smart-hybrid-light-ds-2cd2067g3-li2uy-sl-4-camera-kit-with-ds-7604ni-m1-4p-4-channel-poe-nvr-no-hdd",
            "hikvision-10-camera-8mp-colorvu-3-0-ds-2cd2387g3-lis2uy-sl-smart-hybrid-light-turret-kit-with-ds-7616ni-m2-16p-16ch-poe-8k-nvr-strobe-speaker-no-hdd-included",
            "8mp-4ch-hikvision-cctv-kit-4-x-outdoor-bullet-cameras-4ch-nvr",
            "8mp-hikvision-colorvu-cctv-kit-6-x-outdoor-8mp-colorvu-turret-cameras-8ch-m-series-nvr-3tb-kit",
            "hikvision-4-x-6mp-strobe-light-two-way-audio-alarm-cameras-4-channel-nvr-cctv-kit-4-x-colorvu-turret-cameras-4ch-nvr-bundle",
            "hikvision-4-x-8mp-strobe-light-two-way-audio-alarm-cameras-8-channel-nvr-cctv-kit-4-x-colorvu-turret-cameras-8ch-8k-nvr-bundle",
            "8mp-hikvision-colorvu-3-0-hybrid-cctv-kit-4-x-liveguard-cameras-8ch-m-series-nvr-4tb",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-8-x-liveguard-cameras-8ch-m-series-nvr-3tb",
            "8mp-hikvision-colorvu-cctv-kit-8-x-colorvu-turret-liveguard-cameras-8ch-m-series-nvr-3tb",
            "8mp-hikvision-colorvu-cctv-kit-4-x-outdoor-8mp-colorvu-turret-cameras-8ch-m-series-nvr-3tb-kit",
            "hikvision-4-x-8mp-cameras-8-channel-nvr-cctv-kit-4-x-colorvu-turret-cameras-8ch-8k-nvr-bundle",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-4-x-liveguard-cameras-8ch-m-series-nvr-3tb",
            "hikvision-8mp-acusense-ds-2cd2t86g2-2i-bullet-10-camera-kit-with-ds-7616ni-m2-16p-16ch-poe-8k-nvr-50m-ir-no-hdd-included"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 18,
          "rankedProductIds": [
            "8284565897273",
            "7591976304697",
            "8284566224953",
            "7591976435769",
            "8284565569593",
            "8284566650937",
            "8284561047609",
            "8284565340217",
            "8284559015993",
            "8284558426169",
            "8284469624889",
            "8284560621625",
            "8284559900729",
            "8284589785145",
            "8284564455481",
            "8284564815929",
            "7591977091129",
            "7591720222777"
          ],
          "rankedProductHandles": [
            "hikvision-6-camera-8mp-acusense-security-kit-with-ds-7608ni-m2-8p-8ch-8-poe-8k-nvr-6x-ds-2cd2086g2h-i2u-sl-fixed-bullet-cameras-2-way-audio-active-strobe-light-4tb-hdd-included",
            "hikvision-4-x-6mp-strobe-light-two-way-audio-alarm-cameras-4-channel-nvr-cctv-kit-4-x-colorvu-turret-cameras-4ch-nvr-bundle",
            "hikvision-8-camera-8mp-acusense-security-kit-with-ds-7608ni-m2-8p-8ch-8-poe-8k-nvr-8x-ds-2cd2086g2h-i2u-sl-fixed-bullet-cameras-2-way-audio-active-strobe-light-no-hdd-included",
            "hikvision-4-x-8mp-strobe-light-two-way-audio-alarm-cameras-8-channel-nvr-cctv-kit-4-x-colorvu-turret-cameras-8ch-8k-nvr-bundle",
            "hikvision-4-camera-8mp-acusense-security-kit-with-ds-7604ni-m1-4p-4ch-poe-nvr-4x-ds-2cd2086g2h-i2u-sl-fixed-bullet-cameras-2-way-audio-active-strobe-light-no-hdd-included",
            "hikvision-10-camera-8mp-acusense-security-kit-with-ds-7616ni-m2-16p-16ch-16-poe-8k-nvr-10x-ds-2cd2086g2h-i2u-sl-fixed-bullet-cameras-2-way-audio-active-strobe-light-no-hdd-included",
            "hikvision-6mp-8ch-cctv-kit-6x-black-liveguard-acusense-turret-cameras-with-strobe-audio-smart-light-8ch-poe-nvr-4tb-ds-2cd2366g2h-is2u-sl-blk-ds-7608ni-m2-8p",
            "hikvision-10-camera-6mp-colorvu-security-kit-with-ds-7616ni-m2-16p-16ch-16-poe-8k-nvr-10x-ds-2cd2067g3-li2uy-sl-fixed-mini-bullet-cameras-dual-microphones-active-strobe-light-no-hdd-included",
            "hikvision-6mp-8ch-cctv-kit-6x-acusense-turret-cameras-with-strobe-audio-8ch-poe-nvr-with-4tb-hdd-ds-2cd2366g2h-is2u-sl-ds-7608ni-m2-8p",
            "hikvision-6mp-4ch-cctv-kit-4x-acusense-turret-cameras-with-strobe-audio-4ch-poe-nvr-without-hdd-ds-2cd2366g2h-is2u-sl-ds-7604ni-i1-4p",
            "hikvision-6mp-8ch-cctv-kit-8x-black-liveguard-acusense-turret-cameras-with-strobe-audio-smart-light-8ch-poe-nvr-4tb-ds-2cd2366g2h-is2u-sl-blk-ds-7608ni-m2-8p",
            "hikvision-6mp-8ch-cctv-kit-4x-black-liveguard-acusense-turret-cameras-with-strobe-audio-smart-light-4ch-poe-nvr-ds-2cd2366g2h-is2u-sl-blk-ds-7604ni-m1-4p",
            "hikvision-6mp-8ch-cctv-kit-8x-liveguard-acusense-cameras-with-strobe-audio-smart-light-8ch-poe-nvr-with-4tb-hdd-ds-2cd2366g2h-is2u-sl-ds-7608ni-m2-8p",
            "hikvision-10-camera-8mp-colorvu-3-0-ds-2cd2387g3-lis2uy-sl-smart-hybrid-light-turret-kit-with-ds-7616ni-m2-16p-16ch-poe-8k-nvr-strobe-speaker-no-hdd-included",
            "hikvision-6-camera-kit-6mp-colorvu-with-ds-7608ni-m2-8p-8ch-poe-nvr-6x-ds-2cd2067g3-li2uy-sl-mini-bullet-cameras-4tb-hdd-included",
            "hikvision-8-camera-kit-with-ds-7608ni-m2-8p-8ch-poe-8k-nvr-8x-6mp-colorvu-ds-2cd2067g3-li2uy-sl-mini-bullet-cameras-4tb-hdd-included",
            "hikvision-6-cameras-8-channel-cctv-kit-2-x-8mp-colorvu-4-x-6mp-acusense-turret-cameras-8ch-8k-nvr-bundle",
            "hikvision-8mp-acusense-8-x-outdoor-turret-with-strobe-siren-8ch-nvr-cctv-kit"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 18,
          "rankedProductIds": [
            "8284565897273",
            "7591918174265",
            "7591977418809",
            "7591977091129",
            "7591629520953",
            "7591977254969",
            "8168391802937",
            "7591918436409",
            "7591629750329",
            "8284566224953",
            "7591865745465",
            "7591621099577",
            "7591778025529",
            "8284565569593",
            "7591976435769",
            "8168572715065",
            "7591865942073",
            "7591629389881"
          ],
          "rankedProductHandles": [
            "hikvision-6-camera-8mp-acusense-security-kit-with-ds-7608ni-m2-8p-8ch-8-poe-8k-nvr-6x-ds-2cd2086g2h-i2u-sl-fixed-bullet-cameras-2-way-audio-active-strobe-light-4tb-hdd-included",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-6-x-liveguard-cameras-8ch-m-series-nvr-3tb",
            "hikvision-4-x-8mp-cameras-4ch-nvr-cctv-kit-4-acusense-turret-cameras-4ch-4k-nvr",
            "hikvision-6-cameras-8-channel-cctv-kit-2-x-8mp-colorvu-4-x-6mp-acusense-turret-cameras-8ch-8k-nvr-bundle",
            "8mp-8ch-hikvision-cctv-kit-6-x-outdoor-bullet-cameras-8ch-nvr",
            "hikvision-6-x-8mp-cameras-8-channel-nvr-cctv-kit-6-acusense-turret-cameras-8ch-8k-nvr-bundle",
            "8mp-8ch-hikvision-cctv-kit-8-x-outdoor-turret-cameras-8ch-nvr",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-8-x-liveguard-cameras-8ch-m-series-nvr-3tb",
            "8mp-8ch-hikvision-cctv-kit-8-x-outdoor-bullet-cameras-8ch-nvr",
            "hikvision-8-camera-8mp-acusense-security-kit-with-ds-7608ni-m2-8p-8ch-8-poe-8k-nvr-8x-ds-2cd2086g2h-i2u-sl-fixed-bullet-cameras-2-way-audio-active-strobe-light-no-hdd-included",
            "8mp-hikvision-colorvu-cctv-kit-6-x-outdoor-8mp-colorvu-turret-cameras-8ch-m-series-nvr-3tb-kit",
            "8mp-4ch-hikvision-cctv-kit-4-x-outdoor-turret-cameras-4ch-nvr",
            "8mp-8ch-hikvision-cctv-kit-8-x-outdoor-acusense-turret-cameras-16ch-nvr-with-3tb",
            "hikvision-4-camera-8mp-acusense-security-kit-with-ds-7604ni-m1-4p-4ch-poe-nvr-4x-ds-2cd2086g2h-i2u-sl-fixed-bullet-cameras-2-way-audio-active-strobe-light-no-hdd-included",
            "hikvision-4-x-8mp-strobe-light-two-way-audio-alarm-cameras-8-channel-nvr-cctv-kit-4-x-colorvu-turret-cameras-8ch-8k-nvr-bundle",
            "8mp-hikvision-colorvu-3-0-hybrid-cctv-kit-4-x-liveguard-cameras-8ch-m-series-nvr-4tb",
            "8mp-hikvision-colorvu-cctv-kit-8-x-colorvu-turret-liveguard-cameras-8ch-m-series-nvr-3tb",
            "8mp-4ch-hikvision-cctv-kit-4-x-outdoor-bullet-cameras-4ch-nvr"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 18,
          "rankedProductIds": [
            "8284589785145",
            "8284589654073",
            "8284567765049",
            "8324154130489",
            "8284589916217",
            "8284566650937",
            "8168391802937",
            "7591778025529",
            "7591629750329",
            "8284566224953",
            "8284589621305",
            "8284589883449",
            "8284589752377",
            "8284564815929",
            "8168575991865",
            "8284565897273",
            "8284566945849",
            "8284567339065"
          ],
          "rankedProductHandles": [
            "hikvision-10-camera-8mp-colorvu-3-0-ds-2cd2387g3-lis2uy-sl-smart-hybrid-light-turret-kit-with-ds-7616ni-m2-16p-16ch-poe-8k-nvr-strobe-speaker-no-hdd-included",
            "hikvision-10-camera-8mp-acusense-ds-2cd2386g2h-iu-turret-kit-with-ds-7616ni-m2-16p-16ch-poe-8k-nvr-no-hdd-included",
            "hikvision-10-camera-8mp-acusense-security-kit-with-ds-7616ni-m2-16p-16ch-16-poe-8k-nvr-10x-ds-2cd2186g2h-isu-fixed-turret-cameras-built-in-microphone-no-hdd-included",
            "hikvision-6mp-8ch-cctv-kit-8x-darkfighter-bullet-cameras-with-acusense-8ch-poe-nvr-with-no-hdd-ds-2cd2t66g2h-2i-ds-7608ni-m2-8p",
            "hikvision-8mp-acusense-ds-2cd2t86g2-2i-bullet-10-camera-kit-with-ds-7616ni-m2-16p-16ch-poe-8k-nvr-50m-ir-no-hdd-included",
            "hikvision-10-camera-8mp-acusense-security-kit-with-ds-7616ni-m2-16p-16ch-16-poe-8k-nvr-10x-ds-2cd2086g2h-i2u-sl-fixed-bullet-cameras-2-way-audio-active-strobe-light-no-hdd-included",
            "8mp-8ch-hikvision-cctv-kit-8-x-outdoor-turret-cameras-8ch-nvr",
            "8mp-8ch-hikvision-cctv-kit-8-x-outdoor-acusense-turret-cameras-16ch-nvr-with-3tb",
            "8mp-8ch-hikvision-cctv-kit-8-x-outdoor-bullet-cameras-8ch-nvr",
            "hikvision-8-camera-8mp-acusense-security-kit-with-ds-7608ni-m2-8p-8ch-8-poe-8k-nvr-8x-ds-2cd2086g2h-i2u-sl-fixed-bullet-cameras-2-way-audio-active-strobe-light-no-hdd-included",
            "hikvision-10-camera-6mp-colorvu-acusense-ds-2cd2367g3-lis2uy-srb-black-turret-kit-with-ds-7616ni-m2-16p-16ch-poe-8k-nvr-no-hdd",
            "hikvision-6mp-acusense-ds-2cd2t66g2h-2i-black-bullet-10-camera-kit-with-ds-7616ni-m2-16p-16ch-poe-8k-nvr-60m-ir-no-hdd-included",
            "hikvision-10-camera-8mp-acusense-active-deterrence-turret-kit-with-ds-7616ni-m2-16p-16ch-poe-8k-nvr-2-8mm-lens-ir-30m-no-hdd-included",
            "hikvision-8-camera-kit-with-ds-7608ni-m2-8p-8ch-poe-8k-nvr-8x-6mp-colorvu-ds-2cd2067g3-li2uy-sl-mini-bullet-cameras-4tb-hdd-included",
            "hikvision-6mp-colorvu-3-0-hybrid-cctv-kit-8-x-liveguard-cameras-8ch-m-series-nvr-4tb",
            "hikvision-6-camera-8mp-acusense-security-kit-with-ds-7608ni-m2-8p-8ch-8-poe-8k-nvr-6x-ds-2cd2086g2h-i2u-sl-fixed-bullet-cameras-2-way-audio-active-strobe-light-4tb-hdd-included",
            "hikvision-10-camera-6mp-acusense-security-kit-with-ds-7616ni-m2-16p-16ch-16-poe-8k-nvr-10x-ds-2cd2066g2h-iu-fixed-mini-bullet-cameras-built-in-microphone-no-hdd-included",
            "hikvision-10-camera-6mp-acusense-security-kit-with-ds-7616ni-m2-16p-16ch-16-poe-8k-nvr-10x-ds-2cd2166g2h-isu-fixed-turret-cameras-built-in-microphone-no-hdd-included"
          ]
        },
        "two-way-audio": {
          "displayName": "Two-way audio",
          "productCount": 6,
          "rankedProductIds": [
            "8284565897273",
            "8284566224953",
            "8284565569593",
            "7591976304697",
            "7591976435769",
            "8284566650937"
          ],
          "rankedProductHandles": [
            "hikvision-6-camera-8mp-acusense-security-kit-with-ds-7608ni-m2-8p-8ch-8-poe-8k-nvr-6x-ds-2cd2086g2h-i2u-sl-fixed-bullet-cameras-2-way-audio-active-strobe-light-4tb-hdd-included",
            "hikvision-8-camera-8mp-acusense-security-kit-with-ds-7608ni-m2-8p-8ch-8-poe-8k-nvr-8x-ds-2cd2086g2h-i2u-sl-fixed-bullet-cameras-2-way-audio-active-strobe-light-no-hdd-included",
            "hikvision-4-camera-8mp-acusense-security-kit-with-ds-7604ni-m1-4p-4ch-poe-nvr-4x-ds-2cd2086g2h-i2u-sl-fixed-bullet-cameras-2-way-audio-active-strobe-light-no-hdd-included",
            "hikvision-4-x-6mp-strobe-light-two-way-audio-alarm-cameras-4-channel-nvr-cctv-kit-4-x-colorvu-turret-cameras-4ch-nvr-bundle",
            "hikvision-4-x-8mp-strobe-light-two-way-audio-alarm-cameras-8-channel-nvr-cctv-kit-4-x-colorvu-turret-cameras-8ch-8k-nvr-bundle",
            "hikvision-10-camera-8mp-acusense-security-kit-with-ds-7616ni-m2-16p-16ch-16-poe-8k-nvr-10x-ds-2cd2086g2h-i2u-sl-fixed-bullet-cameras-2-way-audio-active-strobe-light-no-hdd-included"
          ]
        }
      }
    },
    "hikvision-colorvu-3-0-cameras": {
      "collectionHandle": "hikvision-colorvu-3-0-cameras",
      "collectionProductCount": 25,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 16,
          "rankedProductIds": [
            "8168595062841",
            "8168572649529",
            "8284579692601",
            "8168610955321",
            "8168622096441",
            "8168601190457",
            "8168599519289",
            "8168600961081",
            "8284554297401",
            "8168617017401",
            "8168621506617",
            "8168621244473",
            "8168614953017",
            "8168575565881",
            "8168589393977",
            "8168586870841"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd3687g3-lizsuy-sl-8mp-darkfighter-bullet-camera-with-dual-illumination-strobe-light-audio-alarm-2-7-13-5mm",
            "hikvision-ds-2cd2387g3-lis2uy-sl-8mp-4k-smart-hybrid-light-colorvu-3-0-turret-camera-with-strobe-speaker",
            "hikvision-ds-2cd2387g3-lis2uy-srb-8mp-4k-smart-hybrid-light-colorvu-3-0-turret-camera-red-blue-strobe-speaker",
            "hikvision-ds-2cd3h67g3-lizsuy-s-6mp-deep-learning-motorised-varifocal-turret-colorvu-3-0security-camera",
            "hikvision-ds-2cd3h87g3-lizsuy-sl-blk-8-mp-ultra-series-deep-learning-motorised-turret-camera-with-dual-illumination-varifocal-2-7-13-5-mm-ir-white-light-up-to-40-m-black",
            "hikvision-ds-2cd2t67g3-lis2uy-sl-6mp-colorvu-3-0-bullet-camera-white",
            "hikvision-ds-2cd3h87g3-lizsuy-sl-8-mp-ultra-series-deep-learning-turret-camera-with-dual-illumination",
            "hikvision-ds-2cd3787g3t-lizsuy-8-mp-dual-illumination-motorized-varifocal-dome-camera",
            "hikvision-ds-2cd3h86g3-lizsuy-sl-8mp-dual-illumination-motorised-turret-camera-with-strobe-siren",
            "hikvision-ds-2cd2187g3-lis2uy-blk-8mp-colorvu-3-0-gen-3-hybrid-dome-camera-black",
            "hikvision-ds-2cd3h66g3-lizsuy-sl-6mp-dual-illumination-turret-camera-with-strobe-light-audio-alarm-motorised-varifocal-2-7-13-5mm-ir-white-light-up-to-40m",
            "hikvision-ds-2cd3787g3t-lizsuy-blk-8mp-colorvu-3-0-dual-illumination-motorised-varifocal-dome-camera-black",
            "hikvision-ds-2cd2167g3-lis2uy-6mp-smart-hybrid-light-dome-2-8-mm-4-mm-lens-options",
            "hikvision-ds-2cd2367g3-lis2uy-sl-6mp-smart-hybrid-light-colorvu-3-0-turret-camera-with-strobe-speaker",
            "hikvision-ds-2cd2t87g3-lis2uy-sl-8mp-colorvu-3-0-bullet-camera-light-speaker-liveguard",
            "hikvision-ds-2cd2187g3-lis2uy-8mp-colorvu-3-0-hybrid-dome-camera"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 14,
          "rankedProductIds": [
            "8284579692601",
            "8168572649529",
            "8284554297401",
            "8168621506617",
            "8168610955321",
            "8168615444537",
            "8168601190457",
            "8168600338489",
            "8168615739449",
            "8168575565881",
            "8168595062841",
            "8168622096441",
            "8168617017401",
            "8168589393977"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd2387g3-lis2uy-srb-8mp-4k-smart-hybrid-light-colorvu-3-0-turret-camera-red-blue-strobe-speaker",
            "hikvision-ds-2cd2387g3-lis2uy-sl-8mp-4k-smart-hybrid-light-colorvu-3-0-turret-camera-with-strobe-speaker",
            "hikvision-ds-2cd3h86g3-lizsuy-sl-8mp-dual-illumination-motorised-turret-camera-with-strobe-siren",
            "hikvision-ds-2cd3h66g3-lizsuy-sl-6mp-dual-illumination-turret-camera-with-strobe-light-audio-alarm-motorised-varifocal-2-7-13-5mm-ir-white-light-up-to-40m",
            "hikvision-ds-2cd3h67g3-lizsuy-s-6mp-deep-learning-motorised-varifocal-turret-colorvu-3-0security-camera",
            "hikvision-ds-2cd2367g3-lis2uy-sl-6mp-colorvu-3-0-gen-3-turret-camera-with-strobe-speaker-black",
            "hikvision-ds-2cd2t67g3-lis2uy-sl-6mp-colorvu-3-0-bullet-camera-white",
            "hikvision-ds-2cd3667g3-lizsuy-sl-6mp-colorvu-varifocal-bullet-camera-smart-hybrid-light",
            "hikvision-ds-2cd2387g3-lis2uy-sl-8mp-colorvu-3-0-turret-camera-with-strobe-speaker-in-black",
            "hikvision-ds-2cd2367g3-lis2uy-sl-6mp-smart-hybrid-light-colorvu-3-0-turret-camera-with-strobe-speaker",
            "hikvision-ds-2cd3687g3-lizsuy-sl-8mp-darkfighter-bullet-camera-with-dual-illumination-strobe-light-audio-alarm-2-7-13-5mm",
            "hikvision-ds-2cd3h87g3-lizsuy-sl-blk-8-mp-ultra-series-deep-learning-motorised-turret-camera-with-dual-illumination-varifocal-2-7-13-5-mm-ir-white-light-up-to-40-m-black",
            "hikvision-ds-2cd2187g3-lis2uy-blk-8mp-colorvu-3-0-gen-3-hybrid-dome-camera-black",
            "hikvision-ds-2cd2t87g3-lis2uy-sl-8mp-colorvu-3-0-bullet-camera-light-speaker-liveguard"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 14,
          "rankedProductIds": [
            "8168622096441",
            "8284554297401",
            "8168621244473",
            "8168572649529",
            "8168599519289",
            "8168617017401",
            "8284579692601",
            "8168589393977",
            "8168621506617",
            "8168586870841",
            "8168586772537",
            "8168615739449",
            "8168610955321",
            "8168600338489"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd3h87g3-lizsuy-sl-blk-8-mp-ultra-series-deep-learning-motorised-turret-camera-with-dual-illumination-varifocal-2-7-13-5-mm-ir-white-light-up-to-40-m-black",
            "hikvision-ds-2cd3h86g3-lizsuy-sl-8mp-dual-illumination-motorised-turret-camera-with-strobe-siren",
            "hikvision-ds-2cd3787g3t-lizsuy-blk-8mp-colorvu-3-0-dual-illumination-motorised-varifocal-dome-camera-black",
            "hikvision-ds-2cd2387g3-lis2uy-sl-8mp-4k-smart-hybrid-light-colorvu-3-0-turret-camera-with-strobe-speaker",
            "hikvision-ds-2cd3h87g3-lizsuy-sl-8-mp-ultra-series-deep-learning-turret-camera-with-dual-illumination",
            "hikvision-ds-2cd2187g3-lis2uy-blk-8mp-colorvu-3-0-gen-3-hybrid-dome-camera-black",
            "hikvision-ds-2cd2387g3-lis2uy-srb-8mp-4k-smart-hybrid-light-colorvu-3-0-turret-camera-red-blue-strobe-speaker",
            "hikvision-ds-2cd2t87g3-lis2uy-sl-8mp-colorvu-3-0-bullet-camera-light-speaker-liveguard",
            "hikvision-ds-2cd3h66g3-lizsuy-sl-6mp-dual-illumination-turret-camera-with-strobe-light-audio-alarm-motorised-varifocal-2-7-13-5mm-ir-white-light-up-to-40m",
            "hikvision-ds-2cd2187g3-lis2uy-8mp-colorvu-3-0-hybrid-dome-camera",
            "hikvision-ds-2cd2087g3-li2uy-8mp-colorvu-3-0-hybrid-mini-bullet-camera",
            "hikvision-ds-2cd2387g3-lis2uy-sl-8mp-colorvu-3-0-turret-camera-with-strobe-speaker-in-black",
            "hikvision-ds-2cd3h67g3-lizsuy-s-6mp-deep-learning-motorised-varifocal-turret-colorvu-3-0security-camera",
            "hikvision-ds-2cd3667g3-lizsuy-sl-6mp-colorvu-varifocal-bullet-camera-smart-hybrid-light"
          ]
        }
      }
    },
    "hikvision-colorvu-full-colour-night-vision-cameras": {
      "collectionHandle": "hikvision-colorvu-full-colour-night-vision-cameras",
      "collectionProductCount": 83,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 16,
          "rankedProductIds": [
            "8168595062841",
            "8168600797241",
            "7591938981945",
            "7591926628409",
            "8168572649529",
            "8284579692601",
            "8168610955321",
            "7591841366073",
            "8168596406329",
            "7591899660345",
            "7591903199289",
            "7591844741177",
            "8168601190457",
            "7591903690809",
            "7591868989497",
            "8168451407929"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd3687g3-lizsuy-sl-8mp-darkfighter-bullet-camera-with-dual-illumination-strobe-light-audio-alarm-2-7-13-5mm",
            "hikvision-ds-2cd3687g3-lizsuy-sl-8mp-darkfighter-bullet-camera-colorvu-strobe-light-audio-alarm-2-7-13-5mm-black",
            "hikvision-ds-2cd2t67g2h-li-6mp-smart-hybrid-light-colorvu-bullet-camera-black",
            "hikvision-ds-2cd2087g2h-liu-sl-8mp-colorvu-mini-bullet-camera-hybrid-light-liveguard-2-8-4mm",
            "hikvision-ds-2cd2387g3-lis2uy-sl-8mp-4k-smart-hybrid-light-colorvu-3-0-turret-camera-with-strobe-speaker",
            "hikvision-ds-2cd2387g3-lis2uy-srb-8mp-4k-smart-hybrid-light-colorvu-3-0-turret-camera-red-blue-strobe-speaker",
            "hikvision-ds-2cd3h67g3-lizsuy-s-6mp-deep-learning-motorised-varifocal-turret-colorvu-3-0security-camera",
            "hikvision-ds-2se4c425mwg-e-14f0-4mp-tandemvu-colorvu-ptz",
            "hikvision-ds-2cd2h87g3-lizsy-8mp-smart-hybrid-light-colorvu-varifocal-turret-camera",
            "hikvision-ds-2cd2387g2h-liu-8mp-4k-smart-hybrid-light-colorvu-turret-camera-with-strobe-speaker",
            "hikvision-ds-2cd2667g2ht-6mp-smart-hybrid-light-colorvu-motorised-vf-bullet-camera-2-8-12-mm",
            "hikvision-ds-2de7a412mcg-eb-4mp-7-inch-4-mp-12x-colorvu-network-speed-dome",
            "hikvision-ds-2cd2t67g3-lis2uy-sl-6mp-colorvu-3-0-bullet-camera-white",
            "hikvision-ds-2cd2767g2ht-6mp-smart-hybrid-light-colorvu-motorised-vf-dome-camera-2-8-12mm",
            "hikvision-8mp-outdoor-colorvu-mini-bullet-camera-hybrid-light-mic-2-8mm",
            "hikvision-ds-2cd2067g2h-liu-sl-6mp-smart-hybrid-light-colorvu-mini-bullet-camera-2-8mm-4mm"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 16,
          "rankedProductIds": [
            "8284591226937",
            "8284579692601",
            "7591774912569",
            "7591855751225",
            "8168572649529",
            "8168610955321",
            "8168615444537",
            "8168601190457",
            "8168600338489",
            "7591905394745",
            "7591899660345",
            "8168575565881",
            "8168615739449",
            "8168600797241",
            "8168595062841",
            "7591903199289"
          ],
          "rankedProductHandles": [
            "hikvision-4mp-colorvu-ds-2xs3q47g1-ldh-4g-solar-powered-pt-camera-with-4g-two-way-audio-built-in-battery-solar-panel",
            "hikvision-ds-2cd2387g3-lis2uy-srb-8mp-4k-smart-hybrid-light-colorvu-3-0-turret-camera-red-blue-strobe-speaker",
            "hikvision-ds-2cd2347g2-lsu-sl-4mp-gen2-colorvu-turret-camera-acusense-speaker-strobe-mic-30m-white-led-2-8mm",
            "hikvision-ds-2cd2367g2p-lsu-sl-6mp-colorvu-turret-dual-head-strobe-speaker-network-camera",
            "hikvision-ds-2cd2387g3-lis2uy-sl-8mp-4k-smart-hybrid-light-colorvu-3-0-turret-camera-with-strobe-speaker",
            "hikvision-ds-2cd3h67g3-lizsuy-s-6mp-deep-learning-motorised-varifocal-turret-colorvu-3-0security-camera",
            "hikvision-ds-2cd2367g3-lis2uy-sl-6mp-colorvu-3-0-gen-3-turret-camera-with-strobe-speaker-black",
            "hikvision-ds-2cd2t67g3-lis2uy-sl-6mp-colorvu-3-0-bullet-camera-white",
            "hikvision-ds-2cd3667g3-lizsuy-sl-6mp-colorvu-varifocal-bullet-camera-smart-hybrid-light",
            "hikvision-ds-2cd2367g2h-lisu-sl-6mp-smart-hybrid-light-colorvu-turret-camera-2-8mm-strobe-speaker",
            "hikvision-ds-2cd2387g2h-liu-8mp-4k-smart-hybrid-light-colorvu-turret-camera-with-strobe-speaker",
            "hikvision-ds-2cd2367g3-lis2uy-sl-6mp-smart-hybrid-light-colorvu-3-0-turret-camera-with-strobe-speaker",
            "hikvision-ds-2cd2387g3-lis2uy-sl-8mp-colorvu-3-0-turret-camera-with-strobe-speaker-in-black",
            "hikvision-ds-2cd3687g3-lizsuy-sl-8mp-darkfighter-bullet-camera-colorvu-strobe-light-audio-alarm-2-7-13-5mm-black",
            "hikvision-ds-2cd3687g3-lizsuy-sl-8mp-darkfighter-bullet-camera-with-dual-illumination-strobe-light-audio-alarm-2-7-13-5mm",
            "hikvision-ds-2cd2667g2ht-6mp-smart-hybrid-light-colorvu-motorised-vf-bullet-camera-2-8-12-mm"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 16,
          "rankedProductIds": [
            "8168572649529",
            "8168621244473",
            "8168596406329",
            "8168626257977",
            "7591903199289",
            "8168617017401",
            "7591926628409",
            "8284579692601",
            "8284598173753",
            "8168589393977",
            "8168586772537",
            "8168586870841",
            "8284591226937",
            "7591899660345",
            "8168615739449",
            "7591858307129"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd2387g3-lis2uy-sl-8mp-4k-smart-hybrid-light-colorvu-3-0-turret-camera-with-strobe-speaker",
            "hikvision-ds-2cd3787g3t-lizsuy-blk-8mp-colorvu-3-0-dual-illumination-motorised-varifocal-dome-camera-black",
            "hikvision-ds-2cd2h87g3-lizsy-8mp-smart-hybrid-light-colorvu-varifocal-turret-camera",
            "hikvision-ds-2xc3386g0h-lisu-sl-pa-polymer-8mp-anti-corrosion-fixed-turret",
            "hikvision-ds-2cd2667g2ht-6mp-smart-hybrid-light-colorvu-motorised-vf-bullet-camera-2-8-12-mm",
            "hikvision-ds-2cd2187g3-lis2uy-blk-8mp-colorvu-3-0-gen-3-hybrid-dome-camera-black",
            "hikvision-ds-2cd2087g2h-liu-sl-8mp-colorvu-mini-bullet-camera-hybrid-light-liveguard-2-8-4mm",
            "hikvision-ds-2cd2387g3-lis2uy-srb-8mp-4k-smart-hybrid-light-colorvu-3-0-turret-camera-red-blue-strobe-speaker",
            "hikvision-4mp-deepinview-ids-2cd8a47g0-sc-zy-self-cleaning-bullet-camera-with-colorvu-2-8-12mm-motorised-varifocal-lens-smart-detection",
            "hikvision-ds-2cd2t87g3-lis2uy-sl-8mp-colorvu-3-0-bullet-camera-light-speaker-liveguard",
            "hikvision-ds-2cd2087g3-li2uy-8mp-colorvu-3-0-hybrid-mini-bullet-camera",
            "hikvision-ds-2cd2187g3-lis2uy-8mp-colorvu-3-0-hybrid-dome-camera",
            "hikvision-4mp-colorvu-ds-2xs3q47g1-ldh-4g-solar-powered-pt-camera-with-4g-two-way-audio-built-in-battery-solar-panel",
            "hikvision-ds-2cd2387g2h-liu-8mp-4k-smart-hybrid-light-colorvu-turret-camera-with-strobe-speaker",
            "hikvision-ds-2cd2387g3-lis2uy-sl-8mp-colorvu-3-0-turret-camera-with-strobe-speaker-in-black",
            "hikvision-4mp-tandemvu-ptz-camera-24-7-colour-180-deg-overview-42x-zoom"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 7,
          "rankedProductIds": [
            "7591841366073",
            "7591924039737",
            "7591858307129",
            "7745682243641",
            "8284591292473",
            "8284591226937",
            "7591734018105"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2se4c425mwg-e-14f0-4mp-tandemvu-colorvu-ptz",
            "hikvision-ds-2sf8c442mxg-elw-26-4mp-tandemvu-ptz-camera-24-7-colour-42x-zoom",
            "hikvision-4mp-tandemvu-ptz-camera-24-7-colour-180-deg-overview-42x-zoom",
            "hikvision-ds-2se4c425mwg-e-14f0-64mp-tandemvu-ir-panoramic-ptz",
            "hikvision-4mp-colorvu-ds-2xs3q47g1-ldwh-c18s40-b-solar-pt-camera-bundle-kit-with-sma-adapter-af003-100-waterproof-sealing-tape-two-way-audio",
            "hikvision-4mp-colorvu-ds-2xs3q47g1-ldh-4g-solar-powered-pt-camera-with-4g-two-way-audio-built-in-battery-solar-panel",
            "hikvision-ds-2de3a400bw-de-colorvu-4mp-outdoor-pan-tilt-network-dome-camera"
          ]
        },
        "two-way-audio": {
          "displayName": "Two-way audio",
          "productCount": 2,
          "rankedProductIds": [
            "8284591226937",
            "8284591292473"
          ],
          "rankedProductHandles": [
            "hikvision-4mp-colorvu-ds-2xs3q47g1-ldh-4g-solar-powered-pt-camera-with-4g-two-way-audio-built-in-battery-solar-panel",
            "hikvision-4mp-colorvu-ds-2xs3q47g1-ldwh-c18s40-b-solar-pt-camera-bundle-kit-with-sma-adapter-af003-100-waterproof-sealing-tape-two-way-audio"
          ]
        }
      }
    },
    "hikvision-colorvu-packages-1": {
      "collectionHandle": "hikvision-colorvu-packages-1",
      "collectionProductCount": 28,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 18,
          "rankedProductIds": [
            "7591977091129",
            "8284564062265",
            "8284563669049",
            "7591918174265",
            "8284589785145",
            "7591865745465",
            "7591976435769",
            "7591918436409",
            "8168572715065",
            "7591865942073",
            "7591976927289",
            "7591865614393",
            "8284554788921",
            "7591918043193",
            "8284554625081",
            "8168573075513",
            "8168572944441",
            "7591918600249"
          ],
          "rankedProductHandles": [
            "hikvision-6-cameras-8-channel-cctv-kit-2-x-8mp-colorvu-4-x-6mp-acusense-turret-cameras-8ch-8k-nvr-bundle",
            "hikvision-6-camera-6mp-smart-hybrid-light-security-kit-with-ds-2cd2067g3-li2uy-sl-cameras-ds-7608ni-m2-8p-8-channel-8-poe-nvr-no-hdd",
            "hikvision-6mp-smart-hybrid-light-ds-2cd2067g3-li2uy-sl-4-camera-kit-with-ds-7604ni-m1-4p-4-channel-poe-nvr-no-hdd",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-6-x-liveguard-cameras-8ch-m-series-nvr-3tb",
            "hikvision-10-camera-8mp-colorvu-3-0-ds-2cd2387g3-lis2uy-sl-smart-hybrid-light-turret-kit-with-ds-7616ni-m2-16p-16ch-poe-8k-nvr-strobe-speaker-no-hdd-included",
            "8mp-hikvision-colorvu-cctv-kit-6-x-outdoor-8mp-colorvu-turret-cameras-8ch-m-series-nvr-3tb-kit",
            "hikvision-4-x-8mp-strobe-light-two-way-audio-alarm-cameras-8-channel-nvr-cctv-kit-4-x-colorvu-turret-cameras-8ch-8k-nvr-bundle",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-8-x-liveguard-cameras-8ch-m-series-nvr-3tb",
            "8mp-hikvision-colorvu-3-0-hybrid-cctv-kit-4-x-liveguard-cameras-8ch-m-series-nvr-4tb",
            "8mp-hikvision-colorvu-cctv-kit-8-x-colorvu-turret-liveguard-cameras-8ch-m-series-nvr-3tb",
            "hikvision-4-x-8mp-cameras-8-channel-nvr-cctv-kit-4-x-colorvu-turret-cameras-8ch-8k-nvr-bundle",
            "8mp-hikvision-colorvu-cctv-kit-4-x-outdoor-8mp-colorvu-turret-cameras-8ch-m-series-nvr-3tb-kit",
            "hikvision-8mp-colorvu-3-0-hybrid-cctv-kit-2-x-liveguard-gen3-cameras-4ch-m-series-nvr",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-4-x-liveguard-cameras-8ch-m-series-nvr-3tb",
            "hikvision-8mp-colorvu-3-0-hybrid-cctv-kit-4-x-liveguard-gen-3-cameras-8ch-m-series-nvr-no-hdd",
            "8mp-hikvision-colorvu-3-0-hybrid-cctv-kit-8-x-liveguard-cameras-8ch-m-series-nvr-4tb",
            "8mp-hikvision-colorvu-3-0-hybrid-cctv-kit-6-x-liveguard-cameras-8ch-m-series-nvr-4tb",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-10-x-liveguard-cameras-16ch-m-series-nvr-3tb"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 16,
          "rankedProductIds": [
            "7591976435769",
            "8284565340217",
            "8284589785145",
            "8284564455481",
            "7591977091129",
            "8284563669049",
            "7591918174265",
            "7591865745465",
            "7591918436409",
            "8168572715065",
            "7591865942073",
            "7591976927289",
            "7591865614393",
            "7591825702969",
            "8284554788921",
            "7591918043193"
          ],
          "rankedProductHandles": [
            "hikvision-4-x-8mp-strobe-light-two-way-audio-alarm-cameras-8-channel-nvr-cctv-kit-4-x-colorvu-turret-cameras-8ch-8k-nvr-bundle",
            "hikvision-10-camera-6mp-colorvu-security-kit-with-ds-7616ni-m2-16p-16ch-16-poe-8k-nvr-10x-ds-2cd2067g3-li2uy-sl-fixed-mini-bullet-cameras-dual-microphones-active-strobe-light-no-hdd-included",
            "hikvision-10-camera-8mp-colorvu-3-0-ds-2cd2387g3-lis2uy-sl-smart-hybrid-light-turret-kit-with-ds-7616ni-m2-16p-16ch-poe-8k-nvr-strobe-speaker-no-hdd-included",
            "hikvision-6-camera-kit-6mp-colorvu-with-ds-7608ni-m2-8p-8ch-poe-nvr-6x-ds-2cd2067g3-li2uy-sl-mini-bullet-cameras-4tb-hdd-included",
            "hikvision-6-cameras-8-channel-cctv-kit-2-x-8mp-colorvu-4-x-6mp-acusense-turret-cameras-8ch-8k-nvr-bundle",
            "hikvision-6mp-smart-hybrid-light-ds-2cd2067g3-li2uy-sl-4-camera-kit-with-ds-7604ni-m1-4p-4-channel-poe-nvr-no-hdd",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-6-x-liveguard-cameras-8ch-m-series-nvr-3tb",
            "8mp-hikvision-colorvu-cctv-kit-6-x-outdoor-8mp-colorvu-turret-cameras-8ch-m-series-nvr-3tb-kit",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-8-x-liveguard-cameras-8ch-m-series-nvr-3tb",
            "8mp-hikvision-colorvu-3-0-hybrid-cctv-kit-4-x-liveguard-cameras-8ch-m-series-nvr-4tb",
            "8mp-hikvision-colorvu-cctv-kit-8-x-colorvu-turret-liveguard-cameras-8ch-m-series-nvr-3tb",
            "hikvision-4-x-8mp-cameras-8-channel-nvr-cctv-kit-4-x-colorvu-turret-cameras-8ch-8k-nvr-bundle",
            "8mp-hikvision-colorvu-cctv-kit-4-x-outdoor-8mp-colorvu-turret-cameras-8ch-m-series-nvr-3tb-kit",
            "4mp-hikvision-colorvu-cctv-kit-4-x-outdoor-colorvu-liveguard-turret-cameras-with-acusense-4ch-nvr-kit",
            "hikvision-8mp-colorvu-3-0-hybrid-cctv-kit-2-x-liveguard-gen3-cameras-4ch-m-series-nvr",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-4-x-liveguard-cameras-8ch-m-series-nvr-3tb"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 16,
          "rankedProductIds": [
            "7591977091129",
            "7591918174265",
            "7591918436409",
            "7591865745465",
            "7591976435769",
            "8168572715065",
            "7591865942073",
            "7591976927289",
            "7591865614393",
            "8284554788921",
            "7591918043193",
            "8284589785145",
            "8284554625081",
            "8168573075513",
            "8168572944441",
            "7591918600249"
          ],
          "rankedProductHandles": [
            "hikvision-6-cameras-8-channel-cctv-kit-2-x-8mp-colorvu-4-x-6mp-acusense-turret-cameras-8ch-8k-nvr-bundle",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-6-x-liveguard-cameras-8ch-m-series-nvr-3tb",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-8-x-liveguard-cameras-8ch-m-series-nvr-3tb",
            "8mp-hikvision-colorvu-cctv-kit-6-x-outdoor-8mp-colorvu-turret-cameras-8ch-m-series-nvr-3tb-kit",
            "hikvision-4-x-8mp-strobe-light-two-way-audio-alarm-cameras-8-channel-nvr-cctv-kit-4-x-colorvu-turret-cameras-8ch-8k-nvr-bundle",
            "8mp-hikvision-colorvu-3-0-hybrid-cctv-kit-4-x-liveguard-cameras-8ch-m-series-nvr-4tb",
            "8mp-hikvision-colorvu-cctv-kit-8-x-colorvu-turret-liveguard-cameras-8ch-m-series-nvr-3tb",
            "hikvision-4-x-8mp-cameras-8-channel-nvr-cctv-kit-4-x-colorvu-turret-cameras-8ch-8k-nvr-bundle",
            "8mp-hikvision-colorvu-cctv-kit-4-x-outdoor-8mp-colorvu-turret-cameras-8ch-m-series-nvr-3tb-kit",
            "hikvision-8mp-colorvu-3-0-hybrid-cctv-kit-2-x-liveguard-gen3-cameras-4ch-m-series-nvr",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-4-x-liveguard-cameras-8ch-m-series-nvr-3tb",
            "hikvision-10-camera-8mp-colorvu-3-0-ds-2cd2387g3-lis2uy-sl-smart-hybrid-light-turret-kit-with-ds-7616ni-m2-16p-16ch-poe-8k-nvr-strobe-speaker-no-hdd-included",
            "hikvision-8mp-colorvu-3-0-hybrid-cctv-kit-4-x-liveguard-gen-3-cameras-8ch-m-series-nvr-no-hdd",
            "8mp-hikvision-colorvu-3-0-hybrid-cctv-kit-8-x-liveguard-cameras-8ch-m-series-nvr-4tb",
            "8mp-hikvision-colorvu-3-0-hybrid-cctv-kit-6-x-liveguard-cameras-8ch-m-series-nvr-4tb",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-10-x-liveguard-cameras-16ch-m-series-nvr-3tb"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 10,
          "rankedProductIds": [
            "8284589785145",
            "8284589621305",
            "8168575991865",
            "8284565340217",
            "7591918436409",
            "7591865942073",
            "7591977091129",
            "7591918600249",
            "7591918174265",
            "7591865745465"
          ],
          "rankedProductHandles": [
            "hikvision-10-camera-8mp-colorvu-3-0-ds-2cd2387g3-lis2uy-sl-smart-hybrid-light-turret-kit-with-ds-7616ni-m2-16p-16ch-poe-8k-nvr-strobe-speaker-no-hdd-included",
            "hikvision-10-camera-6mp-colorvu-acusense-ds-2cd2367g3-lis2uy-srb-black-turret-kit-with-ds-7616ni-m2-16p-16ch-poe-8k-nvr-no-hdd",
            "hikvision-6mp-colorvu-3-0-hybrid-cctv-kit-8-x-liveguard-cameras-8ch-m-series-nvr-4tb",
            "hikvision-10-camera-6mp-colorvu-security-kit-with-ds-7616ni-m2-16p-16ch-16-poe-8k-nvr-10x-ds-2cd2067g3-li2uy-sl-fixed-mini-bullet-cameras-dual-microphones-active-strobe-light-no-hdd-included",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-8-x-liveguard-cameras-8ch-m-series-nvr-3tb",
            "8mp-hikvision-colorvu-cctv-kit-8-x-colorvu-turret-liveguard-cameras-8ch-m-series-nvr-3tb",
            "hikvision-6-cameras-8-channel-cctv-kit-2-x-8mp-colorvu-4-x-6mp-acusense-turret-cameras-8ch-8k-nvr-bundle",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-10-x-liveguard-cameras-16ch-m-series-nvr-3tb",
            "8mp-hikvision-colorvu-hybrid-cctv-kit-6-x-liveguard-cameras-8ch-m-series-nvr-3tb",
            "8mp-hikvision-colorvu-cctv-kit-6-x-outdoor-8mp-colorvu-turret-cameras-8ch-m-series-nvr-3tb-kit"
          ]
        }
      }
    },
    "hikvision-corrosion-resistant-cameras-1": {
      "collectionHandle": "hikvision-corrosion-resistant-cameras-1",
      "collectionProductCount": 35,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 6,
          "rankedProductIds": [
            "8168515141689",
            "7745682407481",
            "8168626257977",
            "7690800627769",
            "7591672840249",
            "7591608909881"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2dt8c442mxg-lwt-4mp-ptz-dome-camera-with-42x-zoom-anti-corrosion-polymer-hybrid-light-ir-500m-36v-dc-ip67",
            "hikvision-ds-2dt8c442mxg-lwt-4mp-ptz-dome-camera-anti-corrosion-polymer-hybrid-light-42x-zoom-36-vdc",
            "hikvision-ds-2xc3386g0h-lisu-sl-pa-polymer-8mp-anti-corrosion-fixed-turret",
            "hikvision-ds-2xc6047g0-ls-4mp-outdoor-colorvu-bullet-camera-anti-corrosion-polymer-ip68-4mm",
            "hikvision-ds-2cd6626b-izhr-2mp-anti-corrosion-outdoor-darkfighter-bullet-camera-ip67-2-8-12mm",
            "hikvision-2mp-anti-corrosion-outdoor-darkfighter-bullet-camera-ip67-2-8-12mm"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 3,
          "rankedProductIds": [
            "8168554889273",
            "8168622555193",
            "7591672840249"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd3686g3-lizsuy-sl-8mp-dual-illumination-strobe-light-and-audible-warning-motorized-varifocal-bullet-camera",
            "hikvision-ds-2xc3646g0h-lizsupa-anti-corrosion-vari-focal-bullet-camera-2-7-13-5mm",
            "hikvision-ds-2cd6626b-izhr-2mp-anti-corrosion-outdoor-darkfighter-bullet-camera-ip67-2-8-12mm"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 6,
          "rankedProductIds": [
            "8168581890105",
            "8284541681721",
            "8168573435961",
            "8168626257977",
            "8168554889273",
            "7745682407481"
          ],
          "rankedProductHandles": [
            "hikvision-anti-corrosion-ds-2xc6686g0-p-izhr-8mp-anpr-bullet-camera-vari-2-8-12mm-ir-60m",
            "hikvision-ds-2st5c432mwg-e-26pa-4mp-32x-zoom-tandemvu-anti-corrosion-ptz-ip-camera-with-acusense-darkfighter-technology",
            "hikvision-ids-2cd7ac5g0-izhs-12mp-deepinview-moto-varifocal-bullet-camera",
            "hikvision-ds-2xc3386g0h-lisu-sl-pa-polymer-8mp-anti-corrosion-fixed-turret",
            "hikvision-ds-2cd3686g3-lizsuy-sl-8mp-dual-illumination-strobe-light-and-audible-warning-motorized-varifocal-bullet-camera",
            "hikvision-ds-2dt8c442mxg-lwt-4mp-ptz-dome-camera-anti-corrosion-polymer-hybrid-light-42x-zoom-36-vdc"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 7,
          "rankedProductIds": [
            "8168515141689",
            "8168597520441",
            "7745682407481",
            "8284541681721",
            "7591606485049",
            "8168599683129",
            "7591881572409"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2dt8c442mxg-lwt-4mp-ptz-dome-camera-with-42x-zoom-anti-corrosion-polymer-hybrid-light-ir-500m-36v-dc-ip67",
            "hikvision-ds-2xc6685g0d-316l-stainless-steel-8-mp-anti-corrosion-bullet-camera",
            "hikvision-ds-2dt8c442mxg-lwt-4mp-ptz-dome-camera-anti-corrosion-polymer-hybrid-light-42x-zoom-36-vdc",
            "hikvision-ds-2st5c432mwg-e-26pa-4mp-32x-zoom-tandemvu-anti-corrosion-ptz-ip-camera-with-acusense-darkfighter-technology",
            "hikvision-hik-2df6223-cxw-2mp-explosion-proof-ptz-camera-23x-optical-zoom-ip68-hi-poe",
            "hikvision-ds-2df3c400scg-d-4g-wl15f1-4-mp-water-level-flood-detection-ptz-dome",
            "hikvision-ds-2dt6232x-aelyt5-6-inch-32x-anti-corrosion-network-speed-dome"
          ]
        }
      }
    },
    "hikvision-darkfighter-cameras": {
      "collectionHandle": "hikvision-darkfighter-cameras",
      "collectionProductCount": 134,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 16,
          "rankedProductIds": [
            "8168620884025",
            "8284591095865",
            "8168595062841",
            "8168624029753",
            "7591729528889",
            "7591717306425",
            "8284598108217",
            "8284598009913",
            "8168603680825",
            "7591646887993",
            "7591672840249",
            "7591658881081",
            "7591608909881",
            "7591607238713",
            "7591607074873",
            "8168627077177"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd3686g2ht-lizsy-8mp-smart-hybrid-motorised-bullet-camera-with-darkfighter-varifocal-2-7-13-5mm-ir-60m",
            "hikvision-6mp-8mp-tandemvu-ultra-ds-2sf8c848mxg1-elwy-26-ptz-camera-with-colorvu-26x-optical-zoom-ir-500m",
            "hikvision-ds-2cd3687g3-lizsuy-sl-8mp-darkfighter-bullet-camera-with-dual-illumination-strobe-light-audio-alarm-2-7-13-5mm",
            "hikvision-ds-2df8c435mhs-delw-4mp-35x-darkfighterx-ptz-camera-dual-sensor-ir-300m-ip67-ik10",
            "hikvision-ds-2df8225ih-ael-2mp-outdoor-darkfighter-x-ptz-25x-zoom",
            "hikvision-ds-2df9c435ihs-dlwt2-4mp-outdoor-darkfighter-x-ptz-camera-35x-zoom-500m-ir-ip67-ik10",
            "hikvision-4mp-deepinview-ids-2cd7a46g2-v-xzhsy-bullet-camera-with-darkfighter-ai-perimeter-protection-2-8-12mm-motorised-varifocal-lens-ir-100m",
            "hikvision-ids-2cd7a45g2-izhsy-4mp-deepinview-moto-varifocal-bullet-camera-with-25x-zoom-darkfighter-2-0-200m-ir",
            "hikvision-ds-2cd2t86g2h-is2u-sl-8mp-white-bullet-camera-2-8mm-60m-ir-acusense-strobe-audible-alarm",
            "hikvision-ds-2cd5a26g0-izs-2mp-outdoor-darkfighter-bullet-camera-ir-140db-wdr-vca-60fps-2-8-12mm",
            "hikvision-ds-2cd6626b-izhr-2mp-anti-corrosion-outdoor-darkfighter-bullet-camera-ip67-2-8-12mm",
            "hikvision-ds-2df8236ix-ael-2mp-outdoor-darkfighter-ptz-camera-wdr-36x-zoom-200m-ir-hipoe",
            "hikvision-2mp-anti-corrosion-outdoor-darkfighter-bullet-camera-ip67-2-8-12mm",
            "hikvision-hik-2df8236iaelw-2mp-outdoor-darkfighter-ptz-camera-wdr-36x-zoom-200m-ir-hipoewiper",
            "hikvision-hik-2df8223iaelw-2mp-outdoor-darkfighter-ptz-camera-wdr-23x-zoom-200m-ir-hipoe-wiper",
            "hikvision-ds-2dv6c425mxg-elwy-4mp-25x-optical-ptz-speed-dome-camera-darkfighter-low-light-200m-ir-ip67"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 16,
          "rankedProductIds": [
            "7591807221817",
            "8168402780217",
            "8284541976633",
            "8168598765625",
            "8168417591353",
            "8168404942905",
            "7591807451193",
            "7591719469113",
            "7591719370809",
            "7591688732729",
            "7591719796793",
            "7591688896569",
            "8168603680825",
            "7591716487225",
            "7591716651065",
            "7591716159545"
          ],
          "rankedProductHandles": [
            "hikvision-acusense-ds-2cd2386g2-isu-sl-ip-camera-8mp-4k-with-sound-strobe-turret-camera-black",
            "hikvision-8mp-acusense-ds-2cd2386g2-isu-sl-ip-turret-camera-4k-with-strobe-audio-fixed-turret-network-camera",
            "hikvision-ptz-nd4404-slaus-dual-lens-4mp4mp-ptz-ip-camera-with-4x-optical-zoom-darkfighter-low-light-active-strobe-audio-alarm",
            "hikvision-ds-2cd2386g2h-is2u-sl-8-mp-acusense-turret-camera-with-strobe-light-audio-and-smart-detection",
            "hikvision-acusense-ds-2cd2t66g2-izsu-sl-ip-camera-6mp-with-audible-warning-strobe-bullet-network-camera",
            "hikvision-ds-2cd2066g2h-i2u-sl-6mp-outdoor-acusense-mini-bullet-camera-mic-ir-strobe-audio-alarm-2-8mm",
            "hikvision-acusense-ds-2cd2t66g2-isu-sl-ip-camera-6mp-with-audible-warning-strobe-bullet-network-camera",
            "hikvision-ds-2cd2066g2-iu-sl-6mp-outdoor-acusense-gen-2-mini-bullet-camera-mic-ir-strobe-audio-alarm-2-8mm",
            "hikvision-ds-2cd2066g2-iu-sl-6mp-outdoor-acusense-gen-2-mini-bullet-camera-mic-ir-strobe-audio-alarm-4mm",
            "hikvision-accusense-ds-2cd2346g1-sl-ip-camera-4mp-2-8mm-lens-inbuilt-audio-speaker-strobe",
            "hikvision-acusense-ds-2cd2t46g2-isu-sl-ip-bullet-camera-4mp-2-8mm-lens-inbuilt-audio-speaker-strobe",
            "hikvision-accusense-ds-2cd2t46g1-4i-sl-ip-bullet-camera-4mp-2-8mm-lens-inbuilt-audio-speaker-strobe",
            "hikvision-ds-2cd2t86g2h-is2u-sl-8mp-white-bullet-camera-2-8mm-60m-ir-acusense-strobe-audible-alarm",
            "hikvision-acusense-ds-2cd2t86g2-isu-sl-ip-camera-8mp-4k-with-audible-warning-strobe-bullet-network-camera",
            "hikvision-acusense-ds-2cd2686g2-izsu-sl-ip-camera-8mp-4k-with-audible-warning-strobe-varifocal-bullet-camera",
            "hikvision-acusense-ds-2cd2386g2-isu-sl-ip-camera-8-mp-ir-fixed-turret-network-camera"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 16,
          "rankedProductIds": [
            "8284541681721",
            "8168595783737",
            "8168618393657",
            "8168599879737",
            "7591807221817",
            "8168620884025",
            "8284597977145",
            "7591726514233",
            "8168604237881",
            "7591772127289",
            "7591844577337",
            "7591716651065",
            "8168572223545",
            "8284597813305",
            "8284598829113",
            "8284597747769"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2st5c432mwg-e-26pa-4mp-32x-zoom-tandemvu-anti-corrosion-ptz-ip-camera-with-acusense-darkfighter-technology",
            "hikvision-ids-mcd402-e-4g-dual-lens-anpr-portable-speed-dome-with-36x-zoom-ai-detection",
            "hikvision-ids-mcd402-es-4g-dual-lens-anpr-portable-speed-dome-kit",
            "hikvision-ds-2cd2386g2h-iu-8mp-4k-acusense-turret-network-camera-with-mic",
            "hikvision-acusense-ds-2cd2386g2-isu-sl-ip-camera-8mp-4k-with-sound-strobe-turret-camera-black",
            "hikvision-ds-2cd3686g2ht-lizsy-8mp-smart-hybrid-motorised-bullet-camera-with-darkfighter-varifocal-2-7-13-5mm-ir-60m",
            "hikvision-ids-2cd7186g2-izhsy-8mp-deepinview-moto-varifocal-dome-camera-with-8-32mm-lens",
            "hikvision-acusense-ds-2cd2686g2t-izs-ip-camera-8mp-4k-varifocal-bullet-camera",
            "hikvision-ids-2cd7586g2-xzhsy-8mp-deepinview-ptrz-motorized-varifocal-dome-darkfighter-2-0-ip67-ik10",
            "hikvision-ids-2cd7a86g0-izhs-4k-deepinview-moto-varifocal-bullet-camera",
            "hikvision-ds-2de4a425iwg-e-4mp-outdoor-ptz-camera-25x-zoom-50m-ir-with-ai-tracking",
            "hikvision-acusense-ds-2cd2686g2-izsu-sl-ip-camera-8mp-4k-with-audible-warning-strobe-varifocal-bullet-camera",
            "hikvision-ids-2cd7186g0-izhsy-8mp-deepinview-moto-varifocal-dome-camera",
            "hikvision-ids-2cd5t87g2-v-xhsy-8mp-deepinviewx-fixed-bullet-camera-with-darkfighter-2-0-perimeter-protection",
            "hikvision-16mp-panoramic-ds-2cd6944g1-ihs-uy-turret-camera-with-180-stitched-view-2-8mm-fixed-lens-ir-20m",
            "hikvision-ids-2cd5387g2-v-xs-8mp-deepinviewx-fixed-turret-camera-with-darkfighter-2-0-human-vehicle-detection-ip67-weather-protection"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 16,
          "rankedProductIds": [
            "8168624029753",
            "7591729528889",
            "7591717306425",
            "7591769899065",
            "7591807221817",
            "7591607631929",
            "7591794769977",
            "7745682604089",
            "7591866892345",
            "7591721828409",
            "7591642660921",
            "8284591095865",
            "7591793262649",
            "7591658881081",
            "7591607238713",
            "7591607074873"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2df8c435mhs-delw-4mp-35x-darkfighterx-ptz-camera-dual-sensor-ir-300m-ip67-ik10",
            "hikvision-ds-2df8225ih-ael-2mp-outdoor-darkfighter-x-ptz-25x-zoom",
            "hikvision-ds-2df9c435ihs-dlwt2-4mp-outdoor-darkfighter-x-ptz-camera-35x-zoom-500m-ir-ip67-ik10",
            "hikvision-ds-2se7c124iw-ae32x-4s5-outdoor-smart-linkage-ptz-camera-acusense-32x-zoom-ip66-ik10-hi-poe",
            "hikvision-acusense-ds-2cd2386g2-isu-sl-ip-camera-8mp-4k-with-sound-strobe-turret-camera-black",
            "hikvision-ds-2df8436ix-ael-4mp-outdoor-hfr-ptz-camera-wdr-36x-zoom-wiper-ip66-200m-ir-hipoe",
            "hikvision-ids-mcd202-b-ptz-2-mp-network-portable-ir-speed-dome-4g",
            "hikvision-ds-2se7c432mwg-eb-26-6mp4mp-tandemvu-outdoor-ptz-camera-acusense-32x-zoom",
            "hikvision-acusense-ptz-4mp-6-252mm-42x-optical-16-x-digital-400m-ir-ip67-face-capture-white",
            "hikvision-ds-2df8442ixs-ael-4mp-outdoor-hfr-ptz-camera-wdr-42x-zoom-ip67-500m-ir-hipoe",
            "hikvision-ds-2xc6224g0-l-2mp-underwater-network-camera",
            "hikvision-6mp-8mp-tandemvu-ultra-ds-2sf8c848mxg1-elwy-26-ptz-camera-with-colorvu-26x-optical-zoom-ir-500m",
            "hikvision-ds-2df6a436x-ael-ptz-8mp42x-ip676-252mm500m-ir-vehicle-human-tracking",
            "hikvision-ds-2df8236ix-ael-2mp-outdoor-darkfighter-ptz-camera-wdr-36x-zoom-200m-ir-hipoe",
            "hikvision-hik-2df8236iaelw-2mp-outdoor-darkfighter-ptz-camera-wdr-36x-zoom-200m-ir-hipoewiper",
            "hikvision-hik-2df8223iaelw-2mp-outdoor-darkfighter-ptz-camera-wdr-23x-zoom-200m-ir-hipoe-wiper"
          ]
        }
      }
    },
    "hikvision-dash-amp-mobile-vehicle-cameras": {
      "collectionHandle": "hikvision-dash-amp-mobile-vehicle-cameras",
      "collectionProductCount": 8,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "hikvision-deepinview-cameras-1": {
      "collectionHandle": "hikvision-deepinview-cameras-1",
      "collectionProductCount": 72,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 5,
          "rankedProductIds": [
            "8284598108217",
            "8284598009913",
            "7591839760441",
            "7591899856953",
            "7591783858233"
          ],
          "rankedProductHandles": [
            "hikvision-4mp-deepinview-ids-2cd7a46g2-v-xzhsy-bullet-camera-with-darkfighter-ai-perimeter-protection-2-8-12mm-motorised-varifocal-lens-ir-100m",
            "hikvision-ids-2cd7a45g2-izhsy-4mp-deepinview-moto-varifocal-bullet-camera-with-25x-zoom-darkfighter-2-0-200m-ir",
            "hikvision-ds-2xs6a87g1-l-c32s80-4k-colorvu-fixed-bullet-solar-power-4g-network-camera-no-battery-2",
            "hikvision-ids-2cd8a66g0-xzhsy-8mp-outdoor-tandemvu-bullet-camera-colorvu-anpr-ip67-10-to-50-mm",
            "hikvision-ds-2xs6a87g1-l-c32s80-4k-colorvu-fixed-bullet-solar-power-4g-network-camera-no-battery"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 16,
          "rankedProductIds": [
            "8284598173753",
            "7591839760441",
            "7591665598521",
            "7591783858233",
            "7591715962937",
            "7591817052217",
            "7591859585081",
            "8168599715897",
            "7591696039993",
            "7591776387129",
            "8168581595193",
            "7591828848697",
            "7591806304313",
            "7591776223289",
            "7591715864633",
            "7591715700793"
          ],
          "rankedProductHandles": [
            "hikvision-4mp-deepinview-ids-2cd8a47g0-sc-zy-self-cleaning-bullet-camera-with-colorvu-2-8-12mm-motorised-varifocal-lens-smart-detection",
            "hikvision-ds-2xs6a87g1-l-c32s80-4k-colorvu-fixed-bullet-solar-power-4g-network-camera-no-battery-2",
            "hikvision-ids-2cd8426g0-f-deepinview-dual-lens-face-recognition-camera",
            "hikvision-ds-2xs6a87g1-l-c32s80-4k-colorvu-fixed-bullet-solar-power-4g-network-camera-no-battery",
            "hikvision-ds-2td2117-10-pa-deepinview-thermal-bullet-camera-ip66-160x120-25fps-10mm",
            "hikvision-ds-2td4228-10-w",
            "hikvision-ds-2tx3636-25a-v1-thermal-smart-linkage-tracking-system",
            "hikvision-hm-td95c8-150ze4fl-w-thermal-optical-bi-spectrum-sphere-ptz-camera-with-smart-analytics",
            "hikvision-ds-2cd7a26g0-izhs-2mp-outdoor-deepinview-bullet-camera-face-recognition-heater-8-32mm",
            "hikvision-ds-2td1217-6-pa-heatpro-turret-6-2mm",
            "hikvision-heat-pro-2td1228t-2-4mp-bi-spectrum-fire-smoke-turret-camera-2-1mm-2-2mm-ir-15m",
            "hikvision-ds-2td1217-6-v1-thermal-optical-network-turret-camera-6mm",
            "hikvision-ds-2td2617-10-qa-thermal-heatpro-cameras-dual-lens-10mm",
            "hikvision-ds-2td1217-2-pa-heatpro-turret-2mm",
            "hikvision-ds-2td2117-6v1-deepinview-thermal-bullet-camera-ip66-160x120-25fps-6mm",
            "hikvision-ds-2td2117-3v1-deepinview-thermal-bullet-camera-ip66-160x120-25fps-3mm"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 16,
          "rankedProductIds": [
            "7591899856953",
            "8168618491961",
            "7591723204665",
            "8168604237881",
            "8284597977145",
            "8168573435961",
            "8284598173753",
            "7591839760441",
            "8284597813305",
            "8284597747769",
            "8168572223545",
            "7591783858233",
            "8284598108217",
            "8284598075449",
            "8284598009913",
            "8284598140985"
          ],
          "rankedProductHandles": [
            "hikvision-ids-2cd8a66g0-xzhsy-8mp-outdoor-tandemvu-bullet-camera-colorvu-anpr-ip67-10-to-50-mm",
            "hikvision-ids-2cd8a46g2-xzhsy-4-mp-dual-channel-deepinview-multi-sensor-bullet-camera-8-32-mm-lens-variant",
            "hikvision-ids-2cd8a46g0-izhs-deepinview-face-recognition-indoor-moto-varifocal-bullet-network-camera",
            "hikvision-ids-2cd7586g2-xzhsy-8mp-deepinview-ptrz-motorized-varifocal-dome-darkfighter-2-0-ip67-ik10",
            "hikvision-ids-2cd7186g2-izhsy-8mp-deepinview-moto-varifocal-dome-camera-with-8-32mm-lens",
            "hikvision-ids-2cd7ac5g0-izhs-12mp-deepinview-moto-varifocal-bullet-camera",
            "hikvision-4mp-deepinview-ids-2cd8a47g0-sc-zy-self-cleaning-bullet-camera-with-colorvu-2-8-12mm-motorised-varifocal-lens-smart-detection",
            "hikvision-ds-2xs6a87g1-l-c32s80-4k-colorvu-fixed-bullet-solar-power-4g-network-camera-no-battery-2",
            "hikvision-ids-2cd5t87g2-v-xhsy-8mp-deepinviewx-fixed-bullet-camera-with-darkfighter-2-0-perimeter-protection",
            "hikvision-ids-2cd5387g2-v-xs-8mp-deepinviewx-fixed-turret-camera-with-darkfighter-2-0-human-vehicle-detection-ip67-weather-protection",
            "hikvision-ids-2cd7186g0-izhsy-8mp-deepinview-moto-varifocal-dome-camera",
            "hikvision-ds-2xs6a87g1-l-c32s80-4k-colorvu-fixed-bullet-solar-power-4g-network-camera-no-battery",
            "hikvision-4mp-deepinview-ids-2cd7a46g2-v-xzhsy-bullet-camera-with-darkfighter-ai-perimeter-protection-2-8-12mm-motorised-varifocal-lens-ir-100m",
            "hikvision-ids-2cd7a46g2-izhsy-5g-4mp-deepinview-moto-varifocal-bullet-camera-with-darkfighter-2-0-150db-wdr-5g-connectivity",
            "hikvision-ids-2cd7a45g2-izhsy-4mp-deepinview-moto-varifocal-bullet-camera-with-25x-zoom-darkfighter-2-0-200m-ir",
            "hikvision-4mp-deepinview-ids-2cd8a46g0-iz-uh-dome-camera-with-ai-detection-2-8-12mm-motorised-varifocal-lens-ir-40m"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 12,
          "rankedProductIds": [
            "7591859585081",
            "8168623833145",
            "7591980367929",
            "8284597846073",
            "8168608497721",
            "7591980204089",
            "8168599715897",
            "8168608792633",
            "7591806304313",
            "8168599978041",
            "8168577433657",
            "8168422113337"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2tx3636-25a-v1-thermal-smart-linkage-tracking-system",
            "hikvision-ds-2de5425iwg-4g-4mp-pro-solar-powered-ptz-camera-with-25x-zoom-256gb-emmc-ir-150m-solar-panel-battery-ip66",
            "hikvision-ds-2de5425iwg-k-4g-4mp-4g-solar-ptz-camera-25x-256gb-includes-solar-panel-battery-ir-ip66",
            "hikvision-ids-2cd7026g0-ap-2mp-deepinview-box-network-camera-with-deep-learning-analytics-audio-alarm-interface",
            "hikvision-ids-2cd7546g2-xzhsy-4mp-deepinview-ptrz-dome-high-speed-motorised-varifocal-with-ultra-low-light-ai-analytics",
            "hikvision-ds-2xs3q47g1-ldwh-c18s40-4mp-colorvu-solar-powered-security-camera-pt-kit",
            "hikvision-hm-td95c8-150ze4fl-w-thermal-optical-bi-spectrum-sphere-ptz-camera-with-smart-analytics",
            "hikvision-ds-2td4228t-10-s2-thermal-optical-bi-spectrum-speed-dome-dual-spectrum-ptz-with-temperature-alarm-fire-detection",
            "hikvision-ds-2td2617-10-qa-thermal-heatpro-cameras-dual-lens-10mm",
            "hikvision-ds-2td4167-50-wy-anti-corrosion-thermal-optical-bi-spectrum-network-speed-dome",
            "hikvision-ds-2td4238-10-s2-4mp-thermographic-thermal-optical-bi-spectrum-network-speed-dome",
            "hikvision-ds-2td4228-10-s2-thermal-optical-bi-spectrum-network-speed-dome"
          ]
        }
      }
    },
    "hikvision-dome-cameras-1": {
      "collectionHandle": "hikvision-dome-cameras-1",
      "collectionProductCount": 57,
      "renderedProductLimit": 250,
      "needs": {
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 11,
          "rankedProductIds": [
            "8168604237881",
            "8168572223545",
            "8284597977145",
            "7591666548793",
            "7591818559545",
            "8168608497721",
            "7591693877305",
            "7591674708025",
            "7591652819001",
            "7591579582521",
            "7591578009657"
          ],
          "rankedProductHandles": [
            "hikvision-ids-2cd7586g2-xzhsy-8mp-deepinview-ptrz-motorized-varifocal-dome-darkfighter-2-0-ip67-ik10",
            "hikvision-ids-2cd7186g0-izhsy-8mp-deepinview-moto-varifocal-dome-camera",
            "hikvision-ids-2cd7186g2-izhsy-8mp-deepinview-moto-varifocal-dome-camera-with-8-32mm-lens",
            "hikvision-ds-2cd55c5g0-izh-12mp-ir-vf-dome-network-camera",
            "hikvision-ds-2cd2586g2-is-8mp-outdoor-acusense-mini-dome-cctv-camera-30-ir-with-mic",
            "hikvision-ids-2cd7546g2-xzhsy-4mp-deepinview-ptrz-dome-high-speed-motorised-varifocal-with-ultra-low-light-ai-analytics",
            "hikvision-acusense-ds-2cd2746g1-izs-4mp-outdoor-dome-camera-h-265-30m-ir-motorised-lens",
            "hikvision-ds-2cd2765fwd-izs-6mp-outdoor-motorised-vf-dome-cctv-camera-30m-ir-io-2-8-12mm",
            "hikvision-ds-2cd5546g0-izs-4mp-motorised-darkfighter-lightfighter-dome-network-camera",
            "hikvision-ds-2cd4565f-iz-camera-2",
            "hikvision-ds-2cd2742fwizs-motorised-vf-dome-camera"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 4,
          "rankedProductIds": [
            "8168608497721",
            "7591598129209",
            "7591597899833",
            "7591597703225"
          ],
          "rankedProductHandles": [
            "hikvision-ids-2cd7546g2-xzhsy-4mp-deepinview-ptrz-dome-high-speed-motorised-varifocal-with-ultra-low-light-ai-analytics",
            "hikvision-hik-2cd2f42fiws6-4mp-indoor-mini-pt-camera-10m-ir-wdr-wifi-audio-alarm-io-6mm",
            "hikvision-hik-2cd2f42fiws4-4mp-indoor-mini-pt-camera-10m-ir-wdr-wifi-audio-alarm-io-4mm",
            "hikvision-hik-2cd2f42fiws2-4mp-indoor-mini-pt-camera-10m-ir-wdr-wifi-audio-io-2-8mm"
          ]
        }
      }
    },
    "hikvision-explosion-proof-cameras": {
      "collectionHandle": "hikvision-explosion-proof-cameras",
      "collectionProductCount": 3,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "hikvision-face-recognition-cameras-1": {
      "collectionHandle": "hikvision-face-recognition-cameras-1",
      "collectionProductCount": 3,
      "renderedProductLimit": 250,
      "needs": {
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 2,
          "rankedProductIds": [
            "8284541681721",
            "8168596373561"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2st5c432mwg-e-26pa-4mp-32x-zoom-tandemvu-anti-corrosion-ptz-ip-camera-with-acusense-darkfighter-technology",
            "hikvision-ds-2cd3a46g2t-izhs-4mp-acusense-varifocal-bullet-camera-with-deep-learning"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 2,
          "rankedProductIds": [
            "7591674576953",
            "8284541681721"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd7a26g0-izhs-face-capture-bullet-camera",
            "hikvision-ds-2st5c432mwg-e-26pa-4mp-32x-zoom-tandemvu-anti-corrosion-ptz-ip-camera-with-acusense-darkfighter-technology"
          ]
        }
      }
    },
    "hikvision-fisheye-cameras": {
      "collectionHandle": "hikvision-fisheye-cameras",
      "collectionProductCount": 11,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "hikvision-full-body-cameras": {
      "collectionHandle": "hikvision-full-body-cameras",
      "collectionProductCount": 5,
      "renderedProductLimit": 250,
      "needs": {
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 2,
          "rankedProductIds": [
            "8168572518457",
            "7591795916857"
          ],
          "rankedProductHandles": [
            "hikvision-ids-2cd7a45g0-p-izhsy-4-7-118mm-4mp-bullet-anpr-4-7-118mm-200m-ir-heater-nema-4x-60fps",
            "hikvision-4mp-outdoor-motorised-deepinview-vf-bullet-camera-heater-4-7-118mm"
          ]
        }
      }
    },
    "hikvision-hdtvi-cameras-1": {
      "collectionHandle": "hikvision-hdtvi-cameras-1",
      "collectionProductCount": 43,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 2,
          "rankedProductIds": [
            "8284598566969",
            "8284554264633"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2ce72uf3t-ls-tvi4-0-8mp-4k-smart-hybrid-light-turret-tvi-camera",
            "hilook-thc-t257-lms-3k-dual-light-audio-fixed-turret-camera-with-mic-and-smart-hybrid-light"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 2,
          "rankedProductIds": [
            "7591710556217",
            "7591654719545"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2ce16h8t-it3f-tvi4-0-5mp-outdoor-bullet-camera-130db-wdr-60m-ir-4-in-1-ip67-12vdc-2-8mm",
            "hikvision-ds-2ae5225ti-tvi-2mp-outdoor-ptz-camera-25x-zoom-150m-ir"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 4,
          "rankedProductIds": [
            "8284554231865",
            "7591718846521",
            "7591670906937",
            "7591670775865"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2ce76u7t-itmf-8mp-4k-turbo-hd-ultra-low-light-turret-camera-with-30m-ir",
            "hikvision-hik-2ce78u7it3f2-tvi4-0-8mp-outdoor-turret-camera-60m-ir-4-in-1-ip67-12vdc-2-8mm",
            "hikvision-ds-2ce19u8t-it3z-tvi4-0-8mp-outdoor-bullet-camera-4k-wdr-ip67-2-8-12mm-12vdc",
            "hikvision-ds-2ce17u8t-tvi4-0-8mp-outdoor-bullet-camera-4k-ultra-low-light-ip67-2-8mm-12vdc"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 8,
          "rankedProductIds": [
            "7591653343289",
            "8168436891705",
            "7591865024569",
            "7591654719545",
            "8168393244729",
            "7591833174073",
            "7591699775545",
            "7591690108985"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2ce56h5t-itm-tvi4-0-5mp-outdoor-ir-eyeball-dome-camera-20fps-2-8mm",
            "hikvision-ds-2ae4225ti-d-2mp-outdoor-ptz-camera-25x-zoom-100m-ir-1",
            "hikvision-ds-2ae4225ti-d-2mp-outdoor-ptz-camera-25x-zoom-100m-ir",
            "hikvision-ds-2ae5225ti-tvi-2mp-outdoor-ptz-camera-25x-zoom-150m-ir",
            "hikvision-ds-2ae5225t-a-pro-series-2mp-25-speed-dome-ptz-outdoor-turbohd-darkfighter-performance",
            "hikvision-ds-2ae4225t-d-4-inch-2-mp-25x-powered-by-darkfighter-analog-speed-dome",
            "hikvision-ds-2ae5232t-ac-hd-tvi-2mp-ptz-camera-with-32x-optical-zoom",
            "hikvision-ds-2ae5232t-a3-hd-tvi-2mp-ptz-camera-32x-optical-zoom"
          ]
        }
      }
    },
    "hikvision-hidden-cameras-1": {
      "collectionHandle": "hikvision-hidden-cameras-1",
      "collectionProductCount": 5,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "hikvision-lightfighter-1": {
      "collectionHandle": "hikvision-lightfighter-1",
      "collectionProductCount": 4,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "hikvision-mini-bullet-cameras-1": {
      "collectionHandle": "hikvision-mini-bullet-cameras-1",
      "collectionProductCount": 19,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 4,
          "rankedProductIds": [
            "8168616165433",
            "8168616460345",
            "8168616362041",
            "8168404942905"
          ],
          "rankedProductHandles": [
            "hikvision-6mp-mini-bullet-colorvu-3-0-strobe-audio-ds-2cd2067g3-li2uy-sl",
            "hikvision-8mp-acusense-black-mini-bullet-strobe-audio-ds-2cd2086g2h-i2u-sl-blk-black",
            "hikvision-8mp-acusense-mini-bullet-strobe-audio-ds-2cd2086g2h-i2u-sl",
            "hikvision-ds-2cd2066g2h-i2u-sl-6mp-outdoor-acusense-mini-bullet-camera-mic-ir-strobe-audio-alarm-2-8mm"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 2,
          "rankedProductIds": [
            "8168616460345",
            "8168616362041"
          ],
          "rankedProductHandles": [
            "hikvision-8mp-acusense-black-mini-bullet-strobe-audio-ds-2cd2086g2h-i2u-sl-blk-black",
            "hikvision-8mp-acusense-mini-bullet-strobe-audio-ds-2cd2086g2h-i2u-sl"
          ]
        }
      }
    },
    "hikvision-mini-dome-cameras-2": {
      "collectionHandle": "hikvision-mini-dome-cameras-2",
      "collectionProductCount": 7,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "hikvision-mini-pt-pan-tilt": {
      "collectionHandle": "hikvision-mini-pt-pan-tilt",
      "collectionProductCount": 2,
      "renderedProductLimit": 250,
      "needs": {
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 1,
          "rankedProductIds": [
            "7591734018105"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2de3a400bw-de-colorvu-4mp-outdoor-pan-tilt-network-dome-camera"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 1,
          "rankedProductIds": [
            "7591734018105"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2de3a400bw-de-colorvu-4mp-outdoor-pan-tilt-network-dome-camera"
          ]
        }
      }
    },
    "hikvision-mobile-vehicle-cameras": {
      "collectionHandle": "hikvision-mobile-vehicle-cameras",
      "collectionProductCount": 21,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "hikvision-panovu-cameras": {
      "collectionHandle": "hikvision-panovu-cameras",
      "collectionProductCount": 12,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 3,
          "rankedProductIds": [
            "8168617181241",
            "8168581169209",
            "8284598829113"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd2387g2p-lsu-sl-blk-8mp-colorvu-turret-4mm-dual-head-strobe-speaker-network-camera-panoramic-black",
            "hikvision-colorvu-2cd2t67g2p-lsu-sl-6mp-dual-lens-stobe-audio-bullet-camera2-8mm-mic",
            "hikvision-16mp-panoramic-ds-2cd6944g1-ihs-uy-turret-camera-with-180-stitched-view-2-8mm-fixed-lens-ir-20m"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 4,
          "rankedProductIds": [
            "8284590440505",
            "8284598829113",
            "8168581038137",
            "8168604762169"
          ],
          "rankedProductHandles": [
            "hikvision-8mp-panovu-ds-2cd6d82g2-is-dual-directional-camera-with-built-in-microphone-poe-ip67-ik10",
            "hikvision-16mp-panoramic-ds-2cd6944g1-ihs-uy-turret-camera-with-180-stitched-view-2-8mm-fixed-lens-ir-20m",
            "hikvision-acusense-ds-2cd2346g2p-isu-sl-panoramic-4mp-turret-camera-fixed-2-8mm-ir-30m-mic",
            "hikvision-ds-2cd6d44g1h-izs-4-sensor-4-mp-panoramic-camera-360-coverage-4-x-varifocal-lenses-ip67-ik10"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 5,
          "rankedProductIds": [
            "8168625471545",
            "8168581038137",
            "8168617181241",
            "8284590440505",
            "8168604762169"
          ],
          "rankedProductHandles": [
            "hikvision-32mp-180-panovu-ds-2cd6984g1-ihsuy-nfc-multisensor-4-directional-camera-2-8mm-lens-ir-20m",
            "hikvision-acusense-ds-2cd2346g2p-isu-sl-panoramic-4mp-turret-camera-fixed-2-8mm-ir-30m-mic",
            "hikvision-ds-2cd2387g2p-lsu-sl-blk-8mp-colorvu-turret-4mm-dual-head-strobe-speaker-network-camera-panoramic-black",
            "hikvision-8mp-panovu-ds-2cd6d82g2-is-dual-directional-camera-with-built-in-microphone-poe-ip67-ik10",
            "hikvision-ds-2cd6d44g1h-izs-4-sensor-4-mp-panoramic-camera-360-coverage-4-x-varifocal-lenses-ip67-ik10"
          ]
        }
      }
    },
    "hikvision-panovu-cameras-1": {
      "collectionHandle": "hikvision-panovu-cameras-1",
      "collectionProductCount": 7,
      "renderedProductLimit": 250,
      "needs": {
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 3,
          "rankedProductIds": [
            "7745683226681",
            "7591661633593",
            "7591654260793"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2de3a404iwg-e-w-4mp-outdoor-mini-ptz-camera-4x-zoom-up-to-50m-ir-wifi",
            "hikvision-4mp-outdoor-mini-ptz-camera-4x-zoom",
            "hikvision-ds-2cd6924f-4-8mp-panovu-panoramic-dark-fighter-cctv-camera"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 5,
          "rankedProductIds": [
            "7591738671161",
            "7591654457401",
            "7745683226681",
            "7591661633593",
            "7591654096953"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd6986f-h-8mp-panovu-panoramic-dark-fighter-cctv-camera",
            "hikvision-ds-2pt5326iz-de-2mp-panovu-mini-ptz-cctv-camera",
            "hikvision-ds-2de3a404iwg-e-w-4mp-outdoor-mini-ptz-camera-4x-zoom-up-to-50m-ir-wifi",
            "hikvision-4mp-outdoor-mini-ptz-camera-4x-zoom",
            "hikvision-ds-2pt3326iz-de3-panovu-mini-series-ir-network-ptz-cctv-camera"
          ]
        }
      }
    },
    "hikvision-people-counting-cameras-1": {
      "collectionHandle": "hikvision-people-counting-cameras-1",
      "collectionProductCount": 4,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "hikvision-ptz-cameras": {
      "collectionHandle": "hikvision-ptz-cameras",
      "collectionProductCount": 109,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 15,
          "rankedProductIds": [
            "7745682407481",
            "8168515141689",
            "7591841366073",
            "8168624029753",
            "7591844741177",
            "7591729528889",
            "7591717306425",
            "7837229809721",
            "8168627077177",
            "7591658881081",
            "7591607238713",
            "7591607074873",
            "7591876427833",
            "7745683521593",
            "7591638925369"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2dt8c442mxg-lwt-4mp-ptz-dome-camera-anti-corrosion-polymer-hybrid-light-42x-zoom-36-vdc",
            "hikvision-ds-2dt8c442mxg-lwt-4mp-ptz-dome-camera-with-42x-zoom-anti-corrosion-polymer-hybrid-light-ir-500m-36v-dc-ip67",
            "hikvision-ds-2se4c425mwg-e-14f0-4mp-tandemvu-colorvu-ptz",
            "hikvision-ds-2df8c435mhs-delw-4mp-35x-darkfighterx-ptz-camera-dual-sensor-ir-300m-ip67-ik10",
            "hikvision-ds-2de7a412mcg-eb-4mp-7-inch-4-mp-12x-colorvu-network-speed-dome",
            "hikvision-ds-2df8225ih-ael-2mp-outdoor-darkfighter-x-ptz-25x-zoom",
            "hikvision-ds-2df9c435ihs-dlwt2-4mp-outdoor-darkfighter-x-ptz-camera-35x-zoom-500m-ir-ip67-ik10",
            "hikvision-ds-2df8c442ixg-elw-8c-series-4mp-42x-darkfighter-ir-network-speed-dome-ptz",
            "hikvision-ds-2dv6c425mxg-elwy-4mp-25x-optical-ptz-speed-dome-camera-darkfighter-low-light-200m-ir-ip67",
            "hikvision-ds-2df8236ix-ael-2mp-outdoor-darkfighter-ptz-camera-wdr-36x-zoom-200m-ir-hipoe",
            "hikvision-hik-2df8236iaelw-2mp-outdoor-darkfighter-ptz-camera-wdr-36x-zoom-200m-ir-hipoewiper",
            "hikvision-hik-2df8223iaelw-2mp-outdoor-darkfighter-ptz-camera-wdr-23x-zoom-200m-ir-hipoe-wiper",
            "hikvision-ds-2df8c425mhs-delw-4-mp-25x-darkfighterx-ir-network-speed-dome-300m-ir",
            "hikvision-ds-2de7a425iw-aeb-4-mp-25x-powered-by-darkfighter-ir-network-speed-dome",
            "hikvision-ds-2df8225ix-aelw-2mp-25x-network-ir-speed-dome"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 16,
          "rankedProductIds": [
            "8168541519929",
            "8284541976633",
            "8284589981753",
            "8284597583929",
            "7837247209529",
            "7591817052217",
            "7745682604089",
            "7591866892345",
            "7591644692537",
            "8284597616697",
            "7591859585081",
            "7591668613177",
            "8168627077177",
            "8168599715897",
            "7591658881081",
            "7591654719545"
          ],
          "rankedProductHandles": [
            "hilook-by-hikvision-ptz-n3404liu-sl-4-mp-4-x-intelligent-network-ptz-2-way-audio-flashing-lights",
            "hikvision-ptz-nd4404-slaus-dual-lens-4mp4mp-ptz-ip-camera-with-4x-optical-zoom-darkfighter-low-light-active-strobe-audio-alarm",
            "hikvision-ds-2de4425iwg1-e-4mp-25x-powered-by-darkfighter-ir-acusense-network-ptz-speed-dome-with-ai-isp-face-capture-strobe-audio-alarm",
            "hikvision-hm-tx3840-15-g0-t1-thermal-tandemvu-smart-linkage-tracking-system-with-4mp-40x-ptz-384x288-thermal-imaging-250m-white-light",
            "hikvision-ds-2td4137t-9w-thermographic-thermal-optical-bi-spectrum-network-speed-dome",
            "hikvision-ds-2td4228-10-w",
            "hikvision-ds-2se7c432mwg-eb-26-6mp4mp-tandemvu-outdoor-ptz-camera-acusense-32x-zoom",
            "hikvision-acusense-ptz-4mp-6-252mm-42x-optical-16-x-digital-400m-ir-ip67-face-capture-white",
            "hikvision-ds-2de4a425iw-de-4mp-outdoor-ptz-camera-25x-zoom-50m-ir",
            "hikvision-hm-tx3840-25-g0-t1-thermal-tandemvu-smart-linkage-tracking-system-with-4mp-40x-ptz-384x288-thermal-imaging-audible-alarm",
            "hikvision-ds-2tx3636-25a-v1-thermal-smart-linkage-tracking-system",
            "hikvision-4mp-outdoor-darkfighter-ptz-camera-25x-zoom",
            "hikvision-ds-2dv6c425mxg-elwy-4mp-25x-optical-ptz-speed-dome-camera-darkfighter-low-light-200m-ir-ip67",
            "hikvision-hm-td95c8-150ze4fl-w-thermal-optical-bi-spectrum-sphere-ptz-camera-with-smart-analytics",
            "hikvision-ds-2df8236ix-ael-2mp-outdoor-darkfighter-ptz-camera-wdr-36x-zoom-200m-ir-hipoe",
            "hikvision-ds-2ae5225ti-tvi-2mp-outdoor-ptz-camera-25x-zoom-150m-ir"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 16,
          "rankedProductIds": [
            "8284541681721",
            "8168595783737",
            "8168618393657",
            "8168624029753",
            "8168541519929",
            "7591844577337",
            "7591717306425",
            "8284541976633",
            "7591979024441",
            "7591769899065",
            "7591652589625",
            "7591661633593",
            "8284597583929",
            "7591858307129",
            "8284590473273",
            "7745682604089"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2st5c432mwg-e-26pa-4mp-32x-zoom-tandemvu-anti-corrosion-ptz-ip-camera-with-acusense-darkfighter-technology",
            "hikvision-ids-mcd402-e-4g-dual-lens-anpr-portable-speed-dome-with-36x-zoom-ai-detection",
            "hikvision-ids-mcd402-es-4g-dual-lens-anpr-portable-speed-dome-kit",
            "hikvision-ds-2df8c435mhs-delw-4mp-35x-darkfighterx-ptz-camera-dual-sensor-ir-300m-ip67-ik10",
            "hilook-by-hikvision-ptz-n3404liu-sl-4-mp-4-x-intelligent-network-ptz-2-way-audio-flashing-lights",
            "hikvision-ds-2de4a425iwg-e-4mp-outdoor-ptz-camera-25x-zoom-50m-ir-with-ai-tracking",
            "hikvision-ds-2df9c435ihs-dlwt2-4mp-outdoor-darkfighter-x-ptz-camera-35x-zoom-500m-ir-ip67-ik10",
            "hikvision-ptz-nd4404-slaus-dual-lens-4mp4mp-ptz-ip-camera-with-4x-optical-zoom-darkfighter-low-light-active-strobe-audio-alarm",
            "hikvision-ds-2de4425iw-det5-4mp-outdoor-mini-ir-ptz-camera-100m-ir-25x-zoom-ip66-poe-12vdc-export",
            "hikvision-ds-2se7c124iw-ae32x-4s5-outdoor-smart-linkage-ptz-camera-acusense-32x-zoom-ip66-ik10-hi-poe",
            "hikvision-ds-2df6a825x-ael-8mp-25x-network-speed-dome",
            "hikvision-4mp-outdoor-mini-ptz-camera-4x-zoom",
            "hikvision-hm-tx3840-15-g0-t1-thermal-tandemvu-smart-linkage-tracking-system-with-4mp-40x-ptz-384x288-thermal-imaging-250m-white-light",
            "hikvision-4mp-tandemvu-ptz-camera-24-7-colour-180-deg-overview-42x-zoom",
            "hikvision-4mp-acusense-ds-2de2a404iwg1-e-mini-outdoor-ptz-camera-with-4x-optical-zoom-ir-20m-ip66",
            "hikvision-ds-2se7c432mwg-eb-26-6mp4mp-tandemvu-outdoor-ptz-camera-acusense-32x-zoom"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 16,
          "rankedProductIds": [
            "7591841366073",
            "8168624029753",
            "7591924039737",
            "7591729528889",
            "7591717306425",
            "7591979024441",
            "7591769899065",
            "7591607631929",
            "7591858307129",
            "7591794769977",
            "7745682604089",
            "7591866892345",
            "7591721828409",
            "7591859585081",
            "7591712817209",
            "8168515141689"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2se4c425mwg-e-14f0-4mp-tandemvu-colorvu-ptz",
            "hikvision-ds-2df8c435mhs-delw-4mp-35x-darkfighterx-ptz-camera-dual-sensor-ir-300m-ip67-ik10",
            "hikvision-ds-2sf8c442mxg-elw-26-4mp-tandemvu-ptz-camera-24-7-colour-42x-zoom",
            "hikvision-ds-2df8225ih-ael-2mp-outdoor-darkfighter-x-ptz-25x-zoom",
            "hikvision-ds-2df9c435ihs-dlwt2-4mp-outdoor-darkfighter-x-ptz-camera-35x-zoom-500m-ir-ip67-ik10",
            "hikvision-ds-2de4425iw-det5-4mp-outdoor-mini-ir-ptz-camera-100m-ir-25x-zoom-ip66-poe-12vdc-export",
            "hikvision-ds-2se7c124iw-ae32x-4s5-outdoor-smart-linkage-ptz-camera-acusense-32x-zoom-ip66-ik10-hi-poe",
            "hikvision-ds-2df8436ix-ael-4mp-outdoor-hfr-ptz-camera-wdr-36x-zoom-wiper-ip66-200m-ir-hipoe",
            "hikvision-4mp-tandemvu-ptz-camera-24-7-colour-180-deg-overview-42x-zoom",
            "hikvision-ids-mcd202-b-ptz-2-mp-network-portable-ir-speed-dome-4g",
            "hikvision-ds-2se7c432mwg-eb-26-6mp4mp-tandemvu-outdoor-ptz-camera-acusense-32x-zoom",
            "hikvision-acusense-ptz-4mp-6-252mm-42x-optical-16-x-digital-400m-ir-ip67-face-capture-white",
            "hikvision-ds-2df8442ixs-ael-4mp-outdoor-hfr-ptz-camera-wdr-42x-zoom-ip67-500m-ir-hipoe",
            "hikvision-ds-2tx3636-25a-v1-thermal-smart-linkage-tracking-system",
            "hikvision-ds-2de4425iw-de-4mp-outdoor-mini-ir-ptz-camera-100m-ir-25x-zoom-ip66-poe-12vdc",
            "hikvision-ds-2dt8c442mxg-lwt-4mp-ptz-dome-camera-with-42x-zoom-anti-corrosion-polymer-hybrid-light-ir-500m-36v-dc-ip67"
          ]
        }
      }
    },
    "hikvision-smart-hybrid-colorvu-cameras-1": {
      "collectionHandle": "hikvision-smart-hybrid-colorvu-cameras-1",
      "collectionProductCount": 43,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 16,
          "rankedProductIds": [
            "8168595062841",
            "8168600797241",
            "7591938981945",
            "7591926628409",
            "8168572649529",
            "8168598569017",
            "8284579692601",
            "7591899660345",
            "8168601190457",
            "7591903199289",
            "8168598700089",
            "7591903690809",
            "7591868989497",
            "8168451407929",
            "7591902216249",
            "8168617017401"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd3687g3-lizsuy-sl-8mp-darkfighter-bullet-camera-with-dual-illumination-strobe-light-audio-alarm-2-7-13-5mm",
            "hikvision-ds-2cd3687g3-lizsuy-sl-8mp-darkfighter-bullet-camera-colorvu-strobe-light-audio-alarm-2-7-13-5mm-black",
            "hikvision-ds-2cd2t67g2h-li-6mp-smart-hybrid-light-colorvu-bullet-camera-black",
            "hikvision-ds-2cd2087g2h-liu-sl-8mp-colorvu-mini-bullet-camera-hybrid-light-liveguard-2-8-4mm",
            "hikvision-ds-2cd2387g3-lis2uy-sl-8mp-4k-smart-hybrid-light-colorvu-3-0-turret-camera-with-strobe-speaker",
            "hikvision-ds-2cd2t66g2h-4i-6-mp-colorvu-hybrid-bullet-camera-4-mm-lens-80-m-ir-black-white",
            "hikvision-ds-2cd2387g3-lis2uy-srb-8mp-4k-smart-hybrid-light-colorvu-3-0-turret-camera-red-blue-strobe-speaker",
            "hikvision-ds-2cd2387g2h-liu-8mp-4k-smart-hybrid-light-colorvu-turret-camera-with-strobe-speaker",
            "hikvision-ds-2cd2t67g3-lis2uy-sl-6mp-colorvu-3-0-bullet-camera-white",
            "hikvision-ds-2cd2667g2ht-6mp-smart-hybrid-light-colorvu-motorised-vf-bullet-camera-2-8-12-mm",
            "hikvision-ds-2cd2t66g2h-2i-6-mp-colorvu-hybrid-bullet-camera-60-m-ir-black-white",
            "hikvision-ds-2cd2767g2ht-6mp-smart-hybrid-light-colorvu-motorised-vf-dome-camera-2-8-12mm",
            "hikvision-8mp-outdoor-colorvu-mini-bullet-camera-hybrid-light-mic-2-8mm",
            "hikvision-ds-2cd2067g2h-liu-sl-6mp-smart-hybrid-light-colorvu-mini-bullet-camera-2-8mm-4mm",
            "hikvision-ds-2cd2367g2h-liu-8mp-4k-smart-hybrid-light-colorvu-turret-camera-2-8mm-4mm",
            "hikvision-ds-2cd2187g3-lis2uy-blk-8mp-colorvu-3-0-gen-3-hybrid-dome-camera-black"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 16,
          "rankedProductIds": [
            "8284579692601",
            "8168572649529",
            "8168601190457",
            "8168600338489",
            "8168615444537",
            "8168615739449",
            "7591905394745",
            "7591899660345",
            "8168575565881",
            "8168600797241",
            "8168595062841",
            "7591903199289",
            "8168617017401",
            "7591926628409",
            "8168589393977",
            "7591938981945"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd2387g3-lis2uy-srb-8mp-4k-smart-hybrid-light-colorvu-3-0-turret-camera-red-blue-strobe-speaker",
            "hikvision-ds-2cd2387g3-lis2uy-sl-8mp-4k-smart-hybrid-light-colorvu-3-0-turret-camera-with-strobe-speaker",
            "hikvision-ds-2cd2t67g3-lis2uy-sl-6mp-colorvu-3-0-bullet-camera-white",
            "hikvision-ds-2cd3667g3-lizsuy-sl-6mp-colorvu-varifocal-bullet-camera-smart-hybrid-light",
            "hikvision-ds-2cd2367g3-lis2uy-sl-6mp-colorvu-3-0-gen-3-turret-camera-with-strobe-speaker-black",
            "hikvision-ds-2cd2387g3-lis2uy-sl-8mp-colorvu-3-0-turret-camera-with-strobe-speaker-in-black",
            "hikvision-ds-2cd2367g2h-lisu-sl-6mp-smart-hybrid-light-colorvu-turret-camera-2-8mm-strobe-speaker",
            "hikvision-ds-2cd2387g2h-liu-8mp-4k-smart-hybrid-light-colorvu-turret-camera-with-strobe-speaker",
            "hikvision-ds-2cd2367g3-lis2uy-sl-6mp-smart-hybrid-light-colorvu-3-0-turret-camera-with-strobe-speaker",
            "hikvision-ds-2cd3687g3-lizsuy-sl-8mp-darkfighter-bullet-camera-colorvu-strobe-light-audio-alarm-2-7-13-5mm-black",
            "hikvision-ds-2cd3687g3-lizsuy-sl-8mp-darkfighter-bullet-camera-with-dual-illumination-strobe-light-audio-alarm-2-7-13-5mm",
            "hikvision-ds-2cd2667g2ht-6mp-smart-hybrid-light-colorvu-motorised-vf-bullet-camera-2-8-12-mm",
            "hikvision-ds-2cd2187g3-lis2uy-blk-8mp-colorvu-3-0-gen-3-hybrid-dome-camera-black",
            "hikvision-ds-2cd2087g2h-liu-sl-8mp-colorvu-mini-bullet-camera-hybrid-light-liveguard-2-8-4mm",
            "hikvision-ds-2cd2t87g3-lis2uy-sl-8mp-colorvu-3-0-bullet-camera-light-speaker-liveguard",
            "hikvision-ds-2cd2t67g2h-li-6mp-smart-hybrid-light-colorvu-bullet-camera-black"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 12,
          "rankedProductIds": [
            "8168572649529",
            "8168617017401",
            "7591903199289",
            "7591926628409",
            "8284579692601",
            "8168589393977",
            "8168586870841",
            "8168586772537",
            "8168615739449",
            "7591899660345",
            "8168600338489",
            "7591903690809"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd2387g3-lis2uy-sl-8mp-4k-smart-hybrid-light-colorvu-3-0-turret-camera-with-strobe-speaker",
            "hikvision-ds-2cd2187g3-lis2uy-blk-8mp-colorvu-3-0-gen-3-hybrid-dome-camera-black",
            "hikvision-ds-2cd2667g2ht-6mp-smart-hybrid-light-colorvu-motorised-vf-bullet-camera-2-8-12-mm",
            "hikvision-ds-2cd2087g2h-liu-sl-8mp-colorvu-mini-bullet-camera-hybrid-light-liveguard-2-8-4mm",
            "hikvision-ds-2cd2387g3-lis2uy-srb-8mp-4k-smart-hybrid-light-colorvu-3-0-turret-camera-red-blue-strobe-speaker",
            "hikvision-ds-2cd2t87g3-lis2uy-sl-8mp-colorvu-3-0-bullet-camera-light-speaker-liveguard",
            "hikvision-ds-2cd2187g3-lis2uy-8mp-colorvu-3-0-hybrid-dome-camera",
            "hikvision-ds-2cd2087g3-li2uy-8mp-colorvu-3-0-hybrid-mini-bullet-camera",
            "hikvision-ds-2cd2387g3-lis2uy-sl-8mp-colorvu-3-0-turret-camera-with-strobe-speaker-in-black",
            "hikvision-ds-2cd2387g2h-liu-8mp-4k-smart-hybrid-light-colorvu-turret-camera-with-strobe-speaker",
            "hikvision-ds-2cd3667g3-lizsuy-sl-6mp-colorvu-varifocal-bullet-camera-smart-hybrid-light",
            "hikvision-ds-2cd2767g2ht-6mp-smart-hybrid-light-colorvu-motorised-vf-dome-camera-2-8-12mm"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 2,
          "rankedProductIds": [
            "8168598569017",
            "8168598700089"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd2t66g2h-4i-6-mp-colorvu-hybrid-bullet-camera-4-mm-lens-80-m-ir-black-white",
            "hikvision-ds-2cd2t66g2h-2i-6-mp-colorvu-hybrid-bullet-camera-60-m-ir-black-white"
          ]
        }
      }
    },
    "hikvision-solar-cameras-1": {
      "collectionHandle": "hikvision-solar-cameras-1",
      "collectionProductCount": 15,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 2,
          "rankedProductIds": [
            "7591839760441",
            "7591783858233"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2xs6a87g1-l-c32s80-4k-colorvu-fixed-bullet-solar-power-4g-network-camera-no-battery-2",
            "hikvision-ds-2xs6a87g1-l-c32s80-4k-colorvu-fixed-bullet-solar-power-4g-network-camera-no-battery"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 6,
          "rankedProductIds": [
            "8284591226937",
            "7591839760441",
            "7591783858233",
            "7591826686009",
            "7591826620473",
            "7591826391097"
          ],
          "rankedProductHandles": [
            "hikvision-4mp-colorvu-ds-2xs3q47g1-ldh-4g-solar-powered-pt-camera-with-4g-two-way-audio-built-in-battery-solar-panel",
            "hikvision-ds-2xs6a87g1-l-c32s80-4k-colorvu-fixed-bullet-solar-power-4g-network-camera-no-battery-2",
            "hikvision-ds-2xs6a87g1-l-c32s80-4k-colorvu-fixed-bullet-solar-power-4g-network-camera-no-battery",
            "hikvision-ds-2txs2628-10p-qa-glt-ch30s80-kit-solar-powered-thermal-camera-kit-30ah-vbattery",
            "hikvision-ds-2txs2628-7p-qa-glt-ch30s80-kit-solar-powered-thermal-camera-kit-30ah-vbattery",
            "hikvision-ds-2txs2628-10p-qa-glt-ch30s80-kit-solar-powered-thermal-camera-kit-no-battery"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 3,
          "rankedProductIds": [
            "7591839760441",
            "7591783858233",
            "8284591226937"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2xs6a87g1-l-c32s80-4k-colorvu-fixed-bullet-solar-power-4g-network-camera-no-battery-2",
            "hikvision-ds-2xs6a87g1-l-c32s80-4k-colorvu-fixed-bullet-solar-power-4g-network-camera-no-battery",
            "hikvision-4mp-colorvu-ds-2xs3q47g1-ldh-4g-solar-powered-pt-camera-with-4g-two-way-audio-built-in-battery-solar-panel"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 5,
          "rankedProductIds": [
            "7591980367929",
            "8168623833145",
            "7591980204089",
            "8284591292473",
            "8284591226937"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2de5425iwg-k-4g-4mp-4g-solar-ptz-camera-25x-256gb-includes-solar-panel-battery-ir-ip66",
            "hikvision-ds-2de5425iwg-4g-4mp-pro-solar-powered-ptz-camera-with-25x-zoom-256gb-emmc-ir-150m-solar-panel-battery-ip66",
            "hikvision-ds-2xs3q47g1-ldwh-c18s40-4mp-colorvu-solar-powered-security-camera-pt-kit",
            "hikvision-4mp-colorvu-ds-2xs3q47g1-ldwh-c18s40-b-solar-pt-camera-bundle-kit-with-sma-adapter-af003-100-waterproof-sealing-tape-two-way-audio",
            "hikvision-4mp-colorvu-ds-2xs3q47g1-ldh-4g-solar-powered-pt-camera-with-4g-two-way-audio-built-in-battery-solar-panel"
          ]
        },
        "two-way-audio": {
          "displayName": "Two-way audio",
          "productCount": 2,
          "rankedProductIds": [
            "8284591226937",
            "8284591292473"
          ],
          "rankedProductHandles": [
            "hikvision-4mp-colorvu-ds-2xs3q47g1-ldh-4g-solar-powered-pt-camera-with-4g-two-way-audio-built-in-battery-solar-panel",
            "hikvision-4mp-colorvu-ds-2xs3q47g1-ldwh-c18s40-b-solar-pt-camera-bundle-kit-with-sma-adapter-af003-100-waterproof-sealing-tape-two-way-audio"
          ]
        }
      }
    },
    "hikvision-temperature-screening-cameras": {
      "collectionHandle": "hikvision-temperature-screening-cameras",
      "collectionProductCount": 2,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "hikvision-thermal-cameras": {
      "collectionHandle": "hikvision-thermal-cameras",
      "collectionProductCount": 62,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 16,
          "rankedProductIds": [
            "8284598894649",
            "8284598861881",
            "8284597583929",
            "7591715962937",
            "7591817052217",
            "8284597616697",
            "8168599715897",
            "7591826686009",
            "7591826620473",
            "7591859585081",
            "7591826391097",
            "7591776387129",
            "8168581595193",
            "7591828848697",
            "7591806304313",
            "7591776223289"
          ],
          "rankedProductHandles": [
            "hikvision-heatpro-hm-td1228t-2-g1-t3a-bi-spectrum-thermal-turret-camera-with-temperature-detection",
            "hikvision-heatpro-hm-td1228-2-g1-t3a-bi-spectrum-thermal-turret-camera-with-human-vehicle-detection",
            "hikvision-hm-tx3840-15-g0-t1-thermal-tandemvu-smart-linkage-tracking-system-with-4mp-40x-ptz-384x288-thermal-imaging-250m-white-light",
            "hikvision-ds-2td2117-10-pa-deepinview-thermal-bullet-camera-ip66-160x120-25fps-10mm",
            "hikvision-ds-2td4228-10-w",
            "hikvision-hm-tx3840-25-g0-t1-thermal-tandemvu-smart-linkage-tracking-system-with-4mp-40x-ptz-384x288-thermal-imaging-audible-alarm",
            "hikvision-hm-td95c8-150ze4fl-w-thermal-optical-bi-spectrum-sphere-ptz-camera-with-smart-analytics",
            "hikvision-ds-2txs2628-10p-qa-glt-ch30s80-kit-solar-powered-thermal-camera-kit-30ah-vbattery",
            "hikvision-ds-2txs2628-7p-qa-glt-ch30s80-kit-solar-powered-thermal-camera-kit-30ah-vbattery",
            "hikvision-ds-2tx3636-25a-v1-thermal-smart-linkage-tracking-system",
            "hikvision-ds-2txs2628-10p-qa-glt-ch30s80-kit-solar-powered-thermal-camera-kit-no-battery",
            "hikvision-ds-2td1217-6-pa-heatpro-turret-6-2mm",
            "hikvision-heat-pro-2td1228t-2-4mp-bi-spectrum-fire-smoke-turret-camera-2-1mm-2-2mm-ir-15m",
            "hikvision-ds-2td1217-6-v1-thermal-optical-network-turret-camera-6mm",
            "hikvision-ds-2td2617-10-qa-thermal-heatpro-cameras-dual-lens-10mm",
            "hikvision-ds-2td1217-2-pa-heatpro-turret-2mm"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 4,
          "rankedProductIds": [
            "8168582053945",
            "8284597583929",
            "8284597616697",
            "8168577433657"
          ],
          "rankedProductHandles": [
            "hikvision-explosion-proof-series-ds-2xe6242f-is-4mp-316l-stainless-steel-camera-6mm-lens-30m-i",
            "hikvision-hm-tx3840-15-g0-t1-thermal-tandemvu-smart-linkage-tracking-system-with-4mp-40x-ptz-384x288-thermal-imaging-250m-white-light",
            "hikvision-hm-tx3840-25-g0-t1-thermal-tandemvu-smart-linkage-tracking-system-with-4mp-40x-ptz-384x288-thermal-imaging-audible-alarm",
            "hikvision-ds-2td4238-10-s2-4mp-thermographic-thermal-optical-bi-spectrum-network-speed-dome"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 12,
          "rankedProductIds": [
            "7591859585081",
            "8168582053945",
            "8284597583929",
            "8284597551161",
            "8284597616697",
            "8168599715897",
            "8284591128633",
            "8168608792633",
            "8168599978041",
            "7591806304313",
            "8168577433657",
            "8168422113337"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2tx3636-25a-v1-thermal-smart-linkage-tracking-system",
            "hikvision-explosion-proof-series-ds-2xe6242f-is-4mp-316l-stainless-steel-camera-6mm-lens-30m-i",
            "hikvision-hm-tx3840-15-g0-t1-thermal-tandemvu-smart-linkage-tracking-system-with-4mp-40x-ptz-384x288-thermal-imaging-250m-white-light",
            "hikvision-hm-tx3840-10-g0-t1-thermal-tandemvu-bi-spectrum-bullet-camera-with-optical-ptz-perimeter-protection-smart-detection",
            "hikvision-hm-tx3840-25-g0-t1-thermal-tandemvu-smart-linkage-tracking-system-with-4mp-40x-ptz-384x288-thermal-imaging-audible-alarm",
            "hikvision-hm-td95c8-150ze4fl-w-thermal-optical-bi-spectrum-sphere-ptz-camera-with-smart-analytics",
            "hikvision-thermal-optical-ds-2td4167t-25-w-bi-spectrum-network-speed-dome-camera-with-thermography-25mm-lens-perimeter-protection",
            "hikvision-ds-2td4228t-10-s2-thermal-optical-bi-spectrum-speed-dome-dual-spectrum-ptz-with-temperature-alarm-fire-detection",
            "hikvision-ds-2td4167-50-wy-anti-corrosion-thermal-optical-bi-spectrum-network-speed-dome",
            "hikvision-ds-2td2617-10-qa-thermal-heatpro-cameras-dual-lens-10mm",
            "hikvision-ds-2td4238-10-s2-4mp-thermographic-thermal-optical-bi-spectrum-network-speed-dome",
            "hikvision-ds-2td4228-10-s2-thermal-optical-bi-spectrum-network-speed-dome"
          ]
        }
      }
    },
    "hikvision-turret-cameras-1": {
      "collectionHandle": "hikvision-turret-cameras-1",
      "collectionProductCount": 91,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 11,
          "rankedProductIds": [
            "7591807221817",
            "8168402780217",
            "8168598765625",
            "7591716159545",
            "8168599879737",
            "8284598894649",
            "8284598861881",
            "7591932231737",
            "7591736934457",
            "7591805091897",
            "8284598829113"
          ],
          "rankedProductHandles": [
            "hikvision-acusense-ds-2cd2386g2-isu-sl-ip-camera-8mp-4k-with-sound-strobe-turret-camera-black",
            "hikvision-8mp-acusense-ds-2cd2386g2-isu-sl-ip-turret-camera-4k-with-strobe-audio-fixed-turret-network-camera",
            "hikvision-ds-2cd2386g2h-is2u-sl-8-mp-acusense-turret-camera-with-strobe-light-audio-and-smart-detection",
            "hikvision-acusense-ds-2cd2386g2-isu-sl-ip-camera-8-mp-ir-fixed-turret-network-camera",
            "hikvision-ds-2cd2386g2h-iu-8mp-4k-acusense-turret-network-camera-with-mic",
            "hikvision-heatpro-hm-td1228t-2-g1-t3a-bi-spectrum-thermal-turret-camera-with-temperature-detection",
            "hikvision-heatpro-hm-td1228-2-g1-t3a-bi-spectrum-thermal-turret-camera-with-human-vehicle-detection",
            "hikvision-acusense-black-ds-2cd2386g2-iu-ip-camera-8mp-4k-turret-network-camera-with-mic",
            "hikvision-acusense-ds-2cd2386g2-i-ip-camera-8mp-4k-turret-network-camera",
            "hikvision-acusense-ds-2cd2366g2-iu-ip-camera-6mp-turret-network-camera-white",
            "hikvision-16mp-panoramic-ds-2cd6944g1-ihs-uy-turret-camera-with-180-stitched-view-2-8mm-fixed-lens-ir-20m"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 16,
          "rankedProductIds": [
            "8168599879737",
            "7591622377529",
            "8284597747769",
            "7591807221817",
            "8168402780217",
            "7591932231737",
            "7591807352889",
            "7591736934457",
            "8168599912505",
            "8168598765625",
            "7591697776697",
            "7591697481785",
            "8284598829113",
            "7591624638521",
            "7591624081465",
            "7591716159545"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd2386g2h-iu-8mp-4k-acusense-turret-network-camera-with-mic",
            "hikvision-hik-2cd2h85wdizs-8mp-outdoor-motorised-vf-turret-h-265-ir-io-wdr-ip67-2-8-12mm",
            "hikvision-ids-2cd5387g2-v-xs-8mp-deepinviewx-fixed-turret-camera-with-darkfighter-2-0-human-vehicle-detection-ip67-weather-protection",
            "hikvision-acusense-ds-2cd2386g2-isu-sl-ip-camera-8mp-4k-with-sound-strobe-turret-camera-black",
            "hikvision-8mp-acusense-ds-2cd2386g2-isu-sl-ip-turret-camera-4k-with-strobe-audio-fixed-turret-network-camera",
            "hikvision-acusense-black-ds-2cd2386g2-iu-ip-camera-8mp-4k-turret-network-camera-with-mic",
            "hikvision-acusense-ds-2cd2386g2-i-ip-camera-8mp-4k-turret-network-camera-2",
            "hikvision-acusense-ds-2cd2386g2-i-ip-camera-8mp-4k-turret-network-camera",
            "hikvision-ds-2cd2386g2h-iu-8mp-4k-acusense-turret-network-camera-with-mic-black",
            "hikvision-ds-2cd2386g2h-is2u-sl-8-mp-acusense-turret-camera-with-strobe-light-audio-and-smart-detection",
            "hikvision-ds-2cd2385g1-i-8mp-black-shadow-outdoor-turret-cctv-camera-h-265-30m-ir",
            "hikvision-ds-2cd2385g1-i-8mp-outdoor-turret-cctv-camera-h-265-30m-ir",
            "hikvision-16mp-panoramic-ds-2cd6944g1-ihs-uy-turret-camera-with-180-stitched-view-2-8mm-fixed-lens-ir-20m",
            "hikvision-hik-2cd2385-4blk-8mp-shadow-series-outdoor-turret-camera-30m-ir-120db-wdr-ip67-4mm",
            "hikvision-hik-2cd2385-2blk-8mp-shadow-series-outdoor-turret-camera-30m-ir-120db-wdr-ip67-2-8mm",
            "hikvision-acusense-ds-2cd2386g2-isu-sl-ip-camera-8-mp-ir-fixed-turret-network-camera"
          ]
        }
      }
    },
    "hikvision-tvi-over-coaxial-cameras-tvi4-0-5mp-amp-8mp": {
      "collectionHandle": "hikvision-tvi-over-coaxial-cameras-tvi4-0-5mp-amp-8mp",
      "collectionProductCount": 50,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 2,
          "rankedProductIds": [
            "8284598566969",
            "8284554264633"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2ce72uf3t-ls-tvi4-0-8mp-4k-smart-hybrid-light-turret-tvi-camera",
            "hilook-thc-t257-lms-3k-dual-light-audio-fixed-turret-camera-with-mic-and-smart-hybrid-light"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 2,
          "rankedProductIds": [
            "7591710556217",
            "7591654719545"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2ce16h8t-it3f-tvi4-0-5mp-outdoor-bullet-camera-130db-wdr-60m-ir-4-in-1-ip67-12vdc-2-8mm",
            "hikvision-ds-2ae5225ti-tvi-2mp-outdoor-ptz-camera-25x-zoom-150m-ir"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 4,
          "rankedProductIds": [
            "8284554231865",
            "7591718846521",
            "7591670906937",
            "7591670775865"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2ce76u7t-itmf-8mp-4k-turbo-hd-ultra-low-light-turret-camera-with-30m-ir",
            "hikvision-hik-2ce78u7it3f2-tvi4-0-8mp-outdoor-turret-camera-60m-ir-4-in-1-ip67-12vdc-2-8mm",
            "hikvision-ds-2ce19u8t-it3z-tvi4-0-8mp-outdoor-bullet-camera-4k-wdr-ip67-2-8-12mm-12vdc",
            "hikvision-ds-2ce17u8t-tvi4-0-8mp-outdoor-bullet-camera-4k-ultra-low-light-ip67-2-8mm-12vdc"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 8,
          "rankedProductIds": [
            "7591653343289",
            "8168436891705",
            "7591865024569",
            "7591654719545",
            "7591699775545",
            "7591690108985",
            "8168393244729",
            "7591833174073"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2ce56h5t-itm-tvi4-0-5mp-outdoor-ir-eyeball-dome-camera-20fps-2-8mm",
            "hikvision-ds-2ae4225ti-d-2mp-outdoor-ptz-camera-25x-zoom-100m-ir-1",
            "hikvision-ds-2ae4225ti-d-2mp-outdoor-ptz-camera-25x-zoom-100m-ir",
            "hikvision-ds-2ae5225ti-tvi-2mp-outdoor-ptz-camera-25x-zoom-150m-ir",
            "hikvision-ds-2ae5232t-ac-hd-tvi-2mp-ptz-camera-with-32x-optical-zoom",
            "hikvision-ds-2ae5232t-a3-hd-tvi-2mp-ptz-camera-32x-optical-zoom",
            "hikvision-ds-2ae5225t-a-pro-series-2mp-25-speed-dome-ptz-outdoor-turbohd-darkfighter-performance",
            "hikvision-ds-2ae4225t-d-4-inch-2-mp-25x-powered-by-darkfighter-analog-speed-dome"
          ]
        }
      }
    },
    "hikvision-vandal-resistant-cameras": {
      "collectionHandle": "hikvision-vandal-resistant-cameras",
      "collectionProductCount": 2,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "hikvision-varifocal-cameras": {
      "collectionHandle": "hikvision-varifocal-cameras",
      "collectionProductCount": 27,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 6,
          "rankedProductIds": [
            "8168604893241",
            "8168620949561",
            "7591701086265",
            "8324132470841",
            "8284598108217",
            "8284598009913"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2cd3786g2ht-lizsuy-8mp-smart-hybrid-light-dome-heop-130-db-wdr-dual-illumination-ip67-ik10",
            "hikvision-ds-2cd3766g2ht-lizsuy-6mp-smart-hybrid-motorised-dome-camera-with-darkfighter-s-varifocal-2-7-13-5mm-ir-white-light-supplement-up-to-40m-in-white-or-black",
            "hikvision-ds-2cd2685g1-izs-8mp-outdoor-motorised-vf-bullet-2-8-12mm-with-darkfighter",
            "hikvision-12mp-colorvu-deepinview-ai-turret-camera-with-smart-hybrid-light-motorised-varifocal-lens-audio",
            "hikvision-4mp-deepinview-ids-2cd7a46g2-v-xzhsy-bullet-camera-with-darkfighter-ai-perimeter-protection-2-8-12mm-motorised-varifocal-lens-ir-100m",
            "hikvision-ids-2cd7a45g2-izhsy-4mp-deepinview-moto-varifocal-bullet-camera-with-25x-zoom-darkfighter-2-0-200m-ir"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 4,
          "rankedProductIds": [
            "8324132470841",
            "8168604893241",
            "7591674708025",
            "7591624966201"
          ],
          "rankedProductHandles": [
            "hikvision-12mp-colorvu-deepinview-ai-turret-camera-with-smart-hybrid-light-motorised-varifocal-lens-audio",
            "hikvision-ds-2cd3786g2ht-lizsuy-8mp-smart-hybrid-light-dome-heop-130-db-wdr-dual-illumination-ip67-ik10",
            "hikvision-ds-2cd2765fwd-izs-6mp-outdoor-motorised-vf-dome-cctv-camera-30m-ir-io-2-8-12mm",
            "hikvision-hik-2cd2h55fwd-izs-5mp-outdoor-motorised-vf-dome-h-265-30m-ir-io-wdr-ip67-2-8-12mm"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 16,
          "rankedProductIds": [
            "8168598143033",
            "8168599322681",
            "8168572518457",
            "8168602402873",
            "8324132470841",
            "8168604893241",
            "8284597977145",
            "7591701086265",
            "7591622377529",
            "8168620949561",
            "8284598108217",
            "8284598075449",
            "8284598009913",
            "7591666548793",
            "8284598140985",
            "7591795916857"
          ],
          "rankedProductHandles": [
            "hikvision-ids-2cd7a45g2-p-izhsy-deepinview-4-mp-anpr-bullet-camera-anpr-25x-zoom-ik10-nema-4x",
            "ds-tcg406-e-5-mp-intelligent-entrance-anpr-camera",
            "hikvision-ids-2cd7a45g0-p-izhsy-4-7-118mm-4mp-bullet-anpr-4-7-118mm-200m-ir-heater-nema-4x-60fps",
            "hikvision-ids-2cd7547g0-p-xzhsy-deepinview-4-mp-anpr-moto-varifocal-dome-camera-2-8-12-mm-darkfighters-wdr-ip67-ik10",
            "hikvision-12mp-colorvu-deepinview-ai-turret-camera-with-smart-hybrid-light-motorised-varifocal-lens-audio",
            "hikvision-ds-2cd3786g2ht-lizsuy-8mp-smart-hybrid-light-dome-heop-130-db-wdr-dual-illumination-ip67-ik10",
            "hikvision-ids-2cd7186g2-izhsy-8mp-deepinview-moto-varifocal-dome-camera-with-8-32mm-lens",
            "hikvision-ds-2cd2685g1-izs-8mp-outdoor-motorised-vf-bullet-2-8-12mm-with-darkfighter",
            "hikvision-hik-2cd2h85wdizs-8mp-outdoor-motorised-vf-turret-h-265-ir-io-wdr-ip67-2-8-12mm",
            "hikvision-ds-2cd3766g2ht-lizsuy-6mp-smart-hybrid-motorised-dome-camera-with-darkfighter-s-varifocal-2-7-13-5mm-ir-white-light-supplement-up-to-40m-in-white-or-black",
            "hikvision-4mp-deepinview-ids-2cd7a46g2-v-xzhsy-bullet-camera-with-darkfighter-ai-perimeter-protection-2-8-12mm-motorised-varifocal-lens-ir-100m",
            "hikvision-ids-2cd7a46g2-izhsy-5g-4mp-deepinview-moto-varifocal-bullet-camera-with-darkfighter-2-0-150db-wdr-5g-connectivity",
            "hikvision-ids-2cd7a45g2-izhsy-4mp-deepinview-moto-varifocal-bullet-camera-with-25x-zoom-darkfighter-2-0-200m-ir",
            "hikvision-ds-2cd55c5g0-izh-12mp-ir-vf-dome-network-camera",
            "hikvision-4mp-deepinview-ids-2cd8a46g0-iz-uh-dome-camera-with-ai-detection-2-8-12mm-motorised-varifocal-lens-ir-40m",
            "hikvision-4mp-outdoor-motorised-deepinview-vf-bullet-camera-heater-4-7-118mm"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 2,
          "rankedProductIds": [
            "7591821213753",
            "8284597846073"
          ],
          "rankedProductHandles": [
            "hikvision-ids-2cd7546g0-s-izhsy-4mp-outdoor-motorised-deepinview-vf-dome-camera-2-8-to-12-mm",
            "hikvision-ids-2cd7026g0-ap-2mp-deepinview-box-network-camera-with-deep-learning-analytics-audio-alarm-interface"
          ]
        }
      }
    },
    "hilook-6mp-camera-nvr-kits": {
      "collectionHandle": "hilook-6mp-camera-nvr-kits",
      "collectionProductCount": 17,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 5,
          "rankedProductIds": [
            "8168587526201",
            "8168436367417",
            "8168587722809",
            "8168488042553",
            "8168491909177"
          ],
          "rankedProductHandles": [
            "hilook-by-hikvision-6mp-2x-t361-4-x-t361-6-camera-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-6mp-2x-t269-4-x-t261-6-camera-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-by-hikvision-4-x-6mp-cameras-with-8ch-nvr-cctv-kit-2-x-t269-mu-sl-2-x-t361h-mu-ai-turret-cameras-8ch-nvr-bundle",
            "hilook-hikvision-6mp-8ch-cctv-kit-with-2x-turret-ip-cameras-and-2x-colour-deterrence-cameras",
            "hilook-hikvision-6mp-4ch-cctv-kit-with-4-colour-deterrence-cameras-ipc-t269-mu-sl-2tb-hdd"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 2,
          "rankedProductIds": [
            "8168587264057",
            "8284578021433"
          ],
          "rankedProductHandles": [
            "hilook-by-hikvision-6mp-ipc-361h-mu-acusense-8ch-cctv-kit-8-x-ip-turret-cameras-8ch-nvr",
            "hilook-hikvision-6mp-acusense-cctv-kit-8x-turret-ipc-t361h-mu-8ch-poe-nvr-4tb-2-x-wall"
          ]
        }
      }
    },
    "hilook-6mp-cameras": {
      "collectionHandle": "hilook-6mp-cameras",
      "collectionProductCount": 23,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "hilook-6mp-ipc-t363h-mu-kits": {
      "collectionHandle": "hilook-6mp-ipc-t363h-mu-kits",
      "collectionProductCount": 5,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "hilook-6mp-t262h-mu-kits": {
      "collectionHandle": "hilook-6mp-t262h-mu-kits",
      "collectionProductCount": 3,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 2,
          "rankedProductIds": [
            "8168436367417",
            "8168488042553"
          ],
          "rankedProductHandles": [
            "hilook-6mp-2x-t269-4-x-t261-6-camera-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-hikvision-6mp-8ch-cctv-kit-with-2x-turret-ip-cameras-and-2x-colour-deterrence-cameras"
          ]
        }
      }
    },
    "hilook-6mp-t262h-mu-kits-1": {
      "collectionHandle": "hilook-6mp-t262h-mu-kits-1",
      "collectionProductCount": 7,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 2,
          "rankedProductIds": [
            "7591977615417",
            "7591977779257"
          ],
          "rankedProductHandles": [
            "hilook-4-x-6mp-cameras-cctv-kit-1-x-strobe-3-x-ai-turret-cameras-4ch-or-8ch-nvr-bundle",
            "hilook-4-x-6mp-cameras-8ch-nvr-cctv-kit-4-ai-turret-cameras-8ch-nvr-bundle"
          ]
        }
      }
    },
    "hilook-6mp-t269mu-sl-kits": {
      "collectionHandle": "hilook-6mp-t269mu-sl-kits",
      "collectionProductCount": 6,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 3,
          "rankedProductIds": [
            "8168587526201",
            "8168436367417",
            "8168587722809"
          ],
          "rankedProductHandles": [
            "hilook-by-hikvision-6mp-2x-t361-4-x-t361-6-camera-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-6mp-2x-t269-4-x-t261-6-camera-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-by-hikvision-4-x-6mp-cameras-with-8ch-nvr-cctv-kit-2-x-t269-mu-sl-2-x-t361h-mu-ai-turret-cameras-8ch-nvr-bundle"
          ]
        }
      }
    },
    "hilook-6mp-t361h-mu-kits": {
      "collectionHandle": "hilook-6mp-t361h-mu-kits",
      "collectionProductCount": 11,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 2,
          "rankedProductIds": [
            "8168587526201",
            "8168587722809"
          ],
          "rankedProductHandles": [
            "hilook-by-hikvision-6mp-2x-t361-4-x-t361-6-camera-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-by-hikvision-4-x-6mp-cameras-with-8ch-nvr-cctv-kit-2-x-t269-mu-sl-2-x-t361h-mu-ai-turret-cameras-8ch-nvr-bundle"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 2,
          "rankedProductIds": [
            "8168587264057",
            "8284578021433"
          ],
          "rankedProductHandles": [
            "hilook-by-hikvision-6mp-ipc-361h-mu-acusense-8ch-cctv-kit-8-x-ip-turret-cameras-8ch-nvr",
            "hilook-hikvision-6mp-acusense-cctv-kit-8x-turret-ipc-t361h-mu-8ch-poe-nvr-4tb-2-x-wall"
          ]
        }
      }
    },
    "hilook-8mp-camera-nvr-kits": {
      "collectionHandle": "hilook-8mp-camera-nvr-kits",
      "collectionProductCount": 13,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 3,
          "rankedProductIds": [
            "8168592146489",
            "8168591949881",
            "8168591786041"
          ],
          "rankedProductHandles": [
            "hilook-by-hikvision-8mp-4k-acusense-6-camera-8ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-by-hikvision-8mp-4k-acusense-8-camera-8ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-by-hikvision-8mp-4k-acusense-4-camera-4ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 7,
          "rankedProductIds": [
            "8168594899001",
            "8168594374713",
            "8168594800697",
            "8168592146489",
            "8168588247097",
            "8168591949881",
            "8168594604089"
          ],
          "rankedProductHandles": [
            "hilook-by-hikvision-8mp-ipc-t383h-mu-acusense-8-x-camera-8ch-nvr-cctv-turret-kit",
            "hilook-by-hikvision-8mp-ipc-t383h-mu-acusense-6-x-camera-8ch-nvr-turret-kit",
            "hilook-by-hikvision-8mp-ipc-t381h-mu-acusense-8-x-camera-8ch-nvr-cctv-turret-kit",
            "hilook-by-hikvision-8mp-4k-acusense-6-camera-8ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-by-hikvision-8mp-ipc-t381h-mu-acusense-6-x-camera-8ch-nvr-turret-kit",
            "hilook-by-hikvision-8mp-4k-acusense-8-camera-8ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-by-hikvision-8mp-ipc-t383h-mu-acusense-8-x-camera-16ch-nvr-cctv-turret-kit"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 8,
          "rankedProductIds": [
            "8168594899001",
            "8168594604089",
            "8168594800697",
            "8168591949881",
            "8168588312633",
            "8168594374713",
            "8168592146489",
            "8168588247097"
          ],
          "rankedProductHandles": [
            "hilook-by-hikvision-8mp-ipc-t383h-mu-acusense-8-x-camera-8ch-nvr-cctv-turret-kit",
            "hilook-by-hikvision-8mp-ipc-t383h-mu-acusense-8-x-camera-16ch-nvr-cctv-turret-kit",
            "hilook-by-hikvision-8mp-ipc-t381h-mu-acusense-8-x-camera-8ch-nvr-cctv-turret-kit",
            "hilook-by-hikvision-8mp-4k-acusense-8-camera-8ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-by-hikvision-8mp-ipc-t381h-mu-acusense-8-x-camera-16ch-nvr-cctv-turret-kit",
            "hilook-by-hikvision-8mp-ipc-t383h-mu-acusense-6-x-camera-8ch-nvr-turret-kit",
            "hilook-by-hikvision-8mp-4k-acusense-6-camera-8ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-by-hikvision-8mp-ipc-t381h-mu-acusense-6-x-camera-8ch-nvr-turret-kit"
          ]
        }
      }
    },
    "hilook-8mp-cameras": {
      "collectionHandle": "hilook-8mp-cameras",
      "collectionProductCount": 18,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 2,
          "rankedProductIds": [
            "8168590016569",
            "8168590147641"
          ],
          "rankedProductHandles": [
            "hilook-ipc-t289ph-mu-sl-8mp-180-turret-camera-with-active-blue-red-strobe-and-two-way-audio-ir-30m-2-8mm-4mm",
            "hilook-ipc-t289ph-mu-sl-blk-8mp-180-turret-camera-with-active-blue-red-strobe-and-two-way-audio-ir-30m-2-8mm-black"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 4,
          "rankedProductIds": [
            "8168592801849",
            "8168596766777",
            "8168590016569",
            "8168590147641"
          ],
          "rankedProductHandles": [
            "hilook-ipc-t383h-mu-pro-series-8mp-acusense-turret-ip-camera-with-built-in-mic",
            "hilook-ipc-t383h-mu-pro-8mp-acusense-turret-ip-camera-with-mic-colour-night-black",
            "hilook-ipc-t289ph-mu-sl-8mp-180-turret-camera-with-active-blue-red-strobe-and-two-way-audio-ir-30m-2-8mm-4mm",
            "hilook-ipc-t289ph-mu-sl-blk-8mp-180-turret-camera-with-active-blue-red-strobe-and-two-way-audio-ir-30m-2-8mm-black"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 2,
          "rankedProductIds": [
            "8168589951033",
            "8168592801849"
          ],
          "rankedProductHandles": [
            "hilook-pro-by-hikvision-ipc-t581h-mu_blk-8mp-hi-color-fixed-turret-network-camera-black",
            "hilook-ipc-t383h-mu-pro-series-8mp-acusense-turret-ip-camera-with-built-in-mic"
          ]
        },
        "two-way-audio": {
          "displayName": "Two-way audio",
          "productCount": 2,
          "rankedProductIds": [
            "8168590016569",
            "8168590147641"
          ],
          "rankedProductHandles": [
            "hilook-ipc-t289ph-mu-sl-8mp-180-turret-camera-with-active-blue-red-strobe-and-two-way-audio-ir-30m-2-8mm-4mm",
            "hilook-ipc-t289ph-mu-sl-blk-8mp-180-turret-camera-with-active-blue-red-strobe-and-two-way-audio-ir-30m-2-8mm-black"
          ]
        }
      }
    },
    "hilook-8mp-t282h-mu-kits": {
      "collectionHandle": "hilook-8mp-t282h-mu-kits",
      "collectionProductCount": 1,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "hilook-8mp-t289mu-sl-kits": {
      "collectionHandle": "hilook-8mp-t289mu-sl-kits",
      "collectionProductCount": 4,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 3,
          "rankedProductIds": [
            "8168592146489",
            "8168591949881",
            "8168591786041"
          ],
          "rankedProductHandles": [
            "hilook-by-hikvision-8mp-4k-acusense-6-camera-8ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-by-hikvision-8mp-4k-acusense-8-camera-8ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-by-hikvision-8mp-4k-acusense-4-camera-4ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 2,
          "rankedProductIds": [
            "8168592146489",
            "8168591949881"
          ],
          "rankedProductHandles": [
            "hilook-by-hikvision-8mp-4k-acusense-6-camera-8ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-by-hikvision-8mp-4k-acusense-8-camera-8ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 2,
          "rankedProductIds": [
            "8168591949881",
            "8168592146489"
          ],
          "rankedProductHandles": [
            "hilook-by-hikvision-8mp-4k-acusense-8-camera-8ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-by-hikvision-8mp-4k-acusense-6-camera-8ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance"
          ]
        }
      }
    },
    "hilook-8mp-t381h-mu-kits": {
      "collectionHandle": "hilook-8mp-t381h-mu-kits",
      "collectionProductCount": 4,
      "renderedProductLimit": 250,
      "needs": {
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 2,
          "rankedProductIds": [
            "8168588247097",
            "8168594800697"
          ],
          "rankedProductHandles": [
            "hilook-by-hikvision-8mp-ipc-t381h-mu-acusense-6-x-camera-8ch-nvr-turret-kit",
            "hilook-by-hikvision-8mp-ipc-t381h-mu-acusense-8-x-camera-8ch-nvr-cctv-turret-kit"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 3,
          "rankedProductIds": [
            "8168594800697",
            "8168588312633",
            "8168588247097"
          ],
          "rankedProductHandles": [
            "hilook-by-hikvision-8mp-ipc-t381h-mu-acusense-8-x-camera-8ch-nvr-cctv-turret-kit",
            "hilook-by-hikvision-8mp-ipc-t381h-mu-acusense-8-x-camera-16ch-nvr-cctv-turret-kit",
            "hilook-by-hikvision-8mp-ipc-t381h-mu-acusense-6-x-camera-8ch-nvr-turret-kit"
          ]
        }
      }
    },
    "hilook-8mp-t383h-mu-kits": {
      "collectionHandle": "hilook-8mp-t383h-mu-kits",
      "collectionProductCount": 4,
      "renderedProductLimit": 250,
      "needs": {
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 2,
          "rankedProductIds": [
            "8168594899001",
            "8168594374713"
          ],
          "rankedProductHandles": [
            "hilook-by-hikvision-8mp-ipc-t383h-mu-acusense-8-x-camera-8ch-nvr-cctv-turret-kit",
            "hilook-by-hikvision-8mp-ipc-t383h-mu-acusense-6-x-camera-8ch-nvr-turret-kit"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 3,
          "rankedProductIds": [
            "8168594899001",
            "8168594604089",
            "8168594374713"
          ],
          "rankedProductHandles": [
            "hilook-by-hikvision-8mp-ipc-t383h-mu-acusense-8-x-camera-8ch-nvr-cctv-turret-kit",
            "hilook-by-hikvision-8mp-ipc-t383h-mu-acusense-8-x-camera-16ch-nvr-cctv-turret-kit",
            "hilook-by-hikvision-8mp-ipc-t383h-mu-acusense-6-x-camera-8ch-nvr-turret-kit"
          ]
        }
      }
    },
    "hilook-cctv-camera-kits": {
      "collectionHandle": "hilook-cctv-camera-kits",
      "collectionProductCount": 51,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 2,
          "rankedProductIds": [
            "8168592277561",
            "7591860797497"
          ],
          "rankedProductHandles": [
            "hilook-by-hikvision-8mp-4k-2-camera-kit-with-2-x-ai-intellisense-full-color-built-in-audio-4ch-4k-nvr",
            "hilook-6mp-2-camera-kit-with-2-x-ai-intellisense-full-color-built-in-audio-4ch-4k-nvr"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 18,
          "rankedProductIds": [
            "7591977615417",
            "7690799644729",
            "7690799153209",
            "8168592146489",
            "8168591949881",
            "7591848312889",
            "7591934033977",
            "8168587526201",
            "8168436367417",
            "7591861026873",
            "8168591786041",
            "7591848116281",
            "7591978795065",
            "7591977779257",
            "7591860797497",
            "8168587722809",
            "8168488042553",
            "8168491909177"
          ],
          "rankedProductHandles": [
            "hilook-4-x-6mp-cameras-cctv-kit-1-x-strobe-3-x-ai-turret-cameras-4ch-or-8ch-nvr-bundle",
            "hikvision-hilook-6mp-acusense-4-camera-cctv-kit-acdc-light-speaker-strobe-black",
            "hikvision-hilook-6mp-acusense-4-camera-cctv-kit-acdc-light-speaker-strobe",
            "hilook-by-hikvision-8mp-4k-acusense-6-camera-8ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-by-hikvision-8mp-4k-acusense-8-camera-8ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-6mp-acusense-6-camera-8ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-8mp-t282-acusense-6-x-camera-8ch-nvr-turret-kit",
            "hilook-by-hikvision-6mp-2x-t361-4-x-t361-6-camera-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-6mp-2x-t269-4-x-t261-6-camera-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-6mp-acusense-8-camera-8ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-by-hikvision-8mp-4k-acusense-4-camera-4ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-6mp-acusense-4-camera-4ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-6mp-acusense-4-camera-4ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance-with-2tb",
            "hilook-4-x-6mp-cameras-8ch-nvr-cctv-kit-4-ai-turret-cameras-8ch-nvr-bundle",
            "hilook-6mp-2-camera-kit-with-2-x-ai-intellisense-full-color-built-in-audio-4ch-4k-nvr",
            "hilook-by-hikvision-4-x-6mp-cameras-with-8ch-nvr-cctv-kit-2-x-t269-mu-sl-2-x-t361h-mu-ai-turret-cameras-8ch-nvr-bundle",
            "hilook-hikvision-6mp-8ch-cctv-kit-with-2x-turret-ip-cameras-and-2x-colour-deterrence-cameras",
            "hilook-hikvision-6mp-4ch-cctv-kit-with-4-colour-deterrence-cameras-ipc-t269-mu-sl-2tb-hdd"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 18,
          "rankedProductIds": [
            "8168594899001",
            "8168594374713",
            "8168594800697",
            "8168592146489",
            "8168593686585",
            "8168591949881",
            "8168588247097",
            "8168594604089",
            "7591934033977",
            "8168591786041",
            "8168588312633",
            "8168594079801",
            "7591934230585",
            "8168588476473",
            "7690799579193",
            "8168592277561",
            "8168436170809",
            "8168472084537"
          ],
          "rankedProductHandles": [
            "hilook-by-hikvision-8mp-ipc-t383h-mu-acusense-8-x-camera-8ch-nvr-cctv-turret-kit",
            "hilook-by-hikvision-8mp-ipc-t383h-mu-acusense-6-x-camera-8ch-nvr-turret-kit",
            "hilook-by-hikvision-8mp-ipc-t381h-mu-acusense-8-x-camera-8ch-nvr-cctv-turret-kit",
            "hilook-by-hikvision-8mp-4k-acusense-6-camera-8ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-6mp-6-camera-ipc-t363h-mu-acusense-4-camera-8ch-turret-kit",
            "hilook-by-hikvision-8mp-4k-acusense-8-camera-8ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-by-hikvision-8mp-ipc-t381h-mu-acusense-6-x-camera-8ch-nvr-turret-kit",
            "hilook-by-hikvision-8mp-ipc-t383h-mu-acusense-8-x-camera-16ch-nvr-cctv-turret-kit",
            "hilook-8mp-t282-acusense-6-x-camera-8ch-nvr-turret-kit",
            "hilook-by-hikvision-8mp-4k-acusense-4-camera-4ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-by-hikvision-8mp-ipc-t381h-mu-acusense-8-x-camera-16ch-nvr-cctv-turret-kit",
            "hilook-by-hikvision-8mp-ipc-t383h-mu-acusense-4-x-camera-8ch-nvr-turret-kit",
            "hilook-8mp-ipc-t282h-mu-acusense-8-x-camera-16ch-nvr-cctv-turret-kit",
            "hilook-by-hikvision-8mp-ipc-t381h-mu-acusense-4-x-camera-8ch-nvr-turret-kit",
            "hikvision-hilook-8mp-ipc-t282h-mu-acusense-4-x-camera-8ch-nvr-turret-cctv-kit-black",
            "hilook-by-hikvision-8mp-4k-2-camera-kit-with-2-x-ai-intellisense-full-color-built-in-audio-4ch-4k-nvr",
            "hilook-6mp-2-camera-kit-with-ai-intellisense-full-color-built-in-audio-4ch-4k-nvr",
            "hilook-8mp-ipc-t282h-mu-acusense-4-x-camera-8ch-nvr-turret-kit"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 16,
          "rankedProductIds": [
            "8168594899001",
            "8168594604089",
            "8168594800697",
            "8168591949881",
            "8168588312633",
            "7591934230585",
            "8168593883193",
            "8284578021433",
            "8168594374713",
            "8168587264057",
            "8168592146489",
            "7591922171961",
            "7591861026873",
            "8168588247097",
            "7591934033977",
            "7591978172473"
          ],
          "rankedProductHandles": [
            "hilook-by-hikvision-8mp-ipc-t383h-mu-acusense-8-x-camera-8ch-nvr-cctv-turret-kit",
            "hilook-by-hikvision-8mp-ipc-t383h-mu-acusense-8-x-camera-16ch-nvr-cctv-turret-kit",
            "hilook-by-hikvision-8mp-ipc-t381h-mu-acusense-8-x-camera-8ch-nvr-cctv-turret-kit",
            "hilook-by-hikvision-8mp-4k-acusense-8-camera-8ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-by-hikvision-8mp-ipc-t381h-mu-acusense-8-x-camera-16ch-nvr-cctv-turret-kit",
            "hilook-8mp-ipc-t282h-mu-acusense-8-x-camera-16ch-nvr-cctv-turret-kit",
            "hilook-6mp-8-camera-ipc-t363h-mu-acusense-8-camera-8ch-turret-kit",
            "hilook-hikvision-6mp-acusense-cctv-kit-8x-turret-ipc-t361h-mu-8ch-poe-nvr-4tb-2-x-wall",
            "hilook-by-hikvision-8mp-ipc-t383h-mu-acusense-6-x-camera-8ch-nvr-turret-kit",
            "hilook-by-hikvision-6mp-ipc-361h-mu-acusense-8ch-cctv-kit-8-x-ip-turret-cameras-8ch-nvr",
            "hilook-by-hikvision-8mp-4k-acusense-6-camera-8ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-6mp-ipc-t262h-mu-acusense-8ch-cctv-kit-8-x-ip-turret-cameras-8ch-nvr",
            "hilook-6mp-acusense-8-camera-8ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-by-hikvision-8mp-ipc-t381h-mu-acusense-6-x-camera-8ch-nvr-turret-kit",
            "hilook-8mp-t282-acusense-6-x-camera-8ch-nvr-turret-kit",
            "hikvision-8-x-6mp-cameras-kit-8-acusense-turret-cameras-8-channel-8k-nvr-security-camera-system"
          ]
        }
      }
    },
    "hilook-ip-cameras": {
      "collectionHandle": "hilook-ip-cameras",
      "collectionProductCount": 36,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 5,
          "rankedProductIds": [
            "7690799644729",
            "7690799153209",
            "7591889076281",
            "7837253533753",
            "7591844413497"
          ],
          "rankedProductHandles": [
            "hikvision-hilook-6mp-acusense-4-camera-cctv-kit-acdc-light-speaker-strobe-black",
            "hikvision-hilook-6mp-acusense-4-camera-cctv-kit-acdc-light-speaker-strobe",
            "hilook-6mp-ipc-t269-mu-sl-all-in-one-camera-with-blue-red-strobe-audio-acdc-black",
            "hilook-by-hikvision-8mp-ipc-t289-mu-sl-all-in-one-camera-with-blue-red-strobe-audio-acdc",
            "hilook-6mp-ipc-t269-mu-sl-all-in-one-camera-with-blue-red-strobe-audio"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 5,
          "rankedProductIds": [
            "7836203679801",
            "7591933739065",
            "7591774388281",
            "7591727497273",
            "7591833501753"
          ],
          "rankedProductHandles": [
            "hikvision-ds-d5c86rb-b-86-inch-4k-interactive-touch-screen-display-monitor-w-camera-and-microphone-array",
            "hilook-8mp-ipc-t282h-mu-acusense-turret-ip-camera-with-built-in-mic",
            "hilook-8mp-ipc-t281h-acusense-turret-ip-camera-with-built-in-mic",
            "hilook-8mp-ipc-t280h-mu-02-turret-ip-camera-with-built-in-mic",
            "hilook-5mp-ipc-t651h-z-motorised-turret-network-camera-2-812mm-motorized-lens"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 6,
          "rankedProductIds": [
            "7837253533753",
            "7591728480313",
            "7591728414777",
            "7591728283705",
            "7591844413497",
            "7591816626233"
          ],
          "rankedProductHandles": [
            "hilook-by-hikvision-8mp-ipc-t289-mu-sl-all-in-one-camera-with-blue-red-strobe-audio-acdc",
            "hilook-4mp-ptz-n2404i-de3-ptz-network-ir-vandal-dome-camera-4x-optical-zoom",
            "hilook-4mp-ipc-b640h-z-motorized-lens-network-ir-bullet-2-812mm-motorised-network-camera",
            "hilook-4mp-ipc-d640h-z-motorized-lens-network-ir-vandal-dome-2-812mm-motorised-network-camera",
            "hilook-6mp-ipc-t269-mu-sl-all-in-one-camera-with-blue-red-strobe-audio",
            "hilook-ptz-n2404i-de3-ptz-2-inch-4-mp-4x-powered-by-darkfighter-ir-network-speed-dome"
          ]
        }
      }
    },
    "hilook-ip-cameras-hilook-2": {
      "collectionHandle": "hilook-ip-cameras-hilook-2",
      "collectionProductCount": 37,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 3,
          "rankedProductIds": [
            "8168541519929",
            "8168629993529",
            "8168592965689"
          ],
          "rankedProductHandles": [
            "hilook-by-hikvision-ptz-n3404liu-sl-4-mp-4-x-intelligent-network-ptz-2-way-audio-flashing-lights",
            "hilook-ptz-n4215-de3-2mp-15x-optical-zoom-ptz-network-dome-camera",
            "hilook-by-hikvision-6mp-ipc-t363h-mu-acusense-turret-ip-camera-with-mic-colour-night-black"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 4,
          "rankedProductIds": [
            "8168592801849",
            "8168596766777",
            "8168541519929",
            "8168484601913"
          ],
          "rankedProductHandles": [
            "hilook-ipc-t383h-mu-pro-series-8mp-acusense-turret-ip-camera-with-built-in-mic",
            "hilook-ipc-t383h-mu-pro-8mp-acusense-turret-ip-camera-with-mic-colour-night-black",
            "hilook-by-hikvision-ptz-n3404liu-sl-4-mp-4-x-intelligent-network-ptz-2-way-audio-flashing-lights",
            "hilook-8mp-ipc-t180h-mu-4k-turret-ip-camera-with-built-in-mic-no-ai"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 5,
          "rankedProductIds": [
            "8168629993529",
            "8168592801849",
            "8168541519929",
            "8168589721657",
            "8168588050489"
          ],
          "rankedProductHandles": [
            "hilook-ptz-n4215-de3-2mp-15x-optical-zoom-ptz-network-dome-camera",
            "hilook-ipc-t383h-mu-pro-series-8mp-acusense-turret-ip-camera-with-built-in-mic",
            "hilook-by-hikvision-ptz-n3404liu-sl-4-mp-4-x-intelligent-network-ptz-2-way-audio-flashing-lights",
            "hilook-by-hikvision-ipc-t561h-mu-6mp-hi-color-fixed-turret-network-camera-black",
            "hilook-by-hikvision-ptz-n4215i-de-2mp-15x-network-ptz-dome-camera"
          ]
        }
      }
    },
    "hilook-pro-series": {
      "collectionHandle": "hilook-pro-series",
      "collectionProductCount": 8,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 2,
          "rankedProductIds": [
            "8168590016569",
            "8168590147641"
          ],
          "rankedProductHandles": [
            "hilook-ipc-t289ph-mu-sl-8mp-180-turret-camera-with-active-blue-red-strobe-and-two-way-audio-ir-30m-2-8mm-4mm",
            "hilook-ipc-t289ph-mu-sl-blk-8mp-180-turret-camera-with-active-blue-red-strobe-and-two-way-audio-ir-30m-2-8mm-black"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 2,
          "rankedProductIds": [
            "8168590016569",
            "8168590147641"
          ],
          "rankedProductHandles": [
            "hilook-ipc-t289ph-mu-sl-8mp-180-turret-camera-with-active-blue-red-strobe-and-two-way-audio-ir-30m-2-8mm-4mm",
            "hilook-ipc-t289ph-mu-sl-blk-8mp-180-turret-camera-with-active-blue-red-strobe-and-two-way-audio-ir-30m-2-8mm-black"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 2,
          "rankedProductIds": [
            "8168589951033",
            "8168589721657"
          ],
          "rankedProductHandles": [
            "hilook-pro-by-hikvision-ipc-t581h-mu_blk-8mp-hi-color-fixed-turret-network-camera-black",
            "hilook-by-hikvision-ipc-t561h-mu-6mp-hi-color-fixed-turret-network-camera-black"
          ]
        },
        "two-way-audio": {
          "displayName": "Two-way audio",
          "productCount": 2,
          "rankedProductIds": [
            "8168590016569",
            "8168590147641"
          ],
          "rankedProductHandles": [
            "hilook-ipc-t289ph-mu-sl-8mp-180-turret-camera-with-active-blue-red-strobe-and-two-way-audio-ir-30m-2-8mm-4mm",
            "hilook-ipc-t289ph-mu-sl-blk-8mp-180-turret-camera-with-active-blue-red-strobe-and-two-way-audio-ir-30m-2-8mm-black"
          ]
        }
      }
    },
    "hilook-ptz-cameras": {
      "collectionHandle": "hilook-ptz-cameras",
      "collectionProductCount": 3,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 2,
          "rankedProductIds": [
            "8168541519929",
            "8168629993529"
          ],
          "rankedProductHandles": [
            "hilook-by-hikvision-ptz-n3404liu-sl-4-mp-4-x-intelligent-network-ptz-2-way-audio-flashing-lights",
            "hilook-ptz-n4215-de3-2mp-15x-optical-zoom-ptz-network-dome-camera"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 2,
          "rankedProductIds": [
            "8168629993529",
            "8168541519929"
          ],
          "rankedProductHandles": [
            "hilook-ptz-n4215-de3-2mp-15x-optical-zoom-ptz-network-dome-camera",
            "hilook-by-hikvision-ptz-n3404liu-sl-4-mp-4-x-intelligent-network-ptz-2-way-audio-flashing-lights"
          ]
        }
      }
    },
    "idis": {
      "collectionHandle": "idis",
      "collectionProductCount": 3,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "inception-1": {
      "collectionHandle": "inception-1",
      "collectionProductCount": 2,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "lightfighter-ptz-cameras-1": {
      "collectionHandle": "lightfighter-ptz-cameras-1",
      "collectionProductCount": 1,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "mobotix-1": {
      "collectionHandle": "mobotix-1",
      "collectionProductCount": 2,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "multi-sensor-cameras": {
      "collectionHandle": "multi-sensor-cameras",
      "collectionProductCount": 1,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "network-camera-brackets-2": {
      "collectionHandle": "network-camera-brackets-2",
      "collectionProductCount": 15,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "nx-witness-1": {
      "collectionHandle": "nx-witness-1",
      "collectionProductCount": 4,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "ptz-camera-brackets-1": {
      "collectionHandle": "ptz-camera-brackets-1",
      "collectionProductCount": 25,
      "renderedProductLimit": 250,
      "needs": {
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 16,
          "rankedProductIds": [
            "8168627208249",
            "7591806533689",
            "8168624193593",
            "7591806795833",
            "7591806664761",
            "7591806500921",
            "8168627142713",
            "7591674380345",
            "7591662321721",
            "7591642497081",
            "7591594197049",
            "7591593869369",
            "7591593738297",
            "7591593607225",
            "7591593443385",
            "7591588069433"
          ],
          "rankedProductHandles": [
            "hikvision-ds-1673zj-p-horizontal-pole-mount-bracket",
            "hikvision-ds-1604zj-corner-corner-wall-mount-bracketfor-ptz-cameras",
            "hikvision-ds-4603zj-waac-wall-mount-bracket-outdoor-aluminium-alloy-arm-for-ptz-cameras",
            "hikvision-ds-1604zj-pole-corner-wall-mount-bracket-for-ptz-cameras",
            "hikvision-ds-1602zj-box-pole-vertical-pole-mount-bracket-with-junction-box-for-ptz-cameras",
            "hikvision-ds-1602zj-box-corner-wall-mount-bracket-with-junction-box-for-ptz-cameras",
            "hikvision-ds-4603zj-paac-aluminium-wall-mount-bracket-for-ptz-dome-cameras-indoor-outdoor-rated",
            "hikvision-ds-1604zj-box-corner-corner-mount-bracket-junction-box-ptz-cameras",
            "hikvision-ds-1602zj-pole-vertical-pole-mount-bracket-ptz-cameras",
            "hikvision-ds-1604zj-box-pole-vertical-pole-mount-bracket-junction-box-ptz-cameras",
            "hikvision-hik-1693zj-wall-mount-bracket-for-ptz-positioner-camera",
            "hikvision-hik-1663zj-ceiling-mount-bracket-for-ptz-cameras",
            "hikvision-hik-1619zj-gooseneck-mount-bracket-for-ptz-cameras",
            "hikvision-hik-1602zjboxpol-vertical-pole-mount-bracket-with-junction-box-for-ptz-cameras",
            "hikvision-hik-1602zjboxcnr-wall-mount-bracket-with-junction-box-for-ptz-cameras-2",
            "hikvision-hik-1602zjboxcnr-wall-mount-bracket-with-junction-box-for-ptz-cameras"
          ]
        }
      }
    },
    "solar-cameras": {
      "collectionHandle": "solar-cameras",
      "collectionProductCount": 8,
      "renderedProductLimit": 250,
      "needs": {
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 2,
          "rankedProductIds": [
            "8168623833145",
            "8168597389369"
          ],
          "rankedProductHandles": [
            "hikvision-ds-2de5425iwg-4g-4mp-pro-solar-powered-ptz-camera-with-25x-zoom-256gb-emmc-ir-150m-solar-panel-battery-ip66",
            "tp-link-vigi-sp6020-intelligent-solar-power-supply-system-60w-with-vigi-c540-4g"
          ]
        }
      }
    },
    "solar-cameras-1": {
      "collectionHandle": "solar-cameras-1",
      "collectionProductCount": 3,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "superspecials-1": {
      "collectionHandle": "superspecials-1",
      "collectionProductCount": 37,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 2,
          "rankedProductIds": [
            "8168592277561",
            "7591860797497"
          ],
          "rankedProductHandles": [
            "hilook-by-hikvision-8mp-4k-2-camera-kit-with-2-x-ai-intellisense-full-color-built-in-audio-4ch-4k-nvr",
            "hilook-6mp-2-camera-kit-with-2-x-ai-intellisense-full-color-built-in-audio-4ch-4k-nvr"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 16,
          "rankedProductIds": [
            "7690799644729",
            "7690799153209",
            "8168592146489",
            "8168591949881",
            "8168587526201",
            "8168436367417",
            "8168591786041",
            "7591848312889",
            "7591861026873",
            "7591978795065",
            "7591848116281",
            "7591860797497",
            "8168491909177",
            "7591811514425",
            "7591809384505",
            "7591810007097"
          ],
          "rankedProductHandles": [
            "hikvision-hilook-6mp-acusense-4-camera-cctv-kit-acdc-light-speaker-strobe-black",
            "hikvision-hilook-6mp-acusense-4-camera-cctv-kit-acdc-light-speaker-strobe",
            "hilook-by-hikvision-8mp-4k-acusense-6-camera-8ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-by-hikvision-8mp-4k-acusense-8-camera-8ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-by-hikvision-6mp-2x-t361-4-x-t361-6-camera-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-6mp-2x-t269-4-x-t261-6-camera-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-by-hikvision-8mp-4k-acusense-4-camera-4ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-6mp-acusense-6-camera-8ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-6mp-acusense-8-camera-8ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-6mp-acusense-4-camera-4ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance-with-2tb",
            "hilook-6mp-acusense-4-camera-4ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-6mp-2-camera-kit-with-2-x-ai-intellisense-full-color-built-in-audio-4ch-4k-nvr",
            "hilook-hikvision-6mp-4ch-cctv-kit-with-4-colour-deterrence-cameras-ipc-t269-mu-sl-2tb-hdd",
            "dahua-8-x-6mp-dh-ipc-hdw3666emp-s-aus-smd-4-0-ai-turret-kit-50m-ir-2-8mm-with-smd-8ch-nvr",
            "dahua-6-x-6mp-dh-ipc-hdw3666emp-s-aus-smd-4-0-ai-turret-kit-50m-ir-2-8mm-with-smd-8ch-nvr-2tb-hdd-wizsense",
            "dahua-4-x-6mp-dh-ipc-hdw3666emp-s-aus-smd-4-0-ai-turret-security-kit-50m-ir-2-8mm-4ch-nvr-2tb-hdd-black"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 7,
          "rankedProductIds": [
            "8168592146489",
            "8168591949881",
            "8168591786041",
            "7591778025529",
            "8168414511161",
            "8168592277561",
            "8168436170809"
          ],
          "rankedProductHandles": [
            "hilook-by-hikvision-8mp-4k-acusense-6-camera-8ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-by-hikvision-8mp-4k-acusense-8-camera-8ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-by-hikvision-8mp-4k-acusense-4-camera-4ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "8mp-8ch-hikvision-cctv-kit-8-x-outdoor-acusense-turret-cameras-16ch-nvr-with-3tb",
            "8mp-16ch-hikvision-cctv-kit-8-x-outdoor-acusense-turret-cameras-16ch-nvr-with-4tb",
            "hilook-by-hikvision-8mp-4k-2-camera-kit-with-2-x-ai-intellisense-full-color-built-in-audio-4ch-4k-nvr",
            "hilook-6mp-2-camera-kit-with-ai-intellisense-full-color-built-in-audio-4ch-4k-nvr"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 7,
          "rankedProductIds": [
            "8168591949881",
            "7591778025529",
            "8168587264057",
            "8168414511161",
            "8168592146489",
            "7591922171961",
            "7591861026873"
          ],
          "rankedProductHandles": [
            "hilook-by-hikvision-8mp-4k-acusense-8-camera-8ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "8mp-8ch-hikvision-cctv-kit-8-x-outdoor-acusense-turret-cameras-16ch-nvr-with-3tb",
            "hilook-by-hikvision-6mp-ipc-361h-mu-acusense-8ch-cctv-kit-8-x-ip-turret-cameras-8ch-nvr",
            "8mp-16ch-hikvision-cctv-kit-8-x-outdoor-acusense-turret-cameras-16ch-nvr-with-4tb",
            "hilook-by-hikvision-8mp-4k-acusense-6-camera-8ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance",
            "hilook-6mp-ipc-t262h-mu-acusense-8ch-cctv-kit-8-x-ip-turret-cameras-8ch-nvr",
            "hilook-6mp-acusense-8-camera-8ch-nvr-kit-acdc-all-in-one-camera-with-colour-deterrance"
          ]
        }
      }
    },
    "tp-link-4mp-cameras": {
      "collectionHandle": "tp-link-4mp-cameras",
      "collectionProductCount": 2,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "tp-link-5mp-cameras": {
      "collectionHandle": "tp-link-5mp-cameras",
      "collectionProductCount": 5,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "tp-link-8mp-cameras": {
      "collectionHandle": "tp-link-8mp-cameras",
      "collectionProductCount": 14,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "tp-link-camera-kits": {
      "collectionHandle": "tp-link-camera-kits",
      "collectionProductCount": 10,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 2,
          "rankedProductIds": [
            "8168497414201",
            "8168574615609"
          ],
          "rankedProductHandles": [
            "8mp-8ch-tp-link-cctv-kit-6-x-ip-turret-cameras-full-colour-speaker-mic-light-8ch-nvr-2tb-promo",
            "tp-link-insight-8mp-bullet-cctv-kit-4-x-ip-cameras-full-colour-speaker-mic-light-4ch-nvr"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 2,
          "rankedProductIds": [
            "8168497414201",
            "8168574615609"
          ],
          "rankedProductHandles": [
            "8mp-8ch-tp-link-cctv-kit-6-x-ip-turret-cameras-full-colour-speaker-mic-light-8ch-nvr-2tb-promo",
            "tp-link-insight-8mp-bullet-cctv-kit-4-x-ip-cameras-full-colour-speaker-mic-light-4ch-nvr"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 2,
          "rankedProductIds": [
            "8168577990713",
            "8168497414201"
          ],
          "rankedProductHandles": [
            "tp-link-insight-5mp-cctv-kit-8-x-ip-turret-cameras-full-colour-speaker-mic-light-8ch-nvr",
            "8mp-8ch-tp-link-cctv-kit-6-x-ip-turret-cameras-full-colour-speaker-mic-light-8ch-nvr-2tb-promo"
          ]
        }
      }
    },
    "tp-link-cctv-systems": {
      "collectionHandle": "tp-link-cctv-systems",
      "collectionProductCount": 32,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 3,
          "rankedProductIds": [
            "7836341796921",
            "7836351758393",
            "7591942422585"
          ],
          "rankedProductHandles": [
            "tp-link-insight-s385-8mp-full-colour-bullet-network-camera",
            "tp-link-insight-s285-8mp-full-colour-bullet-network-camera",
            "tp-link-vigi-c385-8mp-full-colour-speaker-mic-light-bullet-network-camera-4mm"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 2,
          "rankedProductIds": [
            "7591935934521",
            "7795445596217"
          ],
          "rankedProductHandles": [
            "tp-link-vigi-c540-4g-4mp-outdoor-full-colour-4g-pan-tilt-network-camera-4mm",
            "tp-link-vigi-insight-s345zi-4mp-bullet-vari-focal-camera"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 4,
          "rankedProductIds": [
            "7836341796921",
            "7836351758393",
            "7591942422585",
            "7591935934521"
          ],
          "rankedProductHandles": [
            "tp-link-insight-s385-8mp-full-colour-bullet-network-camera",
            "tp-link-insight-s285-8mp-full-colour-bullet-network-camera",
            "tp-link-vigi-c385-8mp-full-colour-speaker-mic-light-bullet-network-camera-4mm",
            "tp-link-vigi-c540-4g-4mp-outdoor-full-colour-4g-pan-tilt-network-camera-4mm"
          ]
        }
      }
    },
    "tp-link-colorpro-cameras": {
      "collectionHandle": "tp-link-colorpro-cameras",
      "collectionProductCount": 1,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "tp-link-vigi-bullet-cameras": {
      "collectionHandle": "tp-link-vigi-bullet-cameras",
      "collectionProductCount": 2,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "tp-link-vigi-cameras": {
      "collectionHandle": "tp-link-vigi-cameras",
      "collectionProductCount": 36,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 3,
          "rankedProductIds": [
            "7591942422585",
            "7836341796921",
            "7836351758393"
          ],
          "rankedProductHandles": [
            "tp-link-vigi-c385-8mp-full-colour-speaker-mic-light-bullet-network-camera-4mm",
            "tp-link-insight-s385-8mp-full-colour-bullet-network-camera",
            "tp-link-insight-s285-8mp-full-colour-bullet-network-camera"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 3,
          "rankedProductIds": [
            "7591935934521",
            "8168597782585",
            "7795445596217"
          ],
          "rankedProductHandles": [
            "tp-link-vigi-c540-4g-4mp-outdoor-full-colour-4g-pan-tilt-network-camera-4mm",
            "tp-link-vigi-c445-4mp-full-colour-speaker-mic-light-turret-network-camera",
            "tp-link-vigi-insight-s345zi-4mp-bullet-vari-focal-camera"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 4,
          "rankedProductIds": [
            "7591942422585",
            "7836341796921",
            "7591935934521",
            "7836351758393"
          ],
          "rankedProductHandles": [
            "tp-link-vigi-c385-8mp-full-colour-speaker-mic-light-bullet-network-camera-4mm",
            "tp-link-insight-s385-8mp-full-colour-bullet-network-camera",
            "tp-link-vigi-c540-4g-4mp-outdoor-full-colour-4g-pan-tilt-network-camera-4mm",
            "tp-link-insight-s285-8mp-full-colour-bullet-network-camera"
          ]
        }
      }
    },
    "tp-link-vigi-full-colour-cameras": {
      "collectionHandle": "tp-link-vigi-full-colour-cameras",
      "collectionProductCount": 15,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "tp-link-vigi-ir-cameras": {
      "collectionHandle": "tp-link-vigi-ir-cameras",
      "collectionProductCount": 4,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "tp-link-vigi-solar-systems": {
      "collectionHandle": "tp-link-vigi-solar-systems",
      "collectionProductCount": 5,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "tp-link-vigi-turret-cameras": {
      "collectionHandle": "tp-link-vigi-turret-cameras",
      "collectionProductCount": 15,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "turret-cameras": {
      "collectionHandle": "turret-cameras",
      "collectionProductCount": 2,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "turret-cameras-idis": {
      "collectionHandle": "turret-cameras-idis",
      "collectionProductCount": 1,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "tvt": {
      "collectionHandle": "tvt",
      "collectionProductCount": 20,
      "renderedProductLimit": 250,
      "needs": {}
    },
    "uniarch-by-uniview-cctv": {
      "collectionHandle": "uniarch-by-uniview-cctv",
      "collectionProductCount": 91,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 6,
          "rankedProductIds": [
            "7591779565625",
            "7591781662777",
            "7591781105721",
            "7591781466169",
            "7591781826617",
            "8168578252857"
          ],
          "rankedProductHandles": [
            "unv-uniarch-ipc-p1e5-ax4pkc-5mp-4x-lighthunter-speaker-strobe-mini-ptz-camera",
            "unv-uniarch-ipc-t1p5-af28kc-b-5mp-turret-network-camera-w-human-detection-light-speaker-black",
            "unv-uniarch-ipc-t1p8-af28kc-b-8mp-4k-turret-network-camera-w-human-detection-light-speaker-black",
            "unv-uniarch-ipc-t1p5-af28kc-5mp-turret-network-camera-w-human-detection-light-speaker",
            "uniarch-unv-tri-guard-ipc-b1p8-af28kc-8mp-4k-bullet-network-camera-w-human-detection-light-speaker",
            "uniview-ipc6424sr-x25-vf-b-4mp-25x-ptz-lighthunter-camera-ir100m-motorised-zoom-ik10-poe"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 15,
          "rankedProductIds": [
            "8168577564729",
            "8168577138745",
            "7591669203001",
            "7591781105721",
            "7591780810809",
            "7591781826617",
            "7591780024377",
            "7591779434553",
            "7591779172409",
            "7591779958841",
            "7591698890809",
            "7591779565625",
            "8168607285305",
            "8168578416697",
            "8168578252857"
          ],
          "rankedProductHandles": [
            "uniview-ipc3638sb-adzk-i0-8mp-lighthunter-motorised-turret-ir40m-built-in-mic-ip67-ik10-poe",
            "uniview-ipc2328sb-dzk-i0-8mp-lighthunter-motorised-bullet-camera-ir50m-ip67-ik10-wdr-poe",
            "unv-uniview-ipc2328sbr5-dpz-8mp-uniview-bullet-ip-poe-motorized-2-812mm-lens",
            "unv-uniarch-ipc-t1p8-af28kc-b-8mp-4k-turret-network-camera-w-human-detection-light-speaker-black",
            "unv-uniarch-ipc-t1p8-af28kc-8mp-4k-turret-network-camera-w-human-detection-light-speaker",
            "uniarch-unv-tri-guard-ipc-b1p8-af28kc-8mp-4k-bullet-network-camera-w-human-detection-light-speaker",
            "unv-uniarch-ipc-b1e8-af28k-8mp-starlight-fixed-bullet-network-camera-w-human-detection",
            "unv-uniarch-ipc-t1e8-af28k-b-8mp-starlight-fixed-turret-network-camera-w-human-detection-black",
            "unv-uniarch-ipc-t1e8-af28k-8mp-starlight-fixed-turret-network-camera-w-human-detection",
            "unv-uniarch-ipc-d1e8-af28k-8mp-starlight-fixed-dome-network-camera-w-human-detection",
            "uniview-2mp-ip-ipc6222er-x20p-b-ptz-20x-zoom-dwdr-smart-function",
            "unv-uniarch-ipc-p1e5-ax4pkc-5mp-4x-lighthunter-speaker-strobe-mini-ptz-camera",
            "uniview-ipc6324lwh-ax5c-vg2-4mp-5x-tri-guard-ptz-network-camera-with-warm-light-two-way-audio-colorhunter",
            "uniview-ipc94144sfw-x25-f40c-4mp4mp-dual-lens-ptz-camera-25x-zoom-ir100m-poe-ip66",
            "uniview-ipc6424sr-x25-vf-b-4mp-25x-ptz-lighthunter-camera-ir100m-motorised-zoom-ik10-poe"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 7,
          "rankedProductIds": [
            "8168578416697",
            "7591779565625",
            "8168578252857",
            "7591698890809",
            "8168578351161",
            "8168607285305",
            "8168577007673"
          ],
          "rankedProductHandles": [
            "uniview-ipc94144sfw-x25-f40c-4mp4mp-dual-lens-ptz-camera-25x-zoom-ir100m-poe-ip66",
            "unv-uniarch-ipc-p1e5-ax4pkc-5mp-4x-lighthunter-speaker-strobe-mini-ptz-camera",
            "uniview-ipc6424sr-x25-vf-b-4mp-25x-ptz-lighthunter-camera-ir100m-motorised-zoom-ik10-poe",
            "uniview-2mp-ip-ipc6222er-x20p-b-ptz-20x-zoom-dwdr-smart-function",
            "uniview-ipc675lfw-ax4dupkc-vg-5mp-4x-ptz-lighthunter-camera-ir50m-poe-ip66",
            "uniview-ipc6324lwh-ax5c-vg2-4mp-5x-tri-guard-ptz-network-camera-with-warm-light-two-way-audio-colorhunter",
            "uniview-ac-tr-we45-in-wall-mount-bracket-for-ptz-cameras"
          ]
        }
      }
    },
    "uniarch-by-uniview-kits-1": {
      "collectionHandle": "uniarch-by-uniview-kits-1",
      "collectionProductCount": 36,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 3,
          "rankedProductIds": [
            "7591786446905",
            "7591786217529",
            "7591785955385"
          ],
          "rankedProductHandles": [
            "unv-uniarch-8mp-starlight-6-x-fixed-turret-network-camera-8ch-kit",
            "unv-uniarch-6mp-starlight-8-x-fixed-black-turret-network-camera-8ch-kit",
            "unv-uniarch-4-x-6mp-starlight-fixed-black-turret-network-camera-4ch-kit"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 7,
          "rankedProductIds": [
            "7591786446905",
            "7591899365433",
            "8168580055097",
            "8168579956793",
            "8168579924025",
            "7591788511289",
            "7591788052537"
          ],
          "rankedProductHandles": [
            "unv-uniarch-8mp-starlight-6-x-fixed-turret-network-camera-8ch-kit",
            "uniarch-powered-by-uniview-4-x-8mp-starlight-fixed-turret-network-camera-8ch-kit",
            "uniview-unv-acutrack-uni8-2-x-8mp-ai-security-camera-kit-with-2tb-hdd-4ch-nvr",
            "uniview-unv-acutrack-owlview-4-x-8mp-smart-cctv-kit-with-4tb-hdd-8ch-nvr",
            "uniview-unv-acutrack-owlview-2-x-8mp-triguard-cctv-kit-with-2tb-hdd-4ch-nvr",
            "unv-uniview-uniarch-8mp-4k-starlight-16-x-fixed-turret-network-camera-16ch-kit",
            "unv-uniview-uniarch-8mp-starlight-10-x-fixed-turret-network-camera-16ch-kit"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 9,
          "rankedProductIds": [
            "7591786938425",
            "7591788511289",
            "7591788052537",
            "7591786643513",
            "7591786217529",
            "7591784677433",
            "7591786446905",
            "7591788347449",
            "7591787823161"
          ],
          "rankedProductHandles": [
            "unv-uniarch-8mp-starlight-8-x-fixed-turret-network-camera-8ch-kit",
            "unv-uniview-uniarch-8mp-4k-starlight-16-x-fixed-turret-network-camera-16ch-kit",
            "unv-uniview-uniarch-8mp-starlight-10-x-fixed-turret-network-camera-16ch-kit",
            "unv-uniarch-4mp-starlight-8-x-fixed-turret-network-camera-8ch-kit",
            "unv-uniarch-6mp-starlight-8-x-fixed-black-turret-network-camera-8ch-kit",
            "unv-uniarch-6mp-starlight-8-x-fixed-turret-network-camera-8ch-kit",
            "unv-uniarch-8mp-starlight-6-x-fixed-turret-network-camera-8ch-kit",
            "unv-uniview-uniarch-6mp-starlight-16-x-fixed-turret-network-camera-16ch-kit",
            "unv-uniview-uniarch-6mp-starlight-10-x-fixed-turret-network-camera-16ch-kit"
          ]
        }
      }
    },
    "uniarch-by-uniview-unv-ip-cameras": {
      "collectionHandle": "uniarch-by-uniview-unv-ip-cameras",
      "collectionProductCount": 34,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 6,
          "rankedProductIds": [
            "7591779565625",
            "7591781662777",
            "7591781826617",
            "7591781466169",
            "7591781105721",
            "8168578252857"
          ],
          "rankedProductHandles": [
            "unv-uniarch-ipc-p1e5-ax4pkc-5mp-4x-lighthunter-speaker-strobe-mini-ptz-camera",
            "unv-uniarch-ipc-t1p5-af28kc-b-5mp-turret-network-camera-w-human-detection-light-speaker-black",
            "uniarch-unv-tri-guard-ipc-b1p8-af28kc-8mp-4k-bullet-network-camera-w-human-detection-light-speaker",
            "unv-uniarch-ipc-t1p5-af28kc-5mp-turret-network-camera-w-human-detection-light-speaker",
            "unv-uniarch-ipc-t1p8-af28kc-b-8mp-4k-turret-network-camera-w-human-detection-light-speaker-black",
            "uniview-ipc6424sr-x25-vf-b-4mp-25x-ptz-lighthunter-camera-ir100m-motorised-zoom-ik10-poe"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 15,
          "rankedProductIds": [
            "8168577564729",
            "8168577138745",
            "7591781826617",
            "7591781105721",
            "7591669203001",
            "7591780810809",
            "7591780024377",
            "7591779434553",
            "7591779172409",
            "8168578416697",
            "7591779958841",
            "8168607285305",
            "7591698890809",
            "7591779565625",
            "8168578252857"
          ],
          "rankedProductHandles": [
            "uniview-ipc3638sb-adzk-i0-8mp-lighthunter-motorised-turret-ir40m-built-in-mic-ip67-ik10-poe",
            "uniview-ipc2328sb-dzk-i0-8mp-lighthunter-motorised-bullet-camera-ir50m-ip67-ik10-wdr-poe",
            "uniarch-unv-tri-guard-ipc-b1p8-af28kc-8mp-4k-bullet-network-camera-w-human-detection-light-speaker",
            "unv-uniarch-ipc-t1p8-af28kc-b-8mp-4k-turret-network-camera-w-human-detection-light-speaker-black",
            "unv-uniview-ipc2328sbr5-dpz-8mp-uniview-bullet-ip-poe-motorized-2-812mm-lens",
            "unv-uniarch-ipc-t1p8-af28kc-8mp-4k-turret-network-camera-w-human-detection-light-speaker",
            "unv-uniarch-ipc-b1e8-af28k-8mp-starlight-fixed-bullet-network-camera-w-human-detection",
            "unv-uniarch-ipc-t1e8-af28k-b-8mp-starlight-fixed-turret-network-camera-w-human-detection-black",
            "unv-uniarch-ipc-t1e8-af28k-8mp-starlight-fixed-turret-network-camera-w-human-detection",
            "uniview-ipc94144sfw-x25-f40c-4mp4mp-dual-lens-ptz-camera-25x-zoom-ir100m-poe-ip66",
            "unv-uniarch-ipc-d1e8-af28k-8mp-starlight-fixed-dome-network-camera-w-human-detection",
            "uniview-ipc6324lwh-ax5c-vg2-4mp-5x-tri-guard-ptz-network-camera-with-warm-light-two-way-audio-colorhunter",
            "uniview-2mp-ip-ipc6222er-x20p-b-ptz-20x-zoom-dwdr-smart-function",
            "unv-uniarch-ipc-p1e5-ax4pkc-5mp-4x-lighthunter-speaker-strobe-mini-ptz-camera",
            "uniview-ipc6424sr-x25-vf-b-4mp-25x-ptz-lighthunter-camera-ir100m-motorised-zoom-ik10-poe"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 6,
          "rankedProductIds": [
            "8168578416697",
            "8168578252857",
            "7591779565625",
            "8168578351161",
            "8168607285305",
            "7591698890809"
          ],
          "rankedProductHandles": [
            "uniview-ipc94144sfw-x25-f40c-4mp4mp-dual-lens-ptz-camera-25x-zoom-ir100m-poe-ip66",
            "uniview-ipc6424sr-x25-vf-b-4mp-25x-ptz-lighthunter-camera-ir100m-motorised-zoom-ik10-poe",
            "unv-uniarch-ipc-p1e5-ax4pkc-5mp-4x-lighthunter-speaker-strobe-mini-ptz-camera",
            "uniview-ipc675lfw-ax4dupkc-vg-5mp-4x-ptz-lighthunter-camera-ir50m-poe-ip66",
            "uniview-ipc6324lwh-ax5c-vg2-4mp-5x-tri-guard-ptz-network-camera-with-warm-light-two-way-audio-colorhunter",
            "uniview-2mp-ip-ipc6222er-x20p-b-ptz-20x-zoom-dwdr-smart-function"
          ]
        }
      }
    },
    "uniview-1": {
      "collectionHandle": "uniview-1",
      "collectionProductCount": 82,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 4,
          "rankedProductIds": [
            "8284556525625",
            "8284556427321",
            "8324119068729",
            "8284554985529"
          ],
          "rankedProductHandles": [
            "uniview-ipc2b18se-adf28kmc-wp-i1-8mp-owlview-plus-tri-guard-fixed-dual-light-bullet-camera-with-built-in-dual-mic-speaker-40m-ir-40m-warm-light-ik10-ip67",
            "uniview-ipc3638se-adf28kmc-wp-i1-8mp-owlview-plus-tri-guard-fixed-dual-light-turret-camera-with-2-8mm-f1-0-lens-30m-ir-30m-warm-light-built-in-dual-mic-speaker-ik10-ip67",
            "uniview-ipc3616le-adf28km-dl-6mp-dual-light-eyeball-network-camera-2-8mm-with-built-in-mic",
            "uniview-ipc2b16ss-adf28kmc-i1-bk-6mp-tri-guard-fixed-bullet-camera-with-active-deterrence-dual-light-2-8mm-lens-built-in-mic-ip67-black-finish"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 5,
          "rankedProductIds": [
            "8284555575353",
            "8284555444281",
            "8284553248825",
            "7591928299577",
            "8284553838649"
          ],
          "rankedProductHandles": [
            "uniview-ipc2b18ss-adf28kmc-i1-bk-8mp-triguard-fixed-bullet-camera-with-red-blue-warning-light-built-in-mic-speaker-40m-ir-ip67-black-finish",
            "uniview-ipc2b16ss-adf28kmc-i1-6mp-triguard-fixed-bullet-camera-with-red-blue-warning-light-built-in-mic-speaker-40m-ir-ip67",
            "uniview-8mp-tri-guard-ipc2b18ss-adf28kmc-i1-bullet-camera-with-active-deterrence-built-in-mic-speaker-2-8mm-lens-ir-white-light-40m",
            "uniview-unv-8mp-hd-intelligent-light-and-audible-warning-fixed-eyeball-network-camera-ipc3638ss-adf28kmc-i1",
            "unv-8mp-lighthunter-ipc3618ss-adf28k-i1-bk-turret-camera-with-ai-perimeter-protection-built-in-mic-2-8mm-lens-ir-40m"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 9,
          "rankedProductIds": [
            "7591928299577",
            "8284556525625",
            "8284553510969",
            "8284553248825",
            "8284553838649",
            "8284553445433",
            "8284554133561",
            "8284553969721",
            "8284553904185"
          ],
          "rankedProductHandles": [
            "uniview-unv-8mp-hd-intelligent-light-and-audible-warning-fixed-eyeball-network-camera-ipc3638ss-adf28kmc-i1",
            "uniview-ipc2b18se-adf28kmc-wp-i1-8mp-owlview-plus-tri-guard-fixed-dual-light-bullet-camera-with-built-in-dual-mic-speaker-40m-ir-40m-warm-light-ik10-ip67",
            "uniview-8mp-lighthunter-ipc2b18ss-adf28k-i1-bullet-camera-with-built-in-mic-2-8mm-lens-ir-80m",
            "uniview-8mp-tri-guard-ipc2b18ss-adf28kmc-i1-bullet-camera-with-active-deterrence-built-in-mic-speaker-2-8mm-lens-ir-white-light-40m",
            "unv-8mp-lighthunter-ipc3618ss-adf28k-i1-bk-turret-camera-with-ai-perimeter-protection-built-in-mic-2-8mm-lens-ir-40m",
            "uniview-8mp-ipc328ss-adf28k-i1-turret-camera-with-intelligent-detection-2-8mm-lens-ir-30m",
            "unv-8mp-colorhunter-ipc3k28se-adf28kmc-dl-i0-bk-dual-lens-panoramic-camera-with-ai-people-counting-built-in-mic-2x2-8mm-lens-ir-warm-led",
            "unv-8mp-lighthunter-ipc3638ss-adf28kmc-i1-bk-turret-camera-with-ai-perimeter-protection-built-in-mic-2-8mm-lens-ir-30m",
            "unv-5mp-lighthunter-ipc3735ss-adzk-i1-dome-camera-with-ai-perimeter-protection-built-in-mic-2-7-13-5mm-motorised-lens-ir-40m"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 3,
          "rankedProductIds": [
            "8324151967801",
            "8324144005177",
            "8284552986681"
          ],
          "rankedProductHandles": [
            "uniview-8mp-pro-series-ipc6828el-x42-w-vh1-lighthunter-laser-ptz-camera-with-42x-optical-zoom-wiper-500m-ir",
            "uniview-tr-we45-a-in-long-wall-mount-bracket-for-ptz-dome-cameras-indoor-outdoor-aluminium-alloy-mount",
            "uniview-tr-uc08-a-in-corner-mount-bracket-for-ptz-dome-cameras-indoor-outdoor-steel-wall-installation"
          ]
        }
      }
    },
    "uniview-cctv-suppliers": {
      "collectionHandle": "uniview-cctv-suppliers",
      "collectionProductCount": 141,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 7,
          "rankedProductIds": [
            "8284556525625",
            "8284556427321",
            "8324119068729",
            "8284554985529",
            "8284518842425",
            "8284518318137",
            "8284518580281"
          ],
          "rankedProductHandles": [
            "uniview-ipc2b18se-adf28kmc-wp-i1-8mp-owlview-plus-tri-guard-fixed-dual-light-bullet-camera-with-built-in-dual-mic-speaker-40m-ir-40m-warm-light-ik10-ip67",
            "uniview-ipc3638se-adf28kmc-wp-i1-8mp-owlview-plus-tri-guard-fixed-dual-light-turret-camera-with-2-8mm-f1-0-lens-30m-ir-30m-warm-light-built-in-dual-mic-speaker-ik10-ip67",
            "uniview-ipc3616le-adf28km-dl-6mp-dual-light-eyeball-network-camera-2-8mm-with-built-in-mic",
            "uniview-ipc2b16ss-adf28kmc-i1-bk-6mp-tri-guard-fixed-bullet-camera-with-active-deterrence-dual-light-2-8mm-lens-built-in-mic-ip67-black-finish",
            "uniview-ipc2b18se-adf28-40-kmc-wp-i1-8mp-owlview-plus-dual-light-ai-bullet-camera-fixed-lens-tri-guard-active-deterrence",
            "uniview-ipc3638se-adf28-40-kmc-wp-i1-8mp-owlview-plus-dual-light-ai-turret-camera-fixed-lens-tri-guard-active-deterrence",
            "uniview-ipc3638se-adzkmc-wp-i1-8mp-tri-guard-ai-turret-camera-varifocal-dual-light-active-deterrence"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 11,
          "rankedProductIds": [
            "8284555575353",
            "8284555444281",
            "8284553248825",
            "7591928299577",
            "8284519104569",
            "8284518842425",
            "8284518318137",
            "8284518580281",
            "8284517597241",
            "8284553838649",
            "8168578252857"
          ],
          "rankedProductHandles": [
            "uniview-ipc2b18ss-adf28kmc-i1-bk-8mp-triguard-fixed-bullet-camera-with-red-blue-warning-light-built-in-mic-speaker-40m-ir-ip67-black-finish",
            "uniview-ipc2b16ss-adf28kmc-i1-6mp-triguard-fixed-bullet-camera-with-red-blue-warning-light-built-in-mic-speaker-40m-ir-ip67",
            "uniview-8mp-tri-guard-ipc2b18ss-adf28kmc-i1-bullet-camera-with-active-deterrence-built-in-mic-speaker-2-8mm-lens-ir-white-light-40m",
            "uniview-unv-8mp-hd-intelligent-light-and-audible-warning-fixed-eyeball-network-camera-ipc3638ss-adf28kmc-i1",
            "uniview-ipc2b16se-adf28-40-kmc-wp-i1-6mp-owlview-plus-dual-light-ai-bullet-camera-with-tri-guard-active-deterrence",
            "uniview-ipc2b18se-adf28-40-kmc-wp-i1-8mp-owlview-plus-dual-light-ai-bullet-camera-fixed-lens-tri-guard-active-deterrence",
            "uniview-ipc3638se-adf28-40-kmc-wp-i1-8mp-owlview-plus-dual-light-ai-turret-camera-fixed-lens-tri-guard-active-deterrence",
            "uniview-ipc3638se-adzkmc-wp-i1-8mp-tri-guard-ai-turret-camera-varifocal-dual-light-active-deterrence",
            "uniview-ipc3636se-adzkmc-wp-i1-6mp-ai-tri-guard-turret-camera-varifocal-dual-light-active-deterrence",
            "unv-8mp-lighthunter-ipc3618ss-adf28k-i1-bk-turret-camera-with-ai-perimeter-protection-built-in-mic-2-8mm-lens-ir-40m",
            "uniview-ipc6424sr-x25-vf-b-4mp-25x-ptz-lighthunter-camera-ir100m-motorised-zoom-ik10-poe"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 16,
          "rankedProductIds": [
            "7591928299577",
            "8168577564729",
            "8284556525625",
            "8284518580281",
            "8168577138745",
            "8284553510969",
            "8284553248825",
            "8284518842425",
            "8284518318137",
            "8284553838649",
            "8284553445433",
            "8284554133561",
            "8284553969721",
            "8284545384505",
            "8284553904185",
            "8284517597241"
          ],
          "rankedProductHandles": [
            "uniview-unv-8mp-hd-intelligent-light-and-audible-warning-fixed-eyeball-network-camera-ipc3638ss-adf28kmc-i1",
            "uniview-ipc3638sb-adzk-i0-8mp-lighthunter-motorised-turret-ir40m-built-in-mic-ip67-ik10-poe",
            "uniview-ipc2b18se-adf28kmc-wp-i1-8mp-owlview-plus-tri-guard-fixed-dual-light-bullet-camera-with-built-in-dual-mic-speaker-40m-ir-40m-warm-light-ik10-ip67",
            "uniview-ipc3638se-adzkmc-wp-i1-8mp-tri-guard-ai-turret-camera-varifocal-dual-light-active-deterrence",
            "uniview-ipc2328sb-dzk-i0-8mp-lighthunter-motorised-bullet-camera-ir50m-ip67-ik10-wdr-poe",
            "uniview-8mp-lighthunter-ipc2b18ss-adf28k-i1-bullet-camera-with-built-in-mic-2-8mm-lens-ir-80m",
            "uniview-8mp-tri-guard-ipc2b18ss-adf28kmc-i1-bullet-camera-with-active-deterrence-built-in-mic-speaker-2-8mm-lens-ir-white-light-40m",
            "uniview-ipc2b18se-adf28-40-kmc-wp-i1-8mp-owlview-plus-dual-light-ai-bullet-camera-fixed-lens-tri-guard-active-deterrence",
            "uniview-ipc3638se-adf28-40-kmc-wp-i1-8mp-owlview-plus-dual-light-ai-turret-camera-fixed-lens-tri-guard-active-deterrence",
            "unv-8mp-lighthunter-ipc3618ss-adf28k-i1-bk-turret-camera-with-ai-perimeter-protection-built-in-mic-2-8mm-lens-ir-40m",
            "uniview-8mp-ipc328ss-adf28k-i1-turret-camera-with-intelligent-detection-2-8mm-lens-ir-30m",
            "unv-8mp-colorhunter-ipc3k28se-adf28kmc-dl-i0-bk-dual-lens-panoramic-camera-with-ai-people-counting-built-in-mic-2x2-8mm-lens-ir-warm-led",
            "unv-8mp-lighthunter-ipc3638ss-adf28kmc-i1-bk-turret-camera-with-ai-perimeter-protection-built-in-mic-2-8mm-lens-ir-30m",
            "uniview-6x-8mp-owlview-security-kit-6-turret-cameras-with-iq-series-nvr-warm-light-colorhunter-built-in-mic-cctv-system",
            "unv-5mp-lighthunter-ipc3735ss-adzk-i1-dome-camera-with-ai-perimeter-protection-built-in-mic-2-7-13-5mm-motorised-lens-ir-40m",
            "uniview-ipc3636se-adzkmc-wp-i1-6mp-ai-tri-guard-turret-camera-varifocal-dual-light-active-deterrence"
          ]
        },
        "wide-area-coverage": {
          "displayName": "Wide area coverage",
          "productCount": 8,
          "rankedProductIds": [
            "8324151967801",
            "8168578416697",
            "8168578252857",
            "8324144005177",
            "8284552986681",
            "8168578351161",
            "8168577007673",
            "8168607285305"
          ],
          "rankedProductHandles": [
            "uniview-8mp-pro-series-ipc6828el-x42-w-vh1-lighthunter-laser-ptz-camera-with-42x-optical-zoom-wiper-500m-ir",
            "uniview-ipc94144sfw-x25-f40c-4mp4mp-dual-lens-ptz-camera-25x-zoom-ir100m-poe-ip66",
            "uniview-ipc6424sr-x25-vf-b-4mp-25x-ptz-lighthunter-camera-ir100m-motorised-zoom-ik10-poe",
            "uniview-tr-we45-a-in-long-wall-mount-bracket-for-ptz-dome-cameras-indoor-outdoor-aluminium-alloy-mount",
            "uniview-tr-uc08-a-in-corner-mount-bracket-for-ptz-dome-cameras-indoor-outdoor-steel-wall-installation",
            "uniview-ipc675lfw-ax4dupkc-vg-5mp-4x-ptz-lighthunter-camera-ir50m-poe-ip66",
            "uniview-ac-tr-we45-in-wall-mount-bracket-for-ptz-cameras",
            "uniview-ipc6324lwh-ax5c-vg2-4mp-5x-tri-guard-ptz-network-camera-with-warm-light-two-way-audio-colorhunter"
          ]
        }
      }
    },
    "uniview-kits": {
      "collectionHandle": "uniview-kits",
      "collectionProductCount": 26,
      "renderedProductLimit": 250,
      "needs": {
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 4,
          "rankedProductIds": [
            "8284545384505",
            "8168580055097",
            "8168579956793",
            "8168579924025"
          ],
          "rankedProductHandles": [
            "uniview-6x-8mp-owlview-security-kit-6-turret-cameras-with-iq-series-nvr-warm-light-colorhunter-built-in-mic-cctv-system",
            "uniview-unv-acutrack-uni8-2-x-8mp-ai-security-camera-kit-with-2tb-hdd-4ch-nvr",
            "uniview-unv-acutrack-owlview-4-x-8mp-smart-cctv-kit-with-4tb-hdd-8ch-nvr",
            "uniview-unv-acutrack-owlview-2-x-8mp-triguard-cctv-kit-with-2tb-hdd-4ch-nvr"
          ]
        }
      }
    },
    "unv-owlview-cctv-cameras": {
      "collectionHandle": "unv-owlview-cctv-cameras",
      "collectionProductCount": 25,
      "renderedProductLimit": 250,
      "needs": {
        "better-night-vision": {
          "displayName": "Better night vision",
          "productCount": 4,
          "rankedProductIds": [
            "8284556427321",
            "8284518842425",
            "8284518318137",
            "8284518580281"
          ],
          "rankedProductHandles": [
            "uniview-ipc3638se-adf28kmc-wp-i1-8mp-owlview-plus-tri-guard-fixed-dual-light-turret-camera-with-2-8mm-f1-0-lens-30m-ir-30m-warm-light-built-in-dual-mic-speaker-ik10-ip67",
            "uniview-ipc2b18se-adf28-40-kmc-wp-i1-8mp-owlview-plus-dual-light-ai-bullet-camera-fixed-lens-tri-guard-active-deterrence",
            "uniview-ipc3638se-adf28-40-kmc-wp-i1-8mp-owlview-plus-dual-light-ai-turret-camera-fixed-lens-tri-guard-active-deterrence",
            "uniview-ipc3638se-adzkmc-wp-i1-8mp-tri-guard-ai-turret-camera-varifocal-dual-light-active-deterrence"
          ]
        },
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 5,
          "rankedProductIds": [
            "8284519104569",
            "8284518842425",
            "8284518318137",
            "8284518580281",
            "8284517597241"
          ],
          "rankedProductHandles": [
            "uniview-ipc2b16se-adf28-40-kmc-wp-i1-6mp-owlview-plus-dual-light-ai-bullet-camera-with-tri-guard-active-deterrence",
            "uniview-ipc2b18se-adf28-40-kmc-wp-i1-8mp-owlview-plus-dual-light-ai-bullet-camera-fixed-lens-tri-guard-active-deterrence",
            "uniview-ipc3638se-adf28-40-kmc-wp-i1-8mp-owlview-plus-dual-light-ai-turret-camera-fixed-lens-tri-guard-active-deterrence",
            "uniview-ipc3638se-adzkmc-wp-i1-8mp-tri-guard-ai-turret-camera-varifocal-dual-light-active-deterrence",
            "uniview-ipc3636se-adzkmc-wp-i1-6mp-ai-tri-guard-turret-camera-varifocal-dual-light-active-deterrence"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 6,
          "rankedProductIds": [
            "8284518580281",
            "8284518842425",
            "8284518318137",
            "8284545384505",
            "8284517597241",
            "8168607285305"
          ],
          "rankedProductHandles": [
            "uniview-ipc3638se-adzkmc-wp-i1-8mp-tri-guard-ai-turret-camera-varifocal-dual-light-active-deterrence",
            "uniview-ipc2b18se-adf28-40-kmc-wp-i1-8mp-owlview-plus-dual-light-ai-bullet-camera-fixed-lens-tri-guard-active-deterrence",
            "uniview-ipc3638se-adf28-40-kmc-wp-i1-8mp-owlview-plus-dual-light-ai-turret-camera-fixed-lens-tri-guard-active-deterrence",
            "uniview-6x-8mp-owlview-security-kit-6-turret-cameras-with-iq-series-nvr-warm-light-colorhunter-built-in-mic-cctv-system",
            "uniview-ipc3636se-adzkmc-wp-i1-6mp-ai-tri-guard-turret-camera-varifocal-dual-light-active-deterrence",
            "uniview-ipc6324lwh-ax5c-vg2-4mp-5x-tri-guard-ptz-network-camera-with-warm-light-two-way-audio-colorhunter"
          ]
        }
      }
    },
    "unv-uniarch-tri-guard-active-deterrance": {
      "collectionHandle": "unv-uniarch-tri-guard-active-deterrance",
      "collectionProductCount": 6,
      "renderedProductLimit": 250,
      "needs": {
        "deter-intruders": {
          "displayName": "Deter intruders",
          "productCount": 3,
          "rankedProductIds": [
            "7591779565625",
            "7591781662777",
            "7591781826617"
          ],
          "rankedProductHandles": [
            "unv-uniarch-ipc-p1e5-ax4pkc-5mp-4x-lighthunter-speaker-strobe-mini-ptz-camera",
            "unv-uniarch-ipc-t1p5-af28kc-b-5mp-turret-network-camera-w-human-detection-light-speaker-black",
            "uniarch-unv-tri-guard-ipc-b1p8-af28kc-8mp-4k-bullet-network-camera-w-human-detection-light-speaker"
          ]
        },
        "identify-people-vehicles": {
          "displayName": "Identify people & vehicles",
          "productCount": 4,
          "rankedProductIds": [
            "7591781826617",
            "7591781105721",
            "7591780810809",
            "7591779565625"
          ],
          "rankedProductHandles": [
            "uniarch-unv-tri-guard-ipc-b1p8-af28kc-8mp-4k-bullet-network-camera-w-human-detection-light-speaker",
            "unv-uniarch-ipc-t1p8-af28kc-b-8mp-4k-turret-network-camera-w-human-detection-light-speaker-black",
            "unv-uniarch-ipc-t1p8-af28kc-8mp-4k-turret-network-camera-w-human-detection-light-speaker",
            "unv-uniarch-ipc-p1e5-ax4pkc-5mp-4x-lighthunter-speaker-strobe-mini-ptz-camera"
          ]
        }
      }
    },
    "wireless-cameras": {
      "collectionHandle": "wireless-cameras",
      "collectionProductCount": 1,
      "renderedProductLimit": 250,
      "needs": {}
    }
  }
};
